import type { Country } from '../../../src/helpers/country-codes'
import type { AppCurrency } from '../../../src/plugins/currency-types'
import type { Decimal } from '../../../src/types/decimal'
import type { Email } from '../../../src/types/email'
import type { Locale } from '../../../src/i18n/types'
import type { PhoneNumber } from '../../../src/types/phoneNumber'
import type { Time } from '../../../src/types/time'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
    T extends { [key: string]: unknown },
    K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
    | T
    | {
          [P in keyof T]?: P extends ' $fragmentName' | '__typename'
              ? T[P]
              : never
      }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string }
    String: { input: string; output: string }
    Boolean: { input: boolean; output: boolean }
    Int: { input: number; output: number }
    Float: { input: number; output: number }
    CatalogueCode: { input: string; output: string }
    Country: { input: Country; output: Country }
    CountrySubdivision: { input: string; output: string }
    Currency: { input: AppCurrency; output: AppCurrency }
    Date: { input: string; output: string }
    DateTime: { input: string; output: string }
    Decimal: { input: Decimal; output: Decimal }
    Email: { input: Email; output: Email }
    GemsApi_StoneIdentifier: { input: string; output: string }
    GemsApi_Uri: { input: string; output: string }
    JSON: {
        input: Record<string | number, unknown>
        output: Record<string | number, unknown>
    }
    Locale: { input: Locale; output: Locale }
    PhoneNumber: { input: PhoneNumber; output: PhoneNumber }
    RenderableTemplate: { input: string; output: string }
    Time: { input: Time; output: Time }
    Upload: { input: File; output: File }
    Uri: { input: string; output: string }
    Void: { input: string; output: string }
}

export type ActivateWarrantyInput = {
    id: Scalars['ID']['input']
    wearer?: InputMaybe<ActivateWarrantyWearerInput>
}

export type ActivateWarrantyWearerInput = {
    email: Scalars['Email']['input']
    emailConsent: Scalars['Boolean']['input']
    name: Scalars['String']['input']
}

export type AddFinalCustomerPriceSurchargeInput = {
    amount: MoneyInput
    componentCode: SurchargeableQuotationComponent
    quotationId: Scalars['ID']['input']
}

export type AddToCartExistingCustomerResult = {
    __typename: 'AddToCartExistingCustomerResult'
    order: Order
    product: OrderProduct
}

export type AddToCartReadyToGoRingExistingCustomerResponse =
    AddToCartReadyToGoRingSuccessExistingCustomer

export type AddToCartReadyToGoRingInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueReadyToGoRingCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    recommendedRingSizeId?: InputMaybe<Scalars['ID']['input']>
    uri: Scalars['Uri']['input']
}

export type AddToCartReadyToGoRingNewCustomerResponse =
    AddToCartReadyToGoRingSuccessNewCustomer

export type AddToCartReadyToGoRingSuccessExistingCustomer = {
    __typename: 'AddToCartReadyToGoRingSuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type AddToCartReadyToGoRingSuccessNewCustomer = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type Address = {
    __typename: 'Address'
    country: Maybe<Scalars['Country']['output']>
    phoneNumber: Maybe<PhoneNumberType>
}

export type AffirmCheckoutObjectInput = {
    cancelUrl: Scalars['Uri']['input']
    confirmationUrl: Scalars['Uri']['input']
}

export type AffirmCompleteTransactionInput = {
    /** checkoutToken=null means declined */
    checkoutToken?: InputMaybe<Scalars['String']['input']>
    transactionId: Scalars['ID']['input']
}

export type AffirmCompleteTransactionResponse = {
    __typename: 'AffirmCompleteTransactionResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type AffirmFinanceOption = {
    __typename: 'AffirmFinanceOption'
    months: Scalars['Int']['output']
    perMonth: Money
    price: Money
}

export type AffirmPaymentInput = {
    transactionId: Scalars['ID']['input']
}

export type AffirmPaymentMethod = {
    __typename: 'AffirmPaymentMethod'
    publicKey: Scalars['String']['output']
    scriptUrl: Scalars['String']['output']
    systemCode: Scalars['ID']['output']
}

export type AffirmPaymentResponse = {
    __typename: 'AffirmPaymentResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type AffirmTransaction = TransactionInterface & {
    __typename: 'AffirmTransaction'
    amount: Money
    /** After decoding you need to set .items.item_url to the product url */
    checkoutObject: Scalars['JSON']['output']
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type AffirmTransactionCheckoutObjectArgs = {
    input: AffirmCheckoutObjectInput
}

export type AffirmTransactionInput = {
    orderId: Scalars['ID']['input']
}

export type AllocationPaymentMethod = {
    __typename: 'AllocationPaymentMethod'
    maxAmount: Money
    systemCode: Scalars['ID']['output']
}

export type AllocationTransaction = TransactionInterface & {
    __typename: 'AllocationTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type AllocationTransactionInput = {
    amount: Scalars['Decimal']['input']
    orderId: Scalars['ID']['input']
}

export type ArticleGridItem = {
    __typename: 'ArticleGridItem'
    description: Scalars['String']['output']
    image: Image
    link: Maybe<Link>
    title: Scalars['String']['output']
}

export type ArticlePreview = {
    __typename: 'ArticlePreview'
    image: Image
    link: Link
    subtitle: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type Asset = {
    __typename: 'Asset'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type AssetSizeArgs = {
    name: MonolithImageSizeName
}

export type Author = {
    __typename: 'Author'
    id: Scalars['ID']['output']
    image: Image
    name: Scalars['String']['output']
    postAggregation: PostsAggregation
    posts: Maybe<Array<Post>>
    slug: Scalars['String']['output']
}

export type AuthorPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type AuthorPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type AuthorsAggregation = {
    __typename: 'AuthorsAggregation'
    count: Scalars['Int']['output']
}

export type AutologinInput = {
    token?: InputMaybe<Scalars['String']['input']>
}

export type AvatarStackItem = {
    __typename: 'AvatarStackItem'
    image: Image
}

export type AvataxAddressInvalidError = {
    __typename: 'AvataxAddressInvalidError'
    message: Scalars['String']['output']
}

export type BankPaymentMethod = {
    __typename: 'BankPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type BankTransaction = TransactionInterface & {
    __typename: 'BankTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type Banner1 = {
    __typename: 'Banner1'
    backgroundColor: Color
    backgroundImage: Maybe<Image>
    button: Maybe<ComponentButton>
    preTitle: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export type Banner2 = {
    __typename: 'Banner2'
    backgroundColor: Color
    button: Maybe<ComponentButton>
    image: Maybe<Image>
    preTitle: Maybe<Scalars['String']['output']>
    text: Maybe<Scalars['String']['output']>
    title: Maybe<Scalars['String']['output']>
}

export const BannerSkinnyBackgroundGraphic = {
    Graphic1: 'GRAPHIC1',
    Graphic2: 'GRAPHIC2',
    Graphic3: 'GRAPHIC3',
    Graphic4: 'GRAPHIC4',
    None: 'NONE',
} as const

export type BannerSkinnyBackgroundGraphic =
    (typeof BannerSkinnyBackgroundGraphic)[keyof typeof BannerSkinnyBackgroundGraphic]
export type BasePromoCode = {
    code: Scalars['String']['output']
    id: Scalars['ID']['output']
}

export type Block = {
    __typename: 'Block'
    anchor: Maybe<BlockAnchor>
    backgroundColor: Color
    backgroundOverflow: Scalars['Boolean']['output']
    collapsibleTitle: Maybe<Scalars['String']['output']>
    components: Array<Component>
    display: Display
    isCollapsible: Scalars['Boolean']['output']
    isOpenByDefault: Scalars['Boolean']['output']
    verticalSpacing: VerticalSpacing
    width: Width
}

export type BlockAnchor = {
    __typename: 'BlockAnchor'
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type BookingAccessibilityOption = {
    __typename: 'BookingAccessibilityOption'
    code: BookingConsultationAccessibility
    label: Scalars['String']['output']
}

export type BookingCancelConsultationInput = {
    id: Scalars['ID']['input']
}

export type BookingConsultation = {
    __typename: 'BookingConsultation'
    accessibility: Maybe<BookingConsultationAccessibility>
    canBeCancelled: Scalars['Boolean']['output']
    comment: Maybe<Scalars['String']['output']>
    consultant: Maybe<Consultant>
    consultationRoom: Maybe<BookingConsultationRoom>
    customer: Maybe<Customer>
    description: Maybe<Scalars['String']['output']>
    editConsultationLink: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    isCancelled: Scalars['Boolean']['output']
    isEligibleToChangeOpportunityOwner: Scalars['Boolean']['output']
    method: BookingConsultationMethod
    note: Maybe<Scalars['String']['output']>
    numberOfPeople: Scalars['Int']['output']
    order: Maybe<Order>
    partnerInvolvement: Maybe<BookingConsultationPartnerInvolvement>
    productDesignComplexity: Maybe<BookingConsultationProductDesignComplexityCode>
    purpose: BookingConsultationPurpose
    rescheduleInfo: Maybe<BookingConsultationRescheduleInfo>
    salesforceId: Maybe<Scalars['String']['output']>
    showroom: Showroom
    startsAt: Scalars['DateTime']['output']
    state: BookingConsultationState
    transitions: Array<BookingConsultationTransitionInfo>
}

export const BookingConsultationAccessibility = {
    Both: 'BOTH',
    None: 'NONE',
    Space: 'SPACE',
    Stairless: 'STAIRLESS',
} as const

export type BookingConsultationAccessibility =
    (typeof BookingConsultationAccessibility)[keyof typeof BookingConsultationAccessibility]
export type BookingConsultationAvailableDate = {
    __typename: 'BookingConsultationAvailableDate'
    consultationAvailableShowrooms: Array<BookingConsultationAvailableShowroom>
    date: Scalars['DateTime']['output']
}

export type BookingConsultationAvailableShowroom = {
    __typename: 'BookingConsultationAvailableShowroom'
    consultationSlots: Array<BookingConsultationSlot>
}

export type BookingConsultationAvailableSlotsByConsultantOrAutoAssingResponse =
    {
        __typename: 'BookingConsultationAvailableSlotsByConsultantOrAutoAssingResponse'
        logs: Array<Scalars['String']['output']>
        slots: Array<BookingConsultationAvailableDate>
    }

export type BookingConsultationComplexity = {
    __typename: 'BookingConsultationComplexity'
    icon: Maybe<Asset>
    systemCode: BookingConsultationComplexityCode
    translation: BookingConsultationComplexityTranslation
}

export type BookingConsultationComplexityTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const BookingConsultationComplexityCode = {
    DiscussDesigns: 'DISCUSS_DESIGNS',
    NotSure: 'NOT_SURE',
    ViewDesigns: 'VIEW_DESIGNS',
} as const

export type BookingConsultationComplexityCode =
    (typeof BookingConsultationComplexityCode)[keyof typeof BookingConsultationComplexityCode]
export type BookingConsultationComplexityTranslation = {
    __typename: 'BookingConsultationComplexityTranslation'
    locale: Scalars['Locale']['output']
    name: Scalars['String']['output']
}

export type BookingConsultationMethod = {
    __typename: 'BookingConsultationMethod'
    icon: Maybe<Asset>
    /** @deprecated systemCode */
    id: Scalars['ID']['output']
    isVirtual: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    systemCode: BookingConsultationMethodCode
    takesRoom: Scalars['Boolean']['output']
}

export const BookingConsultationMethodCode = {
    ByPhone: 'BY_PHONE',
    InPerson: 'IN_PERSON',
    Virtual: 'VIRTUAL',
} as const

export type BookingConsultationMethodCode =
    (typeof BookingConsultationMethodCode)[keyof typeof BookingConsultationMethodCode]
export type BookingConsultationMutableFields = {
    accessibility?: InputMaybe<BookingConsultationAccessibility>
    comment?: InputMaybe<Scalars['String']['input']>
    consultant?: InputMaybe<Scalars['ID']['input']>
    consultationRoomKind?: InputMaybe<BookingConsultationRoomKind>
    description?: InputMaybe<Scalars['String']['input']>
    note?: InputMaybe<Scalars['String']['input']>
    numberOfPeople: Scalars['Int']['input']
    parent?: InputMaybe<Scalars['ID']['input']>
    partnerInvolvement?: InputMaybe<Scalars['ID']['input']>
    showroom: Scalars['ID']['input']
    startTime: Scalars['DateTime']['input']
}

export type BookingConsultationPartnerInvolvement = {
    __typename: 'BookingConsultationPartnerInvolvement'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
}

export type BookingConsultationProductDesignComplexity = {
    __typename: 'BookingConsultationProductDesignComplexity'
    code: BookingConsultationProductDesignComplexityCode
    label: Scalars['String']['output']
}

export const BookingConsultationProductDesignComplexityCode = {
    Bespoke: 'BESPOKE',
    CollectionModified: 'COLLECTION_MODIFIED',
    Idk: 'IDK',
} as const

export type BookingConsultationProductDesignComplexityCode =
    (typeof BookingConsultationProductDesignComplexityCode)[keyof typeof BookingConsultationProductDesignComplexityCode]
export type BookingConsultationPurpose = {
    __typename: 'BookingConsultationPurpose'
    /** Duration in minutes */
    duration: Scalars['Int']['output']
    icon: Maybe<Asset>
    /** @deprecated systemCode */
    id: Scalars['ID']['output']
    methods: Array<BookingConsultationMethod>
    name: Scalars['String']['output']
    requireConsultant: Scalars['Boolean']['output']
    requireOrder: Maybe<BookingConsultationPurposeOrder>
    slotLengthInMinutes: Scalars['Int']['output']
    systemCode: BookingConsultationPurposeCode
    type: BookingConsultationType
}

export const BookingConsultationPurposeCode = {
    Collection: 'COLLECTION',
    CollectionNoBreak: 'COLLECTION_NO_BREAK',
    EngagementRing: 'ENGAGEMENT_RING',
    FullService: 'FULL_SERVICE',
    FullServiceNoBreak: 'FULL_SERVICE_NO_BREAK',
    Inspection: 'INSPECTION',
    InspectionNoBreak: 'INSPECTION_NO_BREAK',
    Other: 'OTHER',
    OtherNoBreak: 'OTHER_NO_BREAK',
    QuickCollection: 'QUICK_COLLECTION',
    QuickEngagementRing: 'QUICK_ENGAGEMENT_RING',
    QuickJewellery: 'QUICK_JEWELLERY',
    QuickWeddingRing: 'QUICK_WEDDING_RING',
    Repair: 'REPAIR',
    RepairNoBreak: 'REPAIR_NO_BREAK',
    Resize: 'RESIZE',
    ResizeNoBreak: 'RESIZE_NO_BREAK',
    WeddingRing: 'WEDDING_RING',
} as const

export type BookingConsultationPurposeCode =
    (typeof BookingConsultationPurposeCode)[keyof typeof BookingConsultationPurposeCode]
export type BookingConsultationPurposeOrder = {
    __typename: 'BookingConsultationPurposeOrder'
    orders: Maybe<Array<Order>>
    statuses: Array<OrderStatus>
}

export type BookingConsultationPurposeOrderOrdersArgs = {
    customerId: InputMaybe<Scalars['ID']['input']>
}

export type BookingConsultationRescheduleInfo = {
    __typename: 'BookingConsultationRescheduleInfo'
    consultations: Array<BookingConsultation>
}

export type BookingConsultationRoom = {
    id: Scalars['ID']['output']
    isAccessible: Scalars['Boolean']['output']
    isWalkIn: Scalars['Boolean']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export const BookingConsultationRoomKind = {
    Consultation: 'CONSULTATION',
    Reception: 'RECEPTION',
} as const

export type BookingConsultationRoomKind =
    (typeof BookingConsultationRoomKind)[keyof typeof BookingConsultationRoomKind]
export type BookingConsultationSlot = {
    __typename: 'BookingConsultationSlot'
    showroom: Showroom
    startTime: Scalars['DateTime']['output']
}

export type BookingConsultationSlotInput = {
    consultant: BookingSystemConsultant
    method: BookingConsultationMethodCode
    order?: InputMaybe<Scalars['ID']['input']>
    prodcutDesignComplexity?: InputMaybe<BookingConsultationProductDesignComplexityCode>
    purpose: BookingConsultationPurposeCode
    region: RegionCode
}

export type BookingConsultationSlotsResponse = {
    __typename: 'BookingConsultationSlotsResponse'
    slots: Array<BookingConsultationSlot>
}

export const BookingConsultationState = {
    Cancelled: 'CANCELLED',
    Completed: 'COMPLETED',
    New: 'NEW',
    NoShow: 'NO_SHOW',
    Open: 'OPEN',
    Pending: 'PENDING',
    Rescheduled: 'RESCHEDULED',
} as const

export type BookingConsultationState =
    (typeof BookingConsultationState)[keyof typeof BookingConsultationState]
export const BookingConsultationTransition = {
    Cancel: 'CANCEL',
    Complete: 'COMPLETE',
    NoShow: 'NO_SHOW',
    Pending: 'PENDING',
    Reschedule: 'RESCHEDULE',
    Submit: 'SUBMIT',
    SubmitPending: 'SUBMIT_PENDING',
} as const

export type BookingConsultationTransition =
    (typeof BookingConsultationTransition)[keyof typeof BookingConsultationTransition]
export type BookingConsultationTransitionInfo = {
    __typename: 'BookingConsultationTransitionInfo'
    label: Scalars['String']['output']
    name: BookingConsultationTransition
    unavailable: Maybe<Array<Scalars['String']['output']>>
}

export type BookingConsultationType = {
    __typename: 'BookingConsultationType'
    name: Maybe<Scalars['String']['output']>
    systemCode: BookingConsultationTypeCode
}

export const BookingConsultationTypeCode = {
    Aftercare: 'AFTERCARE',
    Collection: 'COLLECTION',
    Sales: 'SALES',
} as const

export type BookingConsultationTypeCode =
    (typeof BookingConsultationTypeCode)[keyof typeof BookingConsultationTypeCode]
export type BookingCreateConsultationConsultationOrderInput = {
    order: Scalars['ID']['input']
}

export type BookingCreateConsultationErrorNoAvailableConsultants = {
    __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    message: Scalars['String']['output']
}

export type BookingCreateConsultationErrorNoAvailableConsultantsMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type BookingCreateConsultationExistingCustomerResponse =
    | BookingCreateConsultationErrorNoAvailableConsultants
    | BookingCreateConsultationSuccessExistingCustomer

export type BookingCreateConsultationInput = {
    accessibility?: InputMaybe<BookingConsultationAccessibility>
    baseInput?: InputMaybe<EnquiryBaseInput>
    comment?: InputMaybe<Scalars['String']['input']>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    consultant: BookingSystemConsultant
    description?: InputMaybe<Scalars['String']['input']>
    method: BookingConsultationMethodCode
    numberOfPeople: Scalars['Int']['input']
    orderInput?: InputMaybe<BookingCreateConsultationConsultationOrderInput>
    phone?: InputMaybe<PhoneNumberInput>
    productDesignComplexity?: InputMaybe<BookingConsultationProductDesignComplexityCode>
    purpose: BookingConsultationPurposeCode
    /** Required if purpose's type's code is SALES */
    salesConsultation?: InputMaybe<BookingCreateConsultationSalesConsultationInput>
    showroom: Scalars['ID']['input']
    startTime: Scalars['DateTime']['input']
    uri: Scalars['Uri']['input']
}

export type BookingCreateConsultationNewCustomerResponse =
    | BookingCreateConsultationErrorNoAvailableConsultants
    | BookingCreateConsultationSuccessNewCustomer

export type BookingCreateConsultationSalesConsultationInput = {
    complexity: BookingConsultationComplexityCode
}

export type BookingCreateConsultationSuccessExistingCustomer = {
    __typename: 'BookingCreateConsultationSuccessExistingCustomer'
    consultation: BookingConsultation
}

export type BookingCreateConsultationSuccessNewCustomer = {
    __typename: 'BookingCreateConsultationSuccessNewCustomer'
    consultation: BookingConsultation
    customerRegistrationResponse: CustomerRegistrationResponse
}

export type BookingInPersonConsultationRoom = BookingConsultationRoom & {
    __typename: 'BookingInPersonConsultationRoom'
    id: Scalars['ID']['output']
    isAccessible: Scalars['Boolean']['output']
    isWalkIn: Scalars['Boolean']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export const BookingSystemConsultant = {
    All: 'ALL',
    Own: 'OWN',
} as const

export type BookingSystemConsultant =
    (typeof BookingSystemConsultant)[keyof typeof BookingSystemConsultant]
export type BookingVirtualConsultationRoom = BookingConsultationRoom & {
    __typename: 'BookingVirtualConsultationRoom'
    id: Scalars['ID']['output']
    isAccessible: Scalars['Boolean']['output']
    isWalkIn: Scalars['Boolean']['output']
    kind: BookingConsultationRoomKind
    name: Scalars['String']['output']
}

export type ButtonEventTracking = {
    __typename: 'ButtonEventTracking'
    action: Maybe<Scalars['String']['output']>
    category: Maybe<Scalars['String']['output']>
    event: Scalars['String']['output']
    label: Maybe<Scalars['String']['output']>
}

export type ButtonIcon = {
    __typename: 'ButtonIcon'
    icon: Icon
    position: HorizontalAlignment
}

export const ButtonSize = {
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize]
export type ButtonStyle = {
    __typename: 'ButtonStyle'
    bottomSpacing: VerticalSpacing
    color: Color
    linkSize: Scalars['Int']['output']
    size: ButtonSize
    topSpacing: VerticalSpacing
    type: ButtonType
    width: ButtonWidth
}

export const ButtonType = {
    Bordered: 'BORDERED',
    Link: 'LINK',
    Solid: 'SOLID',
} as const

export type ButtonType = (typeof ButtonType)[keyof typeof ButtonType]
export const ButtonWidth = {
    Fixed: 'FIXED',
    Fluid: 'FLUID',
} as const

export type ButtonWidth = (typeof ButtonWidth)[keyof typeof ButtonWidth]
export type CalculateGemsApiStoneTotalSalePriceInput = {
    currency: CurrencyInput
    priceUsd: Scalars['Float']['input']
    region: RegionCode
}

export type CardCarouselCard = {
    __typename: 'CardCarouselCard'
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    image: Image
    link: Link
    title: Scalars['String']['output']
}

export type CarouselCustomProduct = {
    __typename: 'CarouselCustomProduct'
    description: Maybe<Scalars['String']['output']>
    image: Image
    link: Maybe<Link>
    title: Maybe<Scalars['String']['output']>
}

export type CatalogueAccentGem = {
    __typename: 'CatalogueAccentGem'
    id: Scalars['ID']['output']
    melee: Melee
    quantity: Scalars['Int']['output']
}

export type CatalogueAggregate = {
    __typename: 'CatalogueAggregate'
    count: Scalars['Int']['output']
}

export type CatalogueBandType = {
    __typename: 'CatalogueBandType'
    id: Scalars['ID']['output']
    translation: CatalogueBandTypeTranslation
}

export type CatalogueBandTypeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueBandTypeTranslation = {
    __typename: 'CatalogueBandTypeTranslation'
    name: Scalars['String']['output']
}

export type CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio = {
    __typename: 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio'
    product: DesignStudioProductEngagementRing
}

export type CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart =
    {
        __typename: 'CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart'
        checkoutProduct: OrderProduct
        designStudioProduct: DesignStudioProductEngagementRing
        order: Order
    }

export type CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse =
    CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer

export type CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse =
    CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer

export type CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse =
    CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer

export type CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse =
    CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer

export type CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer'
    order: Order
    product: OrderProduct
}

export type CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
    customer: CustomerRegistrationResponse
    order: Order
    product: OrderProduct
}

export type CatalogueEngagementRing = CatalogueProduct & {
    __typename: 'CatalogueEngagementRing'
    accentGemItems: Array<CatalogueAccentGem>
    bandThickness: Scalars['Float']['output']
    bandWidth: Scalars['Float']['output']
    catalogueCode: Scalars['CatalogueCode']['output']
    centreStoneConstraints: CatalogueEngagementRingCentreStoneConstraints
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    designFeatures: Array<EngagementRingDesignFeatureLabel>
    designStyle: EngagementRingDesignStyleLabel
    designerQuote: Maybe<Scalars['String']['output']>
    designerQuoteUs: Maybe<Scalars['String']['output']>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isAvailableForRingBuilder: Scalars['Boolean']['output']
    isRemoveSignatureStone: Scalars['Boolean']['output']
    isResizeable: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    meleeItems: Array<CatalogueMelee>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueEngagementRing>
    reviews: Array<Review>
    reviewsAggregate: ReviewsAggregate
    ringBuilderProducts: Array<RingBuilder>
    ringStyles: Array<EngagementRingStyleLabel>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    signatureStones: Array<CatalogueEngagementRingAndSignatureStone>
    sizes: Array<RingSizeOrRecommendedRingSize>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    supportsExpress: Scalars['Boolean']['output']
    translation: CatalogueEngagementRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueEngagementRing>
    variationsByCentreStoneShape: Array<CatalogueEngagementRing>
    variationsByPrimaryMetal: Array<CatalogueEngagementRing>
    video: Maybe<CatalogueVideo>
}

export type CatalogueEngagementRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueEngagementRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueEngagementRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueEngagementRingRingBuilderProductsArgs = {
    input: RingBuilderProductFilterInput
}

export type CatalogueEngagementRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingSizesArgs = {
    region: RegionCode
}

export type CatalogueEngagementRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueEngagementRingAndSignatureStone = {
    __typename: 'CatalogueEngagementRingAndSignatureStone'
    salePrice: SalePrice
    signatureStone: CatalogueEngagementRingSignatureStone
}

export type CatalogueEngagementRingAndSignatureStoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingCentreStoneConstraints = {
    __typename: 'CatalogueEngagementRingCentreStoneConstraints'
    shape: StoneShape
    weight: CatalogueEngagementRingCentreStoneWeightConstraint
}

export type CatalogueEngagementRingCentreStoneWeightConstraint = {
    __typename: 'CatalogueEngagementRingCentreStoneWeightConstraint'
    max: Scalars['Decimal']['output']
    min: Scalars['Decimal']['output']
}

export type CatalogueEngagementRingContainsProductsInput = {
    shape: StoneShapeCode
}

export type CatalogueEngagementRingFilterInput = {
    centreStoneShape: StoneShapeCode
    primaryMetalCode: MetalCode
    slug: Scalars['String']['input']
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueEngagementRingFilters = {
    __typename: 'CatalogueEngagementRingFilters'
    centreStoneShapes: Array<CatalogueFilterShapeItem>
    designFeatures: Array<CatalogueFilterEngagementRingDesignFeatureItem>
    designStyles: Array<CatalogueFilterEngagementRingDesingStyleItem>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    ringStyles: Array<CatalogueFilterEngagementRingStylesItem>
}

export type CatalogueEngagementRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueEngagementRingFiltersVariation = {
    __typename: 'CatalogueEngagementRingFiltersVariation'
    centreStoneShape: Maybe<StoneShapeCode>
    designFeature: Maybe<EngagementRingDesignFeatureLabelCode>
    designStyle: Maybe<EngagementRingDesignStyleLabelCode>
    primaryMetal: Maybe<MetalCode>
    ringStyle: Maybe<EngagementRingStyleLabelCode>
}

export type CatalogueEngagementRingSignatureStone = {
    __typename: 'CatalogueEngagementRingSignatureStone'
    color: StoneColor
    crystal: StoneCrystal
    id: Scalars['ID']['output']
    image: Scalars['Uri']['output']
    isDefault: Scalars['Boolean']['output']
    price: Money
    segmentName: Scalars['String']['output']
    width: Scalars['String']['output']
}

export type CatalogueEngagementRingSignatureStonePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueEngagementRingSignatureStoneInput = {
    color: StoneColorCode
    crystal: StoneCrystalCode
    width: Scalars['String']['input']
}

export type CatalogueEngagementRingTranslation = {
    __typename: 'CatalogueEngagementRingTranslation'
    description: Maybe<Scalars['String']['output']>
    locale: Scalars['Locale']['output']
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueEngagementRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    centreStoneShapes?: InputMaybe<Array<StoneShapeCode>>
    designFeatures?: InputMaybe<Array<EngagementRingDesignFeatureLabelCode>>
    designStyles?: InputMaybe<Array<EngagementRingDesignStyleLabelCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    ringStyles?: InputMaybe<Array<EngagementRingStyleLabelCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueFilterEngagementRingDesignFeatureItem = {
    __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
    label: EngagementRingDesignFeatureLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterEngagementRingDesingStyleItem = {
    __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
    label: EngagementRingDesignStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterEngagementRingStylesItem = {
    __typename: 'CatalogueFilterEngagementRingStylesItem'
    label: EngagementRingStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueFilterJewelleryBraceletProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryBraceletProductStyleLabel'
    label: JewelleryBraceletProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryDesignStyleLabel = {
    __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
    label: JewelleryDesignStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryEarringsProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryEarringsProductStyleLabel'
    label: JewelleryEarringsProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryGemstoneLabel = {
    __typename: 'CatalogueFilterJewelleryGemstoneLabel'
    label: JewelleryGemstoneLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryNecklaceProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryNecklaceProductStyleLabel'
    label: JewelleryNecklaceProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterJewelleryRingProductStyleLabel = {
    __typename: 'CatalogueFilterJewelleryRingProductStyleLabel'
    label: JewelleryRingProductStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterMetalItem = {
    __typename: 'CatalogueFilterMetalItem'
    metal: Metal
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterPriceInput = {
    currency: CurrencyInput
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
    region: RegionCode
}

export type CatalogueFilterShapeItem = {
    __typename: 'CatalogueFilterShapeItem'
    shape: StoneShape
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterWeddingRingCategoriesItem = {
    __typename: 'CatalogueFilterWeddingRingCategoriesItem'
    label: WeddingRingCategoryLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFilterWeddingRingStylesItem = {
    __typename: 'CatalogueFilterWeddingRingStylesItem'
    label: WeddingRingStyleLabel
    totalResults: Scalars['Int']['output']
}

export type CatalogueFiltersPriceInput = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueImage = {
    __typename: 'CatalogueImage'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type CatalogueImageSizeArgs = {
    name: MonolithImageSizeName
}

export type CatalogueJewelleriesBraceletsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryBraceletProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesBraceletsFiltersVariation = {
    __typename: 'CatalogueJewelleriesBraceletsFiltersVariation'
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryBraceletProductStyle>
}

export type CatalogueJewelleriesEarringsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryEarringsProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesEarringsFiltersVariation = {
    __typename: 'CatalogueJewelleriesEarringsFiltersVariation'
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryEarringsProductStyle>
}

export type CatalogueJewelleriesFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesFilters = {
    __typename: 'CatalogueJewelleriesFilters'
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
}

export type CatalogueJewelleriesFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleriesFiltersVariation = {
    __typename: 'CatalogueJewelleriesFiltersVariation'
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
}

export type CatalogueJewelleriesNecklacesFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryNecklaceProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesNecklacesFiltersVariation = {
    __typename: 'CatalogueJewelleriesNecklacesFiltersVariation'
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryNecklaceProductStyle>
}

export type CatalogueJewelleriesRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    designStyles?: InputMaybe<Array<JewelleryDesignStyle>>
    gemstones?: InputMaybe<Array<JewelleryGemstoneCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    productStyles?: InputMaybe<Array<JewelleryRingProductStyle>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleriesRingsFiltersVariation = {
    __typename: 'CatalogueJewelleriesRingsFiltersVariation'
    designStyle: Maybe<JewelleryDesignStyle>
    gemstone: Maybe<JewelleryGemstoneCode>
    primaryMetal: Maybe<MetalCode>
    productStyle: Maybe<JewelleryRingProductStyle>
}

export type CatalogueJewellery = {
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    designStyles: Array<JewelleryDesignStyleLabel>
    designerQuote: Maybe<Scalars['String']['output']>
    designerQuoteUs: Maybe<Scalars['String']['output']>
    engravingDisabled: Scalars['Boolean']['output']
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    gemstones: Array<JewelleryGemstoneLabel>
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isRemoveSignatureStone: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueProduct>
    reviews: Array<Review>
    reviewsAggregate: ReviewsAggregate
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    sku: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    supportsExpress: Scalars['Boolean']['output']
    updatedAt: Maybe<Scalars['DateTime']['output']>
    video: Maybe<CatalogueVideo>
}

export type CatalogueJewelleryFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewellerySalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBracelet = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryBracelet'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designStyles: Array<JewelleryDesignStyleLabel>
        designerQuote: Maybe<Scalars['String']['output']>
        designerQuoteUs: Maybe<Scalars['String']['output']>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isRemoveSignatureStone: Scalars['Boolean']['output']
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryBraceletProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryBracelet>
        reviews: Array<Review>
        reviewsAggregate: ReviewsAggregate
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        supportsExpress: Scalars['Boolean']['output']
        translation: CatalogueJewelleryBraceletTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryBracelet>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryBraceletDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryBraceletFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryBraceletImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryBraceletSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryBraceletTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryBraceletTranslation = {
    __typename: 'CatalogueJewelleryBraceletTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryBraceletsFilters = {
    __typename: 'CatalogueJewelleryBraceletsFilters'
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryBraceletProductStyleLabel>
}

export type CatalogueJewelleryBraceletsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryEarrings = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryEarrings'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designStyles: Array<JewelleryDesignStyleLabel>
        designerQuote: Maybe<Scalars['String']['output']>
        designerQuoteUs: Maybe<Scalars['String']['output']>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isRemoveSignatureStone: Scalars['Boolean']['output']
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryEarringsProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryEarrings>
        reviews: Array<Review>
        reviewsAggregate: ReviewsAggregate
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        supportsExpress: Scalars['Boolean']['output']
        translation: CatalogueJewelleryEarringsTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryEarrings>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryEarringsDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryEarringsFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryEarringsImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryEarringsSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryEarringsTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryEarringsFilters = {
    __typename: 'CatalogueJewelleryEarringsFilters'
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryEarringsProductStyleLabel>
}

export type CatalogueJewelleryEarringsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryEarringsTranslation = {
    __typename: 'CatalogueJewelleryEarringsTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryFilterInput = {
    primaryMetalCode: MetalCode
    slug: Scalars['String']['input']
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueJewelleryNecklace = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryNecklace'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designStyles: Array<JewelleryDesignStyleLabel>
        designerQuote: Maybe<Scalars['String']['output']>
        designerQuoteUs: Maybe<Scalars['String']['output']>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isRemoveSignatureStone: Scalars['Boolean']['output']
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryNecklaceProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryNecklace>
        reviews: Array<Review>
        reviewsAggregate: ReviewsAggregate
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        supportsExpress: Scalars['Boolean']['output']
        translation: CatalogueJewelleryNecklaceTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryNecklace>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryNecklaceDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryNecklaceFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryNecklaceImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryNecklaceSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryNecklaceTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryNecklaceTranslation = {
    __typename: 'CatalogueJewelleryNecklaceTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryNecklacesFilters = {
    __typename: 'CatalogueJewelleryNecklacesFilters'
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryNecklaceProductStyleLabel>
}

export type CatalogueJewelleryNecklacesFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueJewelleryRing = CatalogueJewellery &
    CatalogueProduct & {
        __typename: 'CatalogueJewelleryRing'
        catalogueCode: Scalars['CatalogueCode']['output']
        customTitleTag: Maybe<Scalars['String']['output']>
        deliveryDays: Scalars['Int']['output']
        designStyles: Array<JewelleryDesignStyleLabel>
        designerQuote: Maybe<Scalars['String']['output']>
        designerQuoteUs: Maybe<Scalars['String']['output']>
        engravingDisabled: Scalars['Boolean']['output']
        financeOptionsAffirm: Maybe<AffirmFinanceOption>
        financeOptionsKlarna: Maybe<KlarnaFinanceOption>
        firstAvailableDeliveryDate: DeliveryDate
        gemstones: Array<JewelleryGemstoneLabel>
        images: Array<CatalogueImage>
        images360: Array<GenericImage>
        isRemoveSignatureStone: Scalars['Boolean']['output']
        isResizeable: Scalars['Boolean']['output']
        isReturnable: Scalars['Boolean']['output']
        mainImage: Maybe<GenericImage>
        primaryMetal: Metal
        productName: Scalars['String']['output']
        productStyles: Array<JewelleryRingProductStyleLabel>
        relatedProducts: Array<CatalogueJewelleryRing>
        reviews: Array<Review>
        reviewsAggregate: ReviewsAggregate
        salePrice: SalePrice
        segmentName: Scalars['String']['output']
        signatureStone: Maybe<Melee>
        sizes: Array<RingSizeOrRecommendedRingSize>
        sku: Maybe<Scalars['String']['output']>
        slug: Scalars['String']['output']
        suffix: Scalars['String']['output']
        suffixSlug: Maybe<Scalars['String']['output']>
        supportsExpress: Scalars['Boolean']['output']
        translation: CatalogueJewelleryRingTranslation
        updatedAt: Maybe<Scalars['DateTime']['output']>
        variations: Array<CatalogueJewelleryRing>
        video: Maybe<CatalogueVideo>
    }

export type CatalogueJewelleryRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueJewelleryRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueJewelleryRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueJewelleryRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueJewelleryRingSizesArgs = {
    region: RegionCode
}

export type CatalogueJewelleryRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueJewelleryRingTranslation = {
    __typename: 'CatalogueJewelleryRingTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueJewelleryRingsFilters = {
    __typename: 'CatalogueJewelleryRingsFilters'
    designStyles: Array<CatalogueFilterJewelleryDesignStyleLabel>
    gemstones: Array<CatalogueFilterJewelleryGemstoneLabel>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    productStyles: Array<CatalogueFilterJewelleryRingProductStyleLabel>
}

export type CatalogueJewelleryRingsFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export const CatalogueJewelleryType = {
    Bracelet: 'BRACELET',
    Earrings: 'EARRINGS',
    Necklace: 'NECKLACE',
    Ring: 'RING',
} as const

export type CatalogueJewelleryType =
    (typeof CatalogueJewelleryType)[keyof typeof CatalogueJewelleryType]
export type CatalogueMelee = {
    __typename: 'CatalogueMelee'
    melee: Melee
    quantity: Scalars['Int']['output']
}

export type CataloguePriceRange = {
    __typename: 'CataloguePriceRange'
    max: Money
    min: Money
}

export type CataloguePriceRangeBar = {
    __typename: 'CataloguePriceRangeBar'
    range: CataloguePriceRange
    totalResults: Scalars['Int']['output']
}

export type CataloguePriceRangeFilter = {
    __typename: 'CataloguePriceRangeFilter'
    absoluteRange: CataloguePriceRange
    bars: Array<CataloguePriceRangeBar>
    currentRange: CataloguePriceRange
}

export type CataloguePriceRangeFilterBarsArgs = {
    input: PriceRangeBarInput
}

export type CatalogueProduct = {
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    designerQuote: Maybe<Scalars['String']['output']>
    designerQuoteUs: Maybe<Scalars['String']['output']>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    images: Array<CatalogueImage>
    isRemoveSignatureStone: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueProduct>
    reviews: Array<Review>
    reviewsAggregate: ReviewsAggregate
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    supportsExpress: Scalars['Boolean']['output']
    updatedAt: Maybe<Scalars['DateTime']['output']>
}

export type CatalogueProductFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueProductFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueProductImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueProductSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const CatalogueProductType = {
    EngagementRing: 'ENGAGEMENT_RING',
    Jewellery: 'JEWELLERY',
    JewelleryBracelet: 'JEWELLERY_BRACELET',
    JewelleryEarrings: 'JEWELLERY_EARRINGS',
    JewelleryNecklace: 'JEWELLERY_NECKLACE',
    JewelleryRing: 'JEWELLERY_RING',
    ReadyToGo: 'READY_TO_GO',
    WeddingRing: 'WEDDING_RING',
} as const

export type CatalogueProductType =
    (typeof CatalogueProductType)[keyof typeof CatalogueProductType]
export type CatalogueReadyToGoRing = CatalogueProduct & {
    __typename: 'CatalogueReadyToGoRing'
    carat: Maybe<Scalars['Float']['output']>
    catalogueCode: Scalars['CatalogueCode']['output']
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    designerQuote: Maybe<Scalars['String']['output']>
    designerQuoteUs: Maybe<Scalars['String']['output']>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    gemType: GemType
    images: Array<CatalogueImage>
    isReadyToShip: Scalars['Boolean']['output']
    isRemoveSignatureStone: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueReadyToGoRing>
    reviews: Array<Review>
    reviewsAggregate: ReviewsAggregate
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    shortDescription: Maybe<Scalars['String']['output']>
    shortName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    sizes: Array<RecommendedRingSize>
    sku: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    supportsExpress: Scalars['Boolean']['output']
    translation: CatalogueReadyToGoRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueReadyToGoRing>
}

export type CatalogueReadyToGoRingDeliveryDaysArgs = {
    region: InputMaybe<RegionCode>
}

export type CatalogueReadyToGoRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingFirstAvailableDeliveryDateArgs = {
    region: RegionCode
}

export type CatalogueReadyToGoRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueReadyToGoRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueReadyToGoRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueReadyToGoRingFilterInput = {
    primaryMetalCode: MetalCode
    slug: Scalars['String']['input']
}

export type CatalogueReadyToGoRingFilters = {
    __typename: 'CatalogueReadyToGoRingFilters'
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
}

export type CatalogueReadyToGoRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueReadyToGoRingTranslation = {
    __typename: 'CatalogueReadyToGoRingTranslation'
    description: Maybe<Scalars['String']['output']>
    seoText: Maybe<Scalars['String']['output']>
}

export type CatalogueReadyToGoRingsFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    readyToShip?: InputMaybe<Scalars['Boolean']['input']>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueSortInput = {
    by: CatalogueSortOrder
    currency: CurrencyInput
}

export const CatalogueSortOrder = {
    ExpressDelivery: 'EXPRESS_DELIVERY',
    PriceAscending: 'PRICE_ASCENDING',
    PriceDescending: 'PRICE_DESCENDING',
    Recommended: 'RECOMMENDED',
} as const

export type CatalogueSortOrder =
    (typeof CatalogueSortOrder)[keyof typeof CatalogueSortOrder]
export type CatalogueVideo = {
    __typename: 'CatalogueVideo'
    type: Scalars['String']['output']
    uri: Scalars['Uri']['output']
}

export type CatalogueWeddingRing = CatalogueProduct & {
    __typename: 'CatalogueWeddingRing'
    accentGemItems: Array<CatalogueAccentGem>
    bandThickness: Scalars['Float']['output']
    bandType: Maybe<CatalogueBandType>
    bandWidth: Scalars['Float']['output']
    catalogueCode: Scalars['CatalogueCode']['output']
    categories: Array<WeddingRingCategoryLabel>
    customTitleTag: Maybe<Scalars['String']['output']>
    deliveryDays: Scalars['Int']['output']
    designerQuote: Maybe<Scalars['String']['output']>
    designerQuoteUs: Maybe<Scalars['String']['output']>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    firstAvailableDeliveryDate: DeliveryDate
    images: Array<CatalogueImage>
    images360: Array<GenericImage>
    isRemoveSignatureStone: Scalars['Boolean']['output']
    isResizeable: Scalars['Boolean']['output']
    isReturnable: Scalars['Boolean']['output']
    mainImage: Maybe<GenericImage>
    meleeItems: Array<CatalogueMelee>
    primaryMetal: Metal
    productName: Scalars['String']['output']
    relatedProducts: Array<CatalogueWeddingRing>
    reviews: Array<Review>
    reviewsAggregate: ReviewsAggregate
    ringStyles: Array<WeddingRingStyleLabel>
    salePrice: SalePrice
    segmentName: Scalars['String']['output']
    signatureStone: Maybe<Melee>
    sizes: Array<RingSizeOrRecommendedRingSize>
    slug: Scalars['String']['output']
    suffix: Maybe<Scalars['String']['output']>
    suffixSlug: Maybe<Scalars['String']['output']>
    supportsExpress: Scalars['Boolean']['output']
    translation: CatalogueWeddingRingTranslation
    updatedAt: Maybe<Scalars['DateTime']['output']>
    variations: Array<CatalogueWeddingRing>
    video: Maybe<CatalogueVideo>
}

export type CatalogueWeddingRingDeliveryDaysArgs = {
    hasEngraving: InputMaybe<Scalars['Boolean']['input']>
    region: InputMaybe<RegionCode>
}

export type CatalogueWeddingRingFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingFirstAvailableDeliveryDateArgs = {
    hasEngraving: Scalars['Boolean']['input']
    region: RegionCode
}

export type CatalogueWeddingRingImagesArgs = {
    limit: InputMaybe<Scalars['Int']['input']>
}

export type CatalogueWeddingRingSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type CatalogueWeddingRingSizesArgs = {
    region: RegionCode
}

export type CatalogueWeddingRingTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type CatalogueWeddingRingFilterInput = {
    catalogueCode?: InputMaybe<Scalars['CatalogueCode']['input']>
    catalogueCodes?: InputMaybe<Array<Scalars['CatalogueCode']['input']>>
    categories?: InputMaybe<Array<WeddingRingCategoryLabelCode>>
    includeHiddenFromProductList?: InputMaybe<Scalars['Boolean']['input']>
    price?: InputMaybe<CatalogueFilterPriceInput>
    primaryMetalCodes?: InputMaybe<Array<MetalCode>>
    ringStyles?: InputMaybe<Array<WeddingRingStyleLabelCode>>
    search?: InputMaybe<Scalars['String']['input']>
    slug?: InputMaybe<Scalars['String']['input']>
    suffixSlug?: InputMaybe<Scalars['String']['input']>
}

export type CatalogueWeddingRingFilters = {
    __typename: 'CatalogueWeddingRingFilters'
    categories: Array<CatalogueFilterWeddingRingCategoriesItem>
    price: CataloguePriceRangeFilter
    primaryMetals: Array<CatalogueFilterMetalItem>
    ringStyles: Array<CatalogueFilterWeddingRingStylesItem>
}

export type CatalogueWeddingRingFiltersPriceArgs = {
    input: CatalogueFiltersPriceInput
}

export type CatalogueWeddingRingFiltersVariation = {
    __typename: 'CatalogueWeddingRingFiltersVariation'
    category: Maybe<WeddingRingCategoryLabelCode>
    primaryMetal: Maybe<MetalCode>
    ringStyle: Maybe<WeddingRingStyleLabelCode>
}

export type CatalogueWeddingRingTranslation = {
    __typename: 'CatalogueWeddingRingTranslation'
    description: Maybe<Scalars['String']['output']>
    locale: Scalars['Locale']['output']
    seoText: Maybe<Scalars['String']['output']>
}

export type CheckoutcomOperationDeclinedError = {
    __typename: 'CheckoutcomOperationDeclinedError'
    message: Scalars['String']['output']
}

export type CheckoutcomPaymentMethod = {
    __typename: 'CheckoutcomPaymentMethod'
    debugMode: Scalars['Boolean']['output']
    publicKey: Scalars['String']['output']
    systemCode: Scalars['ID']['output']
}

export type CheckoutcomTransaction = TransactionInterface & {
    __typename: 'CheckoutcomTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export const CmsEnquiryFormType = {
    BlogPost: 'BLOG_POST',
    EngagementRing: 'ENGAGEMENT_RING',
    EngagementRingBrowse: 'ENGAGEMENT_RING_BROWSE',
    EngagementRingImageAttachedLanding:
        'ENGAGEMENT_RING_IMAGE_ATTACHED_LANDING',
    JewelleryProductLandingGeneric: 'JEWELLERY_PRODUCT_LANDING_GENERIC',
    LocationSignup: 'LOCATION_SIGNUP',
    WeddingRing: 'WEDDING_RING',
    WeddingRingBespokeLanding: 'WEDDING_RING_BESPOKE_LANDING',
} as const

export type CmsEnquiryFormType =
    (typeof CmsEnquiryFormType)[keyof typeof CmsEnquiryFormType]
export const CmsGemstoneColorCode = {
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type CmsGemstoneColorCode =
    (typeof CmsGemstoneColorCode)[keyof typeof CmsGemstoneColorCode]
export type CollectFromShowroomInput = {
    billingAddress: OrderBillingAddressInput
    deliveryData: OrderCollectFromShowroomDeliveryInput
    orderId: Scalars['ID']['input']
    showroomID: Scalars['ID']['input']
}

export const Color = {
    Blue: 'BLUE',
    Blush: 'BLUSH',
    Green: 'GREEN',
    Red: 'RED',
    Sage: 'SAGE',
    Slate: 'SLATE',
    Stone: 'STONE',
    Stone2: 'STONE2',
    Stone3: 'STONE3',
    Taaffeite: 'TAAFFEITE',
    White: 'WHITE',
} as const

export type Color = (typeof Color)[keyof typeof Color]
export type CommissionJunctionInput = {
    code: Scalars['String']['input']
}

export type CompleteCheckoutcomTransactionInput = {
    checkoutcomTransactionId: Scalars['ID']['input']
    ckoId: Scalars['String']['input']
}

export type CompleteCheckoutcomTransactionPost3dsError =
    | CheckoutcomOperationDeclinedError
    | DesiredDeliveryDateInvalidError
    | OrderAlreadyCompletedError
    | PaymentAmountInvalidError

export type CompleteCheckoutcomTransactionPost3dsFailureResponse = {
    __typename: 'CompleteCheckoutcomTransactionPost3dsFailureResponse'
    errors: Array<CompleteCheckoutcomTransactionPost3dsError>
}

export type CompleteCheckoutcomTransactionPost3dsResponse =
    | CompleteCheckoutcomTransactionPost3dsFailureResponse
    | CompleteCheckoutcomTransactionPost3dsSuccessResponse

export type CompleteCheckoutcomTransactionPost3dsSuccessResponse = {
    __typename: 'CompleteCheckoutcomTransactionPost3dsSuccessResponse'
    order: Order
}

export type Component =
    | ComponentArticleGrid
    | ComponentArticlePreviews
    | ComponentBannerSkinny
    | ComponentBannerTitle
    | ComponentCard
    | ComponentCardCarousel
    | ComponentCatalogueProductCarousel
    | ComponentContent
    | ComponentContentTwoColumns
    | ComponentContentWithGallery
    | ComponentCustomProductCarousel
    | ComponentFaq
    | ComponentFullWidthImage
    | ComponentGalleryCarousel
    | ComponentGalleryWithEnquiry
    | ComponentGlobalComponent
    | ComponentGlobalSpacer
    | ComponentIconCarousel
    | ComponentInstagramPosts
    | ComponentInstagramWithContent
    | ComponentJobs
    | ComponentLogos
    | ComponentLogosCarousel
    | ComponentLogosWithText
    | ComponentMainCover
    | ComponentOnThisPage
    | ComponentQuote
    | ComponentRelatedProducts
    | ComponentReviewCarousel
    | ComponentRoundedImage
    | ComponentRoundedImageContent
    | ComponentShopWithConfidence
    | ComponentSideBySideImages
    | ComponentSquareBoxes
    | ComponentTable
    | ComponentTextCarousel
    | ComponentTextOverImage
    | ComponentTextWithImage
    | ComponentTextWithImageCarousel
    | ComponentVideo
    | ComponentVideoWithContent
    | ComponentWarrantyActivationForm

export type ComponentArticleGrid = {
    __typename: 'ComponentArticleGrid'
    articles: Array<ArticleGridItem>
}

export type ComponentArticleGridArticlesArgs = {
    locale: Scalars['Locale']['input']
}

export type ComponentArticlePreviews = {
    __typename: 'ComponentArticlePreviews'
    articles: Array<ArticlePreview>
}

export type ComponentArticlePreviewsArticlesArgs = {
    locale: Scalars['Locale']['input']
}

export type ComponentBannerSkinny = {
    __typename: 'ComponentBannerSkinny'
    backgroundColor: Color
    backgroundGraphic: Maybe<BannerSkinnyBackgroundGraphic>
    backgroundImage: Maybe<Image>
    title: ComponentTitle
    useBackgroundImage: Maybe<Scalars['Boolean']['output']>
}

export type ComponentBannerTitle = {
    __typename: 'ComponentBannerTitle'
    date: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    image: Image
    tag: HtmlTag
    title: Scalars['String']['output']
}

export type ComponentButton = {
    __typename: 'ComponentButton'
    alignment: HorizontalAlignment
    eventTracking: Maybe<ButtonEventTracking>
    icon: Maybe<ButtonIcon>
    link: Link
    style: ButtonStyle
    text: Scalars['String']['output']
}

export type ComponentCard = {
    __typename: 'ComponentCard'
    backgroundColor: Color
    content: Array<ContentComponentItem>
    image: Maybe<Image>
}

export type ComponentCardCarousel = {
    __typename: 'ComponentCardCarousel'
    items: Array<CardCarouselCard>
}

export type ComponentCatalogueProductCarousel = {
    __typename: 'ComponentCatalogueProductCarousel'
    items: Array<ComponentCatalogueProductCarouselItem>
}

export type ComponentCatalogueProductCarouselItem = {
    __typename: 'ComponentCatalogueProductCarouselItem'
    catalogueCode: Scalars['String']['output']
    product: Maybe<CatalogueProduct>
}

export type ComponentContent = {
    __typename: 'ComponentContent'
    content: Array<ContentComponentItem>
}

export type ComponentContentTwoColumns = {
    __typename: 'ComponentContentTwoColumns'
    leftColumnBackgroundColor: Color
    leftColumnContent: Array<ContentComponentItem>
    rightColumnBackgroundColor: Color
    rightColumnContent: Array<ContentComponentItem>
}

export type ComponentContentWithGallery = {
    __typename: 'ComponentContentWithGallery'
    content: Array<ContentComponentItem>
    gallery: Array<GalleryItem>
}

export type ComponentCustomProductCarousel = {
    __typename: 'ComponentCustomProductCarousel'
    products: Array<CarouselCustomProduct>
}

export type ComponentFaq = {
    __typename: 'ComponentFaq'
    sections: Array<FaqSection>
    showNavigation: Scalars['Boolean']['output']
}

export type ComponentFullWidthImage = {
    __typename: 'ComponentFullWidthImage'
    image: Image
    link: Maybe<Link>
    width: ImageWidth
}

export type ComponentGalleryCarousel = {
    __typename: 'ComponentGalleryCarousel'
    items: Array<GalleryCarouselCard>
}

export type ComponentGalleryWithEnquiry = {
    __typename: 'ComponentGalleryWithEnquiry'
    buttonText: Maybe<Scalars['String']['output']>
    items: Array<GalleryWithEnquiryCard>
    loadMoreButtonText: Maybe<Scalars['String']['output']>
    modalButtonText: Maybe<Scalars['String']['output']>
    modalType: CmsEnquiryFormType
    type: CmsEnquiryFormType
}

export type ComponentGlobalComponent = {
    __typename: 'ComponentGlobalComponent'
    backgroundColor: Color
    components: Array<Component>
}

export type ComponentGlobalSpacer = {
    __typename: 'ComponentGlobalSpacer'
    spacing: Spacing
}

export type ComponentIconCarousel = {
    __typename: 'ComponentIconCarousel'
    items: Array<IconCarouselItem>
}

export type ComponentImage = {
    __typename: 'ComponentImage'
    image: Image
}

export type ComponentInstagramPosts = {
    __typename: 'ComponentInstagramPosts'
    instagramUser: Scalars['String']['output']
    instagramUserLink: Scalars['String']['output']
    posts: Array<InstagramPost>
    preTitle: Maybe<Scalars['String']['output']>
    title: ComponentTitle
}

export type ComponentInstagramWithContent = {
    __typename: 'ComponentInstagramWithContent'
    content: Maybe<Array<ContentComponentItem>>
    instagramEmbedCode: Maybe<Scalars['String']['output']>
    instagramImage: Maybe<Image>
    instagramLink: Maybe<Scalars['String']['output']>
    instagramPosition: ImagePosition
    instagramUsername: Maybe<Scalars['String']['output']>
    useImage: Maybe<Scalars['Boolean']['output']>
    width: InstagramWithContentWidth
}

export type ComponentJobs = {
    __typename: 'ComponentJobs'
    jobs: Array<Job>
}

export type ComponentLogos = {
    __typename: 'ComponentLogos'
    logos: Array<Logo>
}

export type ComponentLogosCarousel = {
    __typename: 'ComponentLogosCarousel'
    logos: Array<Logo>
}

export type ComponentLogosWithText = {
    __typename: 'ComponentLogosWithText'
    logos: Array<LogoWithText>
}

export type ComponentMainCover = {
    __typename: 'ComponentMainCover'
    background: ComponentMainCoverBackground
    content: Array<ContentComponentItem>
    height: ComponentMainCoverHeight
    overlay: ComponentMainCoverBackgroundOverlay
    width: ComponentMainCoverWidth
}

export type ComponentMainCoverBackground =
    | ComponentMainCoverBackgroundImage
    | ComponentMainCoverBackgroundVideo

export type ComponentMainCoverBackgroundImage = {
    __typename: 'ComponentMainCoverBackgroundImage'
    backgroundImage: Image
    mobileBackgroundImage: Image
}

export const ComponentMainCoverBackgroundOverlay = {
    GradientBottomToTop: 'GRADIENT_BOTTOM_TO_TOP',
    GradientTopToBottom: 'GRADIENT_TOP_TO_BOTTOM',
    None: 'NONE',
    Solid: 'SOLID',
} as const

export type ComponentMainCoverBackgroundOverlay =
    (typeof ComponentMainCoverBackgroundOverlay)[keyof typeof ComponentMainCoverBackgroundOverlay]
export type ComponentMainCoverBackgroundVideo = {
    __typename: 'ComponentMainCoverBackgroundVideo'
    cover: Image
    mobileCover: Image
    video: Video
}

export const ComponentMainCoverHeight = {
    Default: 'DEFAULT',
    Short: 'SHORT',
    Tall: 'TALL',
} as const

export type ComponentMainCoverHeight =
    (typeof ComponentMainCoverHeight)[keyof typeof ComponentMainCoverHeight]
export const ComponentMainCoverWidth = {
    ContentWidth: 'CONTENT_WIDTH',
    Full: 'FULL',
    Normal: 'NORMAL',
} as const

export type ComponentMainCoverWidth =
    (typeof ComponentMainCoverWidth)[keyof typeof ComponentMainCoverWidth]
export type ComponentOnThisPage = {
    __typename: 'ComponentOnThisPage'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentOrderedList = {
    __typename: 'ComponentOrderedList'
    items: Array<OrderedListItem>
}

export type ComponentQuote = {
    __typename: 'ComponentQuote'
    author: Maybe<Scalars['String']['output']>
    hasBackgroundImage: Scalars['Boolean']['output']
    image: Maybe<Image>
    quote: Scalars['String']['output']
    showQuotationMarks: Scalars['Boolean']['output']
    size: QuoteSize
}

export type ComponentRelatedProducts = {
    __typename: 'ComponentRelatedProducts'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentReviewCarousel = {
    __typename: 'ComponentReviewCarousel'
    reviews: Array<ReviewCarouselCard>
}

export type ComponentRoundedImage = {
    __typename: 'ComponentRoundedImage'
    backgroundColor: Color
    backgroundImage: Maybe<Image>
    backgroundImageColor: Color
    roundedImage: Image
}

export type ComponentRoundedImageContent = {
    __typename: 'ComponentRoundedImageContent'
    content: Array<ContentComponentItem>
    roundedImage: ComponentRoundedImage
}

export type ComponentShopWithConfidence = {
    __typename: 'ComponentShopWithConfidence'
    components: Array<ShopWithConfidenceComponent>
    ethnicallySourcedDiamonds: Array<ContentComponentItem>
    financingOptions: Array<ContentComponentItem>
    greenlandRuby: Array<ContentComponentItem>
    handFinished: Array<ContentComponentItem>
    resize: Array<ContentComponentItem>
    returnPolicy: Array<ContentComponentItem>
    shipping: Array<ContentComponentItem>
    title: Maybe<ComponentTitle>
}

export type ComponentSideBySideImage = {
    __typename: 'ComponentSideBySideImage'
    caption: Maybe<Scalars['String']['output']>
    content: Array<ContentComponentItem>
    image: Image
    link: Maybe<Link>
}

export type ComponentSideBySideImages = {
    __typename: 'ComponentSideBySideImages'
    images: Array<ComponentSideBySideImage>
}

export type ComponentSpacer = {
    __typename: 'ComponentSpacer'
    spacing: Spacing
}

export type ComponentSquareBoxes = {
    __typename: 'ComponentSquareBoxes'
    items: Array<SquareBoxes>
}

export type ComponentTable = {
    __typename: 'ComponentTable'
    table: Maybe<Table>
}

export type ComponentText = {
    __typename: 'ComponentText'
    alignment: HorizontalAlignment
    text: Scalars['String']['output']
    textSize: TextSize
}

export type ComponentTextCarousel = {
    __typename: 'ComponentTextCarousel'
    items: Array<TextCarouselItem>
}

export type ComponentTextOverImage = {
    __typename: 'ComponentTextOverImage'
    content: Array<ContentComponentItem>
    image: Image
}

export type ComponentTextWithImage = {
    __typename: 'ComponentTextWithImage'
    content: Array<ContentComponentItem>
    image: Image
    imageFormat: ImageFormat
    imagePosition: ImagePosition
    padding: Padding
}

export type ComponentTextWithImageCarousel = {
    __typename: 'ComponentTextWithImageCarousel'
    slidePadding: SlidePadding
    slides: Array<ComponentTextWithImage>
}

export type ComponentTitle = {
    __typename: 'ComponentTitle'
    alignment: HorizontalAlignment
    color: Color
    tag: HtmlTag
    /** @deprecated use texts */
    text: Scalars['String']['output']
    texts: Array<ComponentTitleComponent>
    titleSize: TitleSize
    titleStyle: TitleStyle
    titleWidth: TitleWidth
}

export type ComponentTitleAmpersand = {
    __typename: 'ComponentTitleAmpersand'
    null: Maybe<Scalars['String']['output']>
}

export type ComponentTitleComponent =
    | ComponentTitleAmpersand
    | ComponentTitleText

export type ComponentTitleText = {
    __typename: 'ComponentTitleText'
    text: Scalars['String']['output']
}

export type ComponentVideo = {
    __typename: 'ComponentVideo'
    video: Video
    width: VideoWidth
}

export type ComponentVideoWithContent = {
    __typename: 'ComponentVideoWithContent'
    content: Array<ContentComponentItem>
    coverImage: Image
    video: Video
    videoPosition: VideoPosition
}

export type ComponentWarrantyActivationForm = {
    __typename: 'ComponentWarrantyActivationForm'
    null: Maybe<Scalars['String']['output']>
}

export type Consultant = {
    __typename: 'Consultant'
    /** @deprecated use avatarImage */
    avatar: Scalars['Uri']['output']
    avatarImage: GenericImage
    canTakeConsultations: Scalars['Boolean']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    isCustomerFacing: Scalars['Boolean']['output']
    showroom: Maybe<Showroom>
    user: User
}

export type ContentComponentItem =
    | ComponentButton
    | ComponentImage
    | ComponentOrderedList
    | ComponentSpacer
    | ComponentText
    | ComponentTitle

export type ConvertMoneyInput = {
    money: MoneyInput
    targetCurrency: Scalars['Currency']['input']
}

export type ConvertPriceBoundsForGems = {
    currency: CurrencyInput
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
    region: RegionCode
}

export type CreateCheckoutcomTransactionError =
    | AvataxAddressInvalidError
    | DesiredDeliveryDateInvalidError
    | OrderAddressNotConfirmedError
    | OrderAlreadyCompletedError
    | OrderEmptyError
    | PaymentAmountInvalidError
    | PaymentMethodNotAllowedError

export type CreateCheckoutcomTransactionFailureResponse = {
    __typename: 'CreateCheckoutcomTransactionFailureResponse'
    errors: Array<CreateCheckoutcomTransactionError>
}

export type CreateCheckoutcomTransactionInput = {
    cardToken: Scalars['String']['input']
    orderId: Scalars['ID']['input']
}

export type CreateCheckoutcomTransactionResponse =
    | CreateCheckoutcomTransactionFailureResponse
    | CreateCheckoutcomTransactionSuccessResponse

export type CreateCheckoutcomTransactionSuccessResponse = {
    __typename: 'CreateCheckoutcomTransactionSuccessResponse'
    transaction: CheckoutcomTransaction
}

export type CreateCustomerByConsultantInput = {
    consultantAutoAssign?: InputMaybe<Scalars['Boolean']['input']>
    customer?: InputMaybe<CustomerRegistrationInput>
    purchaseType?: InputMaybe<PurchaseType>
}

export type CredentialsInput = {
    identifier: Scalars['Email']['input']
    password: Scalars['String']['input']
}

export type CurrencyInput = {
    currency?: InputMaybe<Scalars['Currency']['input']>
    region: RegionCode
}

export type Customer = {
    __typename: 'Customer'
    adminProfileUrl: Maybe<Scalars['Uri']['output']>
    billingAddress: Maybe<Address>
    bookingRescheduleInfo: Maybe<BookingConsultationRescheduleInfo>
    cart: Order
    consultant: Maybe<Consultant>
    designInspiration: Maybe<DesignInspiration>
    designStudioProduct: Maybe<DesignStudioProduct>
    designStudioProducts: Array<DesignStudioProduct>
    disabledThirdPartyCookies: Scalars['Boolean']['output']
    discoveryData: Maybe<CustomerDiscoveryData>
    engagementRingRecommendations: Maybe<UserCustomerEngagementRingRecommendations>
    enquiries: Array<Enquiry>
    id: Scalars['ID']['output']
    isConsultantChangeable: Scalars['Boolean']['output']
    note: Maybe<Scalars['String']['output']>
    order: Maybe<Order>
    orders: Array<Order>
    ordersByConsultationPurpose: Array<Order>
    questionnaireByType: Maybe<QuestionnaireCompletedQuestionnaire>
    referrer: Maybe<Customer>
    retailCart: Order
    salesforceProfileUrl: Maybe<Scalars['Uri']['output']>
    shippingAddress: Maybe<Address>
    user: User
}

export type CustomerDesignStudioProductArgs = {
    id: Scalars['ID']['input']
}

export type CustomerIsConsultantChangeableArgs = {
    purpose: BookingConsultationPurposeCode
}

export type CustomerOrderArgs = {
    id: Scalars['ID']['input']
}

export type CustomerOrdersByConsultationPurposeArgs = {
    purpose: BookingConsultationPurposeCode
}

export type CustomerQuestionnaireByTypeArgs = {
    type: QuestionnaireType
}

export type CustomerCreatedByConsultant = {
    __typename: 'CustomerCreatedByConsultant'
    customer: Customer
    isNew: Scalars['Boolean']['output']
}

export type CustomerDiscoveryData = {
    __typename: 'CustomerDiscoveryData'
    partnerInvolvement: Maybe<CustomerDiscoveryDataQuestionOption>
    referralSource: Maybe<CustomerDiscoveryDataQuestionOption>
    referralSourceOther: Maybe<Scalars['String']['output']>
}

export type CustomerDiscoveryDataQuestionOption = {
    __typename: 'CustomerDiscoveryDataQuestionOption'
    id: Scalars['ID']['output']
    label: Scalars['String']['output']
}

export type CustomerPromoCode = {
    __typename: 'CustomerPromoCode'
    deletable: Scalars['Boolean']['output']
    id: Scalars['ID']['output']
    promoCode: BasePromoCode
}

export type CustomerReferralInput = {
    code: Scalars['String']['input']
}

export type CustomerReferralResult =
    | CustomerSetReferralError
    | CustomerSetReferralSuccess

export type CustomerRegistrationByAppleInput = {
    code: Scalars['String']['input']
    currency: CurrencyInput
    firstName?: InputMaybe<Scalars['String']['input']>
    forgottenPasswordUrl?: InputMaybe<Scalars['Uri']['input']>
    lastName?: InputMaybe<Scalars['String']['input']>
    phone?: InputMaybe<PhoneNumberInput>
    region: RegionCode
}

export type CustomerRegistrationByFacebookInput = {
    accessToken: Scalars['String']['input']
    currency: CurrencyInput
    forgottenPasswordUrl?: InputMaybe<Scalars['Uri']['input']>
    phone?: InputMaybe<PhoneNumberInput>
    region: RegionCode
}

export type CustomerRegistrationByGoogleInput = {
    currency: CurrencyInput
    forgottenPasswordUrl?: InputMaybe<Scalars['Uri']['input']>
    phone?: InputMaybe<PhoneNumberInput>
    region: RegionCode
    token: Scalars['String']['input']
}

export type CustomerRegistrationByManualInput = {
    currency: CurrencyInput
    email: Scalars['Email']['input']
    emailConsent: Scalars['Boolean']['input']
    firstName: Scalars['String']['input']
    forgottenPasswordUrl?: InputMaybe<Scalars['Uri']['input']>
    lastName?: InputMaybe<Scalars['String']['input']>
    phone?: InputMaybe<PhoneNumberInput>
    privacyConsent: Scalars['Boolean']['input']
    region: RegionCode
    username?: InputMaybe<Scalars['String']['input']>
}

export type CustomerRegistrationInput = {
    byApple?: InputMaybe<CustomerRegistrationByAppleInput>
    byFacebook?: InputMaybe<CustomerRegistrationByFacebookInput>
    byGoogle?: InputMaybe<CustomerRegistrationByGoogleInput>
    byManual?: InputMaybe<CustomerRegistrationByManualInput>
}

export type CustomerRegistrationResponse = {
    __typename: 'CustomerRegistrationResponse'
    login: Maybe<LoginResponseSuccess>
}

export type CustomerSetDiscoveryDataInput = {
    partnerInvolvement?: InputMaybe<Scalars['ID']['input']>
    referralSource: CustomerSetDiscoveryDataReferralSourceInput
}

export type CustomerSetDiscoveryDataReferralSourceInput = {
    id?: InputMaybe<Scalars['ID']['input']>
    other?: InputMaybe<Scalars['String']['input']>
}

export type CustomerSetNoteInput = {
    note: Scalars['String']['input']
}

export type CustomerSetReferralError = {
    __typename: 'CustomerSetReferralError'
    message: Scalars['String']['output']
}

export type CustomerSetReferralSuccess = {
    __typename: 'CustomerSetReferralSuccess'
    customer: Customer
}

export const CustomerSort = {
    LatestRegistered: 'LATEST_REGISTERED',
} as const

export type CustomerSort = (typeof CustomerSort)[keyof typeof CustomerSort]
export type CustomersFiltersInput = {
    searchTerm?: InputMaybe<Scalars['String']['input']>
}

export type CustomersResult = {
    __typename: 'CustomersResult'
    customers: Array<Customer>
    total: Scalars['Int']['output']
}

export type CustomersResultCustomersArgs = {
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CustomerSort>
}

export type DeliverToAddressInput = {
    /** null billingAddress signifies that billing address is the same as shipping address */
    billingAddress?: InputMaybe<OrderBillingAddressInput>
    /** null desiredDeliveryDate means ASAR */
    desiredDeliveryDate?: InputMaybe<Scalars['DateTime']['input']>
    orderId: Scalars['ID']['input']
    shippingAddress: OrderShipToAddressInput
}

export type DeliveryDate = {
    __typename: 'DeliveryDate'
    date: Scalars['DateTime']['output']
    validUntil: Scalars['DateTime']['output']
}

export type DesignInspiration = {
    __typename: 'DesignInspiration'
    id: Scalars['ID']['output']
    url: Scalars['String']['output']
}

export type DesignStudioCentreStone =
    | DesignStudioExternalCentreStone
    | DesignStudioInternalCentreStone

export type DesignStudioEngagementRingCentreStone = {
    __typename: 'DesignStudioEngagementRingCentreStone'
    approved: Scalars['Boolean']['output']
    comment: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    originalSalePrice: Money
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    salePrice: Money
    stone: DesignStudioCentreStone
}

export type DesignStudioEngagementRingError =
    | DesignStudioEngagementRingErrorGeneric
    | DesignStudioEngagementRingErrorMaxCaratWeight
    | DesignStudioEngagementRingErrorMinCaratWeight
    | DesignStudioEngagementRingErrorShapeMismatch

export type DesignStudioEngagementRingErrorGeneric = {
    __typename: 'DesignStudioEngagementRingErrorGeneric'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorGenericMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorMaxCaratWeight = {
    __typename: 'DesignStudioEngagementRingErrorMaxCaratWeight'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorMaxCaratWeightMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorMinCaratWeight = {
    __typename: 'DesignStudioEngagementRingErrorMinCaratWeight'
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorMinCaratWeightMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingErrorShapeMismatch = {
    __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
    matchingVariation: Maybe<CatalogueEngagementRing>
    message: Scalars['String']['output']
}

export type DesignStudioEngagementRingErrorShapeMismatchMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type DesignStudioEngagementRingFailure = {
    __typename: 'DesignStudioEngagementRingFailure'
    errors: Array<DesignStudioEngagementRingError>
}

export type DesignStudioEngagementRingMount = {
    __typename: 'DesignStudioEngagementRingMount'
    approved: Scalars['Boolean']['output']
    comment: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    melees: Array<DesignStudioMeleeItem>
    metals: Array<Metal>
    originalSalePrice: Money
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    salePrice: Money
    sideStones: Array<DesignStudioSideStone>
    signatureStones: Array<DesignStudioSignatureStone>
}

export type DesignStudioExternalCentreStone = {
    __typename: 'DesignStudioExternalCentreStone'
    crystal: Maybe<StoneCrystal>
    id: Scalars['ID']['output']
    weight: Maybe<Scalars['Decimal']['output']>
}

export type DesignStudioExternalSideStone = {
    __typename: 'DesignStudioExternalSideStone'
    crystal: Maybe<StoneCrystal>
    id: Scalars['ID']['output']
    weight: Maybe<Scalars['Decimal']['output']>
}

export type DesignStudioInternalCentreStone = {
    __typename: 'DesignStudioInternalCentreStone'
    id: Scalars['ID']['output']
    nonSku: Maybe<HistoricalNonSku>
    sku: Maybe<Stone>
}

export type DesignStudioInternalSideStone = {
    __typename: 'DesignStudioInternalSideStone'
    id: Scalars['ID']['output']
    item: DesignStudioSideStoneItem
    quantity: Scalars['Int']['output']
}

export type DesignStudioJewelleryInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueJewelleryCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    engraving?: InputMaybe<Scalars['String']['input']>
    ringSize?: InputMaybe<RingSizeInput>
    uri: Scalars['Uri']['input']
}

export type DesignStudioMeleeItem = {
    __typename: 'DesignStudioMeleeItem'
    id: Scalars['ID']['output']
    melee: Melee
    quantity: Scalars['Int']['output']
}

export type DesignStudioProduct = {
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductAdditionalResize = DesignStudioProduct & {
    __typename: 'DesignStudioProductAdditionalResize'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductCustom = DesignStudioProduct & {
    __typename: 'DesignStudioProductCustom'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductEngagementRing = DesignStudioProduct & {
    __typename: 'DesignStudioProductEngagementRing'
    availableSizes: Array<RingSizeOrRecommendedRingSize>
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    engraving: Maybe<Scalars['String']['output']>
    finalQuotation: Maybe<QuotationEngagementRing>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<QuotationEngagementRing>
    size: Maybe<RingSizeOrRecommendedRingSize>
}

export type DesignStudioProductEngagementRingUpdate = {
    engraving?: InputMaybe<Scalars['String']['input']>
    size?: InputMaybe<RingSizeInput>
}

export type DesignStudioProductGeneric = DesignStudioProduct & {
    __typename: 'DesignStudioProductGeneric'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    customer: Customer
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductLooseStone = DesignStudioProduct & {
    __typename: 'DesignStudioProductLooseStone'
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    finalQuotation: Maybe<Quotation>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<Quotation>
}

export type DesignStudioProductWeddingRing = DesignStudioProduct & {
    __typename: 'DesignStudioProductWeddingRing'
    availableSizes: Array<RingSizeOrRecommendedRingSize>
    cantBeResized: Scalars['Boolean']['output']
    cantBeReturned: Scalars['Boolean']['output']
    engraving: Maybe<Scalars['String']['output']>
    finalQuotation: Maybe<QuotationWeddingRing>
    id: Scalars['ID']['output']
    isAutofinalizable: Scalars['Boolean']['output']
    name: Scalars['String']['output']
    orderProduct: OrderProduct
    quotations: Array<QuotationWeddingRing>
    size: Maybe<RingSizeOrRecommendedRingSize>
}

export type DesignStudioProductWeddingRingUpdate = {
    engraving?: InputMaybe<Scalars['String']['input']>
    size?: InputMaybe<RingSizeInput>
}

export type DesignStudioQuotationEngagementRingUpdate = {
    ringApproved?: InputMaybe<Scalars['Boolean']['input']>
    stoneApproved?: InputMaybe<Scalars['Boolean']['input']>
}

export type DesignStudioSideStone =
    | DesignStudioExternalSideStone
    | DesignStudioInternalSideStone

export type DesignStudioSideStoneItem = Melee | Stone

export type DesignStudioSignatureStone = {
    __typename: 'DesignStudioSignatureStone'
    id: Scalars['ID']['output']
    melee: Melee
}

export type DesignStudioWeddingRingInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueWeddingRingCode: Scalars['CatalogueCode']['input']
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    engraving?: InputMaybe<Scalars['String']['input']>
    ringSize: RingSizeInput
    uri: Scalars['Uri']['input']
}

export type DesiredDeliveryDateInvalidError = {
    __typename: 'DesiredDeliveryDateInvalidError'
    message: Scalars['String']['output']
}

export const Display = {
    Block: 'BLOCK',
    Flex: 'FLEX',
} as const

export type Display = (typeof Display)[keyof typeof Display]
export type EngagementRingDesignFeatureLabel = {
    __typename: 'EngagementRingDesignFeatureLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingDesignFeatureLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingDesignFeatureLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingDesignFeatureLabelCode = {
    BeadSetting: 'BEAD_SETTING',
    BezelSetting: 'BEZEL_SETTING',
    BlueSapphire: 'BLUE_SAPPHIRE',
    CathedralSetting: 'CATHEDRAL_SETTING',
    ChannelSetting: 'CHANNEL_SETTING',
    Classic: 'CLASSIC',
    ColouredGemstones: 'COLOURED_GEMSTONES',
    Contemporary: 'CONTEMPORARY',
    DoubleHalo: 'DOUBLE_HALO',
    EagleClaws: 'EAGLE_CLAWS',
    Emerald: 'EMERALD',
    Fishtail: 'FISHTAIL',
    GreenSapphire: 'GREEN_SAPPHIRE',
    HandEngraving: 'HAND_ENGRAVING',
    Milgrain: 'MILGRAIN',
    MixedMetal: 'MIXED_METAL',
    PinkSapphire: 'PINK_SAPPHIRE',
    PurpleSapphire: 'PURPLE_SAPPHIRE',
    Ruby: 'RUBY',
    SplitShank: 'SPLIT_SHANK',
    TealSapphire: 'TEAL_SAPPHIRE',
    YellowSapphire: 'YELLOW_SAPPHIRE',
} as const

export type EngagementRingDesignFeatureLabelCode =
    (typeof EngagementRingDesignFeatureLabelCode)[keyof typeof EngagementRingDesignFeatureLabelCode]
export type EngagementRingDesignStyleLabel = {
    __typename: 'EngagementRingDesignStyleLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingDesignStyleLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingDesignStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingDesignStyleLabelCode = {
    ArtDeco: 'ART_DECO',
    Bezel: 'BEZEL',
    Cathedral: 'CATHEDRAL',
    Classic: 'CLASSIC',
    Cluster: 'CLUSTER',
    Contemporary: 'CONTEMPORARY',
    Dainty: 'DAINTY',
    EastWest: 'EAST_WEST',
    Filigree: 'FILIGREE',
    Floral: 'FLORAL',
    HiddenHalo: 'HIDDEN_HALO',
    MixedMetal: 'MIXED_METAL',
    Sapphire: 'SAPPHIRE',
    SplitShank: 'SPLIT_SHANK',
    Twisted: 'TWISTED',
    Unique: 'UNIQUE',
    Vintage: 'VINTAGE',
} as const

export type EngagementRingDesignStyleLabelCode =
    (typeof EngagementRingDesignStyleLabelCode)[keyof typeof EngagementRingDesignStyleLabelCode]
export type EngagementRingStoneRecommendationCard = {
    __typename: 'EngagementRingStoneRecommendationCard'
    description: Scalars['String']['output']
    notFoundContent: Array<ContentComponentItem>
    notSupportedContent: Array<ContentComponentItem>
    title: Scalars['String']['output']
}

export type EngagementRingStoneRecommendationNaturalDiamonds = {
    __typename: 'EngagementRingStoneRecommendationNaturalDiamonds'
    forBalanceCard: EngagementRingStoneRecommendationCard
    forSizeCard: EngagementRingStoneRecommendationCard
    labGrownAlternative: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendationNonSkuGemStoneCard = {
    __typename: 'EngagementRingStoneRecommendationNonSkuGemStoneCard'
    color: CmsGemstoneColorCode
    content: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendationNonSkuLabGrown = {
    __typename: 'EngagementRingStoneRecommendationNonSkuLabGrown'
    forPriceCard: EngagementRingStoneRecommendationCard
    forSizeCard: EngagementRingStoneRecommendationCard
    naturalDiamondAlternative: EngagementRingStoneRecommendationCard
}

export type EngagementRingStoneRecommendations = {
    __typename: 'EngagementRingStoneRecommendations'
    blocks: Array<Block>
    fullSearchButtonText: Scalars['String']['output']
    introductionText: Scalars['String']['output']
    naturalDiamonds: EngagementRingStoneRecommendationNaturalDiamonds
    nonSkuGemStones: Array<EngagementRingStoneRecommendationNonSkuGemStoneCard>
    nonSkuLabGrown: EngagementRingStoneRecommendationNonSkuLabGrown
}

export type EngagementRingStoneRecommendationsNonSkuGemStonesArgs = {
    colorCodes: InputMaybe<Array<CmsGemstoneColorCode>>
}

export type EngagementRingStyleLabel = {
    __typename: 'EngagementRingStyleLabel'
    icon: Maybe<Asset>
    systemCode: EngagementRingStyleLabelCode
    translation: ProductLabelTranslation
}

export type EngagementRingStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const EngagementRingStyleLabelCode = {
    GemstoneSides: 'GEMSTONE_SIDES',
    Halo: 'HALO',
    Pave: 'PAVE',
    Solitaire: 'SOLITAIRE',
    ToiMoi: 'TOI_MOI',
    Trilogy: 'TRILOGY',
} as const

export type EngagementRingStyleLabelCode =
    (typeof EngagementRingStyleLabelCode)[keyof typeof EngagementRingStyleLabelCode]
export type Enquiry =
    | EnquiryConsultation
    | EnquiryEngagementRingAddToCart
    | EnquiryWeddingRingAddToCart

export type EnquiryBaseInput = {
    currency: CurrencyInput
    region: RegionCode
    uri: Scalars['Uri']['input']
}

export type EnquiryConsultation = {
    __typename: 'EnquiryConsultation'
    consultation: BookingConsultation
    id: Scalars['ID']['output']
}

export const EnquiryContactUsEnquiryPurpose = {
    Aftercare: 'AFTERCARE',
    Product: 'PRODUCT',
    Returning: 'RETURNING',
} as const

export type EnquiryContactUsEnquiryPurpose =
    (typeof EnquiryContactUsEnquiryPurpose)[keyof typeof EnquiryContactUsEnquiryPurpose]
export type EnquiryContactUsInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    instructions: Scalars['String']['input']
    purpose: EnquiryContactUsEnquiryPurpose
    uri: Scalars['Uri']['input']
}

export type EnquiryCustomEngagementRing = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueEngagementRingFilter: CatalogueEngagementRingFilterInput
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    uri: Scalars['Uri']['input']
}

export type EnquiryDiamondSearchProduct = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    currency: CurrencyInput
    gemsApiStoneIdentifier: Scalars['ID']['input']
    region: RegionCode
    uri: Scalars['Uri']['input']
}

export type EnquiryEngagementRingAddToCart = {
    __typename: 'EnquiryEngagementRingAddToCart'
    product: DesignStudioProductEngagementRing
}

export type EnquiryEngagementRingCollectionInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    catalogueEngagementRingFilter: CatalogueEngagementRingFilterInput
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    uri: Scalars['Uri']['input']
}

export type EnquiryFormContent = {
    __typename: 'EnquiryFormContent'
    buttonText: Scalars['String']['output']
    description: Maybe<Scalars['String']['output']>
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type EnquiryImageInput = {
    name: Scalars['String']['input']
    uri: Scalars['Uri']['input']
}

export type EnquiryInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    image?: InputMaybe<EnquiryImageInput>
    type: EnquiryType
    uri: Scalars['Uri']['input']
}

export type EnquiryResponseExistingCustomer = {
    __typename: 'EnquiryResponseExistingCustomer'
    marketingCloudForm: Scalars['String']['output']
}

export type EnquiryResponseNewCustomer = {
    __typename: 'EnquiryResponseNewCustomer'
    customer: CustomerRegistrationResponse
    marketingCloudForm: Scalars['String']['output']
}

export const EnquiryType = {
    BlogPost: 'BLOG_POST',
    EngagementRing: 'ENGAGEMENT_RING',
    EngagementRingBrowse: 'ENGAGEMENT_RING_BROWSE',
    EngagementRingImageAttachedLanding:
        'ENGAGEMENT_RING_IMAGE_ATTACHED_LANDING',
    JewelleryProductLandingGeneric: 'JEWELLERY_PRODUCT_LANDING_GENERIC',
    LocationSignup: 'LOCATION_SIGNUP',
    WeddingRing: 'WEDDING_RING',
    WeddingRingBespokeLanding: 'WEDDING_RING_BESPOKE_LANDING',
} as const

export type EnquiryType = (typeof EnquiryType)[keyof typeof EnquiryType]
export type EnquiryWeddingRingAddToCart = {
    __typename: 'EnquiryWeddingRingAddToCart'
    product: DesignStudioProductWeddingRing
}

export type FaqQuestion = {
    __typename: 'FaqQuestion'
    content: Array<ContentComponentItem>
    expandedByDefault: Scalars['Boolean']['output']
    question: Scalars['String']['output']
}

export type FaqSection = {
    __typename: 'FaqSection'
    questions: Array<FaqQuestion>
    title: Maybe<Scalars['String']['output']>
}

export type Footer = {
    __typename: 'Footer'
    columns: Array<FooterColumn>
    copyright: Scalars['String']['output']
    logos: Array<FooterLogo>
}

export type FooterColumn = {
    __typename: 'FooterColumn'
    items: Array<FooterColumnItem>
}

export type FooterColumnItem =
    | FooterColumnItemLinkList
    | FooterColumnItemSeparator
    | FooterColumnItemText
    | FooterColumnItemTitle
    | FooterColumnItemWorkingHours

export type FooterColumnItemLink = {
    __typename: 'FooterColumnItemLink'
    link: Link
    text: Scalars['String']['output']
}

export type FooterColumnItemLinkList = {
    __typename: 'FooterColumnItemLinkList'
    links: Array<FooterColumnItemLink>
}

export type FooterColumnItemSeparator = {
    __typename: 'FooterColumnItemSeparator'
    line: Scalars['Boolean']['output']
}

export type FooterColumnItemText = {
    __typename: 'FooterColumnItemText'
    text: Scalars['String']['output']
}

export type FooterColumnItemTitle = {
    __typename: 'FooterColumnItemTitle'
    title: Scalars['String']['output']
}

export type FooterColumnItemWorkingHours = {
    __typename: 'FooterColumnItemWorkingHours'
    workingHours: Array<WorkingHours>
}

export type FooterColumnItemWorkingHoursWorkingHoursArgs = {
    locale: Scalars['Locale']['input']
}

export type FooterLogo = {
    __typename: 'FooterLogo'
    link: Maybe<Scalars['String']['output']>
    logo: Image
}

export type GalleryCarouselCard = {
    __typename: 'GalleryCarouselCard'
    image: Image
    link: Maybe<Link>
}

export type GalleryItem = {
    __typename: 'GalleryItem'
    image: Image
}

export type GalleryWithEnquiryCard = {
    __typename: 'GalleryWithEnquiryCard'
    caption: Scalars['String']['output']
    image: Image
    slug: Scalars['String']['output']
}

export const GemType = {
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    NaturalDiamond: 'NATURAL_DIAMOND',
} as const

export type GemType = (typeof GemType)[keyof typeof GemType]
export type GemsApiPriceBounds = {
    __typename: 'GemsApiPriceBounds'
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
}

export type GemsApiStone = {
    __typename: 'GemsApiStone'
    identifier: Scalars['ID']['output']
    stone: Maybe<GemsApi_Stone>
}

export type GemsApi_Bounds = {
    __typename: 'GemsApi_Bounds'
    categories: Array<GemsApi_StoneCategoryInfo>
    category: Array<GemsApi_StoneCategory>
    clarities: Array<GemsApi_StoneClarityInfo>
    clarity: Array<GemsApi_StoneClarity>
    colors: Array<GemsApi_StoneColorInfo>
    colour: Array<GemsApi_StoneColour>
    crystal: Array<GemsApi_StoneCrystal>
    crystals: Array<GemsApi_StoneCrystalInfo>
    cut: Array<GemsApi_StoneCut>
    cuts: Array<GemsApi_StoneCutInfo>
    deliveryDays: GemsApi_IntRange
    depth: GemsApi_Range
    depthPercent: GemsApi_Range
    fluorescence: Array<GemsApi_StoneFluorescence>
    fluorescences: Array<GemsApi_StoneFluorescenceInfo>
    gemstoneType: Maybe<Array<GemsApi_GemstoneTypeFilter>>
    grade: Array<GemsApi_StoneGrade>
    grades: Array<GemsApi_StoneGradeInfo>
    length: GemsApi_Range
    originCountry: Array<GemsApi_Country>
    polish: Array<GemsApi_StonePolish>
    polishes: Array<GemsApi_StonePolishInfo>
    price: GemsApi_PriceRange
    priceByShape: Array<GemsApi_PriceRangeByShape>
    ratio: GemsApi_Range
    shape: Array<GemsApi_StoneShape>
    shapePriceBounds: GemsApi_PriceRange
    shapes: Array<GemsApi_StoneShapeInfo>
    shippingFromCountry: Array<GemsApi_Country>
    symmetries: Array<GemsApi_StoneSymmetryInfo>
    symmetry: Array<GemsApi_StoneSymmetry>
    tablePercent: GemsApi_Range
    weight: GemsApi_Range
    width: GemsApi_Range
}

export type GemsApi_BoundsShapePriceBoundsArgs = {
    shape: InputMaybe<GemsApi_StoneShape>
}

export const GemsApi_CertificateLab = {
    Egl: 'EGL',
    Gcal: 'GCAL',
    Gia: 'GIA',
    Gsi: 'GSI',
    Hrd: 'HRD',
    Igi: 'IGI',
    Sgl: 'SGL',
} as const

export type GemsApi_CertificateLab =
    (typeof GemsApi_CertificateLab)[keyof typeof GemsApi_CertificateLab]
export const GemsApi_Country = {
    Ad: 'AD',
    Ae: 'AE',
    Af: 'AF',
    Ag: 'AG',
    Ai: 'AI',
    Al: 'AL',
    Am: 'AM',
    Ao: 'AO',
    Aq: 'AQ',
    Ar: 'AR',
    As: 'AS',
    At: 'AT',
    Au: 'AU',
    Aw: 'AW',
    Ax: 'AX',
    Az: 'AZ',
    Ba: 'BA',
    Bb: 'BB',
    Bd: 'BD',
    Be: 'BE',
    Bf: 'BF',
    Bg: 'BG',
    Bh: 'BH',
    Bi: 'BI',
    Bj: 'BJ',
    Bl: 'BL',
    Bm: 'BM',
    Bn: 'BN',
    Bo: 'BO',
    Bq: 'BQ',
    Br: 'BR',
    Bs: 'BS',
    Bt: 'BT',
    Bv: 'BV',
    Bw: 'BW',
    By: 'BY',
    Bz: 'BZ',
    Ca: 'CA',
    Cc: 'CC',
    Cd: 'CD',
    Cf: 'CF',
    Cg: 'CG',
    Ch: 'CH',
    Ci: 'CI',
    Ck: 'CK',
    Cl: 'CL',
    Cm: 'CM',
    Cn: 'CN',
    Co: 'CO',
    Cr: 'CR',
    Cu: 'CU',
    Cv: 'CV',
    Cw: 'CW',
    Cx: 'CX',
    Cy: 'CY',
    Cz: 'CZ',
    De: 'DE',
    Dj: 'DJ',
    Dk: 'DK',
    Dm: 'DM',
    Do: 'DO',
    Dz: 'DZ',
    Ec: 'EC',
    Ee: 'EE',
    Eg: 'EG',
    Eh: 'EH',
    Er: 'ER',
    Es: 'ES',
    Et: 'ET',
    Fi: 'FI',
    Fj: 'FJ',
    Fk: 'FK',
    Fm: 'FM',
    Fo: 'FO',
    Fr: 'FR',
    Ga: 'GA',
    Gb: 'GB',
    Gd: 'GD',
    Ge: 'GE',
    Gf: 'GF',
    Gg: 'GG',
    Gh: 'GH',
    Gi: 'GI',
    Gl: 'GL',
    Gm: 'GM',
    Gn: 'GN',
    Gp: 'GP',
    Gq: 'GQ',
    Gr: 'GR',
    Gs: 'GS',
    Gt: 'GT',
    Gu: 'GU',
    Gw: 'GW',
    Gy: 'GY',
    Hk: 'HK',
    Hm: 'HM',
    Hn: 'HN',
    Hr: 'HR',
    Ht: 'HT',
    Hu: 'HU',
    Id: 'ID',
    Ie: 'IE',
    Il: 'IL',
    Im: 'IM',
    In: 'IN',
    Io: 'IO',
    Iq: 'IQ',
    Ir: 'IR',
    Is: 'IS',
    It: 'IT',
    Je: 'JE',
    Jm: 'JM',
    Jo: 'JO',
    Jp: 'JP',
    Ke: 'KE',
    Kg: 'KG',
    Kh: 'KH',
    Ki: 'KI',
    Km: 'KM',
    Kn: 'KN',
    Kp: 'KP',
    Kr: 'KR',
    Kw: 'KW',
    Ky: 'KY',
    Kz: 'KZ',
    La: 'LA',
    Lb: 'LB',
    Lc: 'LC',
    Li: 'LI',
    Lk: 'LK',
    Lr: 'LR',
    Ls: 'LS',
    Lt: 'LT',
    Lu: 'LU',
    Lv: 'LV',
    Ly: 'LY',
    Ma: 'MA',
    Mc: 'MC',
    Md: 'MD',
    Me: 'ME',
    Mf: 'MF',
    Mg: 'MG',
    Mh: 'MH',
    Mk: 'MK',
    Ml: 'ML',
    Mm: 'MM',
    Mn: 'MN',
    Mo: 'MO',
    Mp: 'MP',
    Mq: 'MQ',
    Mr: 'MR',
    Ms: 'MS',
    Mt: 'MT',
    Mu: 'MU',
    Mv: 'MV',
    Mw: 'MW',
    Mx: 'MX',
    My: 'MY',
    Mz: 'MZ',
    Na: 'NA',
    Nc: 'NC',
    Ne: 'NE',
    Nf: 'NF',
    Ng: 'NG',
    Ni: 'NI',
    Nl: 'NL',
    No: 'NO',
    Np: 'NP',
    Nr: 'NR',
    Nu: 'NU',
    Nz: 'NZ',
    Om: 'OM',
    Pa: 'PA',
    Pe: 'PE',
    Pf: 'PF',
    Pg: 'PG',
    Ph: 'PH',
    Pk: 'PK',
    Pl: 'PL',
    Pm: 'PM',
    Pn: 'PN',
    Pr: 'PR',
    Ps: 'PS',
    Pt: 'PT',
    Pw: 'PW',
    Py: 'PY',
    Qa: 'QA',
    Re: 'RE',
    Ro: 'RO',
    Rs: 'RS',
    Ru: 'RU',
    Rw: 'RW',
    Sa: 'SA',
    Sb: 'SB',
    Sc: 'SC',
    Sd: 'SD',
    Se: 'SE',
    Sg: 'SG',
    Sh: 'SH',
    Si: 'SI',
    Sj: 'SJ',
    Sk: 'SK',
    Sl: 'SL',
    Sm: 'SM',
    Sn: 'SN',
    So: 'SO',
    Sr: 'SR',
    Ss: 'SS',
    St: 'ST',
    Sv: 'SV',
    Sx: 'SX',
    Sy: 'SY',
    Sz: 'SZ',
    Tc: 'TC',
    Td: 'TD',
    Tf: 'TF',
    Tg: 'TG',
    Th: 'TH',
    Tj: 'TJ',
    Tk: 'TK',
    Tl: 'TL',
    Tm: 'TM',
    Tn: 'TN',
    To: 'TO',
    Tr: 'TR',
    Tt: 'TT',
    Tv: 'TV',
    Tw: 'TW',
    Tz: 'TZ',
    Ua: 'UA',
    Ug: 'UG',
    Um: 'UM',
    Us: 'US',
    Uy: 'UY',
    Uz: 'UZ',
    Va: 'VA',
    Vc: 'VC',
    Ve: 'VE',
    Vg: 'VG',
    Vi: 'VI',
    Vn: 'VN',
    Vu: 'VU',
    Wf: 'WF',
    Ws: 'WS',
    Ye: 'YE',
    Yt: 'YT',
    Za: 'ZA',
    Zm: 'ZM',
    Zw: 'ZW',
} as const

export type GemsApi_Country =
    (typeof GemsApi_Country)[keyof typeof GemsApi_Country]
export type GemsApi_GemstoneTypeFilter = {
    __typename: 'GemsApi_GemstoneTypeFilter'
    colorWithInfo: GemsApi_StoneColorInfo
    colour: GemsApi_StoneColour
    crystal: GemsApi_StoneCrystal
    crystalWithInfo: GemsApi_StoneCrystalInfo
}

export type GemsApi_GemstoneTypeFilterInput = {
    colour: GemsApi_StoneColour
    crystal: GemsApi_StoneCrystal
}

export type GemsApi_IntRange = {
    __typename: 'GemsApi_IntRange'
    max: Scalars['Int']['output']
    min: Scalars['Int']['output']
}

export type GemsApi_Pagination = {
    __typename: 'GemsApi_Pagination'
    limit: Scalars['Int']['output']
    page: Scalars['Int']['output']
    pages: Scalars['Int']['output']
    total: Scalars['Int']['output']
}

export type GemsApi_PaginationInput = {
    limit?: InputMaybe<Scalars['Int']['input']>
    page?: InputMaybe<Scalars['Int']['input']>
}

export type GemsApi_PricePoint = {
    __typename: 'GemsApi_PricePoint'
    market: Scalars['String']['output']
    price: Scalars['Float']['output']
}

export type GemsApi_PriceRange = {
    __typename: 'GemsApi_PriceRange'
    max: Scalars['Float']['output']
    maxInCurrency: Maybe<Money>
    min: Scalars['Float']['output']
    minInCurrency: Maybe<Money>
}

export type GemsApi_PriceRangeMaxInCurrencyArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type GemsApi_PriceRangeMinInCurrencyArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type GemsApi_PriceRangeByShape = {
    __typename: 'GemsApi_PriceRangeByShape'
    range: GemsApi_PriceRange
    shape: GemsApi_StoneShape
}

export type GemsApi_Range = {
    __typename: 'GemsApi_Range'
    max: Scalars['Float']['output']
    min: Scalars['Float']['output']
}

export type GemsApi_RangeInput = {
    max?: InputMaybe<Scalars['Float']['input']>
    min?: InputMaybe<Scalars['Float']['input']>
}

export type GemsApi_SelectedRange = {
    __typename: 'GemsApi_SelectedRange'
    max: Maybe<Scalars['Float']['output']>
    min: Maybe<Scalars['Float']['output']>
}

export type GemsApi_SelectedSorting = {
    __typename: 'GemsApi_SelectedSorting'
    direction: Maybe<GemsApi_SortingDirection>
    field: Maybe<GemsApi_SortingField>
}

export type GemsApi_SelectedStoneFilters = {
    __typename: 'GemsApi_SelectedStoneFilters'
    category: Maybe<Array<GemsApi_StoneCategory>>
    clarity: Maybe<Array<GemsApi_StoneClarity>>
    colour: Maybe<Array<GemsApi_StoneColour>>
    costPrice: Maybe<GemsApi_SelectedRange>
    crystal: Maybe<Array<GemsApi_StoneCrystal>>
    cut: Maybe<Array<GemsApi_StoneCut>>
    depth: Maybe<GemsApi_SelectedRange>
    depthPercent: Maybe<GemsApi_SelectedRange>
    fluorescence: Maybe<Array<GemsApi_StoneFluorescence>>
    grade: Maybe<Array<GemsApi_StoneGrade>>
    hasPhoto: Maybe<Scalars['Boolean']['output']>
    isCanadaMark: Maybe<Scalars['Boolean']['output']>
    isDtlReport: Maybe<Scalars['Boolean']['output']>
    isRtg: Maybe<Scalars['Boolean']['output']>
    isScsReport: Maybe<Scalars['Boolean']['output']>
    isStock: Maybe<Scalars['Boolean']['output']>
    lab: Maybe<Array<GemsApi_CertificateLab>>
    length: Maybe<GemsApi_SelectedRange>
    notClarity: Maybe<Array<GemsApi_StoneClarity>>
    notColour: Maybe<Array<GemsApi_StoneColour>>
    notSymmetry: Maybe<Array<GemsApi_StoneSymmetry>>
    originCountry: Maybe<Array<GemsApi_Country>>
    polish: Maybe<Array<GemsApi_StonePolish>>
    price: Maybe<GemsApi_SelectedRange>
    priceIndex: Maybe<Scalars['String']['output']>
    ratio: Maybe<GemsApi_SelectedRange>
    shape: Maybe<Array<GemsApi_StoneShape>>
    shippingFrom: Maybe<Array<GemsApi_Country>>
    sorting: Maybe<GemsApi_SelectedSorting>
    symmetry: Maybe<Array<GemsApi_StoneSymmetry>>
    tablePercent: Maybe<GemsApi_SelectedRange>
    weight: Maybe<GemsApi_SelectedRange>
    width: Maybe<GemsApi_SelectedRange>
    withOriginCountry: Maybe<Scalars['Boolean']['output']>
    withVideo: Maybe<Scalars['Boolean']['output']>
}

export const GemsApi_SortingDirection = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const

export type GemsApi_SortingDirection =
    (typeof GemsApi_SortingDirection)[keyof typeof GemsApi_SortingDirection]
export const GemsApi_SortingField = {
    Price: 'PRICE',
    Rap: 'RAP',
    Weight: 'WEIGHT',
} as const

export type GemsApi_SortingField =
    (typeof GemsApi_SortingField)[keyof typeof GemsApi_SortingField]
export type GemsApi_Stone = {
    __typename: 'GemsApi_Stone'
    blackInclusion: Maybe<GemsApi_StoneBlackInclusion>
    category: GemsApi_StoneCategory
    categoryWithInfo: GemsApi_StoneCategoryInfo
    certificates: GemsApi_StoneCertificates
    clarity: GemsApi_StoneClarity
    clarityWithInfo: GemsApi_StoneClarityInfo
    colorWithInfo: GemsApi_StoneColorInfo
    colour: GemsApi_StoneColour
    colourShade: Maybe<GemsApi_StoneColourShade>
    containsEngagementRings: Maybe<Scalars['Boolean']['output']>
    crownAngle: Maybe<Scalars['Float']['output']>
    crownHeight: Maybe<Scalars['Float']['output']>
    crystal: GemsApi_StoneCrystal
    crystalWithInfo: GemsApi_StoneCrystalInfo
    culet: Maybe<GemsApi_StoneCulet>
    cut: Maybe<GemsApi_StoneCut>
    cutWithInfo: Maybe<GemsApi_StoneCutInfo>
    deliveryDays: Maybe<Scalars['Int']['output']>
    depth: Maybe<Scalars['Float']['output']>
    depthPercent: Maybe<Scalars['Float']['output']>
    dtlReport: Maybe<GemsApi_DtlReport>
    externalId: Scalars['String']['output']
    eyeClean: Maybe<GemsApi_StoneEyeClean>
    feedIdentifier: Scalars['String']['output']
    fluorescence: Maybe<GemsApi_StoneFluorescence>
    fluorescenceColour: Maybe<GemsApi_StoneFluorescenceColour>
    fluorescenceWithInfo: Maybe<GemsApi_StoneFluorescenceInfo>
    girdleMax: Maybe<GemsApi_StoneGirdle>
    girdleMin: Maybe<GemsApi_StoneGirdle>
    grade: Maybe<GemsApi_StoneGrade>
    gradeWithInfo: Maybe<GemsApi_StoneGradeInfo>
    growthMethod: Maybe<GemsApi_StoneGrowthMethod>
    hasPublicImages: Scalars['Boolean']['output']
    identifier: Scalars['GemsApi_StoneIdentifier']['output']
    image: Maybe<GemsApi_StoneImage>
    images: Array<GemsApi_StoneImage>
    isB2B: Scalars['Boolean']['output']
    isCanadaMark: Scalars['Boolean']['output']
    isCertificateVerified: Scalars['Boolean']['output']
    isHideCertificateNumber: Scalars['Boolean']['output']
    isHideMeasurements: Scalars['Boolean']['output']
    isMilky: Maybe<Scalars['Boolean']['output']>
    isTreated: Maybe<Scalars['Boolean']['output']>
    isValidB2C: Scalars['Boolean']['output']
    length: Maybe<Scalars['Float']['output']>
    originCountry: Maybe<GemsApi_Country>
    pavilionAngle: Maybe<Scalars['Float']['output']>
    pavilionDepth: Maybe<Scalars['Float']['output']>
    polish: Maybe<GemsApi_StonePolish>
    polishWithInfo: Maybe<GemsApi_StonePolishInfo>
    price: Scalars['Float']['output']
    pricingNoVat: Array<GemsApi_PricePoint>
    ratio: Maybe<Scalars['Float']['output']>
    salePrice: Maybe<Money>
    scsReport: Maybe<Scalars['String']['output']>
    shape: GemsApi_StoneShape
    shapeWithInfo: GemsApi_StoneShapeInfo
    shippingFromCountry: Maybe<GemsApi_Country>
    symmetry: Maybe<GemsApi_StoneSymmetry>
    symmetryWithInfo: Maybe<GemsApi_StoneSymmetryInfo>
    tablePercent: Maybe<Scalars['Float']['output']>
    v360Url: Maybe<Scalars['String']['output']>
    weight: Scalars['Float']['output']
    width: Maybe<Scalars['Float']['output']>
}

export type GemsApi_StoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const GemsApi_StoneBlackInclusion = {
    Black: 'BLACK',
    Light: 'LIGHT',
    None: 'NONE',
    VeryLight: 'VERY_LIGHT',
} as const

export type GemsApi_StoneBlackInclusion =
    (typeof GemsApi_StoneBlackInclusion)[keyof typeof GemsApi_StoneBlackInclusion]
export const GemsApi_StoneCategory = {
    Diamond: 'DIAMOND',
    FancyDiamond: 'FANCY_DIAMOND',
    Gemstone: 'GEMSTONE',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
} as const

export type GemsApi_StoneCategory =
    (typeof GemsApi_StoneCategory)[keyof typeof GemsApi_StoneCategory]
export type GemsApi_StoneCategoryInfo = {
    __typename: 'GemsApi_StoneCategoryInfo'
    code: GemsApi_StoneCategory
    info: Maybe<StoneCategory>
}

export type GemsApi_StoneCertificates = {
    __typename: 'GemsApi_StoneCertificates'
    gcal: Maybe<Scalars['String']['output']>
    gia: Maybe<Scalars['String']['output']>
    igi: Maybe<Scalars['String']['output']>
}

export const GemsApi_StoneClarity = {
    DiamondFl: 'DIAMOND_FL',
    DiamondIf: 'DIAMOND_IF',
    DiamondSi1: 'DIAMOND_SI1',
    DiamondSi2: 'DIAMOND_SI2',
    DiamondVs1: 'DIAMOND_VS1',
    DiamondVs2: 'DIAMOND_VS2',
    DiamondVvs1: 'DIAMOND_VVS1',
    DiamondVvs2: 'DIAMOND_VVS2',
    GemstoneEyeClean: 'GEMSTONE_EYE_CLEAN',
    GemstoneIncluded: 'GEMSTONE_INCLUDED',
    GemstoneLoupeClean: 'GEMSTONE_LOUPE_CLEAN',
    GemstoneSlightlyIncluded: 'GEMSTONE_SLIGHTLY_INCLUDED',
} as const

export type GemsApi_StoneClarity =
    (typeof GemsApi_StoneClarity)[keyof typeof GemsApi_StoneClarity]
export type GemsApi_StoneClarityInfo = {
    __typename: 'GemsApi_StoneClarityInfo'
    code: GemsApi_StoneClarity
    info: Maybe<StoneClarity>
}

export type GemsApi_StoneCollection = {
    __typename: 'GemsApi_StoneCollection'
    collection: Array<GemsApi_Stone>
    filters: GemsApi_SelectedStoneFilters
    pagination: GemsApi_Pagination
}

export type GemsApi_StoneColorInfo = {
    __typename: 'GemsApi_StoneColorInfo'
    code: GemsApi_StoneColour
    info: Maybe<StoneColor>
}

export const GemsApi_StoneColour = {
    DiamondD: 'DIAMOND_D',
    DiamondE: 'DIAMOND_E',
    DiamondF: 'DIAMOND_F',
    DiamondG: 'DIAMOND_G',
    DiamondH: 'DIAMOND_H',
    DiamondI: 'DIAMOND_I',
    DiamondJ: 'DIAMOND_J',
    DiamondK: 'DIAMOND_K',
    DiamondL: 'DIAMOND_L',
    DiamondM: 'DIAMOND_M',
    FancyDiamondAchrioteColourless: 'FANCY_DIAMOND_ACHRIOTE_COLOURLESS',
    FancyDiamondBlack: 'FANCY_DIAMOND_BLACK',
    FancyDiamondBlue: 'FANCY_DIAMOND_BLUE',
    FancyDiamondBlueGray: 'FANCY_DIAMOND_BLUE_GRAY',
    FancyDiamondBlueGreen: 'FANCY_DIAMOND_BLUE_GREEN',
    FancyDiamondBlueViolet: 'FANCY_DIAMOND_BLUE_VIOLET',
    FancyDiamondBluishGray: 'FANCY_DIAMOND_BLUISH_GRAY',
    FancyDiamondBluishGreen: 'FANCY_DIAMOND_BLUISH_GREEN',
    FancyDiamondBluishViolet: 'FANCY_DIAMOND_BLUISH_VIOLET',
    FancyDiamondBrown: 'FANCY_DIAMOND_BROWN',
    FancyDiamondBrownishGreen: 'FANCY_DIAMOND_BROWNISH_GREEN',
    FancyDiamondBrownishOrange: 'FANCY_DIAMOND_BROWNISH_ORANGE',
    FancyDiamondBrownishPink: 'FANCY_DIAMOND_BROWNISH_PINK',
    FancyDiamondBrownishPurple: 'FANCY_DIAMOND_BROWNISH_PURPLE',
    FancyDiamondBrownishRed: 'FANCY_DIAMOND_BROWNISH_RED',
    FancyDiamondBrownishYellow: 'FANCY_DIAMOND_BROWNISH_YELLOW',
    FancyDiamondBrownGreen: 'FANCY_DIAMOND_BROWN_GREEN',
    FancyDiamondBrownGreenishYellow: 'FANCY_DIAMOND_BROWN_GREENISH_YELLOW',
    FancyDiamondBrownOrange: 'FANCY_DIAMOND_BROWN_ORANGE',
    FancyDiamondBrownPink: 'FANCY_DIAMOND_BROWN_PINK',
    FancyDiamondBrownPurple: 'FANCY_DIAMOND_BROWN_PURPLE',
    FancyDiamondBrownRed: 'FANCY_DIAMOND_BROWN_RED',
    FancyDiamondBrownYellow: 'FANCY_DIAMOND_BROWN_YELLOW',
    FancyDiamondCanaryYellow: 'FANCY_DIAMOND_CANARY_YELLOW',
    FancyDiamondCatsEye: 'FANCY_DIAMOND_CATS_EYE',
    FancyDiamondChameleon: 'FANCY_DIAMOND_CHAMELEON',
    FancyDiamondChampagne: 'FANCY_DIAMOND_CHAMPAGNE',
    FancyDiamondChocolate: 'FANCY_DIAMOND_CHOCOLATE',
    FancyDiamondChromeDeepGreen: 'FANCY_DIAMOND_CHROME_DEEP_GREEN',
    FancyDiamondCognac: 'FANCY_DIAMOND_COGNAC',
    FancyDiamondColorChange: 'FANCY_DIAMOND_COLOR_CHANGE',
    FancyDiamondDraviteBrown: 'FANCY_DIAMOND_DRAVITE_BROWN',
    FancyDiamondElbaite: 'FANCY_DIAMOND_ELBAITE',
    FancyDiamondGray: 'FANCY_DIAMOND_GRAY',
    FancyDiamondGrayishBlue: 'FANCY_DIAMOND_GRAYISH_BLUE',
    FancyDiamondGrayishGreen: 'FANCY_DIAMOND_GRAYISH_GREEN',
    FancyDiamondGrayishPurple: 'FANCY_DIAMOND_GRAYISH_PURPLE',
    FancyDiamondGrayishViolet: 'FANCY_DIAMOND_GRAYISH_VIOLET',
    FancyDiamondGrayBlue: 'FANCY_DIAMOND_GRAY_BLUE',
    FancyDiamondGrayGreen: 'FANCY_DIAMOND_GRAY_GREEN',
    FancyDiamondGrayPurple: 'FANCY_DIAMOND_GRAY_PURPLE',
    FancyDiamondGrayViolet: 'FANCY_DIAMOND_GRAY_VIOLET',
    FancyDiamondGreen: 'FANCY_DIAMOND_GREEN',
    FancyDiamondGreenishBlue: 'FANCY_DIAMOND_GREENISH_BLUE',
    FancyDiamondGreenishBrown: 'FANCY_DIAMOND_GREENISH_BROWN',
    FancyDiamondGreenishGray: 'FANCY_DIAMOND_GREENISH_GRAY',
    FancyDiamondGreenishYellow: 'FANCY_DIAMOND_GREENISH_YELLOW',
    FancyDiamondGreenBlue: 'FANCY_DIAMOND_GREEN_BLUE',
    FancyDiamondGreenBrown: 'FANCY_DIAMOND_GREEN_BROWN',
    FancyDiamondGreenGray: 'FANCY_DIAMOND_GREEN_GRAY',
    FancyDiamondGreenYellow: 'FANCY_DIAMOND_GREEN_YELLOW',
    FancyDiamondGrey: 'FANCY_DIAMOND_GREY',
    FancyDiamondGreyBlue: 'FANCY_DIAMOND_GREY_BLUE',
    FancyDiamondGreyGreen: 'FANCY_DIAMOND_GREY_GREEN',
    FancyDiamondGreyGreenishYellow: 'FANCY_DIAMOND_GREY_GREENISH_YELLOW',
    FancyDiamondGreyPurple: 'FANCY_DIAMOND_GREY_PURPLE',
    FancyDiamondGreyViolet: 'FANCY_DIAMOND_GREY_VIOLET',
    FancyDiamondGreyYellowishGreen: 'FANCY_DIAMOND_GREY_YELLOWISH_GREEN',
    FancyDiamondOrange: 'FANCY_DIAMOND_ORANGE',
    FancyDiamondOrangeBrown: 'FANCY_DIAMOND_ORANGE_BROWN',
    FancyDiamondOrangePink: 'FANCY_DIAMOND_ORANGE_PINK',
    FancyDiamondOrangeRed: 'FANCY_DIAMOND_ORANGE_RED',
    FancyDiamondOrangeYellow: 'FANCY_DIAMOND_ORANGE_YELLOW',
    FancyDiamondOrangishBrown: 'FANCY_DIAMOND_ORANGISH_BROWN',
    FancyDiamondOrangishPink: 'FANCY_DIAMOND_ORANGISH_PINK',
    FancyDiamondOrangishRed: 'FANCY_DIAMOND_ORANGISH_RED',
    FancyDiamondOrangishYellow: 'FANCY_DIAMOND_ORANGISH_YELLOW',
    FancyDiamondOrangyBrown: 'FANCY_DIAMOND_ORANGY_BROWN',
    FancyDiamondOrangyPink: 'FANCY_DIAMOND_ORANGY_PINK',
    FancyDiamondOrangyRed: 'FANCY_DIAMOND_ORANGY_RED',
    FancyDiamondOrangyYellow: 'FANCY_DIAMOND_ORANGY_YELLOW',
    FancyDiamondOther: 'FANCY_DIAMOND_OTHER',
    FancyDiamondPadparadscha: 'FANCY_DIAMOND_PADPARADSCHA',
    FancyDiamondParaiba: 'FANCY_DIAMOND_PARAIBA',
    FancyDiamondPeach: 'FANCY_DIAMOND_PEACH',
    FancyDiamondPink: 'FANCY_DIAMOND_PINK',
    FancyDiamondPinkishBrown: 'FANCY_DIAMOND_PINKISH_BROWN',
    FancyDiamondPinkishOrange: 'FANCY_DIAMOND_PINKISH_ORANGE',
    FancyDiamondPinkishPurple: 'FANCY_DIAMOND_PINKISH_PURPLE',
    FancyDiamondPinkishRed: 'FANCY_DIAMOND_PINKISH_RED',
    FancyDiamondPinkBrown: 'FANCY_DIAMOND_PINK_BROWN',
    FancyDiamondPinkOrange: 'FANCY_DIAMOND_PINK_ORANGE',
    FancyDiamondPinkPurple: 'FANCY_DIAMOND_PINK_PURPLE',
    FancyDiamondPurple: 'FANCY_DIAMOND_PURPLE',
    FancyDiamondPurpleGray: 'FANCY_DIAMOND_PURPLE_GRAY',
    FancyDiamondPurplePink: 'FANCY_DIAMOND_PURPLE_PINK',
    FancyDiamondPurpleRed: 'FANCY_DIAMOND_PURPLE_RED',
    FancyDiamondPurplishGray: 'FANCY_DIAMOND_PURPLISH_GRAY',
    FancyDiamondPurplishPink: 'FANCY_DIAMOND_PURPLISH_PINK',
    FancyDiamondPurplishRed: 'FANCY_DIAMOND_PURPLISH_RED',
    FancyDiamondRed: 'FANCY_DIAMOND_RED',
    FancyDiamondReddishBrown: 'FANCY_DIAMOND_REDDISH_BROWN',
    FancyDiamondReddishOrange: 'FANCY_DIAMOND_REDDISH_ORANGE',
    FancyDiamondReddishPurple: 'FANCY_DIAMOND_REDDISH_PURPLE',
    FancyDiamondRedBrown: 'FANCY_DIAMOND_RED_BROWN',
    FancyDiamondRedOrange: 'FANCY_DIAMOND_RED_ORANGE',
    FancyDiamondRedPurple: 'FANCY_DIAMOND_RED_PURPLE',
    FancyDiamondRubellite: 'FANCY_DIAMOND_RUBELLITE',
    FancyDiamondSaltAndPepper: 'FANCY_DIAMOND_SALT_AND_PEPPER',
    FancyDiamondSchorlBlack: 'FANCY_DIAMOND_SCHORL_BLACK',
    FancyDiamondSiberitePurple: 'FANCY_DIAMOND_SIBERITE_PURPLE',
    FancyDiamondTeal: 'FANCY_DIAMOND_TEAL',
    FancyDiamondTurquoise: 'FANCY_DIAMOND_TURQUOISE',
    FancyDiamondVerdelitePurple: 'FANCY_DIAMOND_VERDELITE_PURPLE',
    FancyDiamondViolet: 'FANCY_DIAMOND_VIOLET',
    FancyDiamondVioletishBlue: 'FANCY_DIAMOND_VIOLETISH_BLUE',
    FancyDiamondVioletishGray: 'FANCY_DIAMOND_VIOLETISH_GRAY',
    FancyDiamondVioletBlue: 'FANCY_DIAMOND_VIOLET_BLUE',
    FancyDiamondVioletGray: 'FANCY_DIAMOND_VIOLET_GRAY',
    FancyDiamondWatermelon: 'FANCY_DIAMOND_WATERMELON',
    FancyDiamondWhite: 'FANCY_DIAMOND_WHITE',
    FancyDiamondYellow: 'FANCY_DIAMOND_YELLOW',
    FancyDiamondYellowishBrown: 'FANCY_DIAMOND_YELLOWISH_BROWN',
    FancyDiamondYellowishGray: 'FANCY_DIAMOND_YELLOWISH_GRAY',
    FancyDiamondYellowishGreen: 'FANCY_DIAMOND_YELLOWISH_GREEN',
    FancyDiamondYellowishOrange: 'FANCY_DIAMOND_YELLOWISH_ORANGE',
    FancyDiamondYellowBrown: 'FANCY_DIAMOND_YELLOW_BROWN',
    FancyDiamondYellowGray: 'FANCY_DIAMOND_YELLOW_GRAY',
    FancyDiamondYellowGreen: 'FANCY_DIAMOND_YELLOW_GREEN',
    FancyDiamondYellowOrange: 'FANCY_DIAMOND_YELLOW_ORANGE',
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneElbaiteStandard: 'GEMSTONE_ELBAITE_STANDARD',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBlueOrBlueGreen: 'GEMSTONE_GREEN_BLUE_OR_BLUE_GREEN',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangishRed: 'GEMSTONE_ORANGISH_RED',
    GemstoneOrangishYellow: 'GEMSTONE_ORANGISH_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstoneParaibaLightBlue: 'GEMSTONE_PARAIBA_LIGHT_BLUE',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedOrangeOrOrangeRed: 'GEMSTONE_RED_ORANGE_OR_ORANGE_RED',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRedPurpleOrPurpleRed: 'GEMSTONE_RED_PURPLE_OR_PURPLE_RED',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneSlightlyPurplishRed: 'GEMSTONE_SLIGHTLY_PURPLISH_RED',
    GemstoneSlightlyYellowishGreen: 'GEMSTONE_SLIGHTLY_YELLOWISH_GREEN',
    GemstoneStronglyPurplishRed: 'GEMSTONE_STRONGLY_PURPLISH_RED',
    GemstoneStronglyYellowishGreen: 'GEMSTONE_STRONGLY_YELLOWISH_GREEN',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdeliteGreen: 'GEMSTONE_VERDELITE_GREEN',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneVerySlightlyBluishGreen: 'GEMSTONE_VERY_SLIGHTLY_BLUISH_GREEN',
    GemstoneVerySlightlyGreenishBlue: 'GEMSTONE_VERY_SLIGHTLY_GREENISH_BLUE',
    GemstoneVeryStronglyBluishGreen: 'GEMSTONE_VERY_STRONGLY_BLUISH_GREEN',
    GemstoneVeryStronglyGreenishBlue: 'GEMSTONE_VERY_STRONGLY_GREENISH_BLUE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowGreenOrGreenYellow: 'GEMSTONE_YELLOW_GREEN_OR_GREEN_YELLOW',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type GemsApi_StoneColour =
    (typeof GemsApi_StoneColour)[keyof typeof GemsApi_StoneColour]
export const GemsApi_StoneColourShade = {
    Blue: 'BLUE',
    Brown: 'BROWN',
    Fancy: 'FANCY',
    Gray: 'GRAY',
    Green: 'GREEN',
    Mixed: 'MIXED',
    None: 'NONE',
    Orange: 'ORANGE',
    Pink: 'PINK',
    Purple: 'PURPLE',
    Yellow: 'YELLOW',
} as const

export type GemsApi_StoneColourShade =
    (typeof GemsApi_StoneColourShade)[keyof typeof GemsApi_StoneColourShade]
export const GemsApi_StoneCrystal = {
    Alexandrite: 'ALEXANDRITE',
    Amethyst: 'AMETHYST',
    Aquamarine: 'AQUAMARINE',
    Citrine: 'CITRINE',
    Diamond: 'DIAMOND',
    Emerald: 'EMERALD',
    FancyDiamond: 'FANCY_DIAMOND',
    Garnet: 'GARNET',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
    Morganite: 'MORGANITE',
    Peridot: 'PERIDOT',
    Ruby: 'RUBY',
    Sapphire: 'SAPPHIRE',
    Spinel: 'SPINEL',
    Tanzanite: 'TANZANITE',
    Topaz: 'TOPAZ',
    Tourmaline: 'TOURMALINE',
    Tsavorite: 'TSAVORITE',
    Zircon: 'ZIRCON',
} as const

export type GemsApi_StoneCrystal =
    (typeof GemsApi_StoneCrystal)[keyof typeof GemsApi_StoneCrystal]
export type GemsApi_StoneCrystalInfo = {
    __typename: 'GemsApi_StoneCrystalInfo'
    code: GemsApi_StoneCrystal
    info: Maybe<StoneCrystal>
}

export const GemsApi_StoneCulet = {
    ExtremelyLarge: 'EXTREMELY_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    SlightlyLarge: 'SLIGHTLY_LARGE',
    Small: 'SMALL',
    VerySmall: 'VERY_SMALL',
} as const

export type GemsApi_StoneCulet =
    (typeof GemsApi_StoneCulet)[keyof typeof GemsApi_StoneCulet]
export const GemsApi_StoneCut = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StoneCut =
    (typeof GemsApi_StoneCut)[keyof typeof GemsApi_StoneCut]
export type GemsApi_StoneCutInfo = {
    __typename: 'GemsApi_StoneCutInfo'
    code: GemsApi_StoneCut
    info: Maybe<StoneCut>
}

export const GemsApi_StoneEyeClean = {
    Ec_50: 'EC_50',
    Ec_75: 'EC_75',
    Ec_100: 'EC_100',
} as const

export type GemsApi_StoneEyeClean =
    (typeof GemsApi_StoneEyeClean)[keyof typeof GemsApi_StoneEyeClean]
export const GemsApi_StoneFancyDiamondColourIntensity = {
    Faint: 'FAINT',
    Fancy: 'FANCY',
    FancyDark: 'FANCY_DARK',
    FancyDeep: 'FANCY_DEEP',
    FancyIntense: 'FANCY_INTENSE',
    FancyLight: 'FANCY_LIGHT',
    FancyVivid: 'FANCY_VIVID',
    Light: 'LIGHT',
    VeryLight: 'VERY_LIGHT',
} as const

export type GemsApi_StoneFancyDiamondColourIntensity =
    (typeof GemsApi_StoneFancyDiamondColourIntensity)[keyof typeof GemsApi_StoneFancyDiamondColourIntensity]
export const GemsApi_StoneFancyDiamondOvertone = {
    Black: 'BLACK',
    Blue: 'BLUE',
    Blueish: 'BLUEISH',
    Brown: 'BROWN',
    Brownish: 'BROWNISH',
    Chameleon: 'CHAMELEON',
    Champagne: 'CHAMPAGNE',
    Cognac: 'COGNAC',
    Green: 'GREEN',
    Greenish: 'GREENISH',
    Grey: 'GREY',
    Greyish: 'GREYISH',
    None: 'NONE',
    Orange: 'ORANGE',
    Orangey: 'ORANGEY',
    Other: 'OTHER',
    Pink: 'PINK',
    Pinkish: 'PINKISH',
    Purple: 'PURPLE',
    Purplish: 'PURPLISH',
    Red: 'RED',
    Reddish: 'REDDISH',
    Violet: 'VIOLET',
    White: 'WHITE',
    Yellow: 'YELLOW',
    Yellowish: 'YELLOWISH',
} as const

export type GemsApi_StoneFancyDiamondOvertone =
    (typeof GemsApi_StoneFancyDiamondOvertone)[keyof typeof GemsApi_StoneFancyDiamondOvertone]
export type GemsApi_StoneFilters = {
    category?: InputMaybe<Array<GemsApi_StoneCategory>>
    clarity?: InputMaybe<Array<GemsApi_StoneClarity>>
    colour?: InputMaybe<Array<GemsApi_StoneColour>>
    costPrice?: InputMaybe<GemsApi_RangeInput>
    costPriceInCurrency?: InputMaybe<GemsApi_StonePriceFilter>
    crystal?: InputMaybe<Array<GemsApi_StoneCrystal>>
    cut?: InputMaybe<Array<GemsApi_StoneCut>>
    deliveryDays?: InputMaybe<Scalars['Int']['input']>
    depth?: InputMaybe<GemsApi_RangeInput>
    depthPercent?: InputMaybe<GemsApi_RangeInput>
    fancyDiamondColourIntensity?: InputMaybe<
        Array<GemsApi_StoneFancyDiamondColourIntensity>
    >
    fancyDiamondOvertone?: InputMaybe<Array<GemsApi_StoneFancyDiamondOvertone>>
    fluorescence?: InputMaybe<Array<GemsApi_StoneFluorescence>>
    gemstoneTypes?: InputMaybe<Array<GemsApi_GemstoneTypeFilterInput>>
    grade?: InputMaybe<Array<GemsApi_StoneGrade>>
    hasPhoto?: InputMaybe<Scalars['Boolean']['input']>
    isCanadaMark?: InputMaybe<Scalars['Boolean']['input']>
    isConsultant?: InputMaybe<Scalars['Boolean']['input']>
    isDtlReport?: InputMaybe<Scalars['Boolean']['input']>
    isRtg?: InputMaybe<Scalars['Boolean']['input']>
    isScsReport?: InputMaybe<Scalars['Boolean']['input']>
    isStock?: InputMaybe<Scalars['Boolean']['input']>
    lab?: InputMaybe<Array<GemsApi_CertificateLab>>
    length?: InputMaybe<GemsApi_RangeInput>
    notClarity?: InputMaybe<Array<GemsApi_StoneClarity>>
    notColour?: InputMaybe<Array<GemsApi_StoneColour>>
    notSymmetry?: InputMaybe<Array<GemsApi_StoneSymmetry>>
    originCountry?: InputMaybe<Array<GemsApi_Country>>
    pagination?: InputMaybe<GemsApi_PaginationInput>
    polish?: InputMaybe<Array<GemsApi_StonePolish>>
    price?: InputMaybe<GemsApi_RangeInput>
    priceInCurrency?: InputMaybe<GemsApi_StonePriceFilter>
    priceIndex?: InputMaybe<Scalars['String']['input']>
    ratio?: InputMaybe<GemsApi_RangeInput>
    shape?: InputMaybe<Array<GemsApi_StoneShape>>
    shippingFrom?: InputMaybe<Array<GemsApi_Country>>
    sorting?: InputMaybe<GemsApi_StoneSorting>
    symmetry?: InputMaybe<Array<GemsApi_StoneSymmetry>>
    tablePercent?: InputMaybe<GemsApi_RangeInput>
    weight?: InputMaybe<GemsApi_RangeInput>
    width?: InputMaybe<GemsApi_RangeInput>
    withOriginCountry?: InputMaybe<Scalars['Boolean']['input']>
    withVideo?: InputMaybe<Scalars['Boolean']['input']>
}

export const GemsApi_StoneFluorescence = {
    Faint: 'FAINT',
    Medium: 'MEDIUM',
    None: 'NONE',
    Slight: 'SLIGHT',
    Strong: 'STRONG',
    VerySlight: 'VERY_SLIGHT',
    VeryStrong: 'VERY_STRONG',
} as const

export type GemsApi_StoneFluorescence =
    (typeof GemsApi_StoneFluorescence)[keyof typeof GemsApi_StoneFluorescence]
export const GemsApi_StoneFluorescenceColour = {
    Blue: 'BLUE',
} as const

export type GemsApi_StoneFluorescenceColour =
    (typeof GemsApi_StoneFluorescenceColour)[keyof typeof GemsApi_StoneFluorescenceColour]
export type GemsApi_StoneFluorescenceInfo = {
    __typename: 'GemsApi_StoneFluorescenceInfo'
    code: GemsApi_StoneFluorescence
    info: Maybe<StoneFluorescence>
}

export const GemsApi_StoneGirdle = {
    ExtremelyThick: 'EXTREMELY_THICK',
    ExtremelyThin: 'EXTREMELY_THIN',
    Medium: 'MEDIUM',
    SlightlyThick: 'SLIGHTLY_THICK',
    SlightlyThin: 'SLIGHTLY_THIN',
    Thick: 'THICK',
    Thin: 'THIN',
    VeryThick: 'VERY_THICK',
    VeryThin: 'VERY_THIN',
} as const

export type GemsApi_StoneGirdle =
    (typeof GemsApi_StoneGirdle)[keyof typeof GemsApi_StoneGirdle]
export const GemsApi_StoneGrade = {
    FancyDiamondFaint: 'FANCY_DIAMOND_FAINT',
    FancyDiamondFancy: 'FANCY_DIAMOND_FANCY',
    FancyDiamondFancyDark: 'FANCY_DIAMOND_FANCY_DARK',
    FancyDiamondFancyDeep: 'FANCY_DIAMOND_FANCY_DEEP',
    FancyDiamondFancyIntense: 'FANCY_DIAMOND_FANCY_INTENSE',
    FancyDiamondFancyLight: 'FANCY_DIAMOND_FANCY_LIGHT',
    FancyDiamondFancyVivid: 'FANCY_DIAMOND_FANCY_VIVID',
    FancyDiamondLight: 'FANCY_DIAMOND_LIGHT',
    FancyDiamondVeryLight: 'FANCY_DIAMOND_VERY_LIGHT',
    GemstoneDark: 'GEMSTONE_DARK',
    GemstoneHot: 'GEMSTONE_HOT',
    GemstoneLight: 'GEMSTONE_LIGHT',
    GemstoneMedium: 'GEMSTONE_MEDIUM',
    GemstoneMediumDark: 'GEMSTONE_MEDIUM_DARK',
    GemstoneMediumLight: 'GEMSTONE_MEDIUM_LIGHT',
    GemstoneVeryDark: 'GEMSTONE_VERY_DARK',
    GemstoneVeryLight: 'GEMSTONE_VERY_LIGHT',
} as const

export type GemsApi_StoneGrade =
    (typeof GemsApi_StoneGrade)[keyof typeof GemsApi_StoneGrade]
export type GemsApi_StoneGradeInfo = {
    __typename: 'GemsApi_StoneGradeInfo'
    code: GemsApi_StoneGrade
    info: Maybe<StoneGrade>
}

export const GemsApi_StoneGrowthMethod = {
    Cvd: 'CVD',
    Hpht: 'HPHT',
    Iia: 'IIA',
} as const

export type GemsApi_StoneGrowthMethod =
    (typeof GemsApi_StoneGrowthMethod)[keyof typeof GemsApi_StoneGrowthMethod]
export type GemsApi_StoneImage = {
    __typename: 'GemsApi_StoneImage'
    isB2B: Scalars['Boolean']['output']
    url: Scalars['GemsApi_Uri']['output']
}

export const GemsApi_StonePolish = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StonePolish =
    (typeof GemsApi_StonePolish)[keyof typeof GemsApi_StonePolish]
export type GemsApi_StonePolishInfo = {
    __typename: 'GemsApi_StonePolishInfo'
    code: GemsApi_StonePolish
    info: Maybe<StonePolish>
}

export type GemsApi_StonePriceFilter = {
    max?: InputMaybe<MoneyInput>
    min?: InputMaybe<MoneyInput>
}

export const GemsApi_StoneShape = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    Flower: 'FLOWER',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type GemsApi_StoneShape =
    (typeof GemsApi_StoneShape)[keyof typeof GemsApi_StoneShape]
export type GemsApi_StoneShapeInfo = {
    __typename: 'GemsApi_StoneShapeInfo'
    code: GemsApi_StoneShape
    info: Maybe<StoneShape>
}

export type GemsApi_StoneSorting = {
    direction?: InputMaybe<GemsApi_SortingDirection>
    field?: InputMaybe<GemsApi_SortingField>
}

export const GemsApi_StoneSymmetry = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type GemsApi_StoneSymmetry =
    (typeof GemsApi_StoneSymmetry)[keyof typeof GemsApi_StoneSymmetry]
export type GemsApi_StoneSymmetryInfo = {
    __typename: 'GemsApi_StoneSymmetryInfo'
    code: GemsApi_StoneSymmetry
    info: Maybe<StoneSymmetry>
}

export type GemsApi_DtlReport = {
    __typename: 'GemsApi_dtlReport'
    code: Scalars['String']['output']
    url: Scalars['GemsApi_Uri']['output']
}

export type GenericImage = {
    __typename: 'GenericImage'
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export type GenericImageSizeArgs = {
    name: MonolithImageSizeName
}

export type GeoPoint = {
    __typename: 'GeoPoint'
    id: Scalars['ID']['output']
    latitude: Scalars['Float']['output']
    longitude: Scalars['Float']['output']
}

export type GetRedirectInput = {
    url: Scalars['String']['input']
}

export type HistoricalNonSku =
    | HistoricalNonSkuGemstone
    | HistoricalNonSkuLabGrown

export type HistoricalNonSkuGemstone = NonSkuGemStoneInterface &
    NonSkuInterface & {
        __typename: 'HistoricalNonSkuGemstone'
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        colorGrade: StoneGrade
        crystal: StoneCrystal
        cut: StoneCut
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Money
        shape: StoneShape
    }

export type HistoricalNonSkuGemstoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type HistoricalNonSkuLabGrown = NonSkuInterface &
    NonSkuLabGrownInterface & {
        __typename: 'HistoricalNonSkuLabGrown'
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        crystal: StoneCrystal
        cut: StoneCut
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Money
        shape: StoneShape
    }

export type HistoricalNonSkuLabGrownSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export const HorizontalAlignment = {
    Center: 'CENTER',
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type HorizontalAlignment =
    (typeof HorizontalAlignment)[keyof typeof HorizontalAlignment]
export const HtmlTag = {
    Div: 'DIV',
    H1: 'H1',
    H2: 'H2',
    H3: 'H3',
    H4: 'H4',
    H5: 'H5',
    H6: 'H6',
} as const

export type HtmlTag = (typeof HtmlTag)[keyof typeof HtmlTag]
export const Icon = {
    Accessibility: 'ACCESSIBILITY',
    AngleDown: 'ANGLE_DOWN',
    AngleDownCircle: 'ANGLE_DOWN_CIRCLE',
    AngleLeft: 'ANGLE_LEFT',
    AngleLeftCircle: 'ANGLE_LEFT_CIRCLE',
    AngleRight: 'ANGLE_RIGHT',
    AngleRightCircle: 'ANGLE_RIGHT_CIRCLE',
    AngleTopCircle: 'ANGLE_TOP_CIRCLE',
    AngleUp: 'ANGLE_UP',
    Bag: 'BAG',
    Banner: 'BANNER',
    Bell: 'BELL',
    BlankPage: 'BLANK_PAGE',
    Box: 'BOX',
    BoxAlt: 'BOX_ALT',
    BoxReturn: 'BOX_RETURN',
    Calendar: 'CALENDAR',
    Camera: 'CAMERA',
    Cart: 'CART',
    CautionCircle: 'CAUTION_CIRCLE',
    CautionTriangle: 'CAUTION_TRIANGLE',
    Chart: 'CHART',
    ChartAlt: 'CHART_ALT',
    Checkmark: 'CHECKMARK',
    CheckmarkCircle: 'CHECKMARK_CIRCLE',
    Clock: 'CLOCK',
    ClockAlt: 'CLOCK_ALT',
    Close: 'CLOSE',
    Cog: 'COG',
    Comments: 'COMMENTS',
    CommentsAlt: 'COMMENTS_ALT',
    CommentDots: 'COMMENT_DOTS',
    CommentDotsAlt: 'COMMENT_DOTS_ALT',
    CommentEmpty: 'COMMENT_EMPTY',
    CommentEmptyAlt: 'COMMENT_EMPTY_ALT',
    CommentRows: 'COMMENT_ROWS',
    CommentRowsAlt: 'COMMENT_ROWS_ALT',
    CreditCard: 'CREDIT_CARD',
    Crosshair: 'CROSSHAIR',
    CrossCircle: 'CROSS_CIRCLE',
    Desktop: 'DESKTOP',
    Diamond: 'DIAMOND',
    DiamondAlt: 'DIAMOND_ALT',
    Dots: 'DOTS',
    DotsCircle: 'DOTS_CIRCLE',
    DotsVertical: 'DOTS_VERTICAL',
    Download: 'DOWNLOAD',
    Envelope: 'ENVELOPE',
    Eye: 'EYE',
    EyeStrikethrough: 'EYE_STRIKETHROUGH',
    Facebook: 'FACEBOOK',
    Filters: 'FILTERS',
    FiltersAlt: 'FILTERS_ALT',
    Globe: 'GLOBE',
    Hamburger: 'HAMBURGER',
    Hand: 'HAND',
    Heart: 'HEART',
    Help: 'HELP',
    House: 'HOUSE',
    IdCard: 'ID_CARD',
    Info: 'INFO',
    Instagram: 'INSTAGRAM',
    Key: 'KEY',
    Link: 'LINK',
    List: 'LIST',
    ListCircle: 'LIST_CIRCLE',
    LocationPin: 'LOCATION_PIN',
    Lock: 'LOCK',
    LockAlt: 'LOCK_ALT',
    Magnifier: 'MAGNIFIER',
    MagnifierAlt: 'MAGNIFIER_ALT',
    Map: 'MAP',
    Minus: 'MINUS',
    MinusCircle: 'MINUS_CIRCLE',
    Mta: 'MTA',
    Notebook: 'NOTEBOOK',
    Page: 'PAGE',
    Paperclip: 'PAPERCLIP',
    PaperAirplane: 'PAPER_AIRPLANE',
    Pencil: 'PENCIL',
    PencilAlt: 'PENCIL_ALT',
    PencilAlt_2: 'PENCIL_ALT_2',
    Phone: 'PHONE',
    Pin: 'PIN',
    Pinterest: 'PINTEREST',
    Play: 'PLAY',
    Plus: 'PLUS',
    PlusCircle: 'PLUS_CIRCLE',
    Power: 'POWER',
    Profile: 'PROFILE',
    Redo: 'REDO',
    Refresh: 'REFRESH',
    Rings: 'RINGS',
    ShapeAsscher: 'SHAPE_ASSCHER',
    ShapeCushion: 'SHAPE_CUSHION',
    ShapeEmerald: 'SHAPE_EMERALD',
    ShapeEuropean: 'SHAPE_EUROPEAN',
    ShapeHeart: 'SHAPE_HEART',
    ShapeHexagonal: 'SHAPE_HEXAGONAL',
    ShapeMarquise: 'SHAPE_MARQUISE',
    ShapeOval: 'SHAPE_OVAL',
    ShapePear: 'SHAPE_PEAR',
    ShapePrincess: 'SHAPE_PRINCESS',
    ShapeRadiant: 'SHAPE_RADIANT',
    ShapeRound: 'SHAPE_ROUND',
    ShapeRoundAlt: 'SHAPE_ROUND_ALT',
    Share: 'SHARE',
    Smartphone: 'SMARTPHONE',
    Speaker_1: 'SPEAKER_1',
    Speaker_2: 'SPEAKER_2',
    Speaker_3: 'SPEAKER_3',
    Speaker_4: 'SPEAKER_4',
    SpeakerMuted: 'SPEAKER_MUTED',
    Star: 'STAR',
    Stop: 'STOP',
    Tablet: 'TABLET',
    Text: 'TEXT',
    TextCircle: 'TEXT_CIRCLE',
    ThreeUsers: 'THREE_USERS',
    Thumbsup: 'THUMBSUP',
    Truck: 'TRUCK',
    Twitter: 'TWITTER',
    TwoUsers: 'TWO_USERS',
    Underground: 'UNDERGROUND',
    Undo: 'UNDO',
    Youtube: 'YOUTUBE',
} as const

export type Icon = (typeof Icon)[keyof typeof Icon]
export type IconCarouselItem = {
    __typename: 'IconCarouselItem'
    icon: Icon
    link: Maybe<Link>
    text: Maybe<Scalars['String']['output']>
}

export type Image = Media & {
    __typename: 'Image'
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    height: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    size: ImageSize
    sizes: Array<ImageSize>
    sources: Array<ImageSrc>
    title: Scalars['String']['output']
    url: Scalars['String']['output']
    width: Scalars['Int']['output']
}

export type ImageSizeArgs = {
    name: ImageSizeName
}

export const ImageFormat = {
    Landscape: 'LANDSCAPE',
    Portrait: 'PORTRAIT',
    Rounded: 'ROUNDED',
    Square: 'SQUARE',
} as const

export type ImageFormat = (typeof ImageFormat)[keyof typeof ImageFormat]
export const ImagePosition = {
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type ImagePosition = (typeof ImagePosition)[keyof typeof ImagePosition]
export type ImageSize = {
    __typename: 'ImageSize'
    mimeType: Scalars['String']['output']
    name: ImageSizeName
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export const ImageSizeName = {
    Cover: 'COVER',
    CoverX2: 'COVER_X2',
    Large: 'LARGE',
    LargeX2: 'LARGE_X2',
    Medium: 'MEDIUM',
    MediumX2: 'MEDIUM_X2',
    Small: 'SMALL',
    SmallX2: 'SMALL_X2',
} as const

export type ImageSizeName = (typeof ImageSizeName)[keyof typeof ImageSizeName]
export type ImageSrc = {
    __typename: 'ImageSrc'
    mimeType: Scalars['String']['output']
    url: Scalars['String']['output']
}

export const ImageWidth = {
    Content: 'CONTENT',
    ExtendedContent: 'EXTENDED_CONTENT',
    Full: 'FULL',
} as const

export type ImageWidth = (typeof ImageWidth)[keyof typeof ImageWidth]
export type InstagramPost = {
    __typename: 'InstagramPost'
    image: Image
    link: Scalars['String']['output']
}

export const InstagramWithContentWidth = {
    Normal: 'NORMAL',
    Wide: 'WIDE',
} as const

export type InstagramWithContentWidth =
    (typeof InstagramWithContentWidth)[keyof typeof InstagramWithContentWidth]
export type InvalidateCacheResult = {
    __typename: 'InvalidateCacheResult'
    errors: Array<InvalidateCacheResultError>
    success: Array<InvalidateCacheResultSuccess>
}

export type InvalidateCacheResultError = {
    __typename: 'InvalidateCacheResultError'
    error: Scalars['String']['output']
    key: Scalars['String']['output']
}

export type InvalidateCacheResultSuccess = {
    __typename: 'InvalidateCacheResultSuccess'
    key: Scalars['String']['output']
}

export const JewelleryBraceletProductStyle = {
    Bangle: 'BANGLE',
    Chain: 'CHAIN',
    Diamond: 'DIAMOND',
    Gemstone: 'GEMSTONE',
    Permanent: 'PERMANENT',
    Tennis: 'TENNIS',
} as const

export type JewelleryBraceletProductStyle =
    (typeof JewelleryBraceletProductStyle)[keyof typeof JewelleryBraceletProductStyle]
export type JewelleryBraceletProductStyleLabel = {
    __typename: 'JewelleryBraceletProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryBraceletProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryBraceletProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryDesignStyle = {
    ArtDeco: 'ART_DECO',
    Bezel: 'BEZEL',
    Birthstone: 'BIRTHSTONE',
    Bridal: 'BRIDAL',
    Butterfly: 'BUTTERFLY',
    Classic: 'CLASSIC',
    Clover: 'CLOVER',
    Cluster: 'CLUSTER',
    Contemporary: 'CONTEMPORARY',
    EvilEye: 'EVIL_EYE',
    Floral: 'FLORAL',
    Halo: 'HALO',
    Heart: 'HEART',
    Initials: 'INITIALS',
    Mothers: 'MOTHERS',
    Solitaire: 'SOLITAIRE',
    Unique: 'UNIQUE',
    Vintage: 'VINTAGE',
} as const

export type JewelleryDesignStyle =
    (typeof JewelleryDesignStyle)[keyof typeof JewelleryDesignStyle]
export type JewelleryDesignStyleLabel = {
    __typename: 'JewelleryDesignStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryDesignStyle
    translation: ProductLabelTranslation
}

export type JewelleryDesignStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryEarringsProductStyle = {
    Cluster: 'CLUSTER',
    Drop: 'DROP',
    Hoops: 'HOOPS',
    Studs: 'STUDS',
} as const

export type JewelleryEarringsProductStyle =
    (typeof JewelleryEarringsProductStyle)[keyof typeof JewelleryEarringsProductStyle]
export type JewelleryEarringsProductStyleLabel = {
    __typename: 'JewelleryEarringsProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryEarringsProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryEarringsProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryGemstoneCode = {
    AlexandriteJun: 'ALEXANDRITE_JUN',
    AmethystFeb: 'AMETHYST_FEB',
    AquamarineMar: 'AQUAMARINE_MAR',
    DiamondApr: 'DIAMOND_APR',
    EmeraldMay: 'EMERALD_MAY',
    GarnetJan: 'GARNET_JAN',
    Pearl: 'PEARL',
    PeridotAug: 'PERIDOT_AUG',
    RubyJul: 'RUBY_JUL',
    SapphireSep: 'SAPPHIRE_SEP',
    TanzaniteDec: 'TANZANITE_DEC',
    TopazNov: 'TOPAZ_NOV',
    TourmalineOct: 'TOURMALINE_OCT',
} as const

export type JewelleryGemstoneCode =
    (typeof JewelleryGemstoneCode)[keyof typeof JewelleryGemstoneCode]
export type JewelleryGemstoneLabel = {
    __typename: 'JewelleryGemstoneLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryGemstoneCode
    translation: ProductLabelTranslation
}

export type JewelleryGemstoneLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryNecklaceProductStyle = {
    Chain: 'CHAIN',
    Choker: 'CHOKER',
    Layered: 'LAYERED',
    Long: 'LONG',
    Short: 'SHORT',
    Solitaire: 'SOLITAIRE',
    Tennis: 'TENNIS',
} as const

export type JewelleryNecklaceProductStyle =
    (typeof JewelleryNecklaceProductStyle)[keyof typeof JewelleryNecklaceProductStyle]
export type JewelleryNecklaceProductStyleLabel = {
    __typename: 'JewelleryNecklaceProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryNecklaceProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryNecklaceProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const JewelleryRingProductStyle = {
    Cocktail: 'COCKTAIL',
    Promise: 'PROMISE',
    Signet: 'SIGNET',
    Stackable: 'STACKABLE',
} as const

export type JewelleryRingProductStyle =
    (typeof JewelleryRingProductStyle)[keyof typeof JewelleryRingProductStyle]
export type JewelleryRingProductStyleLabel = {
    __typename: 'JewelleryRingProductStyleLabel'
    icon: Maybe<Asset>
    systemCode: JewelleryRingProductStyle
    translation: ProductLabelTranslation
}

export type JewelleryRingProductStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type Job = {
    __typename: 'Job'
    applicationRecipientEmail: Scalars['String']['output']
    closingDate: Maybe<Scalars['String']['output']>
    content: Array<ContentComponentItem>
    contractType: Scalars['String']['output']
    expandedByDefault: Scalars['Boolean']['output']
    location: Scalars['String']['output']
    postedDate: Scalars['String']['output']
    salary: Scalars['String']['output']
    startDate: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
    vacancyReference: Maybe<Scalars['String']['output']>
}

export type KlarnaFinanceOption = {
    __typename: 'KlarnaFinanceOption'
    months: Scalars['Int']['output']
    perMonth: Money
    price: Money
}

export type KlarnaPaymentInput = {
    data: Scalars['String']['input']
    orderId: Scalars['ID']['input']
}

export type KlarnaPaymentMethod = {
    __typename: 'KlarnaPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type KlarnaPaymentResponse = {
    __typename: 'KlarnaPaymentResponse'
    errors: Array<Scalars['String']['output']>
    order: Order
}

export type KlarnaTransaction = TransactionInterface & {
    __typename: 'KlarnaTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    sessionData: Scalars['JSON']['output']
    status: TransactionStatus
}

export type KlarnaTransactionInput = {
    /** deposit amount within 20% and 50% of order total */
    depositAmount: Scalars['Decimal']['input']
    orderId: Scalars['ID']['input']
}

export type Language = {
    __typename: 'Language'
    locale: Scalars['Locale']['output']
    translations: Array<Translation>
}

export type LegacyTransaction = TransactionInterface & {
    __typename: 'LegacyTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    paymentMethodName: Scalars['String']['output']
    status: TransactionStatus
}

export type LegacyTransactionPaymentMethodNameArgs = {
    locale: Scalars['Locale']['input']
}

export type Link = {
    __typename: 'Link'
    item: LinkItem
    target: LinkTarget
    text: Scalars['String']['output']
}

export type LinkItem =
    | LinkItemAffirm
    | LinkItemBookingForm
    | LinkItemCustom
    | LinkItemOpenContactForm
    | LinkItemOpenEnquiryForm
    | LinkItemOpenIntercom
    | LinkItemOpenSpeakToExpertModal
    | Page
    | Post
    | Questionnaire

export type LinkItemAffirm = {
    __typename: 'LinkItemAffirm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemBookingForm = {
    __typename: 'LinkItemBookingForm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemCustom = {
    __typename: 'LinkItemCustom'
    url: Scalars['String']['output']
}

export type LinkItemOpenContactForm = {
    __typename: 'LinkItemOpenContactForm'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemOpenEnquiryForm = {
    __typename: 'LinkItemOpenEnquiryForm'
    cmsEnquiryFormType: CmsEnquiryFormType
    enquiryType: EnquiryType
}

export type LinkItemOpenIntercom = {
    __typename: 'LinkItemOpenIntercom'
    emptyField: Maybe<Scalars['String']['output']>
}

export type LinkItemOpenSpeakToExpertModal = {
    __typename: 'LinkItemOpenSpeakToExpertModal'
    emptyField: Maybe<Scalars['String']['output']>
}

export const LinkTarget = {
    Blank: 'BLANK',
    Self: 'SELF',
} as const

export type LinkTarget = (typeof LinkTarget)[keyof typeof LinkTarget]
export type LoginResponse = LoginResponseFailure | LoginResponseSuccess

export const LoginResponseErrorCode = {
    InvalidCredentials: 'INVALID_CREDENTIALS',
} as const

export type LoginResponseErrorCode =
    (typeof LoginResponseErrorCode)[keyof typeof LoginResponseErrorCode]
export type LoginResponseFailure = {
    __typename: 'LoginResponseFailure'
    code: LoginResponseErrorCode
    message: Scalars['String']['output']
}

export type LoginResponseFailureMessageArgs = {
    locale: Scalars['Locale']['input']
}

export type LoginResponseSuccess = {
    __typename: 'LoginResponseSuccess'
    jwt: Scalars['String']['output']
    user: User
}

export type Logo = {
    __typename: 'Logo'
    image: Image
    link: Maybe<Scalars['String']['output']>
}

export type LogoWithText = {
    __typename: 'LogoWithText'
    description: Maybe<Scalars['String']['output']>
    image: Image
    link: Maybe<Link>
    title: Scalars['String']['output']
}

export type MagicLinkConsume = {
    email: Scalars['Email']['input']
    expires: Scalars['Int']['input']
    hash: Scalars['String']['input']
}

export type MagicLinkConsumeError = {
    __typename: 'MagicLinkConsumeError'
    message: Scalars['String']['output']
}

export type MagicLinkConsumeResponse =
    | MagicLinkConsumeError
    | MagicLinkConsumeSuccess

export type MagicLinkConsumeSuccess = {
    __typename: 'MagicLinkConsumeSuccess'
    login: LoginResponseSuccess
}

export type MagicLinkRequest = {
    email: Scalars['Email']['input']
    redirect: Scalars['Uri']['input']
}

export type MarketingDataInput = {
    clientId?: InputMaybe<Scalars['String']['input']>
    fbclid?: InputMaybe<Scalars['String']['input']>
    fbp?: InputMaybe<Scalars['String']['input']>
    ftSetTime?: InputMaybe<Scalars['DateTime']['input']>
    ftUtm: UtmInput
    gclid?: InputMaybe<Scalars['String']['input']>
    ltUtm: UtmInput
    sessionId?: InputMaybe<Scalars['String']['input']>
}

export type MarketingDataResponse = {
    __typename: 'MarketingDataResponse'
    success: Scalars['Boolean']['output']
}

export type Media = {
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    url: Scalars['String']['output']
}

export type Melee = {
    __typename: 'Melee'
    caratWeight: Scalars['Decimal']['output']
    clarities: Array<StoneClarity>
    colors: Array<StoneColor>
    crystal: StoneCrystal
    grade: Maybe<StoneGrade>
    id: Scalars['ID']['output']
    segmentName: Scalars['String']['output']
    shape: StoneShape
    width: Scalars['String']['output']
}

export type MenuItem = {
    __typename: 'MenuItem'
    hideOnDesktop: Scalars['Boolean']['output']
    hideOnMobile: Scalars['Boolean']['output']
    link: Link
    subMenu: Maybe<SubMenu>
    title: Scalars['String']['output']
}

export type Meta = {
    __typename: 'Meta'
    description: Scalars['String']['output']
    image: Maybe<Image>
    robots: Maybe<Robots>
    title: Scalars['String']['output']
}

export type Metal = {
    __typename: 'Metal'
    color: Maybe<MetalColor>
    element: MetalElement
    karat: Maybe<Scalars['Int']['output']>
    millesimalFineness: Scalars['Decimal']['output']
    orderIndex: Scalars['Int']['output']
    segmentName: Scalars['String']['output']
    systemCode: MetalCode
    translation: MetalTranslation
}

export type MetalTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalCode = {
    EighteenKaratRoseGold: 'EIGHTEEN_KARAT_ROSE_GOLD',
    EighteenKaratWhiteGold: 'EIGHTEEN_KARAT_WHITE_GOLD',
    EighteenKaratYellowGold: 'EIGHTEEN_KARAT_YELLOW_GOLD',
    FourteenKaratRoseGold: 'FOURTEEN_KARAT_ROSE_GOLD',
    FourteenKaratWhiteGold: 'FOURTEEN_KARAT_WHITE_GOLD',
    FourteenKaratYellowGold: 'FOURTEEN_KARAT_YELLOW_GOLD',
    NineKaratRoseGold: 'NINE_KARAT_ROSE_GOLD',
    NineKaratWhiteGold: 'NINE_KARAT_WHITE_GOLD',
    NineKaratYellowGold: 'NINE_KARAT_YELLOW_GOLD',
    Platinum: 'PLATINUM',
    Silver: 'SILVER',
} as const

export type MetalCode = (typeof MetalCode)[keyof typeof MetalCode]
export type MetalColor = {
    __typename: 'MetalColor'
    systemCode: MetalColorCode
    translation: MetalColorTranslation
}

export type MetalColorTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalColorCode = {
    Rose: 'ROSE',
    White: 'WHITE',
    Yellow: 'YELLOW',
} as const

export type MetalColorCode =
    (typeof MetalColorCode)[keyof typeof MetalColorCode]
export type MetalColorTranslation = {
    __typename: 'MetalColorTranslation'
    name: Scalars['String']['output']
}

export type MetalElement = {
    __typename: 'MetalElement'
    systemCode: MetalElementCode
    translation: MetalElementTranslation
}

export type MetalElementTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const MetalElementCode = {
    Gold: 'GOLD',
    Platinum: 'PLATINUM',
    Silver: 'SILVER',
} as const

export type MetalElementCode =
    (typeof MetalElementCode)[keyof typeof MetalElementCode]
export type MetalElementTranslation = {
    __typename: 'MetalElementTranslation'
    name: Scalars['String']['output']
}

export type MetalTranslation = {
    __typename: 'MetalTranslation'
    name: Scalars['String']['output']
}

export type Money = {
    __typename: 'Money'
    amount: Scalars['Decimal']['output']
    currency: Scalars['Currency']['output']
}

export type MoneyInput = {
    amount: Scalars['Decimal']['input']
    currency: CurrencyInput
}

export type MonolithImageSize = {
    __typename: 'MonolithImageSize'
    name: MonolithImageSizeName
    sources: Array<ImageSrc>
    url: Scalars['String']['output']
}

export const MonolithImageSizeName = {
    Cover: 'COVER',
    CoverX2: 'COVER_X2',
    Large: 'LARGE',
    LargeX2: 'LARGE_X2',
    Medium: 'MEDIUM',
    MediumX2: 'MEDIUM_X2',
    Small: 'SMALL',
    SmallX2: 'SMALL_X2',
} as const

export type MonolithImageSizeName =
    (typeof MonolithImageSizeName)[keyof typeof MonolithImageSizeName]
export type MultiUsePromoCode = BasePromoCode & {
    __typename: 'MultiUsePromoCode'
    code: Scalars['String']['output']
    id: Scalars['ID']['output']
    promoCodeRuleset: Maybe<PromoCodeRuleset>
}

export type Mutation = {
    __typename: 'Mutation'
    activateWarranty: Maybe<Scalars['Void']['output']>
    addDesignStudioProductToMyCart: Order
    addFinalCustomerPriceSurcharge: AddToCartExistingCustomerResult
    addToCartReadyToGoRingExistingCustomer: AddToCartReadyToGoRingExistingCustomerResponse
    addToCartReadyToGoRingNewCustomer: AddToCartReadyToGoRingNewCustomerResponse
    applyPromoCode: Maybe<PromoCodeApplicationResult>
    applyPromoCodeByConsultant: Maybe<PromoCodeApplicationResult>
    /** @deprecated Booking form has to be reworked from the ground. */
    applyTransitionToConsultationByConsultant: Maybe<BookingConsultation>
    autologin: LoginResponse
    cancelActionOnReader: StripeTerminalReaderResponse
    cancelConsultation: Scalars['Boolean']['output']
    completeAffirmTransactionPostIframe: AffirmCompleteTransactionResponse
    completeCheckoutcomTransactionPost3ds: CompleteCheckoutcomTransactionPost3dsResponse
    consultantLogin: LoginResponse
    createAffirmTransaction: AffirmTransaction
    createAllocationTransaction: AllocationTransaction
    createBankTransaction: BankTransaction
    createCheckoutcomTransaction: CreateCheckoutcomTransactionResponse
    /** @deprecated Booking form has to be reworked from the ground. */
    createConsultationByConsultant: Maybe<BookingConsultation>
    /** For logged user */
    createConsultationExistingCustomer: BookingCreateConsultationExistingCustomerResponse
    /** For not-logged user */
    createConsultationNewCustomer: BookingCreateConsultationNewCustomerResponse
    createCustomerByConsultant: CustomerCreatedByConsultant
    createCustomerThroughQuestionnaireWithoutQuestionnaire: CustomerRegistrationResponse
    createDesignInspiration: DesignInspiration
    createDesignStudioProductAndAddToCartJewelleryExistingCustomer: CatalogueDesignStudioCheckoutJewelleryExistingCustomerResponse
    createDesignStudioProductAndAddToCartJewelleryNewCustomer: CatalogueDesignStudioCheckoutJewelleryNewCustomerResponse
    createDesignStudioProductAndAddToCartWeddingRingExistingCustomer: CatalogueDesignStudioCheckoutWeddingRingExistingCustomerResponse
    createDesignStudioProductAndAddToCartWeddingRingNewCustomer: CatalogueDesignStudioCheckoutWeddingRingNewCustomerResponse
    createEnquiryContactUsExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryContactUsNewCustomer: EnquiryResponseNewCustomer
    createEnquiryCustomEngagementRingExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryCustomEngagementRingNewCustomer: EnquiryResponseNewCustomer
    createEnquiryDiamondSearchProductExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryDiamondSearchProductNewCustomer: EnquiryResponseNewCustomer
    createEnquiryEngagementRingPreferAnotherShapeExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryEngagementRingPreferAnotherShapeNewCustomer: EnquiryResponseNewCustomer
    createEnquiryExistingCustomer: EnquiryResponseExistingCustomer
    createEnquiryNewCustomer: EnquiryResponseNewCustomer
    createKlarnaTransaction: KlarnaTransaction
    customerSetDiscoveryDataByConsultant: Customer
    customerSetNoteByConsultant: Maybe<Customer>
    customerSetReferral: Maybe<CustomerReferralResult>
    customerSetReferralByConsultant: Maybe<CustomerReferralResult>
    deletePromoCodeByConsultant: Maybe<PromoCodeApplicationResult>
    designStudioProductEngagementRingUpdate: DesignStudioProductEngagementRing
    designStudioProductWeddingRingUpdate: DesignStudioProductWeddingRing
    impersonate: Maybe<LoginResponse>
    invalidateCache: InvalidateCacheResult
    login: LoginResponse
    loginWithApple: LoginResponse
    loginWithFacebook: LoginResponse
    loginWithGoogle: LoginResponse
    logout: Scalars['Boolean']['output']
    magicLinkConsume: MagicLinkConsumeResponse
    magicLinkRequest: Maybe<Scalars['Void']['output']>
    marketingData: MarketingDataResponse
    nonSkuGemStoneChangeImage: NonSkuGemstone
    /** @deprecated use nonSkuGemStoneCreateOrUpdate */
    nonSkuGemStoneCreate: NonSkuGemstone
    nonSkuGemStoneDelete: NonSkuGemstone
    nonSkuGemStoneDeleteImage: NonSkuGemstone
    nonSkuGemstoneCaratDimensionCreate: NonSkuGemstoneCaratDimension
    nonSkuGemstoneCaratDimensionDelete: NonSkuGemstoneCaratDimension
    nonSkuGemstoneColorCrystalDimensionCreate: NonSkuGemstoneType
    nonSkuGemstoneColorCrystalDimensionDelete: NonSkuGemstoneType
    nonSkuGemstoneGradeClarityDimensionCreate: NonSkuGemstoneGradeClarityDimension
    nonSkuGemstoneGradeClarityDimensionDelete: NonSkuGemstoneGradeClarityDimension
    nonSkuGemstoneImageCreate: NonSkuGemstoneImage
    nonSkuGemstoneImageDelete: NonSkuGemstoneImage
    nonSkuGemstoneImageUpdate: NonSkuGemstoneImage
    nonSkuGemstoneShapeDimensionCreate: NonSkuGemstoneShapeDimension
    nonSkuGemstoneShapeDimensionDelete: NonSkuGemstoneShapeDimension
    nonSkuLabGrownCaratDimensionCreate: NonSkuLabGrownCaratDimension
    nonSkuLabGrownCaratDimensionDelete: NonSkuLabGrownCaratDimension
    nonSkuLabGrownDiamondChangeImage: NonSkuLabGrown
    /** @deprecated use nonSkuLabGrownDiamondCreateOrUpdate */
    nonSkuLabGrownDiamondCreate: NonSkuLabGrown
    nonSkuLabGrownDiamondDelete: NonSkuLabGrown
    nonSkuLabGrownDiamondDeleteImage: NonSkuLabGrown
    nonSkuLabGrownGradeDimensionCreate: NonSkuLabGrownGradeDimension
    nonSkuLabGrownGradeDimensionDelete: NonSkuLabGrownGradeDimension
    nonSkuLabGrownShapeDimensionCreate: NonSkuLabGrownShapeDimension
    nonSkuLabGrownShapeDimensionDelete: NonSkuLabGrownShapeDimension
    nonSkuLabGrownShapeDimensionUpdate: NonSkuLabGrownShapeDimension
    payViaAffirm: AffirmPaymentResponse
    payViaAllocation: Order
    payViaBank: Order
    payViaCheckoutcom: PayViaCheckoutcomResponse
    payViaKlarna: KlarnaPaymentResponse
    payViaNoPayment: Order
    ping: Scalars['String']['output']
    processPaymentIntent: StripePaymentResponse
    questionnaireCompleteExistingCustomer: QuestionnaireCompletedExistingCustomerResponse
    questionnaireCompleteNewCustomer: QuestionnaireCompletedNewCustomerResponse
    quotationEngagementRingUpdate: QuotationEngagementRing
    removeFinalCustomerPriceSurcharge: AddToCartExistingCustomerResult
    removeFromCartByConsultant: Order
    removeFromMyCart: Order
    removeFromRetailCartByConsultant: Order
    retailCreateConsultation: Maybe<RetailCreateConsultationResponse>
    retailUpdateConsultationComment: Maybe<BookingConsultation>
    retryPaymentIntent: StripePaymentIntentResponse
    ringBuilder: RingBuilder
    ringBuilderResolveExistingCustomer: RingBuilderResolvedExistingCustomer
    ringBuilderResolveNewCustomer: RingBuilderResolvedNewCustomer
    ringBuilderSet: RingBuilderSetResult
    sendPaymentIntent: StripePaymentIntentResponse
    setOrderCollectFromShowroomInformation: SetDeliveryInformationResponse
    setOrderDeliverToAddressInformation: SetDeliveryInformationResponse
    stockInStoreAddToCartByConsultant: Maybe<AddToCartExistingCustomerResult>
    stripePresentPaymentMethod: Maybe<Scalars['Void']['output']>
    /** @deprecated Booking form has to be reworked from the ground. */
    updateConsultationByConsultant: Maybe<BookingConsultation>
}

export type MutationActivateWarrantyArgs = {
    input: ActivateWarrantyInput
}

export type MutationAddDesignStudioProductToMyCartArgs = {
    productId: Scalars['ID']['input']
}

export type MutationAddFinalCustomerPriceSurchargeArgs = {
    input: AddFinalCustomerPriceSurchargeInput
}

export type MutationAddToCartReadyToGoRingExistingCustomerArgs = {
    input: AddToCartReadyToGoRingInput
}

export type MutationAddToCartReadyToGoRingNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: AddToCartReadyToGoRingInput
}

export type MutationApplyPromoCodeArgs = {
    promoCode: Scalars['String']['input']
}

export type MutationApplyPromoCodeByConsultantArgs = {
    customerId: Scalars['ID']['input']
    promoCode: Scalars['String']['input']
}

export type MutationApplyTransitionToConsultationByConsultantArgs = {
    id: Scalars['ID']['input']
    transition: BookingConsultationTransition
}

export type MutationAutologinArgs = {
    authToken: Scalars['String']['input']
    input: InputMaybe<AutologinInput>
}

export type MutationCancelActionOnReaderArgs = {
    readerId: Scalars['ID']['input']
}

export type MutationCancelConsultationArgs = {
    input: BookingCancelConsultationInput
}

export type MutationCompleteAffirmTransactionPostIframeArgs = {
    input: AffirmCompleteTransactionInput
}

export type MutationCompleteCheckoutcomTransactionPost3dsArgs = {
    input: CompleteCheckoutcomTransactionInput
}

export type MutationConsultantLoginArgs = {
    credentials: CredentialsInput
}

export type MutationCreateAffirmTransactionArgs = {
    input: AffirmTransactionInput
}

export type MutationCreateAllocationTransactionArgs = {
    input: AllocationTransactionInput
}

export type MutationCreateBankTransactionArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationCreateCheckoutcomTransactionArgs = {
    input: CreateCheckoutcomTransactionInput
}

export type MutationCreateConsultationByConsultantArgs = {
    autoAssignConsultant: Scalars['Boolean']['input']
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    customer: Scalars['ID']['input']
    input: BookingConsultationMutableFields
    isWalkIn: Scalars['Boolean']['input']
    opportunity: InputMaybe<Scalars['String']['input']>
    order: InputMaybe<Scalars['ID']['input']>
    productDesignComplexity: InputMaybe<BookingConsultationProductDesignComplexityCode>
    reassignOpportunity: Scalars['Boolean']['input']
}

export type MutationCreateConsultationExistingCustomerArgs = {
    input: BookingCreateConsultationInput
}

export type MutationCreateConsultationNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: BookingCreateConsultationInput
}

export type MutationCreateCustomerByConsultantArgs = {
    info: InputMaybe<CreateCustomerByConsultantInput>
    input: InputMaybe<CustomerRegistrationInput>
}

export type MutationCreateCustomerThroughQuestionnaireWithoutQuestionnaireArgs =
    {
        input: CustomerRegistrationInput
        type: QuestionnaireType
    }

export type MutationCreateDesignInspirationArgs = {
    file: Scalars['Upload']['input']
}

export type MutationCreateDesignStudioProductAndAddToCartJewelleryExistingCustomerArgs =
    {
        input: DesignStudioJewelleryInput
    }

export type MutationCreateDesignStudioProductAndAddToCartJewelleryNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: DesignStudioJewelleryInput
    }

export type MutationCreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerArgs =
    {
        input: DesignStudioWeddingRingInput
    }

export type MutationCreateDesignStudioProductAndAddToCartWeddingRingNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: DesignStudioWeddingRingInput
    }

export type MutationCreateEnquiryContactUsExistingCustomerArgs = {
    input: EnquiryContactUsInput
}

export type MutationCreateEnquiryContactUsNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryContactUsInput
}

export type MutationCreateEnquiryCustomEngagementRingExistingCustomerArgs = {
    input: EnquiryCustomEngagementRing
}

export type MutationCreateEnquiryCustomEngagementRingNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryCustomEngagementRing
}

export type MutationCreateEnquiryDiamondSearchProductExistingCustomerArgs = {
    input: EnquiryDiamondSearchProduct
}

export type MutationCreateEnquiryDiamondSearchProductNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryDiamondSearchProduct
}

export type MutationCreateEnquiryEngagementRingPreferAnotherShapeExistingCustomerArgs =
    {
        input: EnquiryEngagementRingCollectionInput
    }

export type MutationCreateEnquiryEngagementRingPreferAnotherShapeNewCustomerArgs =
    {
        customer: CustomerRegistrationInput
        input: EnquiryEngagementRingCollectionInput
    }

export type MutationCreateEnquiryExistingCustomerArgs = {
    input: EnquiryInput
}

export type MutationCreateEnquiryNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: EnquiryInput
}

export type MutationCreateKlarnaTransactionArgs = {
    input: KlarnaTransactionInput
}

export type MutationCustomerSetDiscoveryDataByConsultantArgs = {
    customer: Scalars['ID']['input']
    input: CustomerSetDiscoveryDataInput
}

export type MutationCustomerSetNoteByConsultantArgs = {
    customerId: Scalars['ID']['input']
    input: CustomerSetNoteInput
}

export type MutationCustomerSetReferralArgs = {
    input: CustomerReferralInput
}

export type MutationCustomerSetReferralByConsultantArgs = {
    customerId: Scalars['ID']['input']
    input: CustomerReferralInput
}

export type MutationDeletePromoCodeByConsultantArgs = {
    id: Scalars['ID']['input']
}

export type MutationDesignStudioProductEngagementRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioProductEngagementRingUpdate
}

export type MutationDesignStudioProductWeddingRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioProductWeddingRingUpdate
}

export type MutationImpersonateArgs = {
    identifier: Scalars['String']['input']
}

export type MutationInvalidateCacheArgs = {
    tags: InputMaybe<Array<Scalars['String']['input']>>
}

export type MutationLoginArgs = {
    credentials: CredentialsInput
}

export type MutationLoginWithAppleArgs = {
    credentials: CustomerRegistrationByAppleInput
}

export type MutationLoginWithFacebookArgs = {
    credentials: CustomerRegistrationByFacebookInput
}

export type MutationLoginWithGoogleArgs = {
    credentials: CustomerRegistrationByGoogleInput
}

export type MutationMagicLinkConsumeArgs = {
    input: MagicLinkConsume
}

export type MutationMagicLinkRequestArgs = {
    input: MagicLinkRequest
}

export type MutationMarketingDataArgs = {
    input: MarketingDataInput
}

export type MutationNonSkuGemStoneChangeImageArgs = {
    id: Scalars['ID']['input']
    image: Scalars['Upload']['input']
}

export type MutationNonSkuGemStoneCreateArgs = {
    input: NonSkuGemStoneCreateInput
}

export type MutationNonSkuGemStoneDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemStoneDeleteImageArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneCaratDimensionCreateArgs = {
    input: NonSkuGemstoneCaratDimensionCreateInput
}

export type MutationNonSkuGemstoneCaratDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneColorCrystalDimensionCreateArgs = {
    input: NonSkuGemstoneColorCrystalDimensionCreateInput
}

export type MutationNonSkuGemstoneColorCrystalDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneGradeClarityDimensionCreateArgs = {
    input: NonSkuGemstoneGradeClarityDimensionCreateInput
}

export type MutationNonSkuGemstoneGradeClarityDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneImageCreateArgs = {
    input: NonSkuGemstoneImageCreateInput
}

export type MutationNonSkuGemstoneImageDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuGemstoneImageUpdateArgs = {
    id: Scalars['ID']['input']
    input: NonSkuGemstoneImageUpdateInput
}

export type MutationNonSkuGemstoneShapeDimensionCreateArgs = {
    input: NonSkuGemstoneShapeDimensionCreateInput
}

export type MutationNonSkuGemstoneShapeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownCaratDimensionCreateArgs = {
    input: NonSkuLabGrownCaratDimensionCreateInput
}

export type MutationNonSkuLabGrownCaratDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownDiamondChangeImageArgs = {
    id: Scalars['ID']['input']
    image: Scalars['Upload']['input']
}

export type MutationNonSkuLabGrownDiamondCreateArgs = {
    input: NonSkuLabGrownDiamondCreateInput
}

export type MutationNonSkuLabGrownDiamondDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownDiamondDeleteImageArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownGradeDimensionCreateArgs = {
    input: NonSkuLabGrownGradeDimensionCreateInput
}

export type MutationNonSkuLabGrownGradeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownShapeDimensionCreateArgs = {
    input: NonSkuLabGrownShapeDimensionCreateInput
}

export type MutationNonSkuLabGrownShapeDimensionDeleteArgs = {
    id: Scalars['ID']['input']
}

export type MutationNonSkuLabGrownShapeDimensionUpdateArgs = {
    id: Scalars['ID']['input']
    input: NonSkuLabGrownShapeDimensionUpdateInput
}

export type MutationPayViaAffirmArgs = {
    input: AffirmPaymentInput
}

export type MutationPayViaAllocationArgs = {
    allocationTransactionId: Scalars['ID']['input']
}

export type MutationPayViaBankArgs = {
    bankTransactionId: Scalars['ID']['input']
}

export type MutationPayViaCheckoutcomArgs = {
    input: PayViaCheckoutcomInput
}

export type MutationPayViaKlarnaArgs = {
    input: KlarnaPaymentInput
}

export type MutationPayViaNoPaymentArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationProcessPaymentIntentArgs = {
    paymentIntentId: Scalars['ID']['input']
    readerId: Scalars['ID']['input']
}

export type MutationQuestionnaireCompleteExistingCustomerArgs = {
    input: QuestionnaireCompleteInput
}

export type MutationQuestionnaireCompleteNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: QuestionnaireCompleteInput
}

export type MutationQuotationEngagementRingUpdateArgs = {
    id: Scalars['ID']['input']
    input: DesignStudioQuotationEngagementRingUpdate
}

export type MutationRemoveFinalCustomerPriceSurchargeArgs = {
    input: RemoveFinalCustomerPriceSurchargeInput
}

export type MutationRemoveFromCartByConsultantArgs = {
    customerId: Scalars['ID']['input']
    input: RemoveFromCartInput
}

export type MutationRemoveFromMyCartArgs = {
    productId: Scalars['ID']['input']
}

export type MutationRemoveFromRetailCartByConsultantArgs = {
    customerId: Scalars['ID']['input']
    input: RemoveFromCartInput
}

export type MutationRetailCreateConsultationArgs = {
    input: RetailCreateConsultationInput
}

export type MutationRetailUpdateConsultationCommentArgs = {
    comment: Scalars['String']['input']
    id: Scalars['ID']['input']
}

export type MutationRetryPaymentIntentArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationRingBuilderArgs = {
    input: RingBuilderInput
}

export type MutationRingBuilderResolveExistingCustomerArgs = {
    input: RingBuilderResolveInput
}

export type MutationRingBuilderResolveNewCustomerArgs = {
    customer: CustomerRegistrationInput
    input: RingBuilderResolveInput
}

export type MutationRingBuilderSetArgs = {
    input: RingBuilderInput
}

export type MutationSendPaymentIntentArgs = {
    orderId: Scalars['ID']['input']
}

export type MutationSetOrderCollectFromShowroomInformationArgs = {
    input: CollectFromShowroomInput
}

export type MutationSetOrderDeliverToAddressInformationArgs = {
    input: DeliverToAddressInput
}

export type MutationStockInStoreAddToCartByConsultantArgs = {
    customerId: Scalars['ID']['input']
    input: StockInStoreAddToCart
}

export type MutationStripePresentPaymentMethodArgs = {
    input: InputMaybe<PresentPaymentMethodInput>
    terminalReaderId: Scalars['ID']['input']
}

export type MutationUpdateConsultationByConsultantArgs = {
    consultationRoom: InputMaybe<Scalars['ID']['input']>
    id: Scalars['ID']['input']
    input: BookingConsultationMutableFields
    isWalkIn: Scalars['Boolean']['input']
    reassignOpportunity: Scalars['Boolean']['input']
}

export type NoPaymentMethod = {
    __typename: 'NoPaymentMethod'
    systemCode: Scalars['ID']['output']
}

export type NonSkuCaratWeightRange = {
    __typename: 'NonSkuCaratWeightRange'
    max: Scalars['Decimal']['output']
    min: Scalars['Decimal']['output']
}

export type NonSkuCaratWeightRangeInput = {
    max?: InputMaybe<Scalars['Decimal']['input']>
    min?: InputMaybe<Scalars['Decimal']['input']>
}

export type NonSkuGemStoneCreateInput = {
    caratDimensionId: Scalars['ID']['input']
    colorCrystalDimensionId: Scalars['ID']['input']
    gradeClarityDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuGemStoneInterface = {
    caratWeight: Scalars['Decimal']['output']
    clarity: StoneClarity
    color: StoneColor
    colorGrade: StoneGrade
    crystal: StoneCrystal
    cut: StoneCut
}

export type NonSkuGemStonesPricingCellFilters = {
    colorCrystalDimensionId?: InputMaybe<Scalars['ID']['input']>
    gradeClarityDimensionId?: InputMaybe<Scalars['ID']['input']>
}

export type NonSkuGemstone = NonSkuGemStoneInterface &
    NonSkuInterface & {
        __typename: 'NonSkuGemstone'
        caratDimension: NonSkuGemstoneCaratDimension
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        colorCrystalDimension: NonSkuGemstoneType
        colorGrade: StoneGrade
        crystal: StoneCrystal
        cut: StoneCut
        gradeClarityDimension: NonSkuGemstoneGradeClarityDimension
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Maybe<Money>
        sampleImage: Maybe<NonSkuImage>
        shape: StoneShape
        shapeDimension: NonSkuGemstoneShapeDimension
        uniqueImage: Maybe<NonSkuImage>
    }

export type NonSkuGemstoneSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuGemstoneCaratDimension = {
    __typename: 'NonSkuGemstoneCaratDimension'
    caratWeight: Scalars['Decimal']['output']
    id: Scalars['ID']['output']
}

export type NonSkuGemstoneCaratDimensionCreateInput = {
    caratWeight: Scalars['Decimal']['input']
}

export type NonSkuGemstoneColorCrystalDimensionCreateInput = {
    color: StoneColorCode
    crystal: StoneCrystalCode
}

export type NonSkuGemstoneFilterInput = {
    carat: Scalars['Decimal']['input']
    clarity: StoneClarityCode
    color: StoneColorCode
    crystal: StoneCrystalCode
    grade: StoneGradeCode
    shape: StoneShapeCode
}

export type NonSkuGemstoneFilters = {
    caratWeightRange?: InputMaybe<NonSkuCaratWeightRangeInput>
    priceRange?: InputMaybe<NonSkuPriceRangeInput>
    shape?: InputMaybe<StoneShapeCode>
    types?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type NonSkuGemstoneGradeClarityDimension = {
    __typename: 'NonSkuGemstoneGradeClarityDimension'
    clarity: StoneClarity
    grade: StoneGrade
    id: Scalars['ID']['output']
}

export type NonSkuGemstoneGradeClarityDimensionCreateInput = {
    clarity: StoneClarityCode
    grade: StoneGradeCode
}

export type NonSkuGemstoneImage = {
    __typename: 'NonSkuGemstoneImage'
    colorCrystalDimension: Maybe<NonSkuGemstoneType>
    id: Scalars['ID']['output']
    image: Maybe<NonSkuImage>
    shapeDimension: Maybe<NonSkuGemstoneShapeDimension>
}

export type NonSkuGemstoneImageCreateInput = {
    colorCrystalDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuGemstoneImageUpdateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
}

export type NonSkuGemstoneShapeDimension = {
    __typename: 'NonSkuGemstoneShapeDimension'
    id: Scalars['ID']['output']
    shape: StoneShape
}

export type NonSkuGemstoneShapeDimensionCreateInput = {
    shape: StoneShapeCode
}

export const NonSkuGemstoneSortField = {
    Carat: 'CARAT',
    Price: 'PRICE',
} as const

export type NonSkuGemstoneSortField =
    (typeof NonSkuGemstoneSortField)[keyof typeof NonSkuGemstoneSortField]
export type NonSkuGemstoneSortInput = {
    direction: NonSkuSortDirection
    field: NonSkuGemstoneSortField
}

export type NonSkuGemstoneType = {
    __typename: 'NonSkuGemstoneType'
    color: StoneColor
    crystal: StoneCrystal
    id: Scalars['ID']['output']
}

export type NonSkuGemstonesBounds = {
    __typename: 'NonSkuGemstonesBounds'
    caratWeight: NonSkuCaratWeightRange
    price: Maybe<NonSkuPriceRange>
    shapes: Array<StoneShape>
    types: Array<NonSkuGemstoneType>
}

export type NonSkuGemstonesBoundsPriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuImage = {
    __typename: 'NonSkuImage'
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    size: MonolithImageSize
    sources: Array<ImageSrc>
    url: Scalars['Uri']['output']
}

export type NonSkuImageSizeArgs = {
    name: MonolithImageSizeName
}

export type NonSkuInterface = {
    caratWeight: Scalars['Decimal']['output']
    image: Maybe<NonSkuImage>
    shape: StoneShape
}

export type NonSkuLabGrown = NonSkuInterface &
    NonSkuLabGrownInterface & {
        __typename: 'NonSkuLabGrown'
        caratDimension: NonSkuLabGrownCaratDimension
        caratWeight: Scalars['Decimal']['output']
        clarity: StoneClarity
        color: StoneColor
        crystal: StoneCrystal
        cut: StoneCut
        gradeDimension: NonSkuLabGrownGradeDimension
        id: Scalars['ID']['output']
        image: Maybe<NonSkuImage>
        salePrice: Maybe<Money>
        sampleImage: Maybe<NonSkuImage>
        shape: StoneShape
        shapeDimension: NonSkuLabGrownShapeDimension
        uniqueImage: Maybe<NonSkuImage>
    }

export type NonSkuLabGrownSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuLabGrownCaratDimension = {
    __typename: 'NonSkuLabGrownCaratDimension'
    caratWeight: Scalars['Decimal']['output']
    id: Scalars['ID']['output']
}

export type NonSkuLabGrownCaratDimensionCreateInput = {
    caratWeight: Scalars['Decimal']['input']
}

export type NonSkuLabGrownDiamondCreateInput = {
    caratDimensionId: Scalars['ID']['input']
    gradeDimensionId: Scalars['ID']['input']
    image?: InputMaybe<Scalars['Upload']['input']>
    shapeDimensionId: Scalars['ID']['input']
}

export type NonSkuLabGrownDiamondFilterInput = {
    carat: Scalars['Decimal']['input']
    clarity: StoneClarityCode
    color: StoneColorCode
    shape: StoneShapeCode
}

export type NonSkuLabGrownDiamondSortInput = {
    direction: NonSkuSortDirection
    field: NonSkuLabGrownSortField
}

export type NonSkuLabGrownDiamondsBounds = {
    __typename: 'NonSkuLabGrownDiamondsBounds'
    caratWeight: NonSkuCaratWeightRange
    colors: Array<StoneColor>
    price: Maybe<NonSkuPriceRange>
    shapes: Array<StoneShape>
}

export type NonSkuLabGrownDiamondsBoundsPriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type NonSkuLabGrownDiamondsFilters = {
    caratWeightRange?: InputMaybe<NonSkuCaratWeightRangeInput>
    colors?: InputMaybe<Array<StoneColorCode>>
    priceRange?: InputMaybe<NonSkuPriceRangeInput>
    shape?: InputMaybe<StoneShapeCode>
}

export type NonSkuLabGrownGradeDimension = {
    __typename: 'NonSkuLabGrownGradeDimension'
    clarity: StoneClarity
    color: StoneColor
    id: Scalars['ID']['output']
}

export type NonSkuLabGrownGradeDimensionCreateInput = {
    clarity: StoneClarityCode
    color: StoneColorCode
}

export type NonSkuLabGrownInterface = {
    clarity: StoneClarity
    color: StoneColor
    crystal: StoneCrystal
    cut: StoneCut
}

export type NonSkuLabGrownPricingCellFilters = {
    gradeDimensionId?: InputMaybe<Scalars['ID']['input']>
}

export type NonSkuLabGrownShapeDimension = {
    __typename: 'NonSkuLabGrownShapeDimension'
    id: Scalars['ID']['output']
    image: Maybe<NonSkuImage>
    shape: StoneShape
}

export type NonSkuLabGrownShapeDimensionCreateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
    shape: StoneShapeCode
}

export type NonSkuLabGrownShapeDimensionUpdateInput = {
    image?: InputMaybe<Scalars['Upload']['input']>
}

export const NonSkuLabGrownSortField = {
    Carat: 'CARAT',
    Price: 'PRICE',
} as const

export type NonSkuLabGrownSortField =
    (typeof NonSkuLabGrownSortField)[keyof typeof NonSkuLabGrownSortField]
export type NonSkuPriceRange = {
    __typename: 'NonSkuPriceRange'
    max: Money
    min: Money
}

export type NonSkuPriceRangeInput = {
    max?: InputMaybe<MoneyInput>
    min?: InputMaybe<MoneyInput>
}

export const NonSkuSortDirection = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const

export type NonSkuSortDirection =
    (typeof NonSkuSortDirection)[keyof typeof NonSkuSortDirection]
export type Order = {
    __typename: 'Order'
    /** mask */
    allowedWeekdays: Scalars['Int']['output']
    availableShowroomsForCollection: Array<Showroom>
    /** @deprecated customerPromoCode */
    basePromoCode: Maybe<BasePromoCode>
    billingAddress: OrderAddress
    customer: Customer
    customerPromoCode: Maybe<CustomerPromoCode>
    /** null desiredDeliveryDate means ASAR */
    desiredDeliveryDate: Maybe<Scalars['DateTime']['output']>
    disabledDates: Array<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    isAsarEnabled: Scalars['Boolean']['output']
    isCompleted: Scalars['Boolean']['output']
    isDeliveryConfirmed: Scalars['Boolean']['output']
    isPayable: Scalars['Boolean']['output']
    isShippingAddressReadonly: Scalars['Boolean']['output']
    paidAmount: Money
    paymentMethods: PaymentMethodContainer
    paymentPlan: PaymentPlan
    placementDate: Maybe<Scalars['DateTime']['output']>
    prediscountSubtotalAmount: Money
    prediscountTotalAmount: Money
    products: Array<OrderProduct>
    /** @deprecated basePromoCode */
    promoCode: Maybe<PromoCode>
    remainingAmount: Money
    salesTaxAmount: Money
    savedAmount: Money
    /**  null before order is dispatched and for collection orders */
    shipmentTrackingInformation: Maybe<ShipmentTrackingInformation>
    shippingAddress: OrderAddress
    shippingAmount: Money
    status: OrderStatus
    subtotalAmount: Money
    totalAmount: Money
    transactions: Array<TransactionInterface>
    vatAmount: Money
}

export type OrderAddress = {
    __typename: 'OrderAddress'
    addressLine1: Maybe<Scalars['String']['output']>
    addressLine2: Maybe<Scalars['String']['output']>
    city: Maybe<Scalars['String']['output']>
    country: Scalars['Country']['output']
    deliveryInstructions: Maybe<Scalars['String']['output']>
    email: Scalars['String']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    lastName: Scalars['String']['output']
    phoneNumber: Maybe<PhoneNumberType>
    postalCode: Maybe<Scalars['String']['output']>
    subdivision: Maybe<Scalars['CountrySubdivision']['output']>
}

export type OrderAddressNotConfirmedError = {
    __typename: 'OrderAddressNotConfirmedError'
    message: Scalars['String']['output']
}

export type OrderAlreadyCompletedError = {
    __typename: 'OrderAlreadyCompletedError'
    message: Scalars['String']['output']
}

export type OrderBillingAddressInput = {
    addressLine1: Scalars['String']['input']
    addressLine2?: InputMaybe<Scalars['String']['input']>
    city: Scalars['String']['input']
    country: Scalars['Country']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber?: InputMaybe<PhoneNumberInput>
    postalCode: Scalars['String']['input']
    subdivision?: InputMaybe<Scalars['CountrySubdivision']['input']>
}

export type OrderCollectFromShowroomDeliveryInput = {
    deliveryInstructions: Scalars['String']['input']
    email: Scalars['Email']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber: PhoneNumberInput
}

export type OrderEmptyError = {
    __typename: 'OrderEmptyError'
    message: Scalars['String']['output']
}

export type OrderProduct = {
    __typename: 'OrderProduct'
    customer: Customer
    designStudioProduct: Maybe<DesignStudioProduct>
    id: Scalars['ID']['output']
    image: Maybe<GenericImage>
    name: Scalars['String']['output']
    order: Order
    prediscountTotalSaleAmount: Money
    stockInStoreCode: Maybe<Scalars['ID']['output']>
    totalSaleAmount: Money
}

export type OrderShipToAddressInput = {
    addressLine1: Scalars['String']['input']
    addressLine2?: InputMaybe<Scalars['String']['input']>
    city: Scalars['String']['input']
    deliveryInstructions?: InputMaybe<Scalars['String']['input']>
    email: Scalars['Email']['input']
    firstName: Scalars['String']['input']
    lastName: Scalars['String']['input']
    phoneNumber: PhoneNumberInput
    postalCode: Scalars['String']['input']
    subdivision?: InputMaybe<Scalars['CountrySubdivision']['input']>
}

export type OrderStatus = {
    __typename: 'OrderStatus'
    name: Scalars['String']['output']
    systemCode: OrderStatusCode
}

export type OrderStatusNameArgs = {
    locale: Scalars['Locale']['input']
}

export const OrderStatusCode = {
    AwaitingInitialPaymentConfirmation: 'AWAITING_INITIAL_PAYMENT_CONFIRMATION',
    Cancelled: 'CANCELLED',
    Cart: 'CART',
    Dispatched: 'DISPATCHED',
    InProgress: 'IN_PROGRESS',
    Refunded: 'REFUNDED',
} as const

export type OrderStatusCode =
    (typeof OrderStatusCode)[keyof typeof OrderStatusCode]
export type OrderedListItem = {
    __typename: 'OrderedListItem'
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export const Padding = {
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    Small: 'SMALL',
} as const

export type Padding = (typeof Padding)[keyof typeof Padding]
export type Page = {
    __typename: 'Page'
    author: Author
    blocks: Array<Block>
    id: Scalars['ID']['output']
    meta: Meta
    pageSettings: PageSettings
    parent: Maybe<Page>
    path: Scalars['String']['output']
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type PageSettings = {
    __typename: 'PageSettings'
    showRingBuilder: Scalars['Boolean']['output']
}

export type PageTooltip = {
    __typename: 'PageTooltip'
    tooltip: Tooltip
    triggerText: Maybe<Scalars['String']['output']>
}

export type PaginationInput = {
    limit: Scalars['Int']['input']
    page: Scalars['Int']['input']
}

export type PayViaCheckoutcomError =
    | CheckoutcomOperationDeclinedError
    | DesiredDeliveryDateInvalidError
    | OrderAlreadyCompletedError
    | PaymentAmountInvalidError

export type PayViaCheckoutcomFailureResponse = {
    __typename: 'PayViaCheckoutcomFailureResponse'
    errors: Array<PayViaCheckoutcomError>
}

export type PayViaCheckoutcomInput = {
    checkoutcomTransactionId: Scalars['ID']['input']
    returnUrl: Scalars['Uri']['input']
}

export type PayViaCheckoutcomResponse =
    | PayViaCheckoutcomFailureResponse
    | PayViaCheckoutcomSuccessResponse

export type PayViaCheckoutcomSuccessResponse = {
    __typename: 'PayViaCheckoutcomSuccessResponse'
    order: Order
    redirectUrl: Scalars['String']['output']
}

export type PaymentAmountInvalidError = {
    __typename: 'PaymentAmountInvalidError'
    message: Scalars['String']['output']
}

export type PaymentIcon = {
    __typename: 'PaymentIcon'
    icon: Image
    name: Scalars['String']['output']
}

export type PaymentMethodContainer = {
    __typename: 'PaymentMethodContainer'
    affirmPayment: Maybe<AffirmPaymentMethod>
    allocationPayment: Maybe<AllocationPaymentMethod>
    bankPayment: Maybe<BankPaymentMethod>
    checkoutcomPayment: Maybe<CheckoutcomPaymentMethod>
    klarnaPayment: Maybe<KlarnaPaymentMethod>
    noPayment: Maybe<NoPaymentMethod>
}

export type PaymentMethodContainerAffirmPaymentArgs = {
    country: InputMaybe<Scalars['Country']['input']>
}

export type PaymentMethodNotAllowedError = {
    __typename: 'PaymentMethodNotAllowedError'
    message: Scalars['String']['output']
}

export type PaymentPlan = {
    __typename: 'PaymentPlan'
    current: Maybe<PaymentPlanUpcomingRecord>
    paid: Array<PaymentPlanPaidRecord>
    upcoming: Array<PaymentPlanUpcomingRecord>
}

export type PaymentPlanPaidRecord = {
    __typename: 'PaymentPlanPaidRecord'
    amount: Money
    paidOn: Scalars['DateTime']['output']
}

export type PaymentPlanUpcomingRecord = {
    __typename: 'PaymentPlanUpcomingRecord'
    amount: Money
}

export type PerkListItem = {
    __typename: 'PerkListItem'
    title: Scalars['String']['output']
}

export const PhoneNumberFormat = {
    E164: 'E164',
    International: 'INTERNATIONAL',
    National: 'NATIONAL',
    Rfc3966: 'RFC3966',
} as const

export type PhoneNumberFormat =
    (typeof PhoneNumberFormat)[keyof typeof PhoneNumberFormat]
export type PhoneNumberInput = {
    countryCode: Scalars['String']['input']
    nationalNumber: Scalars['String']['input']
}

export type PhoneNumberType = {
    __typename: 'PhoneNumberType'
    countryCode: Maybe<Scalars['String']['output']>
    e164: Scalars['PhoneNumber']['output']
    formatted: Scalars['String']['output']
    nationalNumber: Maybe<Scalars['String']['output']>
}

export type PhoneNumberTypeFormattedArgs = {
    format: PhoneNumberFormat
}

export type Post = {
    __typename: 'Post'
    author: Author
    blocks: Array<Block>
    categories: Array<PostCategory>
    createdAt: Scalars['Date']['output']
    date: Scalars['Date']['output']
    excerpt: Scalars['String']['output']
    featuredImage: Image
    id: Scalars['ID']['output']
    meta: Meta
    modifiedAt: Scalars['Date']['output']
    relatedPosts: Maybe<Array<Post>>
    showModifiedDate: Scalars['Boolean']['output']
    slug: Scalars['String']['output']
    tags: Array<PostTag>
    title: Scalars['String']['output']
}

export type PostAuthorArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoriesArgs = {
    locale: Scalars['Locale']['input']
}

export type PostRelatedPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
}

export type PostTagsArgs = {
    locale: Scalars['Locale']['input']
}

export type PostAuthorsFilter = {
    hideEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type PostCategoriesAggregation = {
    __typename: 'PostCategoriesAggregation'
    count: Scalars['Int']['output']
}

export type PostCategoriesFilter = {
    hideEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type PostCategory = {
    __typename: 'PostCategory'
    children: Maybe<Array<PostCategory>>
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    parent: Maybe<PostCategory>
    postAggregation: PostsAggregation
    posts: Array<Post>
    slug: Scalars['String']['output']
}

export type PostCategoryChildrenArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryParentArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type PostCategoryPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PostFilterInput = {
    categories?: InputMaybe<Array<Scalars['ID']['input']>>
    locale: Scalars['Locale']['input']
    search?: InputMaybe<Scalars['String']['input']>
    tags?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PostTag = {
    __typename: 'PostTag'
    id: Scalars['ID']['output']
    name: Scalars['String']['output']
    postAggregation: PostsAggregation
    posts: Array<Post>
    slug: Scalars['String']['output']
}

export type PostTagPostAggregationArgs = {
    locale: Scalars['Locale']['input']
}

export type PostTagPostsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>
    locale: Scalars['Locale']['input']
    page?: InputMaybe<Scalars['Int']['input']>
}

export type PostTagsAggregation = {
    __typename: 'PostTagsAggregation'
    count: Scalars['Int']['output']
}

export type PostTagsFilter = {
    hideEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type PostsAggregation = {
    __typename: 'PostsAggregation'
    count: Scalars['Int']['output']
}

export type PreHeader = {
    __typename: 'PreHeader'
    link: Link
}

export type PresentPaymentMethodInput = {
    cardNumber?: InputMaybe<Scalars['String']['input']>
}

export type PriceRangeBarInput = {
    count?: InputMaybe<Scalars['Int']['input']>
}

export type ProductLabelTranslation = {
    __typename: 'ProductLabelTranslation'
    facetedContentName: Maybe<Scalars['String']['output']>
    name: Scalars['String']['output']
}

export type ProductPageDetails = {
    __typename: 'ProductPageDetails'
    accordionItems: Array<ProductPageDetailsAccordionItem>
    blocks: Array<Block>
    ctaPerksLink: Maybe<Link>
    ctaPerksList: Array<PerkListItem>
    id: Scalars['ID']['output']
    meta: Meta
    path: Scalars['String']['output']
    priceExplainedTooltip: Maybe<PageTooltip>
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type ProductPageDetailsAccordionItem = {
    expanded: Scalars['Boolean']['output']
}

export type ProductPageDetailsAccordionItemAboutThisProduct =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemAboutThisProduct'
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageDetailsAccordionItemDesignInspiration =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemDesignInspiration'
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageDetailsAccordionItemFinance =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemFinance'
        components: Array<Component>
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageDetailsAccordionItemGeneric =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemGeneric'
        components: Array<Component>
        expanded: Scalars['Boolean']['output']
        title: Scalars['String']['output']
    }

export type ProductPageDetailsAccordionItemShipping =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemShipping'
        components: Array<Component>
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageDetailsAccordionItemSizing =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemSizing'
        components: Array<Component>
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageDetailsAccordionItemWarranty =
    ProductPageDetailsAccordionItem & {
        __typename: 'ProductPageDetailsAccordionItemWarranty'
        components: Array<Component>
        expanded: Scalars['Boolean']['output']
    }

export type ProductPageFacetedContent = {
    __typename: 'ProductPageFacetedContent'
    contentTitle: Scalars['RenderableTemplate']['output']
    description: Scalars['RenderableTemplate']['output']
    longDescription: Maybe<ProductPageFacetedContentLongDescription>
    meta: Meta
    productString: Scalars['RenderableTemplate']['output']
    title: Scalars['RenderableTemplate']['output']
}

export type ProductPageFacetedContentInput = {
    diamondSearch?: InputMaybe<ProductPageFacetedContentInputDiamondSearch>
    engagementRings?: InputMaybe<ProductPageFacetedContentInputEngagementRings>
    gemstoneNonSku?: InputMaybe<ProductPageFacetedContentInputGemstoneNonSku>
    jewellery?: InputMaybe<ProductPageFacetedContentInputJewellery>
    labGrownNonSku?: InputMaybe<ProductPageFacetedContentInputLabGrownNonSku>
    weddingRings?: InputMaybe<ProductPageFacetedContentInputWeddingRings>
}

export type ProductPageFacetedContentInputDiamondSearch = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputEngagementRings = {
    designStyle?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    ringStyle?: InputMaybe<Scalars['String']['input']>
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputGemstoneNonSku = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputJewellery = {
    category?: InputMaybe<Scalars['String']['input']>
    designStyle?: InputMaybe<Scalars['String']['input']>
    gemstone?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    productStyle?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputLabGrownNonSku = {
    shape?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentInputWeddingRings = {
    category?: InputMaybe<Scalars['String']['input']>
    metal?: InputMaybe<Scalars['String']['input']>
    ringStyle?: InputMaybe<Scalars['String']['input']>
}

export type ProductPageFacetedContentLongDescription =
    | ProductPageFacetedContentLongDescriptionBlock
    | ProductPageFacetedContentLongDescriptionText

export type ProductPageFacetedContentLongDescriptionBlock = {
    __typename: 'ProductPageFacetedContentLongDescriptionBlock'
    blocks: Array<Block>
}

export type ProductPageFacetedContentLongDescriptionText = {
    __typename: 'ProductPageFacetedContentLongDescriptionText'
    text: Scalars['RenderableTemplate']['output']
}

export type ProductPageListing = {
    __typename: 'ProductPageListing'
    afterGrid: Array<Block>
    banner1: Maybe<Banner1>
    banner2: Maybe<Banner2>
    beforeFilters: Array<Block>
    id: Scalars['ID']['output']
    meta: Meta
    path: Scalars['String']['output']
    slug: Scalars['String']['output']
    title: Scalars['String']['output']
}

export type PromoCode = {
    __typename: 'PromoCode'
    code: Scalars['String']['output']
    id: Scalars['ID']['output']
}

export const PromoCodeApplicationError = {
    ErrorAfterFirstSaleOnly: 'ERROR_AFTER_FIRST_SALE_ONLY',
    ErrorCodeAlreadyUsed: 'ERROR_CODE_ALREADY_USED',
    ErrorDisabled: 'ERROR_DISABLED',
    ErrorDoesNotExist: 'ERROR_DOES_NOT_EXIST',
    ErrorExpired: 'ERROR_EXPIRED',
    ErrorFirstSaleOnly: 'ERROR_FIRST_SALE_ONLY',
    ErrorLimitedToCountry: 'ERROR_LIMITED_TO_COUNTRY',
    ErrorSingleUseCodeAlreadyUsed: 'ERROR_SINGLE_USE_CODE_ALREADY_USED',
    ErrorSingleUseOnly: 'ERROR_SINGLE_USE_ONLY',
} as const

export type PromoCodeApplicationError =
    (typeof PromoCodeApplicationError)[keyof typeof PromoCodeApplicationError]
export type PromoCodeApplicationResult = {
    __typename: 'PromoCodeApplicationResult'
    cart: Order
    error: Maybe<PromoCodeApplicationError>
    retailCart: Order
}

export const PromoCodeDiscountType = {
    ExpressFeeWaiver: 'EXPRESS_FEE_WAIVER',
    Fixed: 'FIXED',
    Percent: 'PERCENT',
} as const

export type PromoCodeDiscountType =
    (typeof PromoCodeDiscountType)[keyof typeof PromoCodeDiscountType]
export type PromoCodeRuleset = {
    __typename: 'PromoCodeRuleset'
    cap: Maybe<Scalars['String']['output']>
    capCurrency: Maybe<Scalars['Currency']['output']>
    discount: Maybe<Scalars['String']['output']>
    discountCurrency: Maybe<Scalars['Currency']['output']>
    discountType: PromoCodeDiscountType
    id: Scalars['ID']['output']
}

export const PurchaseType = {
    EngagementRing: 'ENGAGEMENT_RING',
    Jewellery: 'JEWELLERY',
    LooseStone: 'LOOSE_STONE',
    WeddingRing: 'WEDDING_RING',
} as const

export type PurchaseType = (typeof PurchaseType)[keyof typeof PurchaseType]
export type Query = {
    __typename: 'Query'
    GemsApi_findStones: Maybe<GemsApi_StoneCollection>
    GemsApi_getBounds: Maybe<GemsApi_Bounds>
    GemsApi_getGiaStone: Maybe<GemsApi_Stone>
    GemsApi_getStone: Maybe<GemsApi_Stone>
    GemsApi_getStoneByExternalId: Maybe<GemsApi_Stone>
    GemsApi_getStones: Array<Maybe<GemsApi_Stone>>
    authorById: Maybe<Author>
    authorBySlug: Maybe<Author>
    authors: Array<Author>
    authorsAggregation: Maybe<AuthorsAggregation>
    avatarStack: Array<AvatarStackItem>
    bookingAccessibilityOptions: Maybe<Array<BookingAccessibilityOption>>
    bookingArchivedConsultationPurposes: Array<BookingConsultationPurpose>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingAvailableDesignComplexities: Array<BookingConsultationProductDesignComplexity>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultants: Array<Consultant>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultation: Maybe<BookingConsultation>
    bookingConsultationAvailableSlots: BookingConsultationSlotsResponse
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultationAvailableSlotsAutoAssign: Maybe<BookingConsultationAvailableSlotsByConsultantOrAutoAssingResponse>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingConsultationAvailableSlotsByConsultant: Maybe<BookingConsultationAvailableSlotsByConsultantOrAutoAssingResponse>
    bookingConsultationComplexities: Array<BookingConsultationComplexity>
    bookingConsultationPartnerInvolvement: Array<BookingConsultationPartnerInvolvement>
    bookingConsultationPurposes: Array<BookingConsultationPurpose>
    bookingConsultationPurposesForRetail: Array<BookingConsultationPurpose>
    /** If this returns true: prompt user for phone */
    bookingConsultationShowPhone: Scalars['Boolean']['output']
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingCustomer: Customer
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingInPersonConsultationRooms: Array<BookingConsultationRoom>
    bookingOpenConsultationsByCustomer: Maybe<Array<BookingConsultation>>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingShowrooms: Array<Showroom>
    /** @deprecated Booking form has to be reworked from the ground. */
    bookingVirtualConsultationRooms: Array<BookingConsultationRoom>
    calculateGemsApiStoneTotalSalePrices: Array<Money>
    catalogueEngagementRing: Maybe<CatalogueEngagementRing>
    catalogueEngagementRingContainsProducts: Array<Scalars['Boolean']['output']>
    catalogueEngagementRingFilters: CatalogueEngagementRingFilters
    catalogueEngagementRingFiltersVariations: Array<CatalogueEngagementRingFiltersVariation>
    catalogueEngagementRings: Array<CatalogueEngagementRing>
    catalogueEngagementRingsAggregate: CatalogueAggregate
    catalogueJewelleries: Array<CatalogueJewellery>
    catalogueJewelleriesAggregate: CatalogueAggregate
    catalogueJewelleriesFilters: CatalogueJewelleriesFilters
    catalogueJewelleriesFiltersVariations: Array<CatalogueJewelleriesFiltersVariation>
    catalogueJewellery: Maybe<CatalogueJewellery>
    catalogueJewelleryBracelet: Maybe<CatalogueJewelleryBracelet>
    catalogueJewelleryBraceletFiltersVariations: Array<CatalogueJewelleriesBraceletsFiltersVariation>
    catalogueJewelleryBracelets: Array<CatalogueJewelleryBracelet>
    catalogueJewelleryBraceletsAggregate: CatalogueAggregate
    catalogueJewelleryBraceletsFilters: CatalogueJewelleryBraceletsFilters
    catalogueJewelleryEarring: Maybe<CatalogueJewelleryEarrings>
    catalogueJewelleryEarrings: Array<CatalogueJewelleryEarrings>
    catalogueJewelleryEarringsAggregate: CatalogueAggregate
    catalogueJewelleryEarringsFilters: CatalogueJewelleryEarringsFilters
    catalogueJewelleryEarringsFiltersVariations: Array<CatalogueJewelleriesEarringsFiltersVariation>
    catalogueJewelleryNecklace: Maybe<CatalogueJewelleryNecklace>
    catalogueJewelleryNecklaces: Array<CatalogueJewelleryNecklace>
    catalogueJewelleryNecklacesAggregate: CatalogueAggregate
    catalogueJewelleryNecklacesFilters: CatalogueJewelleryNecklacesFilters
    catalogueJewelleryNecklacesFiltersVariations: Array<CatalogueJewelleriesNecklacesFiltersVariation>
    catalogueJewelleryRing: Maybe<CatalogueJewelleryRing>
    catalogueJewelleryRings: Array<CatalogueJewelleryRing>
    catalogueJewelleryRingsAggregate: CatalogueAggregate
    catalogueJewelleryRingsFilters: CatalogueJewelleryRingsFilters
    catalogueJewelleryRingsFiltersVariations: Array<CatalogueJewelleriesRingsFiltersVariation>
    catalogueProducts: Array<CatalogueProduct>
    catalogueReadyToGoRing: Maybe<CatalogueReadyToGoRing>
    catalogueReadyToGoRings: Array<CatalogueReadyToGoRing>
    catalogueReadyToGoRingsAggregate: CatalogueAggregate
    catalogueReadyToGoRingsFilters: CatalogueReadyToGoRingFilters
    catalogueWeddingRing: Maybe<CatalogueWeddingRing>
    catalogueWeddingRingFilterVariations: Array<CatalogueWeddingRingFiltersVariation>
    catalogueWeddingRingFilters: CatalogueWeddingRingFilters
    catalogueWeddingRings: Array<CatalogueWeddingRing>
    catalogueWeddingRingsAggregate: CatalogueAggregate
    convertPriceBoundsForGems: GemsApiPriceBounds
    convertPriceBoundsForGemsMulti: Array<GemsApiPriceBounds>
    customerDiscoveryDataPartnerInvolvementOptions: Array<CustomerDiscoveryDataQuestionOption>
    customerDiscoveryDataReferralSourceOptions: Array<CustomerDiscoveryDataQuestionOption>
    customerExists: Scalars['Boolean']['output']
    customers: CustomersResult
    defaultAlternateRegion: Region
    defaultRegion: Region
    deliveryDaysForBespokeEngagementRings: Scalars['Int']['output']
    engagementRingStoneRecommendations: Maybe<EngagementRingStoneRecommendations>
    enquiryFormContents: Array<EnquiryFormContent>
    footer: Maybe<Footer>
    language: Maybe<Language>
    languages: Array<Language>
    mainMenu: Array<MenuItem>
    me: Maybe<User>
    metals: Array<Metal>
    nonSkuGemStone: Maybe<NonSkuGemstone>
    nonSkuGemStones: Array<NonSkuGemstone>
    nonSkuGemStonesBounds: NonSkuGemstonesBounds
    nonSkuGemStonesPricingCells: Array<NonSkuGemstone>
    nonSkuGemstoneCaratDimensions: Array<NonSkuGemstoneCaratDimension>
    nonSkuGemstoneColorCrystalDimensions: Array<NonSkuGemstoneType>
    nonSkuGemstoneGradeClarityDimensions: Array<NonSkuGemstoneGradeClarityDimension>
    nonSkuGemstoneImages: Array<NonSkuGemstoneImage>
    nonSkuGemstoneShapeDimensions: Array<NonSkuGemstoneShapeDimension>
    nonSkuLabGrownCaratDimensions: Array<NonSkuLabGrownCaratDimension>
    nonSkuLabGrownDiamond: Maybe<NonSkuLabGrown>
    nonSkuLabGrownDiamonds: Array<NonSkuLabGrown>
    nonSkuLabGrownDiamondsBounds: NonSkuLabGrownDiamondsBounds
    nonSkuLabGrownGradeDimensions: Array<NonSkuLabGrownGradeDimension>
    nonSkuLabGrownPricingCells: Array<NonSkuLabGrown>
    nonSkuLabGrownShapeDimensions: Array<NonSkuLabGrownShapeDimension>
    pageByPath: Maybe<Page>
    pageProductDetails: Maybe<ProductPageDetails>
    pageProductListing: Maybe<ProductPageListing>
    pageProductListingFacetedContent: Maybe<ProductPageFacetedContent>
    pages: Array<Page>
    paymentIcons: Array<PaymentIcon>
    ping: Scalars['String']['output']
    postBySlug: Maybe<Post>
    postCategories: Array<PostCategory>
    postCategoriesAggregation: PostCategoriesAggregation
    postCategoryBySlug: Maybe<PostCategory>
    postTagAggregation: PostTagsAggregation
    postTagBySlug: Maybe<PostTag>
    postTags: Array<PostTag>
    posts: Array<Post>
    postsAggregation: PostsAggregation
    preHeader: Maybe<PreHeader>
    questionnaire: Maybe<Questionnaire>
    questionnaires: Array<Questionnaire>
    redirection: Maybe<Redirection>
    region: Region
    regionSuggest: Region
    regions: Array<Region>
    /** @deprecated Booking form has to be reworked from the ground. */
    retailConsultationAvailableSlots: Array<BookingConsultationAvailableDate>
    reviews: Array<Review>
    ringBuilder: RingBuilder
    searchEverywhere: SearchEverywhereResponse
    socialNetworks: Array<SocialNetwork>
    stoneCategoriesBySystemCode: Array<StoneCategory>
    stoneCategoryBySystemCode: StoneCategory
    stoneClarities: Array<StoneClarity>
    stoneClaritiesBySystemCode: Array<StoneClarity>
    stoneClarityBySystemCode: StoneClarity
    stoneColorBySystemCode: StoneColor
    stoneColors: Array<StoneColor>
    stoneColorsBySystemCode: Array<StoneColor>
    stoneCrystals: Array<StoneCrystal>
    stoneCrystalsBySystemCode: Array<StoneCrystal>
    stoneCutsBySystemCodes: Array<StoneCut>
    stoneFluorescencesBySystemCodes: Array<StoneFluorescence>
    stoneGrades: Array<StoneGrade>
    stoneGradesBySystemCodes: Array<StoneGrade>
    stonePolishesBySystemCodes: Array<StonePolish>
    stoneShapeBySystemCodes: Array<StoneShape>
    stoneShapes: Array<StoneShape>
    stoneSymmetriesBySystemCodes: Array<StoneSymmetry>
    tooltip: Maybe<Tooltip>
    topBar: Maybe<TopBar>
    validateConsultationInput: Scalars['Boolean']['output']
    validateCustomerRegistrationInput: Scalars['Boolean']['output']
    warrantyActivated: Maybe<Scalars['Boolean']['output']>
    workingHours: Array<WorkingHours>
}

export type QueryGemsApi_FindStonesArgs = {
    filters: InputMaybe<GemsApi_StoneFilters>
}

export type QueryGemsApi_GetBoundsArgs = {
    categories: Array<GemsApi_StoneCategory>
    isConsultant: InputMaybe<Scalars['Boolean']['input']>
    market: Scalars['String']['input']
    notClarity: InputMaybe<Array<GemsApi_StoneClarity>>
    notColour: InputMaybe<Array<GemsApi_StoneColour>>
    notSymmetry: InputMaybe<Array<GemsApi_StoneSymmetry>>
}

export type QueryGemsApi_GetGiaStoneArgs = {
    giaCertificate: Scalars['String']['input']
}

export type QueryGemsApi_GetStoneArgs = {
    identifier: Scalars['GemsApi_StoneIdentifier']['input']
}

export type QueryGemsApi_GetStoneByExternalIdArgs = {
    externalId: Scalars['String']['input']
    feedIdentifier: Scalars['String']['input']
}

export type QueryGemsApi_GetStonesArgs = {
    identifiers: Array<Scalars['GemsApi_StoneIdentifier']['input']>
}

export type QueryAuthorByIdArgs = {
    id: Scalars['String']['input']
    locale: Scalars['Locale']['input']
}

export type QueryAuthorBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryAuthorsArgs = {
    filter: InputMaybe<PostAuthorsFilter>
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryAuthorsAggregationArgs = {
    filter: InputMaybe<PostAuthorsFilter>
    locale: Scalars['Locale']['input']
}

export type QueryAvatarStackArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryBookingConsultationArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingConsultationAvailableSlotsArgs = {
    input: BookingConsultationSlotInput
}

export type QueryBookingConsultationAvailableSlotsAutoAssignArgs = {
    accessibility: InputMaybe<BookingConsultationAccessibility>
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    order: InputMaybe<Scalars['ID']['input']>
    productDesignComplexity: InputMaybe<BookingConsultationProductDesignComplexityCode>
    showroom: Scalars['ID']['input']
}

export type QueryBookingConsultationAvailableSlotsByConsultantArgs = {
    accessibility: InputMaybe<BookingConsultationAccessibility>
    consultant: InputMaybe<Scalars['ID']['input']>
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    consultationRoom: InputMaybe<Scalars['ID']['input']>
    consultationRoomKind: BookingConsultationRoomKind
    ignoreConsultation: InputMaybe<Scalars['ID']['input']>
    isWalkIn: Scalars['Boolean']['input']
    order: InputMaybe<Scalars['ID']['input']>
    productDesignComplexity: InputMaybe<BookingConsultationProductDesignComplexityCode>
    showroom: Scalars['ID']['input']
}

export type QueryBookingCustomerArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingInPersonConsultationRoomsArgs = {
    consultationPurposeId: Scalars['ID']['input']
    isWalkIn: Scalars['Boolean']['input']
    kind: BookingConsultationRoomKind
    showroomId: Scalars['ID']['input']
}

export type QueryBookingOpenConsultationsByCustomerArgs = {
    id: Scalars['ID']['input']
}

export type QueryBookingVirtualConsultationRoomsArgs = {
    consultationPurposeId: Scalars['ID']['input']
    kind: BookingConsultationRoomKind
    showroomId: Scalars['ID']['input']
}

export type QueryCalculateGemsApiStoneTotalSalePricesArgs = {
    input: Array<CalculateGemsApiStoneTotalSalePriceInput>
}

export type QueryCatalogueEngagementRingArgs = {
    filter: CatalogueEngagementRingFilterInput
}

export type QueryCatalogueEngagementRingContainsProductsArgs = {
    input: Array<CatalogueEngagementRingContainsProductsInput>
}

export type QueryCatalogueEngagementRingFiltersArgs = {
    input: CatalogueEngagementRingsFilterInput
}

export type QueryCatalogueEngagementRingFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueEngagementRingsArgs = {
    filter: InputMaybe<CatalogueEngagementRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueEngagementRingsAggregateArgs = {
    filter: InputMaybe<CatalogueEngagementRingsFilterInput>
}

export type QueryCatalogueJewelleriesArgs = {
    filter: InputMaybe<CatalogueJewelleriesFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleriesAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesFilterInput>
}

export type QueryCatalogueJewelleriesFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesFilterInput>
}

export type QueryCatalogueJewelleriesFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryArgs = {
    filter: CatalogueJewelleryFilterInput
    type: InputMaybe<CatalogueJewelleryType>
}

export type QueryCatalogueJewelleryBraceletArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryBraceletFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryBraceletsArgs = {
    filter: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryBraceletsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
}

export type QueryCatalogueJewelleryBraceletsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesBraceletsFilterInput>
}

export type QueryCatalogueJewelleryEarringArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryEarringsArgs = {
    filter: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryEarringsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
}

export type QueryCatalogueJewelleryEarringsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesEarringsFilterInput>
}

export type QueryCatalogueJewelleryEarringsFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryNecklaceArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryNecklacesArgs = {
    filter: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryNecklacesAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
}

export type QueryCatalogueJewelleryNecklacesFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesNecklacesFilterInput>
}

export type QueryCatalogueJewelleryNecklacesFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueJewelleryRingArgs = {
    filter: CatalogueJewelleryFilterInput
}

export type QueryCatalogueJewelleryRingsArgs = {
    filter: InputMaybe<CatalogueJewelleriesRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueJewelleryRingsAggregateArgs = {
    filter: InputMaybe<CatalogueJewelleriesRingsFilterInput>
}

export type QueryCatalogueJewelleryRingsFiltersArgs = {
    input: InputMaybe<CatalogueJewelleriesRingsFilterInput>
}

export type QueryCatalogueJewelleryRingsFiltersVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueProductsArgs = {
    filter: InputMaybe<CatalogueFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueReadyToGoRingArgs = {
    filter: CatalogueReadyToGoRingFilterInput
}

export type QueryCatalogueReadyToGoRingsArgs = {
    filter: InputMaybe<CatalogueReadyToGoRingsFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueReadyToGoRingsAggregateArgs = {
    filter: InputMaybe<CatalogueReadyToGoRingsFilterInput>
}

export type QueryCatalogueReadyToGoRingsFiltersArgs = {
    input: InputMaybe<CatalogueReadyToGoRingsFilterInput>
}

export type QueryCatalogueWeddingRingArgs = {
    filter: CatalogueWeddingRingFilterInput
}

export type QueryCatalogueWeddingRingFilterVariationsArgs = {
    maxSlots: InputMaybe<Scalars['Int']['input']>
}

export type QueryCatalogueWeddingRingFiltersArgs = {
    input: CatalogueWeddingRingFilterInput
}

export type QueryCatalogueWeddingRingsArgs = {
    filter: InputMaybe<CatalogueWeddingRingFilterInput>
    pagination: InputMaybe<PaginationInput>
    sort: InputMaybe<CatalogueSortInput>
}

export type QueryCatalogueWeddingRingsAggregateArgs = {
    filter: InputMaybe<CatalogueWeddingRingFilterInput>
}

export type QueryConvertPriceBoundsForGemsArgs = {
    input: ConvertPriceBoundsForGems
}

export type QueryConvertPriceBoundsForGemsMultiArgs = {
    input: Array<ConvertPriceBoundsForGems>
}

export type QueryCustomerExistsArgs = {
    email: Scalars['Email']['input']
}

export type QueryCustomersArgs = {
    filters: InputMaybe<CustomersFiltersInput>
}

export type QueryEngagementRingStoneRecommendationsArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryEnquiryFormContentsArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryFooterArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryLanguageArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryMainMenuArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryNonSkuGemStoneArgs = {
    currency: CurrencyInput
    filter: NonSkuGemstoneFilterInput
    region: RegionCode
}

export type QueryNonSkuGemStonesArgs = {
    currency: CurrencyInput
    filters: InputMaybe<NonSkuGemstoneFilters>
    region: RegionCode
    sort: InputMaybe<NonSkuGemstoneSortInput>
}

export type QueryNonSkuGemStonesPricingCellsArgs = {
    filters: InputMaybe<NonSkuGemStonesPricingCellFilters>
}

export type QueryNonSkuLabGrownDiamondArgs = {
    currency: CurrencyInput
    filter: NonSkuLabGrownDiamondFilterInput
    region: RegionCode
}

export type QueryNonSkuLabGrownDiamondsArgs = {
    currency: CurrencyInput
    filters: InputMaybe<NonSkuLabGrownDiamondsFilters>
    region: RegionCode
    sort: InputMaybe<NonSkuLabGrownDiamondSortInput>
}

export type QueryNonSkuLabGrownPricingCellsArgs = {
    filters: InputMaybe<NonSkuLabGrownPricingCellFilters>
}

export type QueryPageByPathArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductDetailsArgs = {
    fallback: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductListingArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryPageProductListingFacetedContentArgs = {
    input: ProductPageFacetedContentInput
    locale: Scalars['Locale']['input']
}

export type QueryPagesArgs = {
    locale: Scalars['Locale']['input']
    pagination: InputMaybe<PaginationInput>
}

export type QueryPaymentIconsArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryPostBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostCategoriesArgs = {
    filter: InputMaybe<PostCategoriesFilter>
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryPostCategoriesAggregationArgs = {
    filter: InputMaybe<PostCategoriesFilter>
    locale: Scalars['Locale']['input']
}

export type QueryPostCategoryBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostTagAggregationArgs = {
    filter: InputMaybe<PostTagsFilter>
    locale: Scalars['Locale']['input']
}

export type QueryPostTagBySlugArgs = {
    locale: Scalars['Locale']['input']
    slug: Scalars['String']['input']
}

export type QueryPostTagsArgs = {
    filter: InputMaybe<PostTagsFilter>
    locale: Scalars['Locale']['input']
    pagination?: PaginationInput
}

export type QueryPostsArgs = {
    filter: InputMaybe<PostFilterInput>
    pagination?: PaginationInput
}

export type QueryPostsAggregationArgs = {
    filter: InputMaybe<PostFilterInput>
}

export type QueryPreHeaderArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryQuestionnaireArgs = {
    id: Scalars['ID']['input']
}

export type QueryRedirectionArgs = {
    input: GetRedirectInput
}

export type QueryRegionArgs = {
    code: RegionCode
}

export type QueryRetailConsultationAvailableSlotsArgs = {
    accessibility: InputMaybe<BookingConsultationAccessibility>
    consultant: InputMaybe<Scalars['ID']['input']>
    consultationMethod: Scalars['ID']['input']
    consultationPurpose: Scalars['ID']['input']
    order: InputMaybe<Scalars['ID']['input']>
    productDesignComplexity: InputMaybe<BookingConsultationProductDesignComplexityCode>
    showroom: Scalars['ID']['input']
}

export type QueryReviewsArgs = {
    filter: InputMaybe<ReviewFilter>
}

export type QueryRingBuilderArgs = {
    input: InputMaybe<RingBuilderGetInput>
}

export type QuerySearchEverywhereArgs = {
    justMe: Scalars['Boolean']['input']
    query: Scalars['String']['input']
}

export type QuerySocialNetworksArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryStoneCategoriesBySystemCodeArgs = {
    systemCodes: Array<StoneCategoryCode>
}

export type QueryStoneCategoryBySystemCodeArgs = {
    systemCode: StoneCategoryCode
}

export type QueryStoneClaritiesArgs = {
    filter: InputMaybe<StoneClarityFilterInput>
}

export type QueryStoneClaritiesBySystemCodeArgs = {
    systemCodes: Array<StoneClarityCode>
}

export type QueryStoneClarityBySystemCodeArgs = {
    systemCode: StoneClarityCode
}

export type QueryStoneColorBySystemCodeArgs = {
    systemCode: StoneColorCode
}

export type QueryStoneColorsArgs = {
    filter: InputMaybe<StoneColorsFilterInput>
}

export type QueryStoneColorsBySystemCodeArgs = {
    systemCodes: Array<StoneColorCode>
}

export type QueryStoneCrystalsArgs = {
    filter: InputMaybe<StoneCrystalsFilterInput>
}

export type QueryStoneCrystalsBySystemCodeArgs = {
    systemCodes: Array<StoneCrystalCode>
}

export type QueryStoneCutsBySystemCodesArgs = {
    systemCodes: Array<StoneCutCode>
}

export type QueryStoneFluorescencesBySystemCodesArgs = {
    systemCodes: Array<StoneFluorescenceCode>
}

export type QueryStoneGradesArgs = {
    filter: InputMaybe<StoneGradesFilterInput>
}

export type QueryStoneGradesBySystemCodesArgs = {
    systemCodes: Array<StoneGradeCode>
}

export type QueryStonePolishesBySystemCodesArgs = {
    systemCodes: Array<StonePolishCode>
}

export type QueryStoneShapeBySystemCodesArgs = {
    systemCodes: Array<StoneShapeCode>
}

export type QueryStoneShapesArgs = {
    filter: InputMaybe<StoneShapeFilterInput>
}

export type QueryStoneSymmetriesBySystemCodesArgs = {
    systemCodes: Array<StoneSymmetryCode>
}

export type QueryTooltipArgs = {
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
}

export type QueryTopBarArgs = {
    locale: Scalars['Locale']['input']
}

export type QueryValidateConsultationInputArgs = {
    input: BookingCreateConsultationInput
}

export type QueryValidateCustomerRegistrationInputArgs = {
    input: CustomerRegistrationInput
}

export type QueryWarrantyActivatedArgs = {
    id: Scalars['ID']['input']
}

export type QueryWorkingHoursArgs = {
    locale: Scalars['Locale']['input']
}

export type Questionnaire = {
    __typename: 'Questionnaire'
    id: Scalars['ID']['output']
    redirectLink: LinkItem
    requireLoginBeforeStarting: Scalars['Boolean']['output']
    signUpStep: QuestionnaireSignUpStep
    steps: Array<QuestionnaireStep>
    title: Scalars['String']['output']
    type: QuestionnaireType
}

export type QuestionnaireAnswer = {
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireAnswerInput = {
    answer: QuestionnaireAnswerValueInput
    question: QuestionnaireQuestionInput
}

export type QuestionnaireAnswerValueInput = {
    file?: InputMaybe<QuestionnaireQuestionFileInput>
    multiChoice?: InputMaybe<Array<QuestionnaireQuestionChoiceInput>>
    number?: InputMaybe<QuestionnaireQuestionFloatInput>
    singleChoice?: InputMaybe<QuestionnaireQuestionChoiceInput>
    text?: InputMaybe<QuestionnaireQuestionTextInput>
}

export const QuestionnaireBackgroundColor = {
    Blue: 'BLUE',
    Blush: 'BLUSH',
    Green: 'GREEN',
    Red: 'RED',
    Sage: 'SAGE',
    Slate: 'SLATE',
    Stone: 'STONE',
    Stone2: 'STONE2',
    Stone3: 'STONE3',
    Taaffeite: 'TAAFFEITE',
    White: 'WHITE',
} as const

export type QuestionnaireBackgroundColor =
    (typeof QuestionnaireBackgroundColor)[keyof typeof QuestionnaireBackgroundColor]
export type QuestionnaireCompleteInput = {
    referenceId: Scalars['ID']['input']
    steps: Array<QuestionnaireCompleteStepInput>
    type: QuestionnaireType
}

export type QuestionnaireCompleteStepInput = {
    answers: Array<QuestionnaireAnswerInput>
    title: Scalars['String']['input']
}

export type QuestionnaireCompletedExistingCustomerResponse = {
    __typename: 'QuestionnaireCompletedExistingCustomerResponse'
    questionnaire: QuestionnaireCompletedQuestionnaire
}

export type QuestionnaireCompletedNewCustomerResponse = {
    __typename: 'QuestionnaireCompletedNewCustomerResponse'
    customer: CustomerRegistrationResponse
    questionnaire: QuestionnaireCompletedQuestionnaire
}

export type QuestionnaireCompletedQuestionnaire = {
    __typename: 'QuestionnaireCompletedQuestionnaire'
    id: Scalars['ID']['output']
    referenceId: Scalars['ID']['output']
    steps: Array<QuestionnaireCompletedQuestionnaireStepSnapshot>
    type: QuestionnaireType
}

export type QuestionnaireCompletedQuestionnaireStepSnapshot = {
    __typename: 'QuestionnaireCompletedQuestionnaireStepSnapshot'
    answers: Array<QuestionnaireAnswer>
    id: Scalars['ID']['output']
    title: Scalars['String']['output']
}

export type QuestionnaireCondition = {
    __typename: 'QuestionnaireCondition'
    rules: Array<QuestionnaireConditionRule>
    type: QuestionnaireConditionType
}

export type QuestionnaireConditionEqualToChoice = {
    __typename: 'QuestionnaireConditionEqualToChoice'
    choice: Maybe<QuestionnaireQuestionChoiceOption>
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionIsEmpty = {
    __typename: 'QuestionnaireConditionIsEmpty'
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionIsEqualTo = {
    __typename: 'QuestionnaireConditionIsEqualTo'
    question: QuestionnaireQuestion
    value: Scalars['String']['output']
}

export type QuestionnaireConditionIsGreaterThan = {
    __typename: 'QuestionnaireConditionIsGreaterThan'
    question: QuestionnaireQuestion
    value: Scalars['Float']['output']
}

export type QuestionnaireConditionIsLessThan = {
    __typename: 'QuestionnaireConditionIsLessThan'
    question: QuestionnaireQuestion
    value: Scalars['Float']['output']
}

export type QuestionnaireConditionIsNotEmpty = {
    __typename: 'QuestionnaireConditionIsNotEmpty'
    question: QuestionnaireQuestion
}

export type QuestionnaireConditionNotIsEqualTo = {
    __typename: 'QuestionnaireConditionNotIsEqualTo'
    question: QuestionnaireQuestion
    value: Scalars['String']['output']
}

export type QuestionnaireConditionRule =
    | QuestionnaireConditionEqualToChoice
    | QuestionnaireConditionIsEmpty
    | QuestionnaireConditionIsEqualTo
    | QuestionnaireConditionIsGreaterThan
    | QuestionnaireConditionIsLessThan
    | QuestionnaireConditionIsNotEmpty
    | QuestionnaireConditionNotIsEqualTo

export const QuestionnaireConditionType = {
    And: 'AND',
    Or: 'OR',
} as const

export type QuestionnaireConditionType =
    (typeof QuestionnaireConditionType)[keyof typeof QuestionnaireConditionType]
export type QuestionnaireCustomerNotification = {
    __typename: 'QuestionnaireCustomerNotification'
    subject: Scalars['String']['output']
    text: Scalars['String']['output']
}

export type QuestionnaireCustomerNotificationInput = {
    subject: Scalars['String']['input']
    text: Scalars['String']['input']
}

export type QuestionnaireQuestion = {
    id: Scalars['ID']['output']
    required: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionAnswerMultiChoice = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerMultiChoice'
    choices: Array<QuestionnaireQuestionChoiceOptionSnapshot>
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerNumber = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerNumber'
    id: Scalars['ID']['output']
    number: Scalars['Float']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerSingleChoice = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerSingleChoice'
    choice: QuestionnaireQuestionChoiceOptionSnapshot
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
}

export type QuestionnaireQuestionAnswerText = QuestionnaireAnswer & {
    __typename: 'QuestionnaireQuestionAnswerText'
    id: Scalars['ID']['output']
    question: QuestionnaireQuestionSnapshot
    text: Scalars['String']['output']
}

export type QuestionnaireQuestionChoice = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionChoice'
    id: Scalars['ID']['output']
    multiple: Scalars['Boolean']['output']
    options: Array<QuestionnaireQuestionChoiceOption>
    required: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionChoiceBehaviourInput = {
    designFeatureSystemCode?: InputMaybe<EngagementRingDesignFeatureLabelCode>
    designStyleSystemCode?: InputMaybe<EngagementRingDesignStyleLabelCode>
    metalSystemCode?: InputMaybe<MetalCode>
    ringStyleSystemCode?: InputMaybe<EngagementRingStyleLabelCode>
    shape?: InputMaybe<StoneShapeCode>
}

export type QuestionnaireQuestionChoiceInput = {
    layout: QuestionnaireQuestionChoiceLayoutInput
    referenceId: Scalars['ID']['input']
}

export type QuestionnaireQuestionChoiceLayoutIconCardInput = {
    backgroundColor: QuestionnaireBackgroundColor
    description?: InputMaybe<Scalars['String']['input']>
    image: Scalars['Uri']['input']
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceLayoutImageCardInput = {
    description?: InputMaybe<Scalars['String']['input']>
    image: Scalars['Uri']['input']
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceLayoutImageInput = {
    image: Scalars['Uri']['input']
}

export type QuestionnaireQuestionChoiceLayoutInput = {
    iconCard?: InputMaybe<QuestionnaireQuestionChoiceLayoutIconCardInput>
    image?: InputMaybe<QuestionnaireQuestionChoiceLayoutImageInput>
    imageCard?: InputMaybe<QuestionnaireQuestionChoiceLayoutImageCardInput>
    text?: InputMaybe<QuestionnaireQuestionChoiceLayoutTextInput>
}

export type QuestionnaireQuestionChoiceLayoutTextInput = {
    description?: InputMaybe<Scalars['String']['input']>
    title: Scalars['String']['input']
}

export type QuestionnaireQuestionChoiceOption = {
    __typename: 'QuestionnaireQuestionChoiceOption'
    behaviour: Maybe<QuestionnaireQuestionChoiceOptionBehaviour>
    content: QuestionnaireQuestionChoiceOptionContent
    id: Scalars['ID']['output']
    systemCode: Maybe<QuestionnaireQuestionChoiceSystemCode>
}

export type QuestionnaireQuestionChoiceOptionBehaviour = {
    __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
    designFeature: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode>
    designStyle: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode>
    metal: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode>
    ringStyle: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode>
    shape: Maybe<QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode>
}

export const QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode =
    {
        BeadSetting: 'BEAD_SETTING',
        BezelSetting: 'BEZEL_SETTING',
        DoubleHalo: 'DOUBLE_HALO',
        EagleClaws: 'EAGLE_CLAWS',
        Fishtail: 'FISHTAIL',
        MixedMetal: 'MIXED_METAL',
        SplitShank: 'SPLIT_SHANK',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignFeatureCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode =
    {
        ArtDeco: 'ART_DECO',
        Classic: 'CLASSIC',
        Contemporary: 'CONTEMPORARY',
        Floral: 'FLORAL',
        Unique: 'UNIQUE',
        Vintage: 'VINTAGE',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementDesignStyleCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode =
    {
        EighteenKaratRoseGold: 'EIGHTEEN_KARAT_ROSE_GOLD',
        EighteenKaratWhiteGold: 'EIGHTEEN_KARAT_WHITE_GOLD',
        EighteenKaratYellowGold: 'EIGHTEEN_KARAT_YELLOW_GOLD',
        Platinum: 'PLATINUM',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingMetalCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode =
    {
        Halo: 'HALO',
        Pave: 'PAVE',
        Solitaire: 'SOLITAIRE',
        Trilogy: 'TRILOGY',
    } as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementRingStyleCode]
export const QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode =
    (typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode)[keyof typeof QuestionnaireQuestionChoiceOptionBehaviourEngagementShapeCode]
export type QuestionnaireQuestionChoiceOptionContent =
    | QuestionnaireQuestionChoiceOptionContentIconCard
    | QuestionnaireQuestionChoiceOptionContentImage
    | QuestionnaireQuestionChoiceOptionContentImageCard
    | QuestionnaireQuestionChoiceOptionContentText

export type QuestionnaireQuestionChoiceOptionContentIconCard =
    QuestionnaireQuestionChoiceOptionContentIconCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
        backgroundColor: Color
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentIconCardConditional>
        description: Maybe<Scalars['String']['output']>
        icon: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardConditional =
    QuestionnaireQuestionChoiceOptionContentIconCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
        backgroundColor: Color
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        icon: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardInterface = {
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    icon: Image
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionContentImage =
    QuestionnaireQuestionChoiceOptionContentImageInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentImageConditional>
        image: Image
    }

export type QuestionnaireQuestionChoiceOptionContentImageCard =
    QuestionnaireQuestionChoiceOptionContentImageCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentImageCardConditional>
        description: Maybe<Scalars['String']['output']>
        image: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardConditional =
    QuestionnaireQuestionChoiceOptionContentImageCardInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        image: Image
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardInterface = {
    description: Maybe<Scalars['String']['output']>
    image: Image
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionContentImageConditional =
    QuestionnaireQuestionChoiceOptionContentImageInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
        conditions: Array<QuestionnaireCondition>
        image: Image
    }

export type QuestionnaireQuestionChoiceOptionContentImageInterface = {
    image: Image
}

export type QuestionnaireQuestionChoiceOptionContentText =
    QuestionnaireQuestionChoiceOptionContentTextInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentText'
        conditionalContent: Array<QuestionnaireQuestionChoiceOptionContentTextConditional>
        description: Maybe<Scalars['String']['output']>
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentTextConditional =
    QuestionnaireQuestionChoiceOptionContentTextInterface & {
        __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
        conditions: Array<QuestionnaireCondition>
        description: Maybe<Scalars['String']['output']>
        title: Scalars['String']['output']
    }

export type QuestionnaireQuestionChoiceOptionContentTextInterface = {
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshot =
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotImage
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard
    | QuestionnaireQuestionChoiceOptionLayoutSnapshotText

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotIconCard'
    backgroundColor: QuestionnaireBackgroundColor
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<Asset>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotImage = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImage'
    icon: Maybe<Asset>
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotImageCard'
    description: Maybe<Scalars['String']['output']>
    icon: Maybe<Asset>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionLayoutSnapshotText = {
    __typename: 'QuestionnaireQuestionChoiceOptionLayoutSnapshotText'
    description: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type QuestionnaireQuestionChoiceOptionSnapshot = {
    __typename: 'QuestionnaireQuestionChoiceOptionSnapshot'
    id: Scalars['ID']['output']
    layout: QuestionnaireQuestionChoiceOptionLayoutSnapshot
    referenceId: Scalars['ID']['output']
}

export const QuestionnaireQuestionChoiceSystemCode = {
    AftercareSpecificService: 'AFTERCARE_SPECIFIC_SERVICE',
    CustomerShippingCountry: 'CUSTOMER_SHIPPING_COUNTRY',
    CustomerShippingFromCountry: 'CUSTOMER_SHIPPING_FROM_COUNTRY',
    CustomerToThMethod: 'CUSTOMER_TO_TH_METHOD',
    DropOffOffice: 'DROP_OFF_OFFICE',
    ErChoosingFor: 'ER_CHOOSING_FOR',
    ErDesignFeatures: 'ER_DESIGN_FEATURES',
    ErDesignStyle: 'ER_DESIGN_STYLE',
    ErMetal: 'ER_METAL',
    ErRingStyle: 'ER_RING_STYLE',
    ErStoneCategory: 'ER_STONE_CATEGORY',
    ErStoneShape: 'ER_STONE_SHAPE',
    PickUpOffice: 'PICK_UP_OFFICE',
    ServiceRequestType: 'SERVICE_REQUEST_TYPE',
    SignificantMonth: 'SIGNIFICANT_MONTH',
    StoneCategory: 'STONE_CATEGORY',
    StoneShape: 'STONE_SHAPE',
    ThToCustomerMethod: 'TH_TO_CUSTOMER_METHOD',
} as const

export type QuestionnaireQuestionChoiceSystemCode =
    (typeof QuestionnaireQuestionChoiceSystemCode)[keyof typeof QuestionnaireQuestionChoiceSystemCode]
export type QuestionnaireQuestionFile = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionFile'
    id: Scalars['ID']['output']
    required: Scalars['Boolean']['output']
    systemCode: Maybe<QuestionnaireQuestionFileSystemCode>
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionFileInput = {
    file: Scalars['Upload']['input']
}

export const QuestionnaireQuestionFileSystemCode = {
    InspirationPhoto: 'INSPIRATION_PHOTO',
} as const

export type QuestionnaireQuestionFileSystemCode =
    (typeof QuestionnaireQuestionFileSystemCode)[keyof typeof QuestionnaireQuestionFileSystemCode]
export type QuestionnaireQuestionFloatInput = {
    number: Scalars['Float']['input']
}

export type QuestionnaireQuestionInput = {
    referenceId: Scalars['ID']['input']
    systemCode?: InputMaybe<Scalars['String']['input']>
    title?: InputMaybe<Scalars['String']['input']>
}

export type QuestionnaireQuestionPrice = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionPrice'
    id: Scalars['ID']['output']
    max: Scalars['Float']['output']
    min: Scalars['Float']['output']
    required: Scalars['Boolean']['output']
    systemCode: Maybe<QuestionnaireQuestionPriceSystemCode>
    title: Maybe<Scalars['String']['output']>
    tooltip: Scalars['RenderableTemplate']['output']
}

export const QuestionnaireQuestionPriceSystemCode = {
    ErBudget: 'ER_BUDGET',
    StoneBudget: 'STONE_BUDGET',
} as const

export type QuestionnaireQuestionPriceSystemCode =
    (typeof QuestionnaireQuestionPriceSystemCode)[keyof typeof QuestionnaireQuestionPriceSystemCode]
export type QuestionnaireQuestionSnapshot = {
    __typename: 'QuestionnaireQuestionSnapshot'
    referenceId: Scalars['ID']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionText = QuestionnaireQuestion & {
    __typename: 'QuestionnaireQuestionText'
    id: Scalars['ID']['output']
    label: Maybe<Scalars['String']['output']>
    placeholder: Maybe<Scalars['String']['output']>
    required: Scalars['Boolean']['output']
    systemCode: Maybe<QuestionnaireQuestionTextSystemCode>
    textarea: Scalars['Boolean']['output']
    title: Maybe<Scalars['String']['output']>
}

export type QuestionnaireQuestionTextInput = {
    text: Scalars['String']['input']
}

export const QuestionnaireQuestionTextSystemCode = {
    AdditionalComments: 'ADDITIONAL_COMMENTS',
    CustomerShippingAddress: 'CUSTOMER_SHIPPING_ADDRESS',
    EngravingValue: 'ENGRAVING_VALUE',
    ErSomeoneElseName: 'ER_SOMEONE_ELSE_NAME',
    ExchangeReason: 'EXCHANGE_REASON',
    FullName: 'FULL_NAME',
    OrderNumber: 'ORDER_NUMBER',
    PartnerName: 'PARTNER_NAME',
    PostErCheckoutRingDecisionNotes: 'POST_ER_CHECKOUT_RING_DECISION_NOTES',
    RepairComments: 'REPAIR_COMMENTS',
    ResizeValue: 'RESIZE_VALUE',
    ReturnReason: 'RETURN_REASON',
    TellUsSomethingElse: 'TELL_US_SOMETHING_ELSE',
} as const

export type QuestionnaireQuestionTextSystemCode =
    (typeof QuestionnaireQuestionTextSystemCode)[keyof typeof QuestionnaireQuestionTextSystemCode]
export type QuestionnaireSignUpStep = {
    __typename: 'QuestionnaireSignUpStep'
    backgroundColor: Color
    description: Maybe<Scalars['String']['output']>
    image: Image
    submitButtonLabel: Maybe<Scalars['String']['output']>
    title: Scalars['String']['output']
}

export type QuestionnaireStep = {
    __typename: 'QuestionnaireStep'
    conditions: Array<QuestionnaireCondition>
    content: Array<QuestionnaireStepContent>
    description: Maybe<Scalars['String']['output']>
    excludeFromProgressIndicator: Maybe<Scalars['Boolean']['output']>
    help: Array<Block>
    title: Scalars['String']['output']
}

export type QuestionnaireStepContent =
    | QuestionnaireStepContentContent
    | QuestionnaireStepContentQuestions

export type QuestionnaireStepContentContent = {
    __typename: 'QuestionnaireStepContentContent'
    blocks: Array<Block>
    conditions: Array<QuestionnaireCondition>
}

export type QuestionnaireStepContentQuestions = {
    __typename: 'QuestionnaireStepContentQuestions'
    conditions: Array<QuestionnaireCondition>
    questions: Array<QuestionnaireQuestion>
}

export type QuestionnaireSubmissionNotification = {
    __typename: 'QuestionnaireSubmissionNotification'
    emails: Array<Scalars['String']['output']>
}

export type QuestionnaireSubmissionNotificationInput = {
    recipients: Array<Scalars['Email']['input']>
}

export const QuestionnaireType = {
    AftercareQuiz: 'AFTERCARE_QUIZ',
    DiamondQuiz: 'DIAMOND_QUIZ',
    GuidedJourney: 'GUIDED_JOURNEY',
    InspirationQuiz: 'INSPIRATION_QUIZ',
    PostErCheckoutSurvey: 'POST_ER_CHECKOUT_SURVEY',
} as const

export type QuestionnaireType =
    (typeof QuestionnaireType)[keyof typeof QuestionnaireType]
export type Quotation = {
    automaticSurchargeableComponents: Maybe<
        Array<SurchargeableQuotationComponent>
    >
    baseTemplate: Maybe<Scalars['String']['output']>
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    totalSalePrice: Money
}

export type QuotationEngagementRing = Quotation & {
    __typename: 'QuotationEngagementRing'
    automaticSurchargeableComponents: Maybe<
        Array<SurchargeableQuotationComponent>
    >
    baseTemplate: Maybe<Scalars['String']['output']>
    centreStone: DesignStudioEngagementRingCentreStone
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    mount: DesignStudioEngagementRingMount
    totalSalePrice: Money
}

export type QuotationJewellery = Quotation & {
    __typename: 'QuotationJewellery'
    automaticSurchargeableComponents: Maybe<
        Array<SurchargeableQuotationComponent>
    >
    baseTemplate: Maybe<Scalars['String']['output']>
    comment: Maybe<Scalars['String']['output']>
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    metals: Array<Metal>
    originalSalePrice: Money
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    signatureStones: Maybe<Array<Maybe<DesignStudioSignatureStone>>>
    totalSalePrice: Money
}

export type QuotationManualSurcharge = {
    __typename: 'QuotationManualSurcharge'
    amount: Money
    description: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
}

export type QuotationPercentageSurcharge = {
    __typename: 'QuotationPercentageSurcharge'
    description: Maybe<Scalars['String']['output']>
    id: Scalars['ID']['output']
    percent: Scalars['Decimal']['output']
}

export type QuotationWeddingRing = Quotation & {
    __typename: 'QuotationWeddingRing'
    automaticSurchargeableComponents: Maybe<
        Array<SurchargeableQuotationComponent>
    >
    baseTemplate: Maybe<Scalars['String']['output']>
    comment: Maybe<Scalars['String']['output']>
    customName: Maybe<Scalars['String']['output']>
    finalUntil: Maybe<Scalars['DateTime']['output']>
    firstAvailableDeliveryDate: DeliveryDate
    id: Scalars['ID']['output']
    image: Maybe<Scalars['Uri']['output']>
    images: Array<Scalars['Uri']['output']>
    isRecommended: Scalars['Boolean']['output']
    isSalesTaxApplicable: Scalars['Boolean']['output']
    isVatApplicable: Scalars['Boolean']['output']
    manualSurcharges: Array<QuotationManualSurcharge>
    metals: Array<Metal>
    originalSalePrice: Money
    percentageSurcharge: Maybe<QuotationPercentageSurcharge>
    signatureStones: Maybe<Array<Maybe<DesignStudioSignatureStone>>>
    totalSalePrice: Money
}

export const QuoteSize = {
    Large: 'LARGE',
    Small: 'SMALL',
} as const

export type QuoteSize = (typeof QuoteSize)[keyof typeof QuoteSize]
export const ReaderActionStatus = {
    Failed: 'FAILED',
    InProgress: 'IN_PROGRESS',
    Succeeded: 'SUCCEEDED',
} as const

export type ReaderActionStatus =
    (typeof ReaderActionStatus)[keyof typeof ReaderActionStatus]
export type RecommendedRingSize = {
    __typename: 'RecommendedRingSize'
    id: Scalars['ID']['output']
    label: Scalars['String']['output']
    ringSize: RingSize
}

export type RecommendedRingSizeLabelArgs = {
    locale: Scalars['Locale']['input']
    region: RegionCode
}

export type Redirection = RedirectionRedirect

export type RedirectionRedirect = {
    __typename: 'RedirectionRedirect'
    code: Scalars['Int']['output']
    target: Scalars['String']['output']
}

export type Region = {
    __typename: 'Region'
    code: RegionCode
    currency: Scalars['Currency']['output']
    isActive: Scalars['Boolean']['output']
    language: Language
    locales: Array<Scalars['Locale']['output']>
    representingCountry: Scalars['Country']['output']
}

export const RegionCode = {
    Au: 'AU',
    Ca: 'CA',
    Eu: 'EU',
    Ie: 'IE',
    Int: 'INT',
    Nz: 'NZ',
    Uk: 'UK',
    Us: 'US',
    Za: 'ZA',
} as const

export type RegionCode = (typeof RegionCode)[keyof typeof RegionCode]
export type RemoveFinalCustomerPriceSurchargeInput = {
    componentCode: SurchargeableQuotationComponent
    quotationId: Scalars['ID']['input']
}

export type RemoveFromCartInput = {
    productId: Scalars['ID']['input']
}

export type RetailBookingCustomerInput = {
    existing?: InputMaybe<Scalars['ID']['input']>
    new?: InputMaybe<CustomerRegistrationInput>
}

export type RetailCreateConsultationInput = {
    bookingInput: BookingCreateConsultationInput
    consultant?: InputMaybe<Scalars['ID']['input']>
    customer: RetailBookingCustomerInput
    parent?: InputMaybe<Scalars['ID']['input']>
}

export type RetailCreateConsultationResponse =
    | BookingConsultation
    | BookingCreateConsultationErrorNoAvailableConsultants

export type Review = {
    __typename: 'Review'
    comment: Scalars['String']['output']
    date: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    name: Maybe<Scalars['String']['output']>
    picture: Maybe<Asset>
    products: Array<CatalogueProduct>
    rating: Scalars['Int']['output']
}

export type ReviewProductsArgs = {
    types: InputMaybe<Array<CatalogueProductType>>
}

export type ReviewCarouselCard = {
    __typename: 'ReviewCarouselCard'
    author: Maybe<Scalars['String']['output']>
    date: Scalars['String']['output']
    review: Scalars['String']['output']
    starsCount: Scalars['Int']['output']
}

export type ReviewFilter = {
    withProductsOfType?: InputMaybe<Array<CatalogueProductType>>
}

export type ReviewsAggregate = {
    __typename: 'ReviewsAggregate'
    rating: Scalars['Float']['output']
    total: Scalars['Int']['output']
}

export type RingBuilder = {
    __typename: 'RingBuilder'
    errors: Array<RingBuilderResolvedFailureError>
    failure: Maybe<DesignStudioEngagementRingFailure>
    financeOptionsAffirm: Maybe<AffirmFinanceOption>
    financeOptionsKlarna: Maybe<KlarnaFinanceOption>
    id: Scalars['ID']['output']
    image: Maybe<GenericImage>
    position1: Maybe<RingBuilderFragment>
    position2: Maybe<RingBuilderFragment>
    productId: Maybe<Scalars['String']['output']>
    salePrice: SalePrice
    stoneRecommendations: StoneRecommendationsResponse
    totalSalePrice: Money
}

export type RingBuilderFinanceOptionsAffirmArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderFinanceOptionsKlarnaArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderStoneRecommendationsArgs = {
    currency: CurrencyInput
    maxPrice: InputMaybe<MoneyInput>
    minPrice: InputMaybe<MoneyInput>
    region: RegionCode
}

export type RingBuilderTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderCentreStone =
    | GemsApiStone
    | NonSkuGemstone
    | NonSkuLabGrown

export type RingBuilderCentreStoneFragment = {
    __typename: 'RingBuilderCentreStoneFragment'
    id: Scalars['ID']['output']
    stone: Maybe<RingBuilderCentreStone>
    totalSalePrice: Money
}

export type RingBuilderCentreStoneFragmentTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderCentreStoneFragmentInput = {
    gemsApiIdentifier?: InputMaybe<Scalars['ID']['input']>
    nonSkuGemstone?: InputMaybe<NonSkuGemstoneFilterInput>
    nonSkuLabGrownDiamond?: InputMaybe<NonSkuLabGrownDiamondFilterInput>
    uri?: InputMaybe<Scalars['Uri']['input']>
}

export type RingBuilderFragment =
    | RingBuilderCentreStoneFragment
    | RingBuilderMountFragment

export type RingBuilderGetInput = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderInput = {
    centreStone?: InputMaybe<RingBuilderCentreStoneFragmentInput>
    /** THIS WILL BECOME REQUIRED */
    getInput?: InputMaybe<RingBuilderGetInput>
    mount?: InputMaybe<RingBuilderMountFragmentInput>
    thirdStepUri?: InputMaybe<Scalars['Uri']['input']>
}

export type RingBuilderMountFragment = {
    __typename: 'RingBuilderMountFragment'
    id: Scalars['ID']['output']
    ring: CatalogueEngagementRing
    signatureStone: CatalogueEngagementRingSignatureStone
    stoneRecommendations: StoneRecommendationsResponse
    totalSalePrice: Money
}

export type RingBuilderMountFragmentStoneRecommendationsArgs = {
    currency: CurrencyInput
    maxPrice: InputMaybe<MoneyInput>
    minPrice: InputMaybe<MoneyInput>
    region: RegionCode
}

export type RingBuilderMountFragmentTotalSalePriceArgs = {
    currency: CurrencyInput
    region: RegionCode
}

export type RingBuilderMountFragmentInput = {
    engagementRing?: InputMaybe<CatalogueEngagementRingFilterInput>
    signatureStone?: InputMaybe<CatalogueEngagementRingSignatureStoneInput>
    uri?: InputMaybe<Scalars['Uri']['input']>
}

export type RingBuilderProductFilterInput = {
    currency: CurrencyInput
    marketingExport?: InputMaybe<Scalars['Boolean']['input']>
    region: RegionCode
    type?: InputMaybe<RingBuilderProductType>
}

export const RingBuilderProductType = {
    NonSkuGemstone: 'NON_SKU_GEMSTONE',
    NonSkuLabGrownDiamond: 'NON_SKU_LAB_GROWN_DIAMOND',
} as const

export type RingBuilderProductType =
    (typeof RingBuilderProductType)[keyof typeof RingBuilderProductType]
export type RingBuilderResolveInput = {
    baseInput?: InputMaybe<EnquiryBaseInput>
    centreStoneUri?: InputMaybe<Scalars['Uri']['input']>
    commissionJunction?: InputMaybe<CommissionJunctionInput>
    currency: CurrencyInput
    engraving?: InputMaybe<Scalars['String']['input']>
    /** THIS WILL BECOME REQUIRED */
    getInput?: InputMaybe<RingBuilderGetInput>
    mode: RingBuilderResolveMode
    region: RegionCode
    ringSize: RingSizeInput
    uri: Scalars['Uri']['input']
}

export const RingBuilderResolveMode = {
    AddToCart: 'ADD_TO_CART',
    Customize: 'CUSTOMIZE',
    Enquiry: 'ENQUIRY',
} as const

export type RingBuilderResolveMode =
    (typeof RingBuilderResolveMode)[keyof typeof RingBuilderResolveMode]
export type RingBuilderResolveResult =
    | CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudio
    | CatalogueDesignStudioCheckoutEngagementRingAddedToDesignStudioAndCart
    | DesignStudioEngagementRingFailure

export type RingBuilderResolvedExistingCustomer =
    | RingBuilderResolvedExistingCustomerSuccess
    | RingBuilderResolvedFailure

export type RingBuilderResolvedExistingCustomerSuccess = {
    __typename: 'RingBuilderResolvedExistingCustomerSuccess'
    data: RingBuilderResolveResult
    redirect: Maybe<Scalars['Uri']['output']>
    ringBuilder: RingBuilder
}

export type RingBuilderResolvedFailure = {
    __typename: 'RingBuilderResolvedFailure'
    errors: Array<RingBuilderResolvedFailureError>
    ringBuilder: RingBuilder
}

export const RingBuilderResolvedFailureError = {
    CentreStoneMissing: 'CENTRE_STONE_MISSING',
    MountMissing: 'MOUNT_MISSING',
    SignatureStoneMissing: 'SIGNATURE_STONE_MISSING',
} as const

export type RingBuilderResolvedFailureError =
    (typeof RingBuilderResolvedFailureError)[keyof typeof RingBuilderResolvedFailureError]
export type RingBuilderResolvedNewCustomer =
    | RingBuilderResolvedFailure
    | RingBuilderResolvedNewCustomerSuccess

export type RingBuilderResolvedNewCustomerSuccess = {
    __typename: 'RingBuilderResolvedNewCustomerSuccess'
    customer: CustomerRegistrationResponse
    data: RingBuilderResolveResult
    redirect: Maybe<Scalars['Uri']['output']>
    ringBuilder: RingBuilder
}

export const RingBuilderSetError = {
    CentreStoneNotFound: 'CENTRE_STONE_NOT_FOUND',
    EngagementRingNotFound: 'ENGAGEMENT_RING_NOT_FOUND',
    SignatureStoneNotFound: 'SIGNATURE_STONE_NOT_FOUND',
} as const

export type RingBuilderSetError =
    (typeof RingBuilderSetError)[keyof typeof RingBuilderSetError]
export type RingBuilderSetResult = {
    __typename: 'RingBuilderSetResult'
    errors: Array<RingBuilderSetError>
    ringBuilder: RingBuilder
}

export type RingSize = {
    __typename: 'RingSize'
    id: Scalars['ID']['output']
    label: Maybe<Scalars['String']['output']>
}

export type RingSizeLabelArgs = {
    region: RegionCode
}

export type RingSizeInput = {
    recommendedRingSizeId?: InputMaybe<Scalars['ID']['input']>
    ringSizeId?: InputMaybe<Scalars['ID']['input']>
}

export type RingSizeOrRecommendedRingSize = RecommendedRingSize | RingSize

export const Robots = {
    NoindexFollow: 'NOINDEX_FOLLOW',
} as const

export type Robots = (typeof Robots)[keyof typeof Robots]
export type SalePrice = {
    __typename: 'SalePrice'
    tax: Maybe<Tax>
    total: Money
}

export type SearchEverywhereResponse = {
    __typename: 'SearchEverywhereResponse'
    customers: Array<Customer>
    orders: Array<Order>
    products: Array<DesignStudioProductGeneric>
}

export type SetDeliveryInformationError = OrderAlreadyCompletedError

export type SetDeliveryInformationFailureResponse = {
    __typename: 'SetDeliveryInformationFailureResponse'
    errors: Array<SetDeliveryInformationError>
}

export type SetDeliveryInformationResponse =
    | SetDeliveryInformationFailureResponse
    | SetDeliveryInformationSuccessResponse

export type SetDeliveryInformationSuccessResponse = {
    __typename: 'SetDeliveryInformationSuccessResponse'
    order: Order
}

export type ShipmentTrackingInformation = {
    __typename: 'ShipmentTrackingInformation'
    /** not to be confused with the order's dispatched at date */
    dispatchedAt: Scalars['DateTime']['output']
    shippingCompany: Scalars['String']['output']
    trackingNumber: Scalars['String']['output']
    trackingUrl: Scalars['String']['output']
}

export type ShopWithConfidenceComponent = {
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceEthnicallySourcedDiamonds =
    ShopWithConfidenceComponent & {
        __typename: 'ShopWithConfidenceEthnicallySourcedDiamonds'
        content: Array<ContentComponentItem>
    }

export type ShopWithConfidenceFinancingOptions = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceFinancingOptions'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceGreenlandRuby = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceGreenlandRuby'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceHandFinished = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceHandFinished'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceResize = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceResize'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceReturnPolicy = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceReturnPolicy'
    content: Array<ContentComponentItem>
}

export type ShopWithConfidenceShipping = ShopWithConfidenceComponent & {
    __typename: 'ShopWithConfidenceShipping'
    content: Array<ContentComponentItem>
}

export type Showroom = {
    __typename: 'Showroom'
    hasWalkInRooms: Scalars['Boolean']['output']
    id: Scalars['ID']['output']
    isAccessible: Scalars['Boolean']['output']
    location: ShowroomLocation
    timezone: Scalars['String']['output']
    translation: ShowroomTranslation
}

export type ShowroomTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export type ShowroomLocation = {
    __typename: 'ShowroomLocation'
    addressLine1: Scalars['String']['output']
    addressLine2: Maybe<Scalars['String']['output']>
    city: Scalars['String']['output']
    country: Scalars['Country']['output']
    geoLocation: Maybe<GeoPoint>
    id: Scalars['ID']['output']
    postalCode: Maybe<Scalars['String']['output']>
    subdivision: Maybe<Scalars['CountrySubdivision']['output']>
}

export type ShowroomTranslation = {
    __typename: 'ShowroomTranslation'
    name: Scalars['String']['output']
}

export type SingleUsePromoCode = BasePromoCode & {
    __typename: 'SingleUsePromoCode'
    code: Scalars['String']['output']
    id: Scalars['ID']['output']
    promoCodeRuleset: Maybe<PromoCodeRuleset>
}

export const SlidePadding = {
    Large: 'LARGE',
    Medium: 'MEDIUM',
    None: 'NONE',
    Small: 'SMALL',
} as const

export type SlidePadding = (typeof SlidePadding)[keyof typeof SlidePadding]
export type SocialNetwork = {
    __typename: 'SocialNetwork'
    icon: Icon
    link: Scalars['String']['output']
    name: Scalars['String']['output']
}

export const Spacing = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type Spacing = (typeof Spacing)[keyof typeof Spacing]
export type SquareBoxes = SquareImageBox | SquareTextBox

export type SquareImageBox = {
    __typename: 'SquareImageBox'
    image: Image
    link: Maybe<Link>
}

export type SquareTextBox = {
    __typename: 'SquareTextBox'
    backgroundColor: Color
    content: Array<ContentComponentItem>
}

export type StockInStoreAddToCart = {
    stockCode: Scalars['ID']['input']
}

export type Stone = {
    __typename: 'Stone'
    caratWeight: Scalars['Decimal']['output']
    certificate: Maybe<StoneCertificate>
    clarity: Maybe<StoneClarity>
    color: Maybe<StoneColor>
    colorGrade: Maybe<StoneGrade>
    crystal: Maybe<StoneCrystal>
    cut: Maybe<StoneCut>
    depthPercent: Scalars['Decimal']['output']
    fluorescence: Maybe<StoneFluorescence>
    id: Scalars['ID']['output']
    measurements: StoneMeasurements
    photo: Maybe<Scalars['Uri']['output']>
    polish: Maybe<StonePolish>
    ratio: Maybe<Scalars['Decimal']['output']>
    shape: Maybe<StoneShape>
    symmetry: Maybe<StoneSymmetry>
    tablePercent: Scalars['Decimal']['output']
}

export type StoneCategory = {
    __typename: 'StoneCategory'
    systemCode: StoneCategoryCode
    translation: StoneCategoryTranslation
}

export type StoneCategoryTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCategoryCode = {
    Diamond: 'DIAMOND',
    FancyDiamond: 'FANCY_DIAMOND',
    Gemstone: 'GEMSTONE',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
} as const

export type StoneCategoryCode =
    (typeof StoneCategoryCode)[keyof typeof StoneCategoryCode]
export type StoneCategoryTranslation = {
    __typename: 'StoneCategoryTranslation'
    name: Scalars['String']['output']
}

export type StoneCertificate = {
    __typename: 'StoneCertificate'
    number: Scalars['String']['output']
    uri: Scalars['Uri']['output']
}

export type StoneClarity = {
    __typename: 'StoneClarity'
    abbreviation: Scalars['String']['output']
    systemCode: StoneClarityCode
    translation: StoneClarityTranslation
}

export type StoneClarityTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneClarityCode = {
    DiamondFl: 'DIAMOND_FL',
    DiamondIf: 'DIAMOND_IF',
    DiamondSi1: 'DIAMOND_SI1',
    DiamondSi2: 'DIAMOND_SI2',
    DiamondVs1: 'DIAMOND_VS1',
    DiamondVs2: 'DIAMOND_VS2',
    DiamondVvs1: 'DIAMOND_VVS1',
    DiamondVvs2: 'DIAMOND_VVS2',
    GemstoneEyeClean: 'GEMSTONE_EYE_CLEAN',
    GemstoneIncluded: 'GEMSTONE_INCLUDED',
    GemstoneLoupeClean: 'GEMSTONE_LOUPE_CLEAN',
    GemstoneSlightlyIncluded: 'GEMSTONE_SLIGHTLY_INCLUDED',
} as const

export type StoneClarityCode =
    (typeof StoneClarityCode)[keyof typeof StoneClarityCode]
export type StoneClarityFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneClarityTranslation = {
    __typename: 'StoneClarityTranslation'
    name: Scalars['String']['output']
}

export type StoneColor = {
    __typename: 'StoneColor'
    systemCode: StoneColorCode
    translation: StoneColorTranslation
}

export type StoneColorTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneColorCode = {
    DiamondD: 'DIAMOND_D',
    DiamondE: 'DIAMOND_E',
    DiamondF: 'DIAMOND_F',
    DiamondG: 'DIAMOND_G',
    DiamondH: 'DIAMOND_H',
    DiamondI: 'DIAMOND_I',
    DiamondJ: 'DIAMOND_J',
    DiamondK: 'DIAMOND_K',
    DiamondL: 'DIAMOND_L',
    DiamondM: 'DIAMOND_M',
    FancyDiamondAchrioteColourless: 'FANCY_DIAMOND_ACHRIOTE_COLOURLESS',
    FancyDiamondBlack: 'FANCY_DIAMOND_BLACK',
    FancyDiamondBlue: 'FANCY_DIAMOND_BLUE',
    FancyDiamondBlueGray: 'FANCY_DIAMOND_BLUE_GRAY',
    FancyDiamondBlueGreen: 'FANCY_DIAMOND_BLUE_GREEN',
    FancyDiamondBlueViolet: 'FANCY_DIAMOND_BLUE_VIOLET',
    FancyDiamondBluishGray: 'FANCY_DIAMOND_BLUISH_GRAY',
    FancyDiamondBluishGreen: 'FANCY_DIAMOND_BLUISH_GREEN',
    FancyDiamondBluishViolet: 'FANCY_DIAMOND_BLUISH_VIOLET',
    FancyDiamondBrown: 'FANCY_DIAMOND_BROWN',
    FancyDiamondBrownishGreen: 'FANCY_DIAMOND_BROWNISH_GREEN',
    FancyDiamondBrownishOrange: 'FANCY_DIAMOND_BROWNISH_ORANGE',
    FancyDiamondBrownishPink: 'FANCY_DIAMOND_BROWNISH_PINK',
    FancyDiamondBrownishPurple: 'FANCY_DIAMOND_BROWNISH_PURPLE',
    FancyDiamondBrownishRed: 'FANCY_DIAMOND_BROWNISH_RED',
    FancyDiamondBrownishYellow: 'FANCY_DIAMOND_BROWNISH_YELLOW',
    FancyDiamondBrownGreen: 'FANCY_DIAMOND_BROWN_GREEN',
    FancyDiamondBrownOrange: 'FANCY_DIAMOND_BROWN_ORANGE',
    FancyDiamondBrownPink: 'FANCY_DIAMOND_BROWN_PINK',
    FancyDiamondBrownPurple: 'FANCY_DIAMOND_BROWN_PURPLE',
    FancyDiamondBrownRed: 'FANCY_DIAMOND_BROWN_RED',
    FancyDiamondBrownYellow: 'FANCY_DIAMOND_BROWN_YELLOW',
    FancyDiamondCanaryYellow: 'FANCY_DIAMOND_CANARY_YELLOW',
    FancyDiamondCatsEye: 'FANCY_DIAMOND_CATS_EYE',
    FancyDiamondChameleon: 'FANCY_DIAMOND_CHAMELEON',
    FancyDiamondChampagne: 'FANCY_DIAMOND_CHAMPAGNE',
    FancyDiamondChocolate: 'FANCY_DIAMOND_CHOCOLATE',
    FancyDiamondChromeDeepGreen: 'FANCY_DIAMOND_CHROME_DEEP_GREEN',
    FancyDiamondCognac: 'FANCY_DIAMOND_COGNAC',
    FancyDiamondColorChange: 'FANCY_DIAMOND_COLOR_CHANGE',
    FancyDiamondDraviteBrown: 'FANCY_DIAMOND_DRAVITE_BROWN',
    FancyDiamondElbaite: 'FANCY_DIAMOND_ELBAITE',
    FancyDiamondGray: 'FANCY_DIAMOND_GRAY',
    FancyDiamondGrayishBlue: 'FANCY_DIAMOND_GRAYISH_BLUE',
    FancyDiamondGrayishGreen: 'FANCY_DIAMOND_GRAYISH_GREEN',
    FancyDiamondGrayishPurple: 'FANCY_DIAMOND_GRAYISH_PURPLE',
    FancyDiamondGrayishViolet: 'FANCY_DIAMOND_GRAYISH_VIOLET',
    FancyDiamondGrayBlue: 'FANCY_DIAMOND_GRAY_BLUE',
    FancyDiamondGrayGreen: 'FANCY_DIAMOND_GRAY_GREEN',
    FancyDiamondGrayPurple: 'FANCY_DIAMOND_GRAY_PURPLE',
    FancyDiamondGrayViolet: 'FANCY_DIAMOND_GRAY_VIOLET',
    FancyDiamondGreen: 'FANCY_DIAMOND_GREEN',
    FancyDiamondGreenishBlue: 'FANCY_DIAMOND_GREENISH_BLUE',
    FancyDiamondGreenishBrown: 'FANCY_DIAMOND_GREENISH_BROWN',
    FancyDiamondGreenishGray: 'FANCY_DIAMOND_GREENISH_GRAY',
    FancyDiamondGreenishYellow: 'FANCY_DIAMOND_GREENISH_YELLOW',
    FancyDiamondGreenBlue: 'FANCY_DIAMOND_GREEN_BLUE',
    FancyDiamondGreenBrown: 'FANCY_DIAMOND_GREEN_BROWN',
    FancyDiamondGreenGray: 'FANCY_DIAMOND_GREEN_GRAY',
    FancyDiamondGreenYellow: 'FANCY_DIAMOND_GREEN_YELLOW',
    FancyDiamondOrange: 'FANCY_DIAMOND_ORANGE',
    FancyDiamondOrangeBrown: 'FANCY_DIAMOND_ORANGE_BROWN',
    FancyDiamondOrangePink: 'FANCY_DIAMOND_ORANGE_PINK',
    FancyDiamondOrangeRed: 'FANCY_DIAMOND_ORANGE_RED',
    FancyDiamondOrangeYellow: 'FANCY_DIAMOND_ORANGE_YELLOW',
    FancyDiamondOrangishBrown: 'FANCY_DIAMOND_ORANGISH_BROWN',
    FancyDiamondOrangishPink: 'FANCY_DIAMOND_ORANGISH_PINK',
    FancyDiamondOrangishRed: 'FANCY_DIAMOND_ORANGISH_RED',
    FancyDiamondOrangishYellow: 'FANCY_DIAMOND_ORANGISH_YELLOW',
    FancyDiamondOrangyBrown: 'FANCY_DIAMOND_ORANGY_BROWN',
    FancyDiamondOrangyPink: 'FANCY_DIAMOND_ORANGY_PINK',
    FancyDiamondOrangyRed: 'FANCY_DIAMOND_ORANGY_RED',
    FancyDiamondOrangyYellow: 'FANCY_DIAMOND_ORANGY_YELLOW',
    FancyDiamondPadparadscha: 'FANCY_DIAMOND_PADPARADSCHA',
    FancyDiamondParaiba: 'FANCY_DIAMOND_PARAIBA',
    FancyDiamondPeach: 'FANCY_DIAMOND_PEACH',
    FancyDiamondPink: 'FANCY_DIAMOND_PINK',
    FancyDiamondPinkishBrown: 'FANCY_DIAMOND_PINKISH_BROWN',
    FancyDiamondPinkishOrange: 'FANCY_DIAMOND_PINKISH_ORANGE',
    FancyDiamondPinkishPurple: 'FANCY_DIAMOND_PINKISH_PURPLE',
    FancyDiamondPinkishRed: 'FANCY_DIAMOND_PINKISH_RED',
    FancyDiamondPinkBrown: 'FANCY_DIAMOND_PINK_BROWN',
    FancyDiamondPinkOrange: 'FANCY_DIAMOND_PINK_ORANGE',
    FancyDiamondPinkPurple: 'FANCY_DIAMOND_PINK_PURPLE',
    FancyDiamondPurple: 'FANCY_DIAMOND_PURPLE',
    FancyDiamondPurpleGray: 'FANCY_DIAMOND_PURPLE_GRAY',
    FancyDiamondPurplePink: 'FANCY_DIAMOND_PURPLE_PINK',
    FancyDiamondPurpleRed: 'FANCY_DIAMOND_PURPLE_RED',
    FancyDiamondPurplishGray: 'FANCY_DIAMOND_PURPLISH_GRAY',
    FancyDiamondPurplishPink: 'FANCY_DIAMOND_PURPLISH_PINK',
    FancyDiamondPurplishRed: 'FANCY_DIAMOND_PURPLISH_RED',
    FancyDiamondRed: 'FANCY_DIAMOND_RED',
    FancyDiamondReddishBrown: 'FANCY_DIAMOND_REDDISH_BROWN',
    FancyDiamondReddishOrange: 'FANCY_DIAMOND_REDDISH_ORANGE',
    FancyDiamondReddishPurple: 'FANCY_DIAMOND_REDDISH_PURPLE',
    FancyDiamondRedBrown: 'FANCY_DIAMOND_RED_BROWN',
    FancyDiamondRedOrange: 'FANCY_DIAMOND_RED_ORANGE',
    FancyDiamondRedPurple: 'FANCY_DIAMOND_RED_PURPLE',
    FancyDiamondRubellite: 'FANCY_DIAMOND_RUBELLITE',
    FancyDiamondSchorlBlack: 'FANCY_DIAMOND_SCHORL_BLACK',
    FancyDiamondSiberitePurple: 'FANCY_DIAMOND_SIBERITE_PURPLE',
    FancyDiamondTeal: 'FANCY_DIAMOND_TEAL',
    FancyDiamondTurquoise: 'FANCY_DIAMOND_TURQUOISE',
    FancyDiamondVerdelitePurple: 'FANCY_DIAMOND_VERDELITE_PURPLE',
    FancyDiamondViolet: 'FANCY_DIAMOND_VIOLET',
    FancyDiamondVioletishBlue: 'FANCY_DIAMOND_VIOLETISH_BLUE',
    FancyDiamondVioletishGray: 'FANCY_DIAMOND_VIOLETISH_GRAY',
    FancyDiamondVioletBlue: 'FANCY_DIAMOND_VIOLET_BLUE',
    FancyDiamondVioletGray: 'FANCY_DIAMOND_VIOLET_GRAY',
    FancyDiamondWatermelon: 'FANCY_DIAMOND_WATERMELON',
    FancyDiamondWhite: 'FANCY_DIAMOND_WHITE',
    FancyDiamondYellow: 'FANCY_DIAMOND_YELLOW',
    FancyDiamondYellowishBrown: 'FANCY_DIAMOND_YELLOWISH_BROWN',
    FancyDiamondYellowishGray: 'FANCY_DIAMOND_YELLOWISH_GRAY',
    FancyDiamondYellowishGreen: 'FANCY_DIAMOND_YELLOWISH_GREEN',
    FancyDiamondYellowishOrange: 'FANCY_DIAMOND_YELLOWISH_ORANGE',
    FancyDiamondYellowBrown: 'FANCY_DIAMOND_YELLOW_BROWN',
    FancyDiamondYellowGray: 'FANCY_DIAMOND_YELLOW_GRAY',
    FancyDiamondYellowGreen: 'FANCY_DIAMOND_YELLOW_GREEN',
    FancyDiamondYellowOrange: 'FANCY_DIAMOND_YELLOW_ORANGE',
    GemstoneAchroiteColourless: 'GEMSTONE_ACHROITE_COLOURLESS',
    GemstoneBiColour: 'GEMSTONE_BI_COLOUR',
    GemstoneBlack: 'GEMSTONE_BLACK',
    GemstoneBlue: 'GEMSTONE_BLUE',
    GemstoneBlueGray: 'GEMSTONE_BLUE_GRAY',
    GemstoneBlueGreen: 'GEMSTONE_BLUE_GREEN',
    GemstoneBlueViolet: 'GEMSTONE_BLUE_VIOLET',
    GemstoneBluishGray: 'GEMSTONE_BLUISH_GRAY',
    GemstoneBluishGreen: 'GEMSTONE_BLUISH_GREEN',
    GemstoneBluishViolet: 'GEMSTONE_BLUISH_VIOLET',
    GemstoneBrown: 'GEMSTONE_BROWN',
    GemstoneBrownishGreen: 'GEMSTONE_BROWNISH_GREEN',
    GemstoneBrownishOrange: 'GEMSTONE_BROWNISH_ORANGE',
    GemstoneBrownishPink: 'GEMSTONE_BROWNISH_PINK',
    GemstoneBrownishPurple: 'GEMSTONE_BROWNISH_PURPLE',
    GemstoneBrownishRed: 'GEMSTONE_BROWNISH_RED',
    GemstoneBrownishYellow: 'GEMSTONE_BROWNISH_YELLOW',
    GemstoneBrownGreen: 'GEMSTONE_BROWN_GREEN',
    GemstoneBrownOrange: 'GEMSTONE_BROWN_ORANGE',
    GemstoneBrownPink: 'GEMSTONE_BROWN_PINK',
    GemstoneBrownPurple: 'GEMSTONE_BROWN_PURPLE',
    GemstoneBrownRed: 'GEMSTONE_BROWN_RED',
    GemstoneBrownYellow: 'GEMSTONE_BROWN_YELLOW',
    GemstoneCanaryYellow: 'GEMSTONE_CANARY_YELLOW',
    GemstoneCatsEye: 'GEMSTONE_CATS_EYE',
    GemstoneChameleon: 'GEMSTONE_CHAMELEON',
    GemstoneChampagne: 'GEMSTONE_CHAMPAGNE',
    GemstoneChocolate: 'GEMSTONE_CHOCOLATE',
    GemstoneChromeDeepGreen: 'GEMSTONE_CHROME_DEEP_GREEN',
    GemstoneCognac: 'GEMSTONE_COGNAC',
    GemstoneColorChange: 'GEMSTONE_COLOR_CHANGE',
    GemstoneDraviteBrown: 'GEMSTONE_DRAVITE_BROWN',
    GemstoneElbaite: 'GEMSTONE_ELBAITE',
    GemstoneGray: 'GEMSTONE_GRAY',
    GemstoneGrayishGreen: 'GEMSTONE_GRAYISH_GREEN',
    GemstoneGrayishPurple: 'GEMSTONE_GRAYISH_PURPLE',
    GemstoneGrayishViolet: 'GEMSTONE_GRAYISH_VIOLET',
    GemstoneGrayBlue: 'GEMSTONE_GRAY_BLUE',
    GemstoneGrayGreen: 'GEMSTONE_GRAY_GREEN',
    GemstoneGrayGreenishYellow: 'GEMSTONE_GRAY_GREENISH_YELLOW',
    GemstoneGrayPurple: 'GEMSTONE_GRAY_PURPLE',
    GemstoneGrayViolet: 'GEMSTONE_GRAY_VIOLET',
    GemstoneGrayYellowishGreen: 'GEMSTONE_GRAY_YELLOWISH_GREEN',
    GemstoneGreen: 'GEMSTONE_GREEN',
    GemstoneGreenishBlue: 'GEMSTONE_GREENISH_BLUE',
    GemstoneGreenishBrown: 'GEMSTONE_GREENISH_BROWN',
    GemstoneGreenishGray: 'GEMSTONE_GREENISH_GRAY',
    GemstoneGreenishYellow: 'GEMSTONE_GREENISH_YELLOW',
    GemstoneGreenBlue: 'GEMSTONE_GREEN_BLUE',
    GemstoneGreenBrown: 'GEMSTONE_GREEN_BROWN',
    GemstoneGreenGray: 'GEMSTONE_GREEN_GRAY',
    GemstoneGreenYellow: 'GEMSTONE_GREEN_YELLOW',
    GemstoneOrange: 'GEMSTONE_ORANGE',
    GemstoneOrangeBrown: 'GEMSTONE_ORANGE_BROWN',
    GemstoneOrangePink: 'GEMSTONE_ORANGE_PINK',
    GemstoneOrangeRed: 'GEMSTONE_ORANGE_RED',
    GemstoneOrangeYellow: 'GEMSTONE_ORANGE_YELLOW',
    GemstoneOrangyBrown: 'GEMSTONE_ORANGY_BROWN',
    GemstoneOrangyPink: 'GEMSTONE_ORANGY_PINK',
    GemstoneOrangyRed: 'GEMSTONE_ORANGY_RED',
    GemstoneOrangyYellow: 'GEMSTONE_ORANGY_YELLOW',
    GemstonePadparadscha: 'GEMSTONE_PADPARADSCHA',
    GemstoneParaiba: 'GEMSTONE_PARAIBA',
    GemstonePeach: 'GEMSTONE_PEACH',
    GemstonePink: 'GEMSTONE_PINK',
    GemstonePinkishBrown: 'GEMSTONE_PINKISH_BROWN',
    GemstonePinkishPurple: 'GEMSTONE_PINKISH_PURPLE',
    GemstonePinkishRed: 'GEMSTONE_PINKISH_RED',
    GemstonePinkBrown: 'GEMSTONE_PINK_BROWN',
    GemstonePinkPurple: 'GEMSTONE_PINK_PURPLE',
    GemstonePurple: 'GEMSTONE_PURPLE',
    GemstonePurpleGray: 'GEMSTONE_PURPLE_GRAY',
    GemstonePurplePink: 'GEMSTONE_PURPLE_PINK',
    GemstonePurpleRed: 'GEMSTONE_PURPLE_RED',
    GemstonePurplishGray: 'GEMSTONE_PURPLISH_GRAY',
    GemstonePurplishPink: 'GEMSTONE_PURPLISH_PINK',
    GemstonePurplishRed: 'GEMSTONE_PURPLISH_RED',
    GemstoneRed: 'GEMSTONE_RED',
    GemstoneReddishBrown: 'GEMSTONE_REDDISH_BROWN',
    GemstoneReddishOrange: 'GEMSTONE_REDDISH_ORANGE',
    GemstoneReddishPurple: 'GEMSTONE_REDDISH_PURPLE',
    GemstoneRedBrown: 'GEMSTONE_RED_BROWN',
    GemstoneRedOrange: 'GEMSTONE_RED_ORANGE',
    GemstoneRedPurple: 'GEMSTONE_RED_PURPLE',
    GemstoneRubellite: 'GEMSTONE_RUBELLITE',
    GemstoneSchorlBlack: 'GEMSTONE_SCHORL_BLACK',
    GemstoneSiberitePurple: 'GEMSTONE_SIBERITE_PURPLE',
    GemstoneTeal: 'GEMSTONE_TEAL',
    GemstoneTurquoise: 'GEMSTONE_TURQUOISE',
    GemstoneVerdelitePurple: 'GEMSTONE_VERDELITE_PURPLE',
    GemstoneViolet: 'GEMSTONE_VIOLET',
    GemstoneVioletishBlue: 'GEMSTONE_VIOLETISH_BLUE',
    GemstoneVioletishGray: 'GEMSTONE_VIOLETISH_GRAY',
    GemstoneVioletishPurple: 'GEMSTONE_VIOLETISH_PURPLE',
    GemstoneVioletBlue: 'GEMSTONE_VIOLET_BLUE',
    GemstoneVioletGray: 'GEMSTONE_VIOLET_GRAY',
    GemstoneWatermelon: 'GEMSTONE_WATERMELON',
    GemstoneWhite: 'GEMSTONE_WHITE',
    GemstoneYellow: 'GEMSTONE_YELLOW',
    GemstoneYellowishBrown: 'GEMSTONE_YELLOWISH_BROWN',
    GemstoneYellowishGray: 'GEMSTONE_YELLOWISH_GRAY',
    GemstoneYellowishGreen: 'GEMSTONE_YELLOWISH_GREEN',
    GemstoneYellowishOrange: 'GEMSTONE_YELLOWISH_ORANGE',
    GemstoneYellowBrown: 'GEMSTONE_YELLOW_BROWN',
    GemstoneYellowGray: 'GEMSTONE_YELLOW_GRAY',
    GemstoneYellowGreen: 'GEMSTONE_YELLOW_GREEN',
    GemstoneYellowOrange: 'GEMSTONE_YELLOW_ORANGE',
} as const

export type StoneColorCode =
    (typeof StoneColorCode)[keyof typeof StoneColorCode]
export type StoneColorTranslation = {
    __typename: 'StoneColorTranslation'
    name: Scalars['String']['output']
}

export type StoneColorsFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneCrystal = {
    __typename: 'StoneCrystal'
    systemCode: StoneCrystalCode
    translation: StoneCrystalTranslation
}

export type StoneCrystalTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCrystalCode = {
    Alexandrite: 'ALEXANDRITE',
    Amethyst: 'AMETHYST',
    Aquamarine: 'AQUAMARINE',
    Citrine: 'CITRINE',
    Diamond: 'DIAMOND',
    Emerald: 'EMERALD',
    FancyDiamond: 'FANCY_DIAMOND',
    Garnet: 'GARNET',
    LabGrownDiamond: 'LAB_GROWN_DIAMOND',
    LabGrownFancyDiamond: 'LAB_GROWN_FANCY_DIAMOND',
    Morganite: 'MORGANITE',
    Peridot: 'PERIDOT',
    Ruby: 'RUBY',
    Sapphire: 'SAPPHIRE',
    Spinel: 'SPINEL',
    Tanzanite: 'TANZANITE',
    Topaz: 'TOPAZ',
    Tourmaline: 'TOURMALINE',
    Tsavorite: 'TSAVORITE',
    Zircon: 'ZIRCON',
} as const

export type StoneCrystalCode =
    (typeof StoneCrystalCode)[keyof typeof StoneCrystalCode]
export type StoneCrystalTranslation = {
    __typename: 'StoneCrystalTranslation'
    name: Scalars['String']['output']
}

export type StoneCrystalsFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneCut = {
    __typename: 'StoneCut'
    abbreviation: Scalars['String']['output']
    systemCode: StoneCutCode
    translation: StoneCutTranslation
}

export type StoneCutTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneCutCode = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StoneCutCode = (typeof StoneCutCode)[keyof typeof StoneCutCode]
export type StoneCutTranslation = {
    __typename: 'StoneCutTranslation'
    name: Scalars['String']['output']
}

export type StoneFluorescence = {
    __typename: 'StoneFluorescence'
    abbreviation: Scalars['String']['output']
    systemCode: StoneFluorescenceCode
    translation: StoneFluorescenceTranslation
}

export type StoneFluorescenceTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneFluorescenceCode = {
    Faint: 'FAINT',
    Medium: 'MEDIUM',
    None: 'NONE',
    Strong: 'STRONG',
    VeryStrong: 'VERY_STRONG',
} as const

export type StoneFluorescenceCode =
    (typeof StoneFluorescenceCode)[keyof typeof StoneFluorescenceCode]
export type StoneFluorescenceTranslation = {
    __typename: 'StoneFluorescenceTranslation'
    name: Scalars['String']['output']
}

export type StoneGrade = {
    __typename: 'StoneGrade'
    categories: Array<StoneCategory>
    systemCode: StoneGradeCode
    translation: StoneGradeTranslation
}

export type StoneGradeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneGradeCode = {
    FancyDiamondFaint: 'FANCY_DIAMOND_FAINT',
    FancyDiamondFancy: 'FANCY_DIAMOND_FANCY',
    FancyDiamondFancyDark: 'FANCY_DIAMOND_FANCY_DARK',
    FancyDiamondFancyDeep: 'FANCY_DIAMOND_FANCY_DEEP',
    FancyDiamondFancyIntense: 'FANCY_DIAMOND_FANCY_INTENSE',
    FancyDiamondFancyLight: 'FANCY_DIAMOND_FANCY_LIGHT',
    FancyDiamondFancyVivid: 'FANCY_DIAMOND_FANCY_VIVID',
    FancyDiamondLight: 'FANCY_DIAMOND_LIGHT',
    FancyDiamondVeryLight: 'FANCY_DIAMOND_VERY_LIGHT',
    GemstoneDark: 'GEMSTONE_DARK',
    GemstoneHot: 'GEMSTONE_HOT',
    GemstoneLight: 'GEMSTONE_LIGHT',
    GemstoneMedium: 'GEMSTONE_MEDIUM',
    GemstoneMediumDark: 'GEMSTONE_MEDIUM_DARK',
    GemstoneMediumLight: 'GEMSTONE_MEDIUM_LIGHT',
    GemstoneVeryDark: 'GEMSTONE_VERY_DARK',
    GemstoneVeryLight: 'GEMSTONE_VERY_LIGHT',
} as const

export type StoneGradeCode =
    (typeof StoneGradeCode)[keyof typeof StoneGradeCode]
export type StoneGradeTranslation = {
    __typename: 'StoneGradeTranslation'
    name: Scalars['String']['output']
}

export type StoneGradesFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneMeasurements = {
    __typename: 'StoneMeasurements'
    depth: Scalars['Decimal']['output']
    length: Scalars['Decimal']['output']
    width: Scalars['Decimal']['output']
}

export type StonePolish = {
    __typename: 'StonePolish'
    abbreviation: Scalars['String']['output']
    systemCode: StonePolishCode
    translation: StonePolishTranslation
}

export type StonePolishTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StonePolishCode = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StonePolishCode =
    (typeof StonePolishCode)[keyof typeof StonePolishCode]
export type StonePolishTranslation = {
    __typename: 'StonePolishTranslation'
    name: Scalars['String']['output']
}

export type StoneRecommendationGemsApiGemstone = {
    __typename: 'StoneRecommendationGemsApiGemstone'
    color: StoneColor
    stone: StoneRecommendationGemsApiStone
}

export type StoneRecommendationGemsApiStone =
    | GemsApi_Stone
    | StoneRecommendationNotFound

export type StoneRecommendationNonSkuGemstone = {
    __typename: 'StoneRecommendationNonSkuGemstone'
    color: StoneColor
    item: StoneRecommendationNonSkuGemstoneItem
}

export type StoneRecommendationNonSkuGemstoneItem =
    | NonSkuGemstone
    | StoneRecommendationNotFound

export type StoneRecommendationNonSkuLabGrownItem =
    | NonSkuLabGrown
    | StoneRecommendationNotFound

export type StoneRecommendationNotFound = {
    __typename: 'StoneRecommendationNotFound'
    haveWithoutPricingRange: Scalars['Boolean']['output']
}

export type StoneRecommendationsNaturalDiamondFilters = {
    __typename: 'StoneRecommendationsNaturalDiamondFilters'
    clarities: Array<StoneClarity>
    colors: Array<StoneColor>
    cuts: Array<StoneCut>
    depthPercentRange: Maybe<StoneRecommendationsPercentRange>
    fluorescences: Array<StoneFluorescence>
    maxCaratWeight: Scalars['Decimal']['output']
    minCaratWeight: Scalars['Decimal']['output']
    polishes: Array<StonePolish>
    priceMax: Money
    priceMin: Money
    region: Region
    shape: StoneShape
    symmetries: Array<StoneSymmetry>
    tablePercentRange: Maybe<StoneRecommendationsPercentRange>
}

export type StoneRecommendationsNaturalDiamondFiltersPriceMaxArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsNaturalDiamondFiltersPriceMinArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsNaturalFilters = {
    __typename: 'StoneRecommendationsNaturalFilters'
    clarities: Array<StoneClarity>
    colors: Array<StoneColor>
    crystals: Array<StoneCrystal>
    cuts: Array<StoneCut>
    depthPercentRange: Maybe<StoneRecommendationsPercentRange>
    fluorescences: Array<StoneFluorescence>
    maxCaratWeight: Scalars['Decimal']['output']
    minCaratWeight: Scalars['Decimal']['output']
    polishes: Array<StonePolish>
    priceMax: Money
    priceMin: Money
    region: Region
    shape: StoneShape
    symmetries: Array<StoneSymmetry>
    tablePercentRange: Maybe<StoneRecommendationsPercentRange>
}

export type StoneRecommendationsNaturalFiltersPriceMaxArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsNaturalFiltersPriceMinArgs = {
    currency: CurrencyInput
}

export type StoneRecommendationsPercentRange = {
    __typename: 'StoneRecommendationsPercentRange'
    max: Scalars['Int']['output']
    min: Scalars['Int']['output']
}

export type StoneRecommendationsPriceRange = {
    __typename: 'StoneRecommendationsPriceRange'
    max: Money
    min: Money
}

export type StoneRecommendationsResponse =
    | StoneRecommendationsResponseFailure
    | StoneRecommendationsResponseSuccess

export const StoneRecommendationsResponseError = {
    MountMissing: 'MOUNT_MISSING',
} as const

export type StoneRecommendationsResponseError =
    (typeof StoneRecommendationsResponseError)[keyof typeof StoneRecommendationsResponseError]
export type StoneRecommendationsResponseFailure = {
    __typename: 'StoneRecommendationsResponseFailure'
    error: Maybe<StoneRecommendationsResponseError>
}

export type StoneRecommendationsResponseSuccess = {
    __typename: 'StoneRecommendationsResponseSuccess'
    naturalDiamondBestForBalance: StoneRecommendationGemsApiStone
    naturalDiamondBestForBalanceFilters: StoneRecommendationsNaturalDiamondFilters
    naturalDiamondBestForSize: StoneRecommendationGemsApiStone
    naturalDiamondBestForSizeFilters: StoneRecommendationsNaturalDiamondFilters
    nonSkuGemStones: Array<StoneRecommendationNonSkuGemstone>
    nonSkuLabGrownBestForPrice: StoneRecommendationNonSkuLabGrownItem
    nonSkuLabGrownBestForSize: StoneRecommendationNonSkuLabGrownItem
    priceBounds: StoneRecommendationsPriceRange
    priceInitialValues: StoneRecommendationsPriceRange
    skuGemStoneFilters: StoneRecommendationsNaturalFilters
    skuGemStones: Array<StoneRecommendationGemsApiGemstone>
}

export type StoneRecommendationsResponseSuccessNonSkuGemStonesArgs = {
    colorCodes: InputMaybe<Array<StoneColorCode>>
}

export type StoneRecommendationsResponseSuccessSkuGemStoneFiltersArgs = {
    colorCodes: InputMaybe<Array<StoneColorCode>>
}

export type StoneRecommendationsResponseSuccessSkuGemStonesArgs = {
    colorCodes: InputMaybe<Array<StoneColorCode>>
}

export type StoneShape = {
    __typename: 'StoneShape'
    icon: Maybe<Asset>
    samplePhoto: Maybe<Asset>
    systemCode: StoneShapeCode
    translation: StoneShapeTranslation
}

export type StoneShapeTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneShapeCode = {
    Asscher: 'ASSCHER',
    BrilliantCutTrapezoid: 'BRILLIANT_CUT_TRAPEZOID',
    Bullet: 'BULLET',
    Cabochon: 'CABOCHON',
    Carre: 'CARRE',
    Circular: 'CIRCULAR',
    Cushion: 'CUSHION',
    Custom: 'CUSTOM',
    Emerald: 'EMERALD',
    European: 'EUROPEAN',
    HalfMoon: 'HALF_MOON',
    Heart: 'HEART',
    Hexagonal: 'HEXAGONAL',
    Kite: 'KITE',
    Marquise: 'MARQUISE',
    Octagonal: 'OCTAGONAL',
    OldMiners: 'OLD_MINERS',
    Oval: 'OVAL',
    Pear: 'PEAR',
    Princess: 'PRINCESS',
    Radiant: 'RADIANT',
    RectangularFrench: 'RECTANGULAR_FRENCH',
    Rose: 'ROSE',
    Round: 'ROUND',
    SquareFrench: 'SQUARE_FRENCH',
    StepCutTrapezoid: 'STEP_CUT_TRAPEZOID',
    StraightBaguette: 'STRAIGHT_BAGUETTE',
    TaperedBaguette: 'TAPERED_BAGUETTE',
    Trapezoid: 'TRAPEZOID',
    Triangular: 'TRIANGULAR',
    Trillion: 'TRILLION',
} as const

export type StoneShapeCode =
    (typeof StoneShapeCode)[keyof typeof StoneShapeCode]
export type StoneShapeFilterInput = {
    category?: InputMaybe<StoneCategoryCode>
}

export type StoneShapeTranslation = {
    __typename: 'StoneShapeTranslation'
    name: Scalars['String']['output']
}

export type StoneSymmetry = {
    __typename: 'StoneSymmetry'
    abbreviation: Scalars['String']['output']
    systemCode: StoneSymmetryCode
    translation: StoneSymmetryTranslation
}

export type StoneSymmetryTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const StoneSymmetryCode = {
    Excellent: 'EXCELLENT',
    Fair: 'FAIR',
    Good: 'GOOD',
    Ideal: 'IDEAL',
    VeryGood: 'VERY_GOOD',
} as const

export type StoneSymmetryCode =
    (typeof StoneSymmetryCode)[keyof typeof StoneSymmetryCode]
export type StoneSymmetryTranslation = {
    __typename: 'StoneSymmetryTranslation'
    name: Scalars['String']['output']
}

export type StripePaymentErrorResponse = {
    __typename: 'StripePaymentErrorResponse'
    message: Scalars['String']['output']
}

export type StripePaymentIntentErrorResponse = {
    __typename: 'StripePaymentIntentErrorResponse'
    message: Scalars['String']['output']
}

export type StripePaymentIntentResponse =
    | StripePaymentIntentErrorResponse
    | StripePaymentIntentSuccessResponse

export type StripePaymentIntentSuccessResponse = {
    __typename: 'StripePaymentIntentSuccessResponse'
    context: Maybe<Scalars['String']['output']>
    paymentIntentId: Scalars['String']['output']
    terminalReaderId: Scalars['String']['output']
}

export type StripePaymentResponse =
    | StripePaymentErrorResponse
    | StripePaymentSuccessResponse

export type StripePaymentSuccessResponse = {
    __typename: 'StripePaymentSuccessResponse'
    actionStatus: ReaderActionStatus
}

export type StripeTerminalReader = {
    __typename: 'StripeTerminalReader'
    id: Scalars['ID']['output']
    stripeId: Scalars['String']['output']
}

export type StripeTerminalReaderErrorResponse = {
    __typename: 'StripeTerminalReaderErrorResponse'
    message: Scalars['String']['output']
}

export type StripeTerminalReaderResponse =
    | StripeTerminalReaderErrorResponse
    | StripeTerminalReaderSuccessResponse

export type StripeTerminalReaderSuccessResponse = {
    __typename: 'StripeTerminalReaderSuccessResponse'
    context: Maybe<Scalars['String']['output']>
    reader: StripeTerminalReader
    status: Scalars['String']['output']
}

export type StripeTransaction = TransactionInterface & {
    __typename: 'StripeTransaction'
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type SubMenu = {
    __typename: 'SubMenu'
    description: Maybe<Scalars['String']['output']>
    editorialContent: Maybe<SubMenuEditorialContent>
    sections: Array<SubMenuSection>
    title: Maybe<Scalars['String']['output']>
    useLargeFormatItems: Scalars['Boolean']['output']
}

export type SubMenuEditorialContent = {
    __typename: 'SubMenuEditorialContent'
    image: Image
    link: Link
    text: Scalars['String']['output']
}

export type SubMenuItem = {
    __typename: 'SubMenuItem'
    icon: Maybe<Image>
    link: Link
    media: Maybe<Image>
    style: SubMenuItemStyle
    title: Scalars['String']['output']
}

export const SubMenuItemStyle = {
    Large: 'LARGE',
    Normal: 'NORMAL',
} as const

export type SubMenuItemStyle =
    (typeof SubMenuItemStyle)[keyof typeof SubMenuItemStyle]
export type SubMenuSection = {
    __typename: 'SubMenuSection'
    items: Array<SubMenuItem>
    title: Maybe<Scalars['String']['output']>
}

export const SurchargeableQuotationComponent = {
    Bracelet: 'BRACELET',
    Earrings: 'EARRINGS',
    EngagementRingGem: 'ENGAGEMENT_RING_GEM',
    EngagementRingMount: 'ENGAGEMENT_RING_MOUNT',
    Necklace: 'NECKLACE',
    Ring: 'RING',
    WeddingRing: 'WEDDING_RING',
} as const

export type SurchargeableQuotationComponent =
    (typeof SurchargeableQuotationComponent)[keyof typeof SurchargeableQuotationComponent]
export type Table = {
    __typename: 'Table'
    body: Maybe<TableBody>
    header: Maybe<TableHeader>
}

export type TableBody = {
    __typename: 'TableBody'
    rows: Maybe<Array<Maybe<TableRow>>>
}

export type TableHeader = {
    __typename: 'TableHeader'
    cells: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type TableRow = {
    __typename: 'TableRow'
    cells: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type Tax = {
    __typename: 'Tax'
    price: Money
    type: TaxType
}

export const TaxType = {
    Gst: 'GST',
    Sales: 'SALES',
    Vat: 'VAT',
} as const

export type TaxType = (typeof TaxType)[keyof typeof TaxType]
export type TextCarouselItem = {
    __typename: 'TextCarouselItem'
    text: Scalars['String']['output']
    title: Scalars['String']['output']
}

export const TextSize = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
} as const

export type TextSize = (typeof TextSize)[keyof typeof TextSize]
export const TitleSize = {
    ExtraLarge: 'EXTRA_LARGE',
    Large: 'LARGE',
    Medium: 'MEDIUM',
    Small: 'SMALL',
    Tiny: 'TINY',
} as const

export type TitleSize = (typeof TitleSize)[keyof typeof TitleSize]
export const TitleStyle = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
} as const

export type TitleStyle = (typeof TitleStyle)[keyof typeof TitleStyle]
export const TitleWidth = {
    Normal: 'NORMAL',
    Wide: 'WIDE',
} as const

export type TitleWidth = (typeof TitleWidth)[keyof typeof TitleWidth]
export type Tooltip = {
    __typename: 'Tooltip'
    content: Array<ContentComponentItem>
    title: Scalars['String']['output']
}

export type TopBar = {
    __typename: 'TopBar'
    consultationPrompt: Maybe<TopBarConsultationPrompt>
    siteWideMessage: Maybe<TopBarSiteWideMessage>
}

export type TopBarConsultationPrompt = {
    __typename: 'TopBarConsultationPrompt'
    link: Link
}

export type TopBarSiteWideMessage = {
    __typename: 'TopBarSiteWideMessage'
    link: Link
    message: Maybe<Scalars['String']['output']>
}

export type TransactionInterface = {
    amount: Money
    createdAt: Scalars['DateTime']['output']
    id: Scalars['ID']['output']
    status: TransactionStatus
}

export type TransactionStatus = {
    __typename: 'TransactionStatus'
    name: Scalars['String']['output']
    systemCode: TransactionStatusCode
}

export type TransactionStatusNameArgs = {
    locale: Scalars['Locale']['input']
}

export const TransactionStatusCode = {
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Declined: 'DECLINED',
    Expired: 'EXPIRED',
    Initialised: 'INITIALISED',
    Pending: 'PENDING',
    Voided: 'VOIDED',
} as const

export type TransactionStatusCode =
    (typeof TransactionStatusCode)[keyof typeof TransactionStatusCode]
export type Translation = {
    __typename: 'Translation'
    token: Scalars['ID']['output']
    translation: Scalars['String']['output']
}

export type User = {
    __typename: 'User'
    consultant: Maybe<Consultant>
    createdAt: Scalars['DateTime']['output']
    customer: Maybe<Customer>
    email: Scalars['Email']['output']
    firstName: Scalars['String']['output']
    id: Scalars['ID']['output']
    isConsultant: Scalars['Boolean']['output']
    lastName: Scalars['String']['output']
}

export type UserCustomerEngagementRingRecommendations = {
    __typename: 'UserCustomerEngagementRingRecommendations'
    designFeature: Maybe<EngagementRingDesignFeatureLabel>
    designStyle: Maybe<EngagementRingDesignStyleLabel>
    items: Array<CatalogueEngagementRing>
    metal: Maybe<Metal>
    ringStyle: Maybe<EngagementRingStyleLabel>
    shape: Maybe<StoneShape>
}

export type UserCustomerEngagementRingRecommendationsItemsArgs = {
    limit?: Scalars['Int']['input']
    page?: Scalars['Int']['input']
}

export type UtmInput = {
    campaign?: InputMaybe<Scalars['String']['input']>
    medium: Scalars['String']['input']
    source: Scalars['String']['input']
}

export const VerticalSpacing = {
    Large: 'LARGE',
    None: 'NONE',
    Normal: 'NORMAL',
} as const

export type VerticalSpacing =
    (typeof VerticalSpacing)[keyof typeof VerticalSpacing]
export type Video = Media & {
    __typename: 'Video'
    alt: Maybe<Scalars['String']['output']>
    caption: Maybe<Scalars['String']['output']>
    description: Maybe<Scalars['String']['output']>
    filename: Scalars['String']['output']
    filesize: Scalars['Int']['output']
    height: Scalars['Int']['output']
    id: Scalars['ID']['output']
    mimeType: Scalars['String']['output']
    name: Scalars['String']['output']
    title: Scalars['String']['output']
    url: Scalars['String']['output']
    width: Scalars['Int']['output']
}

export const VideoPosition = {
    Left: 'LEFT',
    Right: 'RIGHT',
} as const

export type VideoPosition = (typeof VideoPosition)[keyof typeof VideoPosition]
export const VideoWidth = {
    Content: 'CONTENT',
    ExtendedContent: 'EXTENDED_CONTENT',
    Full: 'FULL',
} as const

export type VideoWidth = (typeof VideoWidth)[keyof typeof VideoWidth]
export type WeddingRingCategoryLabel = {
    __typename: 'WeddingRingCategoryLabel'
    icon: Maybe<Asset>
    systemCode: WeddingRingCategoryLabelCode
    translation: ProductLabelTranslation
}

export type WeddingRingCategoryLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const WeddingRingCategoryLabelCode = {
    Ladies: 'LADIES',
    Mens: 'MENS',
} as const

export type WeddingRingCategoryLabelCode =
    (typeof WeddingRingCategoryLabelCode)[keyof typeof WeddingRingCategoryLabelCode]
export type WeddingRingStyleLabel = {
    __typename: 'WeddingRingStyleLabel'
    icon: Maybe<Asset>
    systemCode: WeddingRingStyleLabelCode
    translation: ProductLabelTranslation
}

export type WeddingRingStyleLabelTranslationArgs = {
    locale: Scalars['Locale']['input']
}

export const WeddingRingStyleLabelCode = {
    Baguette: 'BAGUETTE',
    BezelSet: 'BEZEL_SET',
    ChannelSet: 'CHANNEL_SET',
    Chevron: 'CHEVRON',
    Curved: 'CURVED',
    Diamond: 'DIAMOND',
    Pave: 'PAVE',
    Plain: 'PLAIN',
    Sapphire: 'SAPPHIRE',
    Twisted: 'TWISTED',
} as const

export type WeddingRingStyleLabelCode =
    (typeof WeddingRingStyleLabelCode)[keyof typeof WeddingRingStyleLabelCode]
export const WeekDay = {
    Friday: 'FRIDAY',
    Monday: 'MONDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY',
    Thursday: 'THURSDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
} as const

export type WeekDay = (typeof WeekDay)[keyof typeof WeekDay]
export const Width = {
    Full: 'FULL',
    Normal: 'NORMAL',
} as const

export type Width = (typeof Width)[keyof typeof Width]
export type WorkingHours = {
    __typename: 'WorkingHours'
    closing: Scalars['Time']['output']
    opening: Scalars['Time']['output']
    weekDays: Array<WeekDay>
}

export type BlockAnchorFragment = { __typename: 'BlockAnchor' } & Pick<
    BlockAnchor,
    'title' | 'slug'
>

export type BlockFragment = { __typename: 'Block' } & Pick<
    Block,
    | 'width'
    | 'backgroundColor'
    | 'backgroundOverflow'
    | 'verticalSpacing'
    | 'display'
    | 'isCollapsible'
    | 'collapsibleTitle'
    | 'isOpenByDefault'
> & {
        anchor: Maybe<{ __typename: 'BlockAnchor' } & BlockAnchorFragment>
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

type Component_ComponentArticleGrid_Fragment = {
    __typename: 'ComponentArticleGrid'
} & Components_ComponentArticleGrid_Fragment

type Component_ComponentArticlePreviews_Fragment = {
    __typename: 'ComponentArticlePreviews'
} & Components_ComponentArticlePreviews_Fragment

type Component_ComponentBannerSkinny_Fragment = {
    __typename: 'ComponentBannerSkinny'
} & Components_ComponentBannerSkinny_Fragment

type Component_ComponentBannerTitle_Fragment = {
    __typename: 'ComponentBannerTitle'
} & Components_ComponentBannerTitle_Fragment

type Component_ComponentCard_Fragment = {
    __typename: 'ComponentCard'
} & Components_ComponentCard_Fragment

type Component_ComponentCardCarousel_Fragment = {
    __typename: 'ComponentCardCarousel'
} & Components_ComponentCardCarousel_Fragment

type Component_ComponentCatalogueProductCarousel_Fragment = {
    __typename: 'ComponentCatalogueProductCarousel'
} & Components_ComponentCatalogueProductCarousel_Fragment

type Component_ComponentContent_Fragment = {
    __typename: 'ComponentContent'
} & Components_ComponentContent_Fragment

type Component_ComponentContentTwoColumns_Fragment = {
    __typename: 'ComponentContentTwoColumns'
} & Components_ComponentContentTwoColumns_Fragment

type Component_ComponentContentWithGallery_Fragment = {
    __typename: 'ComponentContentWithGallery'
} & Components_ComponentContentWithGallery_Fragment

type Component_ComponentCustomProductCarousel_Fragment = {
    __typename: 'ComponentCustomProductCarousel'
} & Components_ComponentCustomProductCarousel_Fragment

type Component_ComponentFaq_Fragment = {
    __typename: 'ComponentFaq'
} & Components_ComponentFaq_Fragment

type Component_ComponentFullWidthImage_Fragment = {
    __typename: 'ComponentFullWidthImage'
} & Components_ComponentFullWidthImage_Fragment

type Component_ComponentGalleryCarousel_Fragment = {
    __typename: 'ComponentGalleryCarousel'
} & Components_ComponentGalleryCarousel_Fragment

type Component_ComponentGalleryWithEnquiry_Fragment = {
    __typename: 'ComponentGalleryWithEnquiry'
} & Components_ComponentGalleryWithEnquiry_Fragment

type Component_ComponentGlobalComponent_Fragment = {
    __typename: 'ComponentGlobalComponent'
} & Components_ComponentGlobalComponent_Fragment &
    ComponentGlobalComponentFragment

type Component_ComponentGlobalSpacer_Fragment = {
    __typename: 'ComponentGlobalSpacer'
} & Components_ComponentGlobalSpacer_Fragment

type Component_ComponentIconCarousel_Fragment = {
    __typename: 'ComponentIconCarousel'
} & Components_ComponentIconCarousel_Fragment

type Component_ComponentInstagramPosts_Fragment = {
    __typename: 'ComponentInstagramPosts'
} & Components_ComponentInstagramPosts_Fragment

type Component_ComponentInstagramWithContent_Fragment = {
    __typename: 'ComponentInstagramWithContent'
} & Components_ComponentInstagramWithContent_Fragment

type Component_ComponentJobs_Fragment = {
    __typename: 'ComponentJobs'
} & Components_ComponentJobs_Fragment

type Component_ComponentLogos_Fragment = {
    __typename: 'ComponentLogos'
} & Components_ComponentLogos_Fragment

type Component_ComponentLogosCarousel_Fragment = {
    __typename: 'ComponentLogosCarousel'
} & Components_ComponentLogosCarousel_Fragment

type Component_ComponentLogosWithText_Fragment = {
    __typename: 'ComponentLogosWithText'
} & Components_ComponentLogosWithText_Fragment

type Component_ComponentMainCover_Fragment = {
    __typename: 'ComponentMainCover'
} & Components_ComponentMainCover_Fragment

type Component_ComponentOnThisPage_Fragment = {
    __typename: 'ComponentOnThisPage'
} & Components_ComponentOnThisPage_Fragment

type Component_ComponentQuote_Fragment = {
    __typename: 'ComponentQuote'
} & Components_ComponentQuote_Fragment

type Component_ComponentRelatedProducts_Fragment = {
    __typename: 'ComponentRelatedProducts'
} & Components_ComponentRelatedProducts_Fragment

type Component_ComponentReviewCarousel_Fragment = {
    __typename: 'ComponentReviewCarousel'
} & Components_ComponentReviewCarousel_Fragment

type Component_ComponentRoundedImage_Fragment = {
    __typename: 'ComponentRoundedImage'
} & Components_ComponentRoundedImage_Fragment

type Component_ComponentRoundedImageContent_Fragment = {
    __typename: 'ComponentRoundedImageContent'
} & Components_ComponentRoundedImageContent_Fragment

type Component_ComponentShopWithConfidence_Fragment = {
    __typename: 'ComponentShopWithConfidence'
} & Components_ComponentShopWithConfidence_Fragment

type Component_ComponentSideBySideImages_Fragment = {
    __typename: 'ComponentSideBySideImages'
} & Components_ComponentSideBySideImages_Fragment

type Component_ComponentSquareBoxes_Fragment = {
    __typename: 'ComponentSquareBoxes'
} & Components_ComponentSquareBoxes_Fragment

type Component_ComponentTable_Fragment = {
    __typename: 'ComponentTable'
} & Components_ComponentTable_Fragment

type Component_ComponentTextCarousel_Fragment = {
    __typename: 'ComponentTextCarousel'
} & Components_ComponentTextCarousel_Fragment

type Component_ComponentTextOverImage_Fragment = {
    __typename: 'ComponentTextOverImage'
} & Components_ComponentTextOverImage_Fragment

type Component_ComponentTextWithImage_Fragment = {
    __typename: 'ComponentTextWithImage'
} & Components_ComponentTextWithImage_Fragment

type Component_ComponentTextWithImageCarousel_Fragment = {
    __typename: 'ComponentTextWithImageCarousel'
} & Components_ComponentTextWithImageCarousel_Fragment

type Component_ComponentVideo_Fragment = {
    __typename: 'ComponentVideo'
} & Components_ComponentVideo_Fragment

type Component_ComponentVideoWithContent_Fragment = {
    __typename: 'ComponentVideoWithContent'
} & Components_ComponentVideoWithContent_Fragment

type Component_ComponentWarrantyActivationForm_Fragment = {
    __typename: 'ComponentWarrantyActivationForm'
} & Components_ComponentWarrantyActivationForm_Fragment

export type ComponentFragment =
    | Component_ComponentArticleGrid_Fragment
    | Component_ComponentArticlePreviews_Fragment
    | Component_ComponentBannerSkinny_Fragment
    | Component_ComponentBannerTitle_Fragment
    | Component_ComponentCard_Fragment
    | Component_ComponentCardCarousel_Fragment
    | Component_ComponentCatalogueProductCarousel_Fragment
    | Component_ComponentContent_Fragment
    | Component_ComponentContentTwoColumns_Fragment
    | Component_ComponentContentWithGallery_Fragment
    | Component_ComponentCustomProductCarousel_Fragment
    | Component_ComponentFaq_Fragment
    | Component_ComponentFullWidthImage_Fragment
    | Component_ComponentGalleryCarousel_Fragment
    | Component_ComponentGalleryWithEnquiry_Fragment
    | Component_ComponentGlobalComponent_Fragment
    | Component_ComponentGlobalSpacer_Fragment
    | Component_ComponentIconCarousel_Fragment
    | Component_ComponentInstagramPosts_Fragment
    | Component_ComponentInstagramWithContent_Fragment
    | Component_ComponentJobs_Fragment
    | Component_ComponentLogos_Fragment
    | Component_ComponentLogosCarousel_Fragment
    | Component_ComponentLogosWithText_Fragment
    | Component_ComponentMainCover_Fragment
    | Component_ComponentOnThisPage_Fragment
    | Component_ComponentQuote_Fragment
    | Component_ComponentRelatedProducts_Fragment
    | Component_ComponentReviewCarousel_Fragment
    | Component_ComponentRoundedImage_Fragment
    | Component_ComponentRoundedImageContent_Fragment
    | Component_ComponentShopWithConfidence_Fragment
    | Component_ComponentSideBySideImages_Fragment
    | Component_ComponentSquareBoxes_Fragment
    | Component_ComponentTable_Fragment
    | Component_ComponentTextCarousel_Fragment
    | Component_ComponentTextOverImage_Fragment
    | Component_ComponentTextWithImage_Fragment
    | Component_ComponentTextWithImageCarousel_Fragment
    | Component_ComponentVideo_Fragment
    | Component_ComponentVideoWithContent_Fragment
    | Component_ComponentWarrantyActivationForm_Fragment

export type WorkingHoursFragment = { __typename: 'WorkingHours' } & Pick<
    WorkingHours,
    'weekDays' | 'opening' | 'closing'
>

type Components_ComponentArticleGrid_Fragment = {
    __typename: 'ComponentArticleGrid'
} & ComponentArticleGridFragment

type Components_ComponentArticlePreviews_Fragment = {
    __typename: 'ComponentArticlePreviews'
} & ComponentArticlePreviewsFragment

type Components_ComponentBannerSkinny_Fragment = {
    __typename: 'ComponentBannerSkinny'
} & ComponentBannerSkinnyFragment

type Components_ComponentBannerTitle_Fragment = {
    __typename: 'ComponentBannerTitle'
} & ComponentBannerTitleFragment

type Components_ComponentCard_Fragment = {
    __typename: 'ComponentCard'
} & ComponentCardFragment

type Components_ComponentCardCarousel_Fragment = {
    __typename: 'ComponentCardCarousel'
} & ComponentCardCarouselFragment

type Components_ComponentCatalogueProductCarousel_Fragment = {
    __typename: 'ComponentCatalogueProductCarousel'
} & ComponentCatalogueProductCarouselFragment

type Components_ComponentContent_Fragment = {
    __typename: 'ComponentContent'
} & ComponentContentFragment

type Components_ComponentContentTwoColumns_Fragment = {
    __typename: 'ComponentContentTwoColumns'
} & ComponentContentTwoColumnsFragment

type Components_ComponentContentWithGallery_Fragment = {
    __typename: 'ComponentContentWithGallery'
} & ComponentContentWithGalleryFragment

type Components_ComponentCustomProductCarousel_Fragment = {
    __typename: 'ComponentCustomProductCarousel'
} & ComponentCustomProductCarouselFragment

type Components_ComponentFaq_Fragment = {
    __typename: 'ComponentFaq'
} & ComponentFaqFragment

type Components_ComponentFullWidthImage_Fragment = {
    __typename: 'ComponentFullWidthImage'
} & ComponentFullWidthImageFragment

type Components_ComponentGalleryCarousel_Fragment = {
    __typename: 'ComponentGalleryCarousel'
} & ComponentGalleryCarouselFragment

type Components_ComponentGalleryWithEnquiry_Fragment = {
    __typename: 'ComponentGalleryWithEnquiry'
} & ComponentGalleryWithEnquiryFragment

type Components_ComponentGlobalComponent_Fragment = {
    __typename: 'ComponentGlobalComponent'
}

type Components_ComponentGlobalSpacer_Fragment = {
    __typename: 'ComponentGlobalSpacer'
} & ComponentGlobalSpacerFragment

type Components_ComponentIconCarousel_Fragment = {
    __typename: 'ComponentIconCarousel'
} & ComponentIconCarouselFragment

type Components_ComponentInstagramPosts_Fragment = {
    __typename: 'ComponentInstagramPosts'
} & ComponentInstagramPostsFragment

type Components_ComponentInstagramWithContent_Fragment = {
    __typename: 'ComponentInstagramWithContent'
} & ComponentInstagramWithContentFragment

type Components_ComponentJobs_Fragment = {
    __typename: 'ComponentJobs'
} & ComponentJobsFragment

type Components_ComponentLogos_Fragment = {
    __typename: 'ComponentLogos'
} & ComponentLogosFragment

type Components_ComponentLogosCarousel_Fragment = {
    __typename: 'ComponentLogosCarousel'
} & ComponentLogosCarouselFragment

type Components_ComponentLogosWithText_Fragment = {
    __typename: 'ComponentLogosWithText'
} & ComponentLogosWithTextFragment

type Components_ComponentMainCover_Fragment = {
    __typename: 'ComponentMainCover'
} & ComponentMainCoverFragment

type Components_ComponentOnThisPage_Fragment = {
    __typename: 'ComponentOnThisPage'
} & ComponentOnThisPageFragment

type Components_ComponentQuote_Fragment = {
    __typename: 'ComponentQuote'
} & ComponentQuoteFragment

type Components_ComponentRelatedProducts_Fragment = {
    __typename: 'ComponentRelatedProducts'
}

type Components_ComponentReviewCarousel_Fragment = {
    __typename: 'ComponentReviewCarousel'
} & ComponentReviewCarouselFragment

type Components_ComponentRoundedImage_Fragment = {
    __typename: 'ComponentRoundedImage'
} & ComponentRoundedImageFragment &
    ComponentRoundedImageFragment

type Components_ComponentRoundedImageContent_Fragment = {
    __typename: 'ComponentRoundedImageContent'
} & ComponentRoundedImageContentFragment

type Components_ComponentShopWithConfidence_Fragment = {
    __typename: 'ComponentShopWithConfidence'
} & ComponentShopWithConfidenceFragment

type Components_ComponentSideBySideImages_Fragment = {
    __typename: 'ComponentSideBySideImages'
} & ComponentSideBySideImagesFragment

type Components_ComponentSquareBoxes_Fragment = {
    __typename: 'ComponentSquareBoxes'
} & ComponentSquareBoxesFragment

type Components_ComponentTable_Fragment = {
    __typename: 'ComponentTable'
} & ComponentTableFragment

type Components_ComponentTextCarousel_Fragment = {
    __typename: 'ComponentTextCarousel'
} & ComponentTextCarouselFragment

type Components_ComponentTextOverImage_Fragment = {
    __typename: 'ComponentTextOverImage'
} & ComponentTextOverImageFragment

type Components_ComponentTextWithImage_Fragment = {
    __typename: 'ComponentTextWithImage'
} & ComponentTextWithImageFragment

type Components_ComponentTextWithImageCarousel_Fragment = {
    __typename: 'ComponentTextWithImageCarousel'
} & ComponentTextWithImageCarouselFragment

type Components_ComponentVideo_Fragment = {
    __typename: 'ComponentVideo'
} & ComponentVideoFragment

type Components_ComponentVideoWithContent_Fragment = {
    __typename: 'ComponentVideoWithContent'
} & ComponentVideoWithContentFragment

type Components_ComponentWarrantyActivationForm_Fragment = {
    __typename: 'ComponentWarrantyActivationForm'
} & ComponentWarrantyActivationFormFragment

export type ComponentsFragment =
    | Components_ComponentArticleGrid_Fragment
    | Components_ComponentArticlePreviews_Fragment
    | Components_ComponentBannerSkinny_Fragment
    | Components_ComponentBannerTitle_Fragment
    | Components_ComponentCard_Fragment
    | Components_ComponentCardCarousel_Fragment
    | Components_ComponentCatalogueProductCarousel_Fragment
    | Components_ComponentContent_Fragment
    | Components_ComponentContentTwoColumns_Fragment
    | Components_ComponentContentWithGallery_Fragment
    | Components_ComponentCustomProductCarousel_Fragment
    | Components_ComponentFaq_Fragment
    | Components_ComponentFullWidthImage_Fragment
    | Components_ComponentGalleryCarousel_Fragment
    | Components_ComponentGalleryWithEnquiry_Fragment
    | Components_ComponentGlobalComponent_Fragment
    | Components_ComponentGlobalSpacer_Fragment
    | Components_ComponentIconCarousel_Fragment
    | Components_ComponentInstagramPosts_Fragment
    | Components_ComponentInstagramWithContent_Fragment
    | Components_ComponentJobs_Fragment
    | Components_ComponentLogos_Fragment
    | Components_ComponentLogosCarousel_Fragment
    | Components_ComponentLogosWithText_Fragment
    | Components_ComponentMainCover_Fragment
    | Components_ComponentOnThisPage_Fragment
    | Components_ComponentQuote_Fragment
    | Components_ComponentRelatedProducts_Fragment
    | Components_ComponentReviewCarousel_Fragment
    | Components_ComponentRoundedImage_Fragment
    | Components_ComponentRoundedImageContent_Fragment
    | Components_ComponentShopWithConfidence_Fragment
    | Components_ComponentSideBySideImages_Fragment
    | Components_ComponentSquareBoxes_Fragment
    | Components_ComponentTable_Fragment
    | Components_ComponentTextCarousel_Fragment
    | Components_ComponentTextOverImage_Fragment
    | Components_ComponentTextWithImage_Fragment
    | Components_ComponentTextWithImageCarousel_Fragment
    | Components_ComponentVideo_Fragment
    | Components_ComponentVideoWithContent_Fragment
    | Components_ComponentWarrantyActivationForm_Fragment

export type ComponentCardFragment = { __typename: 'ComponentCard' } & Pick<
    ComponentCard,
    'backgroundColor'
> & {
        cardImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentArticleGridFragment = {
    __typename: 'ComponentArticleGrid'
} & {
    articles: Array<{ __typename: 'ArticleGridItem' } & ArticleGridItemFragment>
}

export type ComponentArticlePreviewsFragment = {
    __typename: 'ComponentArticlePreviews'
} & {
    articles: Array<{ __typename: 'ArticlePreview' } & ArticlePreviewFragment>
}

export type ComponentBannerSkinnyFragment = {
    __typename: 'ComponentBannerSkinny'
} & Pick<
    ComponentBannerSkinny,
    'useBackgroundImage' | 'backgroundColor' | 'backgroundGraphic'
> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageCoverFragment>
        title: { __typename: 'ComponentTitle' } & ComponentTitleFragment
    }

export type ComponentBannerTitleFragment = {
    __typename: 'ComponentBannerTitle'
} & Pick<ComponentBannerTitle, 'date' | 'description' | 'tag'> & {
        bannerTitle: ComponentBannerTitle['title']
    } & { image: { __typename: 'Image' } & ImageLargeFragment }

export type ComponentCatalogueProductCarouselFragment = {
    __typename: 'ComponentCatalogueProductCarousel'
} & {
    items: Array<
        { __typename: 'ComponentCatalogueProductCarouselItem' } & Pick<
            ComponentCatalogueProductCarouselItem,
            'catalogueCode'
        > & {
                product: Maybe<
                    | ({ __typename: 'CatalogueEngagementRing' } & {
                          variationsByPrimaryMetal: Array<
                              {
                                  __typename: 'CatalogueEngagementRing'
                              } & ProductCard_CatalogueEngagementRing_Fragment
                          >
                      } & ProductCard_CatalogueEngagementRing_Fragment)
                    | ({ __typename: 'CatalogueJewelleryBracelet' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryBracelet'
                              } & ProductCard_CatalogueJewelleryBracelet_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryBracelet_Fragment)
                    | ({ __typename: 'CatalogueJewelleryEarrings' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryEarrings'
                              } & ProductCard_CatalogueJewelleryEarrings_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryEarrings_Fragment)
                    | ({ __typename: 'CatalogueJewelleryNecklace' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryNecklace'
                              } & ProductCard_CatalogueJewelleryNecklace_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryNecklace_Fragment)
                    | ({ __typename: 'CatalogueJewelleryRing' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueJewelleryRing'
                              } & ProductCard_CatalogueJewelleryRing_Fragment
                          >
                      } & ProductCard_CatalogueJewelleryRing_Fragment)
                    | ({
                          __typename: 'CatalogueReadyToGoRing'
                      } & ProductCard_CatalogueReadyToGoRing_Fragment)
                    | ({ __typename: 'CatalogueWeddingRing' } & {
                          variations: Array<
                              {
                                  __typename: 'CatalogueWeddingRing'
                              } & ProductCard_CatalogueWeddingRing_Fragment
                          >
                      } & ProductCard_CatalogueWeddingRing_Fragment)
                >
            }
    >
}

export type ComponentContentFragment = { __typename: 'ComponentContent' } & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
}

export type ComponentContentTwoColumnsFragment = {
    __typename: 'ComponentContentTwoColumns'
} & Pick<
    ComponentContentTwoColumns,
    'leftColumnBackgroundColor' | 'rightColumnBackgroundColor'
> & {
        leftColumnContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        rightColumnContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentContentWithGalleryFragment = {
    __typename: 'ComponentContentWithGallery'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    gallery: Array<
        { __typename: 'GalleryItem' } & {
            image: { __typename: 'Image' } & ImageLargeFragment
        }
    >
}

export type ComponentCustomProductCarouselFragment = {
    __typename: 'ComponentCustomProductCarousel'
} & {
    products: Array<
        {
            __typename: 'CarouselCustomProduct'
        } & CustomProductCarouselCardFragment
    >
}

export type ComponentFaqFragment = { __typename: 'ComponentFaq' } & Pick<
    ComponentFaq,
    'showNavigation'
> & { sections: Array<{ __typename: 'FaqSection' } & FaqSectionFragment> }

export type ComponentFullWidthImageFragment = {
    __typename: 'ComponentFullWidthImage'
} & Pick<ComponentFullWidthImage, 'width'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ComponentGalleryCarouselFragment = {
    __typename: 'ComponentGalleryCarousel'
} & {
    items: Array<
        { __typename: 'GalleryCarouselCard' } & GalleryCarouselCardFragment
    >
}

export type ComponentGlobalComponentFragment = {
    __typename: 'ComponentGlobalComponent'
} & Pick<ComponentGlobalComponent, 'backgroundColor'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Components_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Components_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Components_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Components_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Components_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Components_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Components_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Components_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Components_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Components_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Components_ComponentCustomProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentFaq'
              } & Components_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Components_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Components_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Components_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Components_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Components_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Components_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Components_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Components_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Components_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Components_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Components_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Components_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Components_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Components_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Components_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Components_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Components_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Components_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Components_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Components_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Components_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Components_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Components_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Components_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Components_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Components_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Components_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Components_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Components_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Components_ComponentWarrantyActivationForm_Fragment)
        >
    }

export type ComponentGlobalSpacerFragment = {
    __typename: 'ComponentGlobalSpacer'
} & Pick<ComponentGlobalSpacer, 'spacing'>

export type ComponentIconCarouselFragment = {
    __typename: 'ComponentIconCarousel'
} & {
    items: Array<
        { __typename: 'IconCarouselItem' } & Pick<
            IconCarouselItem,
            'icon' | 'text'
        > & { itemLink: Maybe<{ __typename: 'Link' } & LinkFragment> }
    >
}

export type ComponentInstagramPostsFragment = {
    __typename: 'ComponentInstagramPosts'
} & Pick<
    ComponentInstagramPosts,
    'preTitle' | 'instagramUser' | 'instagramUserLink'
> & {
        title: { __typename: 'ComponentTitle' } & ComponentTitleFragment
        posts: Array<
            { __typename: 'InstagramPost' } & Pick<InstagramPost, 'link'> & {
                    image: { __typename: 'Image' } & ImageLargeFragment
                }
        >
    }

export type ComponentInstagramWithContentFragment = {
    __typename: 'ComponentInstagramWithContent'
} & Pick<
    ComponentInstagramWithContent,
    | 'useImage'
    | 'instagramEmbedCode'
    | 'instagramUsername'
    | 'instagramLink'
    | 'instagramPosition'
> & { instagramWithContentWidth: ComponentInstagramWithContent['width'] } & {
        instagramImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        optionalContent: Maybe<
            Array<
                | ({
                      __typename: 'ComponentButton'
                  } & ContentComponentItem_ComponentButton_Fragment)
                | ({
                      __typename: 'ComponentImage'
                  } & ContentComponentItem_ComponentImage_Fragment)
                | ({
                      __typename: 'ComponentOrderedList'
                  } & ContentComponentItem_ComponentOrderedList_Fragment)
                | ({
                      __typename: 'ComponentSpacer'
                  } & ContentComponentItem_ComponentSpacer_Fragment)
                | ({
                      __typename: 'ComponentText'
                  } & ContentComponentItem_ComponentText_Fragment)
                | ({
                      __typename: 'ComponentTitle'
                  } & ContentComponentItem_ComponentTitle_Fragment)
            >
        >
    }

export type ComponentJobsFragment = { __typename: 'ComponentJobs' } & {
    jobs: Array<{ __typename: 'Job' } & ComponentJobsJobFragment>
}

export type ComponentJobsJobFragment = { __typename: 'Job' } & Pick<
    Job,
    | 'expandedByDefault'
    | 'title'
    | 'startDate'
    | 'closingDate'
    | 'postedDate'
    | 'location'
    | 'contractType'
    | 'salary'
    | 'vacancyReference'
    | 'applicationRecipientEmail'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentLogosFragment = { __typename: 'ComponentLogos' } & {
    logos: Array<
        { __typename: 'Logo' } & Pick<Logo, 'link'> & {
                image: { __typename: 'Image' } & ImageLargeFragment
            }
    >
}

export type ComponentLogosCarouselFragment = {
    __typename: 'ComponentLogosCarousel'
} & {
    logos: Array<
        { __typename: 'Logo' } & Pick<Logo, 'link'> & {
                image: { __typename: 'Image' } & ImageLargeFragment
            }
    >
}

export type ComponentLogosWithTextFragment = {
    __typename: 'ComponentLogosWithText'
} & { logos: Array<{ __typename: 'LogoWithText' } & LogoWithTextFragment> }

export type LogoWithTextFragment = { __typename: 'LogoWithText' } & Pick<
    LogoWithText,
    'title' | 'description'
> & {
        image: { __typename: 'Image' } & ImageMediumFragment
        logoLink: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ComponentMainCoverFragment = {
    __typename: 'ComponentMainCover'
} & Pick<ComponentMainCover, 'height' | 'overlay'> & {
        contentWidth: ComponentMainCover['width']
    } & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        background:
            | ({ __typename: 'ComponentMainCoverBackgroundImage' } & {
                  backgroundImage: { __typename: 'Image' } & ImageCoverFragment
                  mobileBackgroundImage: {
                      __typename: 'Image'
                  } & ImageLargeFragment
              })
            | ({ __typename: 'ComponentMainCoverBackgroundVideo' } & {
                  video: { __typename: 'Video' } & VideoFragment
                  cover: { __typename: 'Image' } & ImageCoverFragment
                  mobileCover: { __typename: 'Image' } & ImageLargeFragment
              })
    }

export type ComponentOnThisPageFragment = { __typename: 'ComponentOnThisPage' }

export type ComponentQuoteFragment = { __typename: 'ComponentQuote' } & Pick<
    ComponentQuote,
    'hasBackgroundImage' | 'quote' | 'author' | 'size' | 'showQuotationMarks'
> & { quoteImage: Maybe<{ __typename: 'Image' } & ImageLargeFragment> }

export type ComponentReviewCarouselFragment = {
    __typename: 'ComponentReviewCarousel'
} & {
    reviews: Array<
        { __typename: 'ReviewCarouselCard' } & Pick<
            ReviewCarouselCard,
            'author' | 'date' | 'review' | 'starsCount'
        >
    >
}

export type ComponentRoundedImageFragment = {
    __typename: 'ComponentRoundedImage'
} & Pick<ComponentRoundedImage, 'backgroundColor' | 'backgroundImageColor'> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
        roundedImage: { __typename: 'Image' } & ImageMediumFragment
    }

export type ComponentRoundedImageContentFragment = {
    __typename: 'ComponentRoundedImageContent'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    roundedImage: {
        __typename: 'ComponentRoundedImage'
    } & ComponentRoundedImageFragment
}

export type ComponentShopWithConfidenceFragment = {
    __typename: 'ComponentShopWithConfidence'
} & {
    shopWithConfidenceTitle: Maybe<
        { __typename: 'ComponentTitle' } & ComponentTitleFragment
    >
    components: Array<
        | ({ __typename: 'ShopWithConfidenceEthnicallySourcedDiamonds' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceFinancingOptions' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceGreenlandRuby' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceHandFinished' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceResize' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceReturnPolicy' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
        | ({ __typename: 'ShopWithConfidenceShipping' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentComponentItem_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentComponentItem_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentComponentItem_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentComponentItem_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentComponentItem_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentComponentItem_ComponentTitle_Fragment)
              >
          })
    >
}

type ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

type ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'isResizeable' | 'isReturnable'> & {
        signatureStone: Maybe<{ __typename: 'Melee' }>
    }

export type ShopWithConfidenceProductFragment =
    | ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment
    | ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment
    | ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment
    | ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment

export type ComponentSideBySideImagesFragment = {
    __typename: 'ComponentSideBySideImages'
} & {
    images: Array<
        {
            __typename: 'ComponentSideBySideImage'
        } & ComponentSideBySideImageFragment
    >
}

export type ComponentTableFragment = { __typename: 'ComponentTable' } & {
    table: Maybe<
        { __typename: 'Table' } & {
            header: Maybe<
                { __typename: 'TableHeader' } & Pick<TableHeader, 'cells'>
            >
            body: Maybe<
                { __typename: 'TableBody' } & {
                    rows: Maybe<
                        Array<
                            Maybe<
                                { __typename: 'TableRow' } & Pick<
                                    TableRow,
                                    'cells'
                                >
                            >
                        >
                    >
                }
            >
        }
    >
}

export type ComponentTextCarouselFragment = {
    __typename: 'ComponentTextCarousel'
} & {
    items: Array<
        { __typename: 'TextCarouselItem' } & Pick<TextCarouselItem, 'title'> & {
                carouselItemText: TextCarouselItem['text']
            }
    >
}

export type ComponentTextOverImageFragment = {
    __typename: 'ComponentTextOverImage'
} & {
    content: Array<
        | ({
              __typename: 'ComponentButton'
          } & ContentComponentItem_ComponentButton_Fragment)
        | ({
              __typename: 'ComponentImage'
          } & ContentComponentItem_ComponentImage_Fragment)
        | ({
              __typename: 'ComponentOrderedList'
          } & ContentComponentItem_ComponentOrderedList_Fragment)
        | ({
              __typename: 'ComponentSpacer'
          } & ContentComponentItem_ComponentSpacer_Fragment)
        | ({
              __typename: 'ComponentText'
          } & ContentComponentItem_ComponentText_Fragment)
        | ({
              __typename: 'ComponentTitle'
          } & ContentComponentItem_ComponentTitle_Fragment)
    >
    image: { __typename: 'Image' } & ImageLargeFragment
}

export type ComponentTextWithImageFragment = {
    __typename: 'ComponentTextWithImage'
} & Pick<
    ComponentTextWithImage,
    'padding' | 'imageFormat' | 'imagePosition'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type ComponentTextWithImageCarouselFragment = {
    __typename: 'ComponentTextWithImageCarousel'
} & Pick<ComponentTextWithImageCarousel, 'slidePadding'> & {
        slides: Array<
            {
                __typename: 'ComponentTextWithImage'
            } & ComponentTextWithImageFragment
        >
    }

export type ComponentVideoFragment = { __typename: 'ComponentVideo' } & {
    videoWidth: ComponentVideo['width']
} & { video: { __typename: 'Video' } & VideoFragment }

export type ComponentVideoWithContentFragment = {
    __typename: 'ComponentVideoWithContent'
} & Pick<ComponentVideoWithContent, 'videoPosition'> & {
        coverImage: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        video: { __typename: 'Video' } & VideoFragment
    }

export type WarrantyActivationQueryVariables = Exact<{
    id: Scalars['ID']['input']
}>

export type WarrantyActivationQuery = { __typename: 'Query' } & Pick<
    Query,
    'warrantyActivated'
>

export type ActivateWarrantyMutationVariables = Exact<{
    input: ActivateWarrantyInput
}>

export type ActivateWarrantyMutation = { __typename: 'Mutation' } & Pick<
    Mutation,
    'activateWarranty'
>

export type ComponentWarrantyActivationFormFragment = {
    __typename: 'ComponentWarrantyActivationForm'
}

type ContentComponentItem_ComponentButton_Fragment = {
    __typename: 'ComponentButton'
} & ComponentButtonFragment

type ContentComponentItem_ComponentImage_Fragment = {
    __typename: 'ComponentImage'
} & ComponentImageFragment

type ContentComponentItem_ComponentOrderedList_Fragment = {
    __typename: 'ComponentOrderedList'
} & ComponentOrderedListFragment

type ContentComponentItem_ComponentSpacer_Fragment = {
    __typename: 'ComponentSpacer'
} & ComponentSpacerFragment

type ContentComponentItem_ComponentText_Fragment = {
    __typename: 'ComponentText'
} & ComponentTextFragment

type ContentComponentItem_ComponentTitle_Fragment = {
    __typename: 'ComponentTitle'
} & ComponentTitleFragment

export type ContentComponentItemFragment =
    | ContentComponentItem_ComponentButton_Fragment
    | ContentComponentItem_ComponentImage_Fragment
    | ContentComponentItem_ComponentOrderedList_Fragment
    | ContentComponentItem_ComponentSpacer_Fragment
    | ContentComponentItem_ComponentText_Fragment
    | ContentComponentItem_ComponentTitle_Fragment

export type ArticleGridItemFragment = { __typename: 'ArticleGridItem' } & Pick<
    ArticleGridItem,
    'title' | 'description'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        itemLink: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ArticlePreviewFragment = { __typename: 'ArticlePreview' } & Pick<
    ArticlePreview,
    'title' | 'subtitle'
> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: { __typename: 'Link' } & LinkFragment
    }

export type BlogMenuFragment = { __typename: 'PostCategory' } & Pick<
    PostCategory,
    'id' | 'name' | 'slug'
> & {
        children: Maybe<
            Array<
                { __typename: 'PostCategory' } & Pick<
                    PostCategory,
                    'id' | 'name' | 'slug'
                >
            >
        >
    }

export type BlogPostPreviewFragment = { __typename: 'Post' } & Pick<
    Post,
    'id' | 'title' | 'slug' | 'excerpt' | 'date'
> & { featuredImage: { __typename: 'Image' } & ImageLargeFragment }

export type CardCarouselCardFragment = {
    __typename: 'CardCarouselCard'
} & Pick<CardCarouselCard, 'backgroundColor' | 'title' | 'description'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type ComponentCardCarouselFragment = {
    __typename: 'ComponentCardCarousel'
} & {
    items: Array<{ __typename: 'CardCarouselCard' } & CardCarouselCardFragment>
}

export type CustomProductCarouselCardFragment = {
    __typename: 'CarouselCustomProduct'
} & Pick<CarouselCustomProduct, 'description' | 'title'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type GalleryCarouselCardFragment = {
    __typename: 'GalleryCarouselCard'
} & {
    image: { __typename: 'Image' } & ImageLargeFragment
    link: Maybe<{ __typename: 'Link' } & LinkFragment>
}

export type ComponentButtonFragment = { __typename: 'ComponentButton' } & Pick<
    ComponentButton,
    'text' | 'alignment'
> & {
        link: { __typename: 'Link' } & LinkFragment
        style: { __typename: 'ButtonStyle' } & Pick<
            ButtonStyle,
            | 'type'
            | 'size'
            | 'color'
            | 'width'
            | 'linkSize'
            | 'topSpacing'
            | 'bottomSpacing'
        >
        icon: Maybe<
            { __typename: 'ButtonIcon' } & Pick<ButtonIcon, 'position' | 'icon'>
        >
    }

export type ComponentImageFragment = { __typename: 'ComponentImage' } & {
    image: { __typename: 'Image' } & ImageLargeFragment
}

export type ComponentOrderedListFragment = {
    __typename: 'ComponentOrderedList'
} & {
    items: Array<{ __typename: 'OrderedListItem' } & OrderedListItemFragment>
}

export type ComponentSpacerFragment = { __typename: 'ComponentSpacer' } & Pick<
    ComponentSpacer,
    'spacing'
>

export type ComponentTextFragment = { __typename: 'ComponentText' } & Pick<
    ComponentText,
    'alignment' | 'text' | 'textSize'
>

export type ComponentTitleFragment = { __typename: 'ComponentTitle' } & Pick<
    ComponentTitle,
    | 'alignment'
    | 'tag'
    | 'text'
    | 'color'
    | 'titleSize'
    | 'titleStyle'
    | 'titleWidth'
> & {
        texts: Array<
            | ({
                  __typename: 'ComponentTitleAmpersand'
              } & ComponentTitleComponent_ComponentTitleAmpersand_Fragment)
            | ({
                  __typename: 'ComponentTitleText'
              } & ComponentTitleComponent_ComponentTitleText_Fragment)
        >
    }

export type ComponentTitleAmpersandFragment = {
    __typename: 'ComponentTitleAmpersand'
} & Pick<ComponentTitleAmpersand, 'null'>

type ComponentTitleComponent_ComponentTitleAmpersand_Fragment = {
    __typename: 'ComponentTitleAmpersand'
} & ComponentTitleAmpersandFragment

type ComponentTitleComponent_ComponentTitleText_Fragment = {
    __typename: 'ComponentTitleText'
} & ComponentTitleTextFragment

export type ComponentTitleComponentFragment =
    | ComponentTitleComponent_ComponentTitleAmpersand_Fragment
    | ComponentTitleComponent_ComponentTitleText_Fragment

export type ComponentTitleTextFragment = {
    __typename: 'ComponentTitleText'
} & Pick<ComponentTitleText, 'text'>

export type OrderedListItemFragment = { __typename: 'OrderedListItem' } & Pick<
    OrderedListItem,
    'title' | 'description'
>

export type FaqQuestionFragment = { __typename: 'FaqQuestion' } & Pick<
    FaqQuestion,
    'question' | 'expandedByDefault'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type FaqSectionFragment = { __typename: 'FaqSection' } & Pick<
    FaqSection,
    'title'
> & { questions: Array<{ __typename: 'FaqQuestion' } & FaqQuestionFragment> }

export type ComponentGalleryWithEnquiryFragment = {
    __typename: 'ComponentGalleryWithEnquiry'
} & Pick<
    ComponentGalleryWithEnquiry,
    | 'type'
    | 'buttonText'
    | 'loadMoreButtonText'
    | 'modalType'
    | 'modalButtonText'
> & {
        items: Array<
            {
                __typename: 'GalleryWithEnquiryCard'
            } & GalleryWithEnquiryCardFragment
        >
    }

export type GalleryWithEnquiryCardFragment = {
    __typename: 'GalleryWithEnquiryCard'
} & Pick<GalleryWithEnquiryCard, 'caption' | 'slug'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type QuestionnaireFragment = { __typename: 'Questionnaire' } & Pick<
    Questionnaire,
    'id' | 'title' | 'type' | 'requireLoginBeforeStarting'
> & {
        steps: Array<
            { __typename: 'QuestionnaireStep' } & QuestionnaireStepFragment
        >
        signUpStep: {
            __typename: 'QuestionnaireSignUpStep'
        } & QuestionnaireSignUpStepFragment
        redirectLink:
            | ({
                  __typename: 'LinkItemAffirm'
              } & LinkItem_LinkItemAffirm_Fragment)
            | ({
                  __typename: 'LinkItemBookingForm'
              } & LinkItem_LinkItemBookingForm_Fragment)
            | ({
                  __typename: 'LinkItemCustom'
              } & LinkItem_LinkItemCustom_Fragment)
            | ({
                  __typename: 'LinkItemOpenContactForm'
              } & LinkItem_LinkItemOpenContactForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenEnquiryForm'
              } & LinkItem_LinkItemOpenEnquiryForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenIntercom'
              } & LinkItem_LinkItemOpenIntercom_Fragment)
            | ({
                  __typename: 'LinkItemOpenSpeakToExpertModal'
              } & LinkItem_LinkItemOpenSpeakToExpertModal_Fragment)
            | ({ __typename: 'Page' } & LinkItem_Page_Fragment)
            | ({ __typename: 'Post' } & LinkItem_Post_Fragment)
            | ({
                  __typename: 'Questionnaire'
              } & LinkItem_Questionnaire_Fragment)
    }

export type QuestionnaireSignUpStepFragment = {
    __typename: 'QuestionnaireSignUpStep'
} & Pick<
    QuestionnaireSignUpStep,
    'title' | 'description' | 'backgroundColor' | 'submitButtonLabel'
> & { image: { __typename: 'Image' } & ImageLargeFragment }

export type QuestionnaireStepFragment = {
    __typename: 'QuestionnaireStep'
} & Pick<
    QuestionnaireStep,
    'title' | 'description' | 'excludeFromProgressIndicator'
> & {
        content: Array<
            | ({
                  __typename: 'QuestionnaireStepContentContent'
              } & QuestionnaireStepContentContentFragment)
            | ({
                  __typename: 'QuestionnaireStepContentQuestions'
              } & QuestionnaireStepContentQuestionsFragment)
        >
        conditions: Array<
            {
                __typename: 'QuestionnaireCondition'
            } & QuestionnaireConditionFragment
        >
        help: Array<{ __typename: 'Block' } & BlockFragment>
    }

export type QuestionnaireConditionFragment = {
    __typename: 'QuestionnaireCondition'
} & Pick<QuestionnaireCondition, 'type'> & {
        rules: Array<
            | ({
                  __typename: 'QuestionnaireConditionEqualToChoice'
              } & QuestionnaireConditionEqualToChoiceFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsEmpty'
              } & QuestionnaireConditionIsEmptyFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsEqualTo'
              } & QuestionnaireConditionIsEqualToFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsGreaterThan'
              } & QuestionnaireConditionIsGreaterThanFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsLessThan'
              } & QuestionnaireConditionIsLessThanFragment)
            | ({
                  __typename: 'QuestionnaireConditionIsNotEmpty'
              } & QuestionnaireConditionIsNotEmptyFragment)
            | ({
                  __typename: 'QuestionnaireConditionNotIsEqualTo'
              } & QuestionnaireConditionNotIsEqualToFragment)
        >
    }

export type QuestionnaireConditionEqualToChoiceFragment = {
    __typename: 'QuestionnaireConditionEqualToChoice'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
              QuestionnaireQuestionFile,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
    choice: Maybe<
        { __typename: 'QuestionnaireQuestionChoiceOption' } & Pick<
            QuestionnaireQuestionChoiceOption,
            'id'
        >
    >
}

export type QuestionnaireConditionIsEmptyFragment = {
    __typename: 'QuestionnaireConditionIsEmpty'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
              QuestionnaireQuestionFile,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionIsEqualToFragment = {
    __typename: 'QuestionnaireConditionIsEqualTo'
} & { valueString: QuestionnaireConditionIsEqualTo['value'] } & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
              QuestionnaireQuestionFile,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionIsGreaterThanFragment = {
    __typename: 'QuestionnaireConditionIsGreaterThan'
} & Pick<QuestionnaireConditionIsGreaterThan, 'value'> & {
        question:
            | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
                  QuestionnaireQuestionChoice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
                  QuestionnaireQuestionFile,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
                  QuestionnaireQuestionPrice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
                  QuestionnaireQuestionText,
                  'id'
              >)
    }

export type QuestionnaireConditionIsLessThanFragment = {
    __typename: 'QuestionnaireConditionIsLessThan'
} & Pick<QuestionnaireConditionIsLessThan, 'value'> & {
        question:
            | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
                  QuestionnaireQuestionChoice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
                  QuestionnaireQuestionFile,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
                  QuestionnaireQuestionPrice,
                  'id'
              >)
            | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
                  QuestionnaireQuestionText,
                  'id'
              >)
    }

export type QuestionnaireConditionIsNotEmptyFragment = {
    __typename: 'QuestionnaireConditionIsNotEmpty'
} & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
              QuestionnaireQuestionFile,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireConditionNotIsEqualToFragment = {
    __typename: 'QuestionnaireConditionNotIsEqualTo'
} & { valueString: QuestionnaireConditionNotIsEqualTo['value'] } & {
    question:
        | ({ __typename: 'QuestionnaireQuestionChoice' } & Pick<
              QuestionnaireQuestionChoice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionFile' } & Pick<
              QuestionnaireQuestionFile,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionPrice' } & Pick<
              QuestionnaireQuestionPrice,
              'id'
          >)
        | ({ __typename: 'QuestionnaireQuestionText' } & Pick<
              QuestionnaireQuestionText,
              'id'
          >)
}

export type QuestionnaireStepContentContentFragment = {
    __typename: 'QuestionnaireStepContentContent'
} & {
    blocks: Array<{ __typename: 'Block' } & BlockFragment>
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

type QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment = {
    __typename: 'QuestionnaireQuestionChoice'
} & Pick<QuestionnaireQuestionChoice, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionChoiceFragment

type QuestionnaireQuestion_QuestionnaireQuestionFile_Fragment = {
    __typename: 'QuestionnaireQuestionFile'
} & Pick<QuestionnaireQuestionFile, 'id' | 'title' | 'required'>

type QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment = {
    __typename: 'QuestionnaireQuestionPrice'
} & Pick<QuestionnaireQuestionPrice, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionPriceFragment

type QuestionnaireQuestion_QuestionnaireQuestionText_Fragment = {
    __typename: 'QuestionnaireQuestionText'
} & Pick<QuestionnaireQuestionText, 'id' | 'title' | 'required'> &
    QuestionnaireQuestionTextFragment

export type QuestionnaireQuestionFragment =
    | QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment
    | QuestionnaireQuestion_QuestionnaireQuestionFile_Fragment
    | QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment
    | QuestionnaireQuestion_QuestionnaireQuestionText_Fragment

export type QuestionnaireQuestionChoiceFragment = {
    __typename: 'QuestionnaireQuestionChoice'
} & Pick<
    QuestionnaireQuestionChoice,
    'id' | 'title' | 'multiple' | 'required'
> & {
        options: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOption'
            } & QuestionnaireQuestionChoiceOptionFragment
        >
    }

export type QuestionnaireQuestionFileFragment = {
    __typename: 'QuestionnaireQuestionFile'
} & Pick<QuestionnaireQuestionFile, 'id' | 'required' | 'title' | 'systemCode'>

export type QuestionnaireQuestionPriceFragment = {
    __typename: 'QuestionnaireQuestionPrice'
} & Pick<
    QuestionnaireQuestionPrice,
    'id' | 'title' | 'required' | 'tooltip' | 'min' | 'max'
>

export type QuestionnaireQuestionTextFragment = {
    __typename: 'QuestionnaireQuestionText'
} & Pick<
    QuestionnaireQuestionText,
    'id' | 'title' | 'label' | 'placeholder' | 'required' | 'textarea'
>

export type QuestionnaireStepContentQuestionsFragment = {
    __typename: 'QuestionnaireStepContentQuestions'
} & {
    questions: Array<
        | ({
              __typename: 'QuestionnaireQuestionChoice'
          } & QuestionnaireQuestion_QuestionnaireQuestionChoice_Fragment)
        | ({
              __typename: 'QuestionnaireQuestionFile'
          } & QuestionnaireQuestion_QuestionnaireQuestionFile_Fragment)
        | ({
              __typename: 'QuestionnaireQuestionPrice'
          } & QuestionnaireQuestion_QuestionnaireQuestionPrice_Fragment)
        | ({
              __typename: 'QuestionnaireQuestionText'
          } & QuestionnaireQuestion_QuestionnaireQuestionText_Fragment)
    >
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

export type QuestionnaireQuestionChoiceOptionFragment = {
    __typename: 'QuestionnaireQuestionChoiceOption'
} & Pick<QuestionnaireQuestionChoiceOption, 'id'> & {
        content:
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment)
            | ({
                  __typename: 'QuestionnaireQuestionChoiceOptionContentText'
              } & QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment)
        behaviour: Maybe<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
            } & QuestionnaireQuestionChoiceOptionBehaviourFragment
        >
    }

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
    } & QuestionnaireQuestionChoiceOptionContentIconCardFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
    } & QuestionnaireQuestionChoiceOptionContentImageFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
    } & QuestionnaireQuestionChoiceOptionContentImageCardFragment

type QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentText'
    } & QuestionnaireQuestionChoiceOptionContentTextFragment

export type QuestionnaireQuestionChoiceOptionContentFragment =
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentIconCard_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImage_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentImageCard_Fragment
    | QuestionnaireQuestionChoiceOptionContent_QuestionnaireQuestionChoiceOptionContentText_Fragment

export type QuestionnaireQuestionChoiceOptionContentIconCardFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentIconCard'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentIconCard,
    'title' | 'description' | 'backgroundColor'
> & {
        icon: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
            } & QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentIconCardConditionalFragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentIconCardConditional'
    } & Pick<
        QuestionnaireQuestionChoiceOptionContentIconCardConditional,
        'title' | 'description'
    > & {
            icon: { __typename: 'Image' } & ImageLargeFragment
            conditions: Array<
                {
                    __typename: 'QuestionnaireCondition'
                } & QuestionnaireConditionFragment
            >
        }

export type QuestionnaireQuestionChoiceOptionContentImageFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImage'
} & {
    image: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
    conditionalContent: Array<
        {
            __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
        } & QuestionnaireQuestionChoiceOptionContentImageConditionalFragment
    >
}

export type QuestionnaireQuestionChoiceOptionContentImageCardFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImageCard'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentImageCard,
    'title' | 'description'
> & {
        image: { __typename: 'Image' } & Pick<Image, 'url'> & ImageLargeFragment
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
            } & QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragment =
    {
        __typename: 'QuestionnaireQuestionChoiceOptionContentImageCardConditional'
    } & Pick<
        QuestionnaireQuestionChoiceOptionContentImageCardConditional,
        'title' | 'description'
    > & {
            image: { __typename: 'Image' } & ImageLargeFragment
            conditions: Array<
                {
                    __typename: 'QuestionnaireCondition'
                } & QuestionnaireConditionFragment
            >
        }

export type QuestionnaireQuestionChoiceOptionContentImageConditionalFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentImageConditional'
} & {
    image: { __typename: 'Image' } & ImageLargeFragment
    conditions: Array<
        {
            __typename: 'QuestionnaireCondition'
        } & QuestionnaireConditionFragment
    >
}

export type QuestionnaireQuestionChoiceOptionContentTextFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentText'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentText,
    'title' | 'description'
> & {
        conditionalContent: Array<
            {
                __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
            } & QuestionnaireQuestionChoiceOptionContentTextConditionalFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionContentTextConditionalFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionContentTextConditional'
} & Pick<
    QuestionnaireQuestionChoiceOptionContentTextConditional,
    'title' | 'description'
> & {
        conditions: Array<
            {
                __typename: 'QuestionnaireCondition'
            } & QuestionnaireConditionFragment
        >
    }

export type QuestionnaireQuestionChoiceOptionBehaviourFragment = {
    __typename: 'QuestionnaireQuestionChoiceOptionBehaviour'
} & Pick<
    QuestionnaireQuestionChoiceOptionBehaviour,
    'metal' | 'ringStyle' | 'designStyle' | 'designFeature' | 'shape'
>

export type ComponentSideBySideImageFragment = {
    __typename: 'ComponentSideBySideImage'
} & Pick<ComponentSideBySideImage, 'caption'> & {
        image: { __typename: 'Image' } & ImageLargeFragment
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        link: Maybe<{ __typename: 'Link' } & LinkFragment>
    }

export type ComponentSquareBoxesFragment = {
    __typename: 'ComponentSquareBoxes'
} & {
    items: Array<
        | ({
              __typename: 'SquareImageBox'
          } & SquareBoxes_SquareImageBox_Fragment)
        | ({ __typename: 'SquareTextBox' } & SquareBoxes_SquareTextBox_Fragment)
    >
}

export type SquareImageBoxFragment = { __typename: 'SquareImageBox' } & {
    image: { __typename: 'Image' } & ImageMediumFragment
    link: Maybe<{ __typename: 'Link' } & LinkFragment>
}

export type SquareTextBoxFragment = { __typename: 'SquareTextBox' } & Pick<
    SquareTextBox,
    'backgroundColor'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

type SquareBoxes_SquareImageBox_Fragment = {
    __typename: 'SquareImageBox'
} & SquareImageBoxFragment

type SquareBoxes_SquareTextBox_Fragment = {
    __typename: 'SquareTextBox'
} & SquareTextBoxFragment

export type SquareBoxesFragment =
    | SquareBoxes_SquareImageBox_Fragment
    | SquareBoxes_SquareTextBox_Fragment

export type ImageCommonFragment = { __typename: 'Image' } & Pick<
    Image,
    'id' | 'alt'
>

export type ImageCoverFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageLargeFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageMediumFragment = { __typename: 'Image' } & {
    size: { __typename: 'ImageSize' } & ImageSizeFragment
    size_x2: { __typename: 'ImageSize' } & ImageSizeFragment
} & ImageCommonFragment

export type ImageSizeFragment = { __typename: 'ImageSize' } & Pick<
    ImageSize,
    'url'
> & {
        sources: Array<
            { __typename: 'ImageSrc' } & Pick<ImageSrc, 'url' | 'mimeType'>
        >
    }

export type VideoFragment = { __typename: 'Video' } & Pick<Video, 'id' | 'url'>

export type EnquiryResponseExistingCustomerFragment = {
    __typename: 'EnquiryResponseExistingCustomer'
} & Pick<EnquiryResponseExistingCustomer, 'marketingCloudForm'>

export type EnquiryResponseNewCustomerFragment = {
    __typename: 'EnquiryResponseNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type CreateEnquiryContactUsExistingCustomerMutationVariables = Exact<{
    input: EnquiryContactUsInput
}>

export type CreateEnquiryContactUsExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryContactUsExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryContactUsNewCustomerMutationVariables = Exact<{
    input: EnquiryContactUsInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateEnquiryContactUsNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryContactUsNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type CreateEnquiryExistingCustomerMutationVariables = Exact<{
    input: EnquiryInput
}>

export type CreateEnquiryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryNewCustomerMutationVariables = Exact<{
    input: EnquiryInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateEnquiryNewCustomerMutation = { __typename: 'Mutation' } & {
    createEnquiryNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type AvatarStackItemFragment = { __typename: 'AvatarStackItem' } & {
    image: { __typename: 'Image' } & ImageLargeFragment
}

type ProductCard_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'seoText' | 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueEngagementRing_Fragment &
    MetalVariation_CatalogueEngagementRing_Fragment &
    GetIsLabGrown_CatalogueEngagementRing_Fragment

type ProductCard_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueJewelleryBracelet_Fragment &
    MetalVariation_CatalogueJewelleryBracelet_Fragment &
    GetIsLabGrown_CatalogueJewelleryBracelet_Fragment

type ProductCard_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueJewelleryEarrings_Fragment &
    MetalVariation_CatalogueJewelleryEarrings_Fragment &
    GetIsLabGrown_CatalogueJewelleryEarrings_Fragment

type ProductCard_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueJewelleryNecklace_Fragment &
    MetalVariation_CatalogueJewelleryNecklace_Fragment &
    GetIsLabGrown_CatalogueJewelleryNecklace_Fragment

type ProductCard_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueJewelleryRing_Fragment &
    MetalVariation_CatalogueJewelleryRing_Fragment &
    GetIsLabGrown_CatalogueJewelleryRing_Fragment

type ProductCard_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    | 'shortName'
    | 'shortDescription'
    | 'catalogueCode'
    | 'productName'
    | 'supportsExpress'
> & {
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueReadyToGoRing_Fragment &
    MetalVariation_CatalogueReadyToGoRing_Fragment &
    GetIsLabGrown_CatalogueReadyToGoRing_Fragment

type ProductCard_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    'catalogueCode' | 'productName' | 'supportsExpress'
> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'seoText' | 'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'> & {
                    medium: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    medium_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
        reviewsAggregate: { __typename: 'ReviewsAggregate' } & Pick<
            ReviewsAggregate,
            'total' | 'rating'
        >
    } & ProductLink_CatalogueWeddingRing_Fragment &
    MetalVariation_CatalogueWeddingRing_Fragment &
    GetIsLabGrown_CatalogueWeddingRing_Fragment

export type ProductCardFragment =
    | ProductCard_CatalogueEngagementRing_Fragment
    | ProductCard_CatalogueJewelleryBracelet_Fragment
    | ProductCard_CatalogueJewelleryEarrings_Fragment
    | ProductCard_CatalogueJewelleryNecklace_Fragment
    | ProductCard_CatalogueJewelleryRing_Fragment
    | ProductCard_CatalogueReadyToGoRing_Fragment
    | ProductCard_CatalogueWeddingRing_Fragment

export type FooterFragment = { __typename: 'Footer' } & Pick<
    Footer,
    'copyright'
> & {
        columns: Array<{ __typename: 'FooterColumn' } & FooterMenuFragment>
        logos: Array<
            { __typename: 'FooterLogo' } & Pick<FooterLogo, 'link'> & {
                    logo: { __typename: 'Image' } & ImageLargeFragment
                }
        >
    }

export type FooterItemDividerFragment = {
    __typename: 'FooterColumnItemSeparator'
} & Pick<FooterColumnItemSeparator, 'line'>

export type FooterItemLinkListFragment = {
    __typename: 'FooterColumnItemLinkList'
} & {
    links: Array<
        { __typename: 'FooterColumnItemLink' } & Pick<
            FooterColumnItemLink,
            'text'
        > & { link: { __typename: 'Link' } & LinkFragment }
    >
}

export type FooterItemTextFragment = {
    __typename: 'FooterColumnItemText'
} & Pick<FooterColumnItemText, 'text'>

export type FooterItemTitleFragment = {
    __typename: 'FooterColumnItemTitle'
} & Pick<FooterColumnItemTitle, 'title'>

export type FooterItemWorkingHoursFragment = {
    __typename: 'FooterColumnItemWorkingHours'
} & {
    workingHours: Array<{ __typename: 'WorkingHours' } & WorkingHoursFragment>
}

export type FooterMenuFragment = { __typename: 'FooterColumn' } & {
    items: Array<
        | ({
              __typename: 'FooterColumnItemLinkList'
          } & FooterMenuItem_FooterColumnItemLinkList_Fragment)
        | ({
              __typename: 'FooterColumnItemSeparator'
          } & FooterMenuItem_FooterColumnItemSeparator_Fragment)
        | ({
              __typename: 'FooterColumnItemText'
          } & FooterMenuItem_FooterColumnItemText_Fragment)
        | ({
              __typename: 'FooterColumnItemTitle'
          } & FooterMenuItem_FooterColumnItemTitle_Fragment)
        | ({
              __typename: 'FooterColumnItemWorkingHours'
          } & FooterMenuItem_FooterColumnItemWorkingHours_Fragment)
    >
}

type FooterMenuItem_FooterColumnItemLinkList_Fragment = {
    __typename: 'FooterColumnItemLinkList'
} & FooterItemLinkListFragment

type FooterMenuItem_FooterColumnItemSeparator_Fragment = {
    __typename: 'FooterColumnItemSeparator'
} & FooterItemDividerFragment

type FooterMenuItem_FooterColumnItemText_Fragment = {
    __typename: 'FooterColumnItemText'
} & FooterItemTextFragment

type FooterMenuItem_FooterColumnItemTitle_Fragment = {
    __typename: 'FooterColumnItemTitle'
} & FooterItemTitleFragment

type FooterMenuItem_FooterColumnItemWorkingHours_Fragment = {
    __typename: 'FooterColumnItemWorkingHours'
} & FooterItemWorkingHoursFragment

export type FooterMenuItemFragment =
    | FooterMenuItem_FooterColumnItemLinkList_Fragment
    | FooterMenuItem_FooterColumnItemSeparator_Fragment
    | FooterMenuItem_FooterColumnItemText_Fragment
    | FooterMenuItem_FooterColumnItemTitle_Fragment
    | FooterMenuItem_FooterColumnItemWorkingHours_Fragment

type ProductGallery_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        }
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'productName' | 'suffix'> & {
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

type ProductGallery_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'productName' | 'suffix'> & {
        images360: Array<{ __typename: 'GenericImage' } & ThreeSixtyFragment>
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'id'> & {
                    large: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    large_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

export type ProductGalleryFragment =
    | ProductGallery_CatalogueEngagementRing_Fragment
    | ProductGallery_CatalogueJewelleryBracelet_Fragment
    | ProductGallery_CatalogueJewelleryEarrings_Fragment
    | ProductGallery_CatalogueJewelleryNecklace_Fragment
    | ProductGallery_CatalogueJewelleryRing_Fragment
    | ProductGallery_CatalogueReadyToGoRing_Fragment
    | ProductGallery_CatalogueWeddingRing_Fragment

export type HeaderMenuFragment = { __typename: 'MenuItem' } & Pick<
    MenuItem,
    'title' | 'hideOnMobile' | 'hideOnDesktop'
> & {
        link: { __typename: 'Link' } & LinkFragment
        subMenu: Maybe<{ __typename: 'SubMenu' } & SubMenuFragment>
    }

export type PreHeaderFragment = { __typename: 'PreHeader' } & {
    link: { __typename: 'Link' } & LinkFragment
}

export type SubMenuFragment = { __typename: 'SubMenu' } & Pick<
    SubMenu,
    'title' | 'description' | 'useLargeFormatItems'
> & {
        sections: Array<
            { __typename: 'SubMenuSection' } & SubMenuSectionFragment
        >
        editorialContent: Maybe<
            {
                __typename: 'SubMenuEditorialContent'
            } & SubMenuEditorialContentFragment
        >
    }

export type SubMenuEditorialContentFragment = {
    __typename: 'SubMenuEditorialContent'
} & Pick<SubMenuEditorialContent, 'text'> & {
        link: { __typename: 'Link' } & LinkFragment
        image: { __typename: 'Image' } & ImageLargeFragment
    }

export type SubMenuItemFragment = { __typename: 'SubMenuItem' } & Pick<
    SubMenuItem,
    'title' | 'style'
> & {
        link: { __typename: 'Link' } & LinkFragment
        media: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
        icon: Maybe<{ __typename: 'Image' } & ImageLargeFragment>
    }

export type SubMenuSectionFragment = { __typename: 'SubMenuSection' } & Pick<
    SubMenuSection,
    'title'
> & { items: Array<{ __typename: 'SubMenuItem' } & SubMenuItemFragment> }

export type TopBarFragment = { __typename: 'TopBar' } & {
    siteWideMessage: Maybe<
        { __typename: 'TopBarSiteWideMessage' } & TopBarSiteWideMessageFragment
    >
    consultationPrompt: Maybe<
        {
            __typename: 'TopBarConsultationPrompt'
        } & TopBarConsultationPromptFragment
    >
}

export type TopBarConsultationPromptFragment = {
    __typename: 'TopBarConsultationPrompt'
} & { link: { __typename: 'Link' } & LinkFragment }

export type TopBarSiteWideMessageFragment = {
    __typename: 'TopBarSiteWideMessage'
} & Pick<TopBarSiteWideMessage, 'message'> & {
        link: { __typename: 'Link' } & LinkFragment
    }

export type ThreeSixtyFragment = { __typename: 'GenericImage' } & Pick<
    GenericImage,
    'url'
> & {
        size: { __typename: 'MonolithImageSize' } & MonolithImageSizeFragment
        size_x2: { __typename: 'MonolithImageSize' } & MonolithImageSizeFragment
    }

export type PageTooltipFragment = { __typename: 'PageTooltip' } & Pick<
    PageTooltip,
    'triggerText'
> & { tooltip: { __typename: 'Tooltip' } & TooltipFragment }

type PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment =
    { __typename: 'ProductPageDetailsAccordionItemAboutThisProduct' } & Pick<
        ProductPageDetailsAccordionItemAboutThisProduct,
        'expanded'
    >

type PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment =
    { __typename: 'ProductPageDetailsAccordionItemDesignInspiration' } & Pick<
        ProductPageDetailsAccordionItemDesignInspiration,
        'expanded'
    >

type PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment = {
    __typename: 'ProductPageDetailsAccordionItemFinance'
} & Pick<ProductPageDetailsAccordionItemFinance, 'expanded'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

type PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment = {
    __typename: 'ProductPageDetailsAccordionItemGeneric'
} & Pick<ProductPageDetailsAccordionItemGeneric, 'title' | 'expanded'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

type PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment = {
    __typename: 'ProductPageDetailsAccordionItemShipping'
} & Pick<ProductPageDetailsAccordionItemShipping, 'expanded'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

type PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment = {
    __typename: 'ProductPageDetailsAccordionItemSizing'
} & Pick<ProductPageDetailsAccordionItemSizing, 'expanded'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

type PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment = {
    __typename: 'ProductPageDetailsAccordionItemWarranty'
} & Pick<ProductPageDetailsAccordionItemWarranty, 'expanded'> & {
        components: Array<
            | ({
                  __typename: 'ComponentArticleGrid'
              } & Component_ComponentArticleGrid_Fragment)
            | ({
                  __typename: 'ComponentArticlePreviews'
              } & Component_ComponentArticlePreviews_Fragment)
            | ({
                  __typename: 'ComponentBannerSkinny'
              } & Component_ComponentBannerSkinny_Fragment)
            | ({
                  __typename: 'ComponentBannerTitle'
              } & Component_ComponentBannerTitle_Fragment)
            | ({
                  __typename: 'ComponentCard'
              } & Component_ComponentCard_Fragment)
            | ({
                  __typename: 'ComponentCardCarousel'
              } & Component_ComponentCardCarousel_Fragment)
            | ({
                  __typename: 'ComponentCatalogueProductCarousel'
              } & Component_ComponentCatalogueProductCarousel_Fragment)
            | ({
                  __typename: 'ComponentContent'
              } & Component_ComponentContent_Fragment)
            | ({
                  __typename: 'ComponentContentTwoColumns'
              } & Component_ComponentContentTwoColumns_Fragment)
            | ({
                  __typename: 'ComponentContentWithGallery'
              } & Component_ComponentContentWithGallery_Fragment)
            | ({
                  __typename: 'ComponentCustomProductCarousel'
              } & Component_ComponentCustomProductCarousel_Fragment)
            | ({ __typename: 'ComponentFaq' } & Component_ComponentFaq_Fragment)
            | ({
                  __typename: 'ComponentFullWidthImage'
              } & Component_ComponentFullWidthImage_Fragment)
            | ({
                  __typename: 'ComponentGalleryCarousel'
              } & Component_ComponentGalleryCarousel_Fragment)
            | ({
                  __typename: 'ComponentGalleryWithEnquiry'
              } & Component_ComponentGalleryWithEnquiry_Fragment)
            | ({
                  __typename: 'ComponentGlobalComponent'
              } & Component_ComponentGlobalComponent_Fragment)
            | ({
                  __typename: 'ComponentGlobalSpacer'
              } & Component_ComponentGlobalSpacer_Fragment)
            | ({
                  __typename: 'ComponentIconCarousel'
              } & Component_ComponentIconCarousel_Fragment)
            | ({
                  __typename: 'ComponentInstagramPosts'
              } & Component_ComponentInstagramPosts_Fragment)
            | ({
                  __typename: 'ComponentInstagramWithContent'
              } & Component_ComponentInstagramWithContent_Fragment)
            | ({
                  __typename: 'ComponentJobs'
              } & Component_ComponentJobs_Fragment)
            | ({
                  __typename: 'ComponentLogos'
              } & Component_ComponentLogos_Fragment)
            | ({
                  __typename: 'ComponentLogosCarousel'
              } & Component_ComponentLogosCarousel_Fragment)
            | ({
                  __typename: 'ComponentLogosWithText'
              } & Component_ComponentLogosWithText_Fragment)
            | ({
                  __typename: 'ComponentMainCover'
              } & Component_ComponentMainCover_Fragment)
            | ({
                  __typename: 'ComponentOnThisPage'
              } & Component_ComponentOnThisPage_Fragment)
            | ({
                  __typename: 'ComponentQuote'
              } & Component_ComponentQuote_Fragment)
            | ({
                  __typename: 'ComponentRelatedProducts'
              } & Component_ComponentRelatedProducts_Fragment)
            | ({
                  __typename: 'ComponentReviewCarousel'
              } & Component_ComponentReviewCarousel_Fragment)
            | ({
                  __typename: 'ComponentRoundedImage'
              } & Component_ComponentRoundedImage_Fragment)
            | ({
                  __typename: 'ComponentRoundedImageContent'
              } & Component_ComponentRoundedImageContent_Fragment)
            | ({
                  __typename: 'ComponentShopWithConfidence'
              } & Component_ComponentShopWithConfidence_Fragment)
            | ({
                  __typename: 'ComponentSideBySideImages'
              } & Component_ComponentSideBySideImages_Fragment)
            | ({
                  __typename: 'ComponentSquareBoxes'
              } & Component_ComponentSquareBoxes_Fragment)
            | ({
                  __typename: 'ComponentTable'
              } & Component_ComponentTable_Fragment)
            | ({
                  __typename: 'ComponentTextCarousel'
              } & Component_ComponentTextCarousel_Fragment)
            | ({
                  __typename: 'ComponentTextOverImage'
              } & Component_ComponentTextOverImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImage'
              } & Component_ComponentTextWithImage_Fragment)
            | ({
                  __typename: 'ComponentTextWithImageCarousel'
              } & Component_ComponentTextWithImageCarousel_Fragment)
            | ({
                  __typename: 'ComponentVideo'
              } & Component_ComponentVideo_Fragment)
            | ({
                  __typename: 'ComponentVideoWithContent'
              } & Component_ComponentVideoWithContent_Fragment)
            | ({
                  __typename: 'ComponentWarrantyActivationForm'
              } & Component_ComponentWarrantyActivationForm_Fragment)
        >
    }

export type PdpAccordionItemFragment =
    | PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment
    | PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment

export type DeliveryTimeframeFragment = { __typename: 'DeliveryDate' } & Pick<
    DeliveryDate,
    'date' | 'validUntil'
>

type MetalVariation_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

type MetalVariation_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & { primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment }

export type MetalVariationFragment =
    | MetalVariation_CatalogueEngagementRing_Fragment
    | MetalVariation_CatalogueJewelleryBracelet_Fragment
    | MetalVariation_CatalogueJewelleryEarrings_Fragment
    | MetalVariation_CatalogueJewelleryNecklace_Fragment
    | MetalVariation_CatalogueJewelleryRing_Fragment
    | MetalVariation_CatalogueReadyToGoRing_Fragment
    | MetalVariation_CatalogueWeddingRing_Fragment

type RelatedProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    variationsByPrimaryMetal: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductCard_CatalogueEngagementRing_Fragment
    >
} & ProductCard_CatalogueEngagementRing_Fragment

type RelatedProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductCard_CatalogueJewelleryBracelet_Fragment
    >
} & ProductCard_CatalogueJewelleryBracelet_Fragment

type RelatedProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductCard_CatalogueJewelleryEarrings_Fragment
    >
} & ProductCard_CatalogueJewelleryEarrings_Fragment

type RelatedProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductCard_CatalogueJewelleryNecklace_Fragment
    >
} & ProductCard_CatalogueJewelleryNecklace_Fragment

type RelatedProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductCard_CatalogueJewelleryRing_Fragment
    >
} & ProductCard_CatalogueJewelleryRing_Fragment

type RelatedProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ProductCard_CatalogueReadyToGoRing_Fragment

type RelatedProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductCard_CatalogueWeddingRing_Fragment
    >
} & ProductCard_CatalogueWeddingRing_Fragment

export type RelatedProductFragment =
    | RelatedProduct_CatalogueEngagementRing_Fragment
    | RelatedProduct_CatalogueJewelleryBracelet_Fragment
    | RelatedProduct_CatalogueJewelleryEarrings_Fragment
    | RelatedProduct_CatalogueJewelleryNecklace_Fragment
    | RelatedProduct_CatalogueJewelleryRing_Fragment
    | RelatedProduct_CatalogueReadyToGoRing_Fragment
    | RelatedProduct_CatalogueWeddingRing_Fragment

export type ReviewsFragment = { __typename: 'Review' } & Pick<
    Review,
    'id' | 'name' | 'comment' | 'date' | 'rating'
> & {
        picture: Maybe<
            { __typename: 'Asset' } & Pick<Asset, 'id'> & {
                    small: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                    small_x2: {
                        __typename: 'MonolithImageSize'
                    } & MonolithImageSizeFragment
                }
        >
    }

export type ReviewsAggregateFragment = {
    __typename: 'ReviewsAggregate'
} & Pick<ReviewsAggregate, 'rating' | 'total'>

export type TaxSnippetFragment = { __typename: 'SalePrice' } & {
    total: { __typename: 'Money' } & MoneyFragment
    tax: Maybe<{ __typename: 'Tax' } & Pick<Tax, 'type'>>
}

type ProductGrid_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    variationsByPrimaryMetal: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductCard_CatalogueEngagementRing_Fragment &
            ProductListAnalytics_CatalogueEngagementRing_Fragment
    >
} & ProductCard_CatalogueEngagementRing_Fragment &
    ProductListAnalytics_CatalogueEngagementRing_Fragment

type ProductGrid_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductCard_CatalogueJewelleryBracelet_Fragment &
            ProductListAnalytics_CatalogueJewelleryBracelet_Fragment
    >
} & ProductCard_CatalogueJewelleryBracelet_Fragment &
    ProductListAnalytics_CatalogueJewelleryBracelet_Fragment

type ProductGrid_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductCard_CatalogueJewelleryEarrings_Fragment &
            ProductListAnalytics_CatalogueJewelleryEarrings_Fragment
    >
} & ProductCard_CatalogueJewelleryEarrings_Fragment &
    ProductListAnalytics_CatalogueJewelleryEarrings_Fragment

type ProductGrid_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductCard_CatalogueJewelleryNecklace_Fragment &
            ProductListAnalytics_CatalogueJewelleryNecklace_Fragment
    >
} & ProductCard_CatalogueJewelleryNecklace_Fragment &
    ProductListAnalytics_CatalogueJewelleryNecklace_Fragment

type ProductGrid_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductCard_CatalogueJewelleryRing_Fragment &
            ProductListAnalytics_CatalogueJewelleryRing_Fragment
    >
} & ProductCard_CatalogueJewelleryRing_Fragment &
    ProductListAnalytics_CatalogueJewelleryRing_Fragment

type ProductGrid_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ProductCard_CatalogueReadyToGoRing_Fragment &
    ProductListAnalytics_CatalogueReadyToGoRing_Fragment

type ProductGrid_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & {
    variations: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductCard_CatalogueWeddingRing_Fragment &
            ProductListAnalytics_CatalogueWeddingRing_Fragment
    >
} & ProductCard_CatalogueWeddingRing_Fragment &
    ProductListAnalytics_CatalogueWeddingRing_Fragment

export type ProductGridFragment =
    | ProductGrid_CatalogueEngagementRing_Fragment
    | ProductGrid_CatalogueJewelleryBracelet_Fragment
    | ProductGrid_CatalogueJewelleryEarrings_Fragment
    | ProductGrid_CatalogueJewelleryNecklace_Fragment
    | ProductGrid_CatalogueJewelleryRing_Fragment
    | ProductGrid_CatalogueReadyToGoRing_Fragment
    | ProductGrid_CatalogueWeddingRing_Fragment

export type MonolithImageSizeFragment = {
    __typename: 'MonolithImageSize'
} & Pick<MonolithImageSize, 'url'> & {
        sources: Array<
            { __typename: 'ImageSrc' } & Pick<ImageSrc, 'url' | 'mimeType'>
        >
    }

export type MarketingDataMutationVariables = Exact<{
    input: MarketingDataInput
}>

export type MarketingDataMutation = { __typename: 'Mutation' } & {
    marketingData: { __typename: 'MarketingDataResponse' } & Pick<
        MarketingDataResponse,
        'success'
    >
}

export type RingBuilderQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type RingBuilderQuery = { __typename: 'Query' } & {
    ringBuilder: { __typename: 'RingBuilder' } & RbFragment
}

export type InitQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    fetchRegionSuggest: Scalars['Boolean']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type InitQuery = { __typename: 'Query' } & {
    me: Maybe<{ __typename: 'User' } & MeFragment>
    workingHours: Array<
        { __typename: 'WorkingHours' } & Pick<
            WorkingHours,
            'weekDays' | 'opening' | 'closing'
        >
    >
    regionSuggest?: { __typename: 'Region' } & Pick<Region, 'code'>
    defaultAlternateRegion: { __typename: 'Region' } & AlternateTagFragment
    regions: Array<
        { __typename: 'Region' } & AlternateTagFragment & RegionPluginFragment
    >
    language: Maybe<
        { __typename: 'Language' } & Pick<Language, 'locale'> & {
                translations: Array<
                    { __typename: 'Translation' } & TranslationFragment
                >
            }
    >
    topBar: Maybe<{ __typename: 'TopBar' } & TopBarFragment>
    preHeader: Maybe<{ __typename: 'PreHeader' } & PreHeaderFragment>
    mainMenu: Array<{ __typename: 'MenuItem' } & HeaderMenuFragment>
    socialNetworks: Array<
        { __typename: 'SocialNetwork' } & SocialNetworkFragment
    >
    paymentIcons: Array<{ __typename: 'PaymentIcon' } & PaymentIconFragment>
    footer: Maybe<{ __typename: 'Footer' } & FooterFragment>
    enquiryFormContents: Array<
        { __typename: 'EnquiryFormContent' } & EnquiryFormContentFragment
    >
}

export type AlternateTagFragment = { __typename: 'Region' } & Pick<
    Region,
    'code' | 'locales'
>

export type RegionPluginFragment = { __typename: 'Region' } & Pick<
    Region,
    'code' | 'currency'
> & { language: { __typename: 'Language' } & Pick<Language, 'locale'> }

export type EnquiryFormContentFragment = {
    __typename: 'EnquiryFormContent'
} & Pick<EnquiryFormContent, 'slug' | 'title' | 'description' | 'buttonText'>

export type TooltipFragment = { __typename: 'Tooltip' } & Pick<
    Tooltip,
    'title'
> & {
        content: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

type GetIsLabGrown_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'suffix'>

type GetIsLabGrown_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'suffix'>

type GetIsLabGrown_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'suffix'>

type GetIsLabGrown_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'suffix'>

export type GetIsLabGrownFragment =
    | GetIsLabGrown_CatalogueEngagementRing_Fragment
    | GetIsLabGrown_CatalogueJewelleryBracelet_Fragment
    | GetIsLabGrown_CatalogueJewelleryEarrings_Fragment
    | GetIsLabGrown_CatalogueJewelleryNecklace_Fragment
    | GetIsLabGrown_CatalogueJewelleryRing_Fragment
    | GetIsLabGrown_CatalogueReadyToGoRing_Fragment
    | GetIsLabGrown_CatalogueWeddingRing_Fragment

export type FacetedContentProductLabelTranslationFragment = {
    __typename: 'ProductLabelTranslation'
} & Pick<ProductLabelTranslation, 'name' | 'facetedContentName'>

export type GemsApiCertificateFragment = { __typename: 'GemsApi_Stone' } & {
    certificates: { __typename: 'GemsApi_StoneCertificates' } & Pick<
        GemsApi_StoneCertificates,
        'gcal' | 'gia' | 'igi'
    >
}

export type NonSkuLabGrownStoneImageFragment = {
    __typename: 'NonSkuLabGrown'
} & {
    image: Maybe<
        { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id'> & {
                size: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                size_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
    >
    shapeDimension: { __typename: 'NonSkuLabGrownShapeDimension' } & Pick<
        NonSkuLabGrownShapeDimension,
        'id'
    > & {
            image: Maybe<
                { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id'> & {
                        size: {
                            __typename: 'MonolithImageSize'
                        } & MonolithImageSizeFragment
                        size_x2: {
                            __typename: 'MonolithImageSize'
                        } & MonolithImageSizeFragment
                    }
            >
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    samplePhoto: Maybe<
                        { __typename: 'Asset' } & Pick<Asset, 'id'> & {
                                size: {
                                    __typename: 'MonolithImageSize'
                                } & MonolithImageSizeFragment
                                size_x2: {
                                    __typename: 'MonolithImageSize'
                                } & MonolithImageSizeFragment
                            }
                    >
                }
        }
}

export type NonSkuGemstoneImageFragment = { __typename: 'NonSkuGemstone' } & {
    image: Maybe<
        { __typename: 'NonSkuImage' } & Pick<NonSkuImage, 'id'> & {
                size: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                size_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
    >
    shapeDimension: { __typename: 'NonSkuGemstoneShapeDimension' } & Pick<
        NonSkuGemstoneShapeDimension,
        'id'
    > & {
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    samplePhoto: Maybe<
                        { __typename: 'Asset' } & Pick<Asset, 'id'> & {
                                size: {
                                    __typename: 'MonolithImageSize'
                                } & MonolithImageSizeFragment
                                size_x2: {
                                    __typename: 'MonolithImageSize'
                                } & MonolithImageSizeFragment
                            }
                    >
                }
        }
}

export type AutologinMutationVariables = Exact<{
    authToken: Scalars['String']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type AutologinMutation = { __typename: 'Mutation' } & {
    autologin:
        | { __typename: 'LoginResponseFailure' }
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponseSuccessFragment)
}

export type CustomerRegistrationResponseFragment = {
    __typename: 'CustomerRegistrationResponse'
} & {
    login: Maybe<
        { __typename: 'LoginResponseSuccess' } & LoginResponseSuccessFragment
    >
}

type LoginResponse_LoginResponseFailure_Fragment = {
    __typename: 'LoginResponseFailure'
} & LoginResponseFailureFragment

type LoginResponse_LoginResponseSuccess_Fragment = {
    __typename: 'LoginResponseSuccess'
} & LoginResponseSuccessFragment

export type LoginResponseFragment =
    | LoginResponse_LoginResponseFailure_Fragment
    | LoginResponse_LoginResponseSuccess_Fragment

export type LoginResponseFailureFragment = {
    __typename: 'LoginResponseFailure'
} & Pick<LoginResponseFailure, 'code' | 'message'>

export type LoginResponseSuccessFragment = {
    __typename: 'LoginResponseSuccess'
} & Pick<LoginResponseSuccess, 'jwt'> & {
        user: { __typename: 'User' } & MeFragment
    }

export type LoginMutationVariables = Exact<{
    credentials: CredentialsInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type LoginMutation = { __typename: 'Mutation' } & {
    login:
        | ({
              __typename: 'LoginResponseFailure'
          } & LoginResponse_LoginResponseFailure_Fragment)
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponse_LoginResponseSuccess_Fragment)
}

export type LoginWithFacebookMutationVariables = Exact<{
    credentials: CustomerRegistrationByFacebookInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type LoginWithFacebookMutation = { __typename: 'Mutation' } & {
    loginWithFacebook:
        | ({
              __typename: 'LoginResponseFailure'
          } & LoginResponse_LoginResponseFailure_Fragment)
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponse_LoginResponseSuccess_Fragment)
}

export type LoginWithGoogleMutationVariables = Exact<{
    credentials: CustomerRegistrationByGoogleInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type LoginWithGoogleMutation = { __typename: 'Mutation' } & {
    loginWithGoogle:
        | ({
              __typename: 'LoginResponseFailure'
          } & LoginResponse_LoginResponseFailure_Fragment)
        | ({
              __typename: 'LoginResponseSuccess'
          } & LoginResponse_LoginResponseSuccess_Fragment)
}

export type LogoutMutationVariables = Exact<{ [key: string]: never }>

export type LogoutMutation = { __typename: 'Mutation' } & Pick<
    Mutation,
    'logout'
>

export type BookingConsultationAvailableSlotsQueryVariables = Exact<{
    input: BookingConsultationSlotInput
    locale: Scalars['Locale']['input']
}>

export type BookingConsultationAvailableSlotsQuery = { __typename: 'Query' } & {
    bookingConsultationAvailableSlots: {
        __typename: 'BookingConsultationSlotsResponse'
    } & BookingConsultationSlotsResponseFragment
}

export type BookingConsultationSlotsResponseFragment = {
    __typename: 'BookingConsultationSlotsResponse'
} & {
    slots: Array<
        {
            __typename: 'BookingConsultationSlot'
        } & BookingConsultationSlotFragment
    >
}

export type BookingConsultationSlotFragment = {
    __typename: 'BookingConsultationSlot'
} & Pick<BookingConsultationSlot, 'startTime'> & {
        showroom: { __typename: 'Showroom' } & ShowroomFragment
    }

export type BookingInitQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type BookingInitQuery = { __typename: 'Query' } & Pick<
    Query,
    'bookingConsultationShowPhone'
> & {
        bookingConsultationPurposes: Array<
            {
                __typename: 'BookingConsultationPurpose'
            } & BookingConsultationPurposeFragment
        >
        bookingConsultationComplexities: Array<
            {
                __typename: 'BookingConsultationComplexity'
            } & BookingConsultationComplexityFragment
        >
    }

export type BookingConsultationPurposeFragment = {
    __typename: 'BookingConsultationPurpose'
} & Pick<BookingConsultationPurpose, 'systemCode' | 'name' | 'duration'> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
        type: { __typename: 'BookingConsultationType' } & Pick<
            BookingConsultationType,
            'systemCode' | 'name'
        >
    }

export type BookingConsultationComplexityFragment = {
    __typename: 'BookingConsultationComplexity'
} & Pick<BookingConsultationComplexity, 'systemCode'> & {
        translation: {
            __typename: 'BookingConsultationComplexityTranslation'
        } & Pick<BookingConsultationComplexityTranslation, 'name'>
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type CreateConsultationExistingCustomerMutationVariables = Exact<{
    input: BookingCreateConsultationInput
    locale: Scalars['Locale']['input']
}>

export type CreateConsultationExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createConsultationExistingCustomer:
        | ({
              __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
          } & BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment)
        | ({
              __typename: 'BookingCreateConsultationSuccessExistingCustomer'
          } & BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment)
}

type BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment =
    {
        __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    } & BookingCreateConsultationErrorNoAvailableConsultantsFragment

type BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment =
    {
        __typename: 'BookingCreateConsultationSuccessExistingCustomer'
    } & BookingCreateConsultationSuccessExistingCustomerFragment

export type BookingCreateConsultationExistingCustomerResponseFragment =
    | BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment
    | BookingCreateConsultationExistingCustomerResponse_BookingCreateConsultationSuccessExistingCustomer_Fragment

export type BookingCreateConsultationSuccessExistingCustomerFragment = {
    __typename: 'BookingCreateConsultationSuccessExistingCustomer'
} & {
    consultation: {
        __typename: 'BookingConsultation'
    } & BookingConsultationFragment
}

export type CreateConsultationNewCustomerMutationVariables = Exact<{
    input: BookingCreateConsultationInput
    customer: CustomerRegistrationInput
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type CreateConsultationNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createConsultationNewCustomer:
        | ({
              __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
          } & BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment)
        | ({
              __typename: 'BookingCreateConsultationSuccessNewCustomer'
          } & BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment)
}

type BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment =
    {
        __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
    } & BookingCreateConsultationErrorNoAvailableConsultantsFragment

type BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment =
    {
        __typename: 'BookingCreateConsultationSuccessNewCustomer'
    } & BookingCreateConsultationSuccessNewCustomerFragment

export type BookingCreateConsultationNewCustomerResponseFragment =
    | BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationErrorNoAvailableConsultants_Fragment
    | BookingCreateConsultationNewCustomerResponse_BookingCreateConsultationSuccessNewCustomer_Fragment

export type BookingCreateConsultationSuccessNewCustomerFragment = {
    __typename: 'BookingCreateConsultationSuccessNewCustomer'
} & {
    customerRegistrationResponse: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
    consultation: {
        __typename: 'BookingConsultation'
    } & BookingConsultationFragment
}

export type CustomerExistsQueryVariables = Exact<{
    email: Scalars['Email']['input']
}>

export type CustomerExistsQuery = { __typename: 'Query' } & Pick<
    Query,
    'customerExists'
>

export type BookingConsultationFragment = {
    __typename: 'BookingConsultation'
} & Pick<
    BookingConsultation,
    'id' | 'description' | 'startsAt' | 'isCancelled' | 'canBeCancelled'
> & {
        purpose: {
            __typename: 'BookingConsultationPurpose'
        } & BookingConsultationPurposeFragment
        method: {
            __typename: 'BookingConsultationMethod'
        } & BookingConsultationMethodFragment
        showroom: { __typename: 'Showroom' } & ShowroomFragment
    }

export type BookingConsultationMethodFragment = {
    __typename: 'BookingConsultationMethod'
} & Pick<BookingConsultationMethod, 'systemCode' | 'name'> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type BookingCreateConsultationErrorNoAvailableConsultantsFragment = {
    __typename: 'BookingCreateConsultationErrorNoAvailableConsultants'
} & Pick<BookingCreateConsultationErrorNoAvailableConsultants, 'message'>

export type BookingOrdersFragment = { __typename: 'Order' } & Pick<Order, 'id'>

export type OrdersQueryVariables = Exact<{ [key: string]: never }>

export type OrdersQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & Pick<User, 'id'> & {
                customer: Maybe<
                    { __typename: 'Customer' } & Pick<Customer, 'id'> & {
                            orders: Array<
                                { __typename: 'Order' } & BookingOrdersFragment
                            >
                        }
                >
            }
    >
}

export type ValidateConsultationInputQueryVariables = Exact<{
    input: BookingCreateConsultationInput
}>

export type ValidateConsultationInputQuery = { __typename: 'Query' } & Pick<
    Query,
    'validateConsultationInput'
>

export type ValidateCustomerRegistrationInputQueryVariables = Exact<{
    input: CustomerRegistrationInput
}>

export type ValidateCustomerRegistrationInputQuery = {
    __typename: 'Query'
} & Pick<Query, 'validateCustomerRegistrationInput'>

export type CartQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type CartQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & {
            customer: Maybe<
                { __typename: 'Customer' } & {
                    cart: { __typename: 'Order' } & OrderFragment
                }
            >
        }
    >
}

export type DesignStudioEngagementRingErrorRootShapeMismatchFragment = {
    __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
} & Pick<DesignStudioEngagementRingErrorShapeMismatch, 'message'>

export type AddToCartJewelleryExistingCustomerMutationVariables = Exact<{
    input: DesignStudioJewelleryInput
}>

export type AddToCartJewelleryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createDesignStudioProductAndAddToCartJewelleryExistingCustomer: {
        __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessExistingCustomer'
    }
}

export type AddToCartJewelleryNewCustomerMutationVariables = Exact<{
    input: DesignStudioJewelleryInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type AddToCartJewelleryNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createDesignStudioProductAndAddToCartJewelleryNewCustomer: {
        __typename: 'CatalogueDesignStudioCheckoutJewellerySuccessNewCustomer'
    } & {
        customer: {
            __typename: 'CustomerRegistrationResponse'
        } & CustomerRegistrationResponseFragment
    }
}

export type OrderByIdQueryVariables = Exact<{
    id: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type OrderByIdQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & {
            customer: Maybe<
                { __typename: 'Customer' } & {
                    order: Maybe<{ __typename: 'Order' } & OrderFragment>
                }
            >
        }
    >
}

export type AddToCartReadyToGoRingNewCustomerResponseFragment = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
} & AddToCartReadyToGoRingSuccessNewCustomerFragment

export type AddToCartReadyToGoRingSuccessNewCustomerFragment = {
    __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type AddToCartReadyToGoRingExistingCustomerMutationVariables = Exact<{
    input: AddToCartReadyToGoRingInput
}>

export type AddToCartReadyToGoRingExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    addToCartReadyToGoRingExistingCustomer: {
        __typename: 'AddToCartReadyToGoRingSuccessExistingCustomer'
    }
}

export type AddToCartReadyToGoRingNewCustomerMutationVariables = Exact<{
    input: AddToCartReadyToGoRingInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type AddToCartReadyToGoRingNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    addToCartReadyToGoRingNewCustomer: {
        __typename: 'AddToCartReadyToGoRingSuccessNewCustomer'
    } & AddToCartReadyToGoRingNewCustomerResponseFragment
}

export type DesignStudioWeddingRingNewCustomerResponseFragment = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
} & DesignStudioWeddingRingSuccessNewCustomerFragment

export type DesignStudioWeddingRingSuccessNewCustomerFragment = {
    __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
} & {
    customer: {
        __typename: 'CustomerRegistrationResponse'
    } & CustomerRegistrationResponseFragment
}

export type CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutationVariables =
    Exact<{
        input: DesignStudioWeddingRingInput
    }>

export type CreateDesignStudioProductAndAddToCartWeddingRingExistingCustomerMutation =
    { __typename: 'Mutation' } & {
        createDesignStudioProductAndAddToCartWeddingRingExistingCustomer: {
            __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessExistingCustomer'
        }
    }

export type CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutationVariables =
    Exact<{
        input: DesignStudioWeddingRingInput
        customer: CustomerRegistrationInput
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateDesignStudioProductAndAddToCartWeddingRingNewCustomerMutation =
    { __typename: 'Mutation' } & {
        createDesignStudioProductAndAddToCartWeddingRingNewCustomer: {
            __typename: 'CatalogueDesignStudioCheckoutWeddingRingSuccessNewCustomer'
        } & DesignStudioWeddingRingNewCustomerResponseFragment
    }

export type AddressFragment = { __typename: 'Address' } & Pick<
    Address,
    'country'
>

type BasePromoCode_MultiUsePromoCode_Fragment = {
    __typename: 'MultiUsePromoCode'
} & Pick<MultiUsePromoCode, 'id' | 'code'>

type BasePromoCode_SingleUsePromoCode_Fragment = {
    __typename: 'SingleUsePromoCode'
} & Pick<SingleUsePromoCode, 'id' | 'code'>

export type BasePromoCodeFragment =
    | BasePromoCode_MultiUsePromoCode_Fragment
    | BasePromoCode_SingleUsePromoCode_Fragment

export type ConsultantFragment = { __typename: 'Consultant' } & Pick<
    Consultant,
    'id' | 'firstName' | 'avatar'
> & { user: { __typename: 'User' } & MeFragment }

export type CustomerFragment = { __typename: 'Customer' } & {
    shippingAddress: Maybe<{ __typename: 'Address' } & AddressFragment>
    billingAddress: Maybe<{ __typename: 'Address' } & AddressFragment>
    cart: { __typename: 'Order' } & OrderFragment
    consultant: Maybe<{ __typename: 'Consultant' } & ConsultantFragment>
    orders: Array<{ __typename: 'Order' } & OrderFragment>
}

export type SetOrderCollectFromShowroomInformationMutationVariables = Exact<{
    input: CollectFromShowroomInput
    locale: Scalars['Locale']['input']
}>

export type SetOrderCollectFromShowroomInformationMutation = {
    __typename: 'Mutation'
} & {
    setOrderCollectFromShowroomInformation:
        | ({
              __typename: 'SetDeliveryInformationFailureResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment)
        | ({
              __typename: 'SetDeliveryInformationSuccessResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment)
}

export type SetOrderDeliverToAddressInformationMutationVariables = Exact<{
    input: DeliverToAddressInput
    locale: Scalars['Locale']['input']
}>

export type SetOrderDeliverToAddressInformationMutation = {
    __typename: 'Mutation'
} & {
    setOrderDeliverToAddressInformation:
        | ({
              __typename: 'SetDeliveryInformationFailureResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment)
        | ({
              __typename: 'SetDeliveryInformationSuccessResponse'
          } & SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment)
}

type SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment =
    {
        __typename: 'SetDeliveryInformationFailureResponse'
    } & SetDeliveryInformationFailureResponseFragment

type SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment =
    {
        __typename: 'SetDeliveryInformationSuccessResponse'
    } & SetDeliveryInformationSuccessResponseFragment

export type SetDeliveryInformationResponseFragment =
    | SetDeliveryInformationResponse_SetDeliveryInformationFailureResponse_Fragment
    | SetDeliveryInformationResponse_SetDeliveryInformationSuccessResponse_Fragment

export type SetDeliveryInformationFailureResponseFragment = {
    __typename: 'SetDeliveryInformationFailureResponse'
} & {
    errors: Array<
        {
            __typename: 'OrderAlreadyCompletedError'
        } & SetDeliveryInformationErrorFragment
    >
}

export type SetDeliveryInformationSuccessResponseFragment = {
    __typename: 'SetDeliveryInformationSuccessResponse'
} & { order: { __typename: 'Order' } & OrderFragment }

export type SetDeliveryInformationErrorFragment = {
    __typename: 'OrderAlreadyCompletedError'
} & Pick<OrderAlreadyCompletedError, 'message'>

export type OrderFragment = { __typename: 'Order' } & Pick<
    Order,
    | 'id'
    | 'placementDate'
    | 'desiredDeliveryDate'
    | 'isAsarEnabled'
    | 'isShippingAddressReadonly'
    | 'isDeliveryConfirmed'
    | 'isCompleted'
    | 'allowedWeekdays'
    | 'disabledDates'
> & {
        products: Array<{ __typename: 'OrderProduct' } & OrderProductFragment>
        paymentPlan: { __typename: 'PaymentPlan' } & PaymentPlanFragment
        subtotalAmount: { __typename: 'Money' } & MoneyFragment
        prediscountSubtotalAmount: { __typename: 'Money' } & MoneyFragment
        prediscountTotalAmount: { __typename: 'Money' } & MoneyFragment
        savedAmount: { __typename: 'Money' } & MoneyFragment
        vatAmount: { __typename: 'Money' } & MoneyFragment
        salesTaxAmount: { __typename: 'Money' } & MoneyFragment
        shippingAmount: { __typename: 'Money' } & MoneyFragment
        totalAmount: { __typename: 'Money' } & MoneyFragment
        paidAmount: { __typename: 'Money' } & MoneyFragment
        transactions: Array<
            | ({
                  __typename: 'AffirmTransaction'
              } & TransactionInterface_AffirmTransaction_Fragment)
            | ({
                  __typename: 'AllocationTransaction'
              } & TransactionInterface_AllocationTransaction_Fragment)
            | ({
                  __typename: 'BankTransaction'
              } & TransactionInterface_BankTransaction_Fragment)
            | ({
                  __typename: 'CheckoutcomTransaction'
              } & TransactionInterface_CheckoutcomTransaction_Fragment)
            | ({
                  __typename: 'KlarnaTransaction'
              } & TransactionInterface_KlarnaTransaction_Fragment)
            | ({
                  __typename: 'LegacyTransaction'
              } & TransactionInterface_LegacyTransaction_Fragment)
            | ({
                  __typename: 'StripeTransaction'
              } & TransactionInterface_StripeTransaction_Fragment)
        >
        basePromoCode: Maybe<
            | ({
                  __typename: 'MultiUsePromoCode'
              } & BasePromoCode_MultiUsePromoCode_Fragment)
            | ({
                  __typename: 'SingleUsePromoCode'
              } & BasePromoCode_SingleUsePromoCode_Fragment)
        >
        paymentMethods: {
            __typename: 'PaymentMethodContainer'
        } & PaymentMethodContainerFragment
        availableShowroomsForCollection: Array<
            { __typename: 'Showroom' } & ShowroomFragment
        >
        shippingAddress: { __typename: 'OrderAddress' } & OrderAddressFragment
        billingAddress: { __typename: 'OrderAddress' } & OrderAddressFragment
        shipmentTrackingInformation: Maybe<
            {
                __typename: 'ShipmentTrackingInformation'
            } & ShipmentTrackingInformationFragment
        >
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        status: { __typename: 'OrderStatus' } & Pick<OrderStatus, 'name'>
    }

export type OrderAddressFragment = { __typename: 'OrderAddress' } & Pick<
    OrderAddress,
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'addressLine1'
    | 'addressLine2'
    | 'city'
    | 'postalCode'
    | 'country'
    | 'subdivision'
    | 'deliveryInstructions'
> & {
        phoneNumber: Maybe<
            { __typename: 'PhoneNumberType' } & Pick<
                PhoneNumberType,
                'countryCode' | 'nationalNumber' | 'e164'
            >
        >
    }

export type OrderProductFragment = { __typename: 'OrderProduct' } & Pick<
    OrderProduct,
    'id' | 'name'
> & {
        image: Maybe<
            { __typename: 'GenericImage' } & {
                size: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                size_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
        >
        prediscountTotalSaleAmount: { __typename: 'Money' } & MoneyFragment
        totalSaleAmount: { __typename: 'Money' } & MoneyFragment
    }

export type AffirmCompleteTransactionResponseFragment = {
    __typename: 'AffirmCompleteTransactionResponse'
} & Pick<AffirmCompleteTransactionResponse, 'errors'> & {
        order: { __typename: 'Order' } & OrderFragment
    }

export type AffirmFinanceOptionsFragment = {
    __typename: 'AffirmFinanceOption'
} & { price: { __typename: 'Money' } & MoneyFragment }

export type AffirmPaymentMethodFragment = {
    __typename: 'AffirmPaymentMethod'
} & Pick<AffirmPaymentMethod, 'systemCode' | 'publicKey' | 'scriptUrl'>

export type AffirmPaymentResponseFragment = {
    __typename: 'AffirmPaymentResponse'
} & Pick<AffirmPaymentResponse, 'errors'> & {
        order: { __typename: 'Order' } & OrderFragment
    }

export type AffirmTransactionFragment = {
    __typename: 'AffirmTransaction'
} & Pick<AffirmTransaction, 'checkoutObject'> &
    TransactionInterface_AffirmTransaction_Fragment

export type AllocationPaymentMethodFragment = {
    __typename: 'AllocationPaymentMethod'
} & Pick<AllocationPaymentMethod, 'systemCode'> & {
        maxAmount: { __typename: 'Money' } & MoneyFragment
    }

export type AllocationTransactionFragment = {
    __typename: 'AllocationTransaction'
} & TransactionInterface_AllocationTransaction_Fragment

export type BankPaymentMethodFragment = {
    __typename: 'BankPaymentMethod'
} & Pick<BankPaymentMethod, 'systemCode'>

export type BankTransactionFragment = {
    __typename: 'BankTransaction'
} & TransactionInterface_BankTransaction_Fragment

export type CheckoutcomPaymentMethodFragment = {
    __typename: 'CheckoutcomPaymentMethod'
} & Pick<CheckoutcomPaymentMethod, 'systemCode' | 'debugMode' | 'publicKey'>

export type LegacyTransactionFragment = {
    __typename: 'LegacyTransaction'
} & Pick<LegacyTransaction, 'paymentMethodName'> &
    TransactionInterface_LegacyTransaction_Fragment

export type NoPaymentMethodFragment = { __typename: 'NoPaymentMethod' } & Pick<
    NoPaymentMethod,
    'systemCode'
>

export type PaymentMethodContainerFragment = {
    __typename: 'PaymentMethodContainer'
} & {
    noPayment: Maybe<
        { __typename: 'NoPaymentMethod' } & NoPaymentMethodFragment
    >
    bankPayment: Maybe<
        { __typename: 'BankPaymentMethod' } & BankPaymentMethodFragment
    >
    allocationPayment: Maybe<
        {
            __typename: 'AllocationPaymentMethod'
        } & AllocationPaymentMethodFragment
    >
    checkoutcomPayment: Maybe<
        {
            __typename: 'CheckoutcomPaymentMethod'
        } & CheckoutcomPaymentMethodFragment
    >
    affirmPayment: Maybe<
        { __typename: 'AffirmPaymentMethod' } & AffirmPaymentMethodFragment
    >
}

export type PaymentPlanFragment = { __typename: 'PaymentPlan' } & {
    paid: Array<
        { __typename: 'PaymentPlanPaidRecord' } & PaymentPlanPaidRecordFragment
    >
    current: Maybe<
        {
            __typename: 'PaymentPlanUpcomingRecord'
        } & PaymentPlanUpcomingRecordFragment
    >
    upcoming: Array<
        {
            __typename: 'PaymentPlanUpcomingRecord'
        } & PaymentPlanUpcomingRecordFragment
    >
}

export type PaymentPlanPaidRecordFragment = {
    __typename: 'PaymentPlanPaidRecord'
} & Pick<PaymentPlanPaidRecord, 'paidOn'> & {
        amount: { __typename: 'Money' } & MoneyFragment
    }

export type PaymentPlanUpcomingRecordFragment = {
    __typename: 'PaymentPlanUpcomingRecord'
} & { amount: { __typename: 'Money' } & MoneyFragment }

type TransactionInterface_AffirmTransaction_Fragment = {
    __typename: 'AffirmTransaction'
} & Pick<AffirmTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_AllocationTransaction_Fragment = {
    __typename: 'AllocationTransaction'
} & Pick<AllocationTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_BankTransaction_Fragment = {
    __typename: 'BankTransaction'
} & Pick<BankTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_CheckoutcomTransaction_Fragment = {
    __typename: 'CheckoutcomTransaction'
} & Pick<CheckoutcomTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_KlarnaTransaction_Fragment = {
    __typename: 'KlarnaTransaction'
} & Pick<KlarnaTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_LegacyTransaction_Fragment = {
    __typename: 'LegacyTransaction'
} & Pick<LegacyTransaction, 'paymentMethodName' | 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

type TransactionInterface_StripeTransaction_Fragment = {
    __typename: 'StripeTransaction'
} & Pick<StripeTransaction, 'id' | 'createdAt'> & {
        amount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'TransactionStatus' } & TransactionStatusFragment
    }

export type TransactionInterfaceFragment =
    | TransactionInterface_AffirmTransaction_Fragment
    | TransactionInterface_AllocationTransaction_Fragment
    | TransactionInterface_BankTransaction_Fragment
    | TransactionInterface_CheckoutcomTransaction_Fragment
    | TransactionInterface_KlarnaTransaction_Fragment
    | TransactionInterface_LegacyTransaction_Fragment
    | TransactionInterface_StripeTransaction_Fragment

export type TransactionStatusFragment = {
    __typename: 'TransactionStatus'
} & Pick<TransactionStatus, 'name'>

export type PromoCodeApplicationResultFragment = {
    __typename: 'PromoCodeApplicationResult'
} & Pick<PromoCodeApplicationResult, 'error'>

export type ShipmentTrackingInformationFragment = {
    __typename: 'ShipmentTrackingInformation'
} & Pick<
    ShipmentTrackingInformation,
    'dispatchedAt' | 'shippingCompany' | 'trackingNumber' | 'trackingUrl'
>

export type ShowroomFragment = { __typename: 'Showroom' } & Pick<
    Showroom,
    'id' | 'isAccessible'
> & {
        location: { __typename: 'ShowroomLocation' } & ShowroomLocationFragment
        translation: { __typename: 'ShowroomTranslation' } & Pick<
            ShowroomTranslation,
            'name'
        >
    }

export type ShowroomLocationFragment = {
    __typename: 'ShowroomLocation'
} & Pick<
    ShowroomLocation,
    | 'postalCode'
    | 'city'
    | 'addressLine1'
    | 'addressLine2'
    | 'country'
    | 'subdivision'
> & {
        geoLocation: Maybe<
            { __typename: 'GeoPoint' } & Pick<
                GeoPoint,
                'id' | 'latitude' | 'longitude'
            >
        >
    }

export type BlogAuthorRouteFragment = { __typename: 'Author' } & Pick<
    Author,
    'slug'
>

export type BlogCategoryRouteFragment = { __typename: 'PostCategory' } & Pick<
    PostCategory,
    'slug'
>

export type BlogTagRouteFragment = { __typename: 'PostTag' } & Pick<
    PostTag,
    'slug'
>

export type PostCategoriesFragment = { __typename: 'Query' } & {
    postCategories: Array<{ __typename: 'PostCategory' } & BlogMenuFragment>
}

export type LinkFragment = { __typename: 'Link' } & Pick<
    Link,
    'text' | 'target'
> & {
        item:
            | ({
                  __typename: 'LinkItemAffirm'
              } & LinkItem_LinkItemAffirm_Fragment)
            | ({
                  __typename: 'LinkItemBookingForm'
              } & LinkItem_LinkItemBookingForm_Fragment)
            | ({
                  __typename: 'LinkItemCustom'
              } & LinkItem_LinkItemCustom_Fragment)
            | ({
                  __typename: 'LinkItemOpenContactForm'
              } & LinkItem_LinkItemOpenContactForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenEnquiryForm'
              } & LinkItem_LinkItemOpenEnquiryForm_Fragment)
            | ({
                  __typename: 'LinkItemOpenIntercom'
              } & LinkItem_LinkItemOpenIntercom_Fragment)
            | ({
                  __typename: 'LinkItemOpenSpeakToExpertModal'
              } & LinkItem_LinkItemOpenSpeakToExpertModal_Fragment)
            | ({ __typename: 'Page' } & LinkItem_Page_Fragment)
            | ({ __typename: 'Post' } & LinkItem_Post_Fragment)
            | ({
                  __typename: 'Questionnaire'
              } & LinkItem_Questionnaire_Fragment)
    }

type LinkItem_LinkItemAffirm_Fragment = { __typename: 'LinkItemAffirm' }

type LinkItem_LinkItemBookingForm_Fragment = {
    __typename: 'LinkItemBookingForm'
}

type LinkItem_LinkItemCustom_Fragment = {
    __typename: 'LinkItemCustom'
} & CustomLinkFragment

type LinkItem_LinkItemOpenContactForm_Fragment = {
    __typename: 'LinkItemOpenContactForm'
}

type LinkItem_LinkItemOpenEnquiryForm_Fragment = {
    __typename: 'LinkItemOpenEnquiryForm'
} & LinkItemOpenEnquiryFormFragment

type LinkItem_LinkItemOpenIntercom_Fragment = {
    __typename: 'LinkItemOpenIntercom'
}

type LinkItem_LinkItemOpenSpeakToExpertModal_Fragment = {
    __typename: 'LinkItemOpenSpeakToExpertModal'
}

type LinkItem_Page_Fragment = { __typename: 'Page' } & PageLinkFragment

type LinkItem_Post_Fragment = { __typename: 'Post' } & PostLinkFragment

type LinkItem_Questionnaire_Fragment = {
    __typename: 'Questionnaire'
} & LinkQuestionnaireFragment

export type LinkItemFragment =
    | LinkItem_LinkItemAffirm_Fragment
    | LinkItem_LinkItemBookingForm_Fragment
    | LinkItem_LinkItemCustom_Fragment
    | LinkItem_LinkItemOpenContactForm_Fragment
    | LinkItem_LinkItemOpenEnquiryForm_Fragment
    | LinkItem_LinkItemOpenIntercom_Fragment
    | LinkItem_LinkItemOpenSpeakToExpertModal_Fragment
    | LinkItem_Page_Fragment
    | LinkItem_Post_Fragment
    | LinkItem_Questionnaire_Fragment

export type PageLinkFragment = { __typename: 'Page' } & Pick<
    Page,
    'id' | 'path'
>

export type PostLinkFragment = { __typename: 'Post' } & Pick<
    Post,
    'id' | 'slug'
>

export type CustomLinkFragment = { __typename: 'LinkItemCustom' } & Pick<
    LinkItemCustom,
    'url'
>

export type LinkQuestionnaireFragment = { __typename: 'Questionnaire' } & Pick<
    Questionnaire,
    'id'
>

export type LinkItemOpenEnquiryFormFragment = {
    __typename: 'LinkItemOpenEnquiryForm'
} & Pick<LinkItemOpenEnquiryForm, 'enquiryType'>

type LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment = {
    __typename: 'DesignStudioProductAdditionalResize'
} & Pick<DesignStudioProductAdditionalResize, 'id'>

type LinkDesignStudioProduct_DesignStudioProductCustom_Fragment = {
    __typename: 'DesignStudioProductCustom'
} & Pick<DesignStudioProductCustom, 'id'>

type LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment = {
    __typename: 'DesignStudioProductEngagementRing'
} & Pick<DesignStudioProductEngagementRing, 'id'>

type LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment = {
    __typename: 'DesignStudioProductGeneric'
} & Pick<DesignStudioProductGeneric, 'id'>

type LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment = {
    __typename: 'DesignStudioProductLooseStone'
} & Pick<DesignStudioProductLooseStone, 'id'>

type LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment = {
    __typename: 'DesignStudioProductWeddingRing'
} & Pick<DesignStudioProductWeddingRing, 'id'>

export type LinkDesignStudioProductFragment =
    | LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment
    | LinkDesignStudioProduct_DesignStudioProductCustom_Fragment
    | LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment
    | LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment
    | LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment
    | LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment

export type LinkOrderFragment = { __typename: 'Order' } & Pick<Order, 'id'>

export type PageFragment = { __typename: 'Page' } & Pick<
    Page,
    'id' | 'title' | 'path'
> & {
        blocks: Array<{ __typename: 'Block' } & BlockFragment>
        meta: { __typename: 'Meta' } & MetaFragment
        pageSettings: { __typename: 'PageSettings' } & Pick<
            PageSettings,
            'showRingBuilder'
        >
    }

export type PageByPathQueryVariables = Exact<{
    path: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type PageByPathQuery = { __typename: 'Query' } & {
    pageByPath: Maybe<{ __typename: 'Page' } & PageFragment>
}

export type ProductPageListingFragment = {
    __typename: 'ProductPageListing'
} & Pick<ProductPageListing, 'id'> & {
        beforeFilters: Array<{ __typename: 'Block' } & BlockFragment>
        afterGrid: Array<{ __typename: 'Block' } & BlockFragment>
        banner1: Maybe<{ __typename: 'Banner1' } & Banner1Fragment>
        banner2: Maybe<{ __typename: 'Banner2' } & Banner2Fragment>
        meta: { __typename: 'Meta' } & MetaFragment
    }

export type TooltipQueryVariables = Exact<{
    path: Scalars['String']['input']
    locale: Scalars['Locale']['input']
}>

export type TooltipQuery = { __typename: 'Query' } & {
    tooltip: Maybe<
        { __typename: 'Tooltip' } & Pick<Tooltip, 'title'> & {
                content: Array<
                    | ({
                          __typename: 'ComponentButton'
                      } & ContentComponentItem_ComponentButton_Fragment)
                    | ({
                          __typename: 'ComponentImage'
                      } & ContentComponentItem_ComponentImage_Fragment)
                    | ({
                          __typename: 'ComponentOrderedList'
                      } & ContentComponentItem_ComponentOrderedList_Fragment)
                    | ({
                          __typename: 'ComponentSpacer'
                      } & ContentComponentItem_ComponentSpacer_Fragment)
                    | ({
                          __typename: 'ComponentText'
                      } & ContentComponentItem_ComponentText_Fragment)
                    | ({
                          __typename: 'ComponentTitle'
                      } & ContentComponentItem_ComponentTitle_Fragment)
                >
            }
    >
}

export type AssetFragment = { __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>

export type Banner1Fragment = { __typename: 'Banner1' } & Pick<
    Banner1,
    'backgroundColor' | 'preTitle' | 'title' | 'text'
> & {
        backgroundImage: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
        button: Maybe<
            { __typename: 'ComponentButton' } & ComponentButtonFragment
        >
    }

export type Banner2Fragment = { __typename: 'Banner2' } & Pick<
    Banner2,
    'backgroundColor' | 'preTitle' | 'title' | 'text'
> & {
        button: Maybe<
            { __typename: 'ComponentButton' } & ComponentButtonFragment
        >
        image: Maybe<{ __typename: 'Image' } & ImageMediumFragment>
    }

export type CostumerConsultantFragment = { __typename: 'Consultant' } & Pick<
    Consultant,
    'id' | 'firstName'
> & {
        avatarImage: { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        user: { __typename: 'User' } & Pick<User, 'id' | 'email'>
    }

export type MeFragment = { __typename: 'User' } & Pick<
    User,
    'id' | 'firstName' | 'lastName' | 'email' | 'isConsultant' | 'createdAt'
> & {
        customer: Maybe<
            { __typename: 'Customer' } & MakeMaybe<
                Pick<
                    Customer,
                    | 'id'
                    | 'disabledThirdPartyCookies'
                    | 'adminProfileUrl'
                    | 'salesforceProfileUrl'
                >,
                'adminProfileUrl' | 'salesforceProfileUrl'
            > & {
                    billingAddress: Maybe<
                        { __typename: 'Address' } & {
                            phoneNumber: Maybe<
                                { __typename: 'PhoneNumberType' } & Pick<
                                    PhoneNumberType,
                                    'e164' | 'nationalNumber' | 'countryCode'
                                >
                            >
                        }
                    >
                    consultant: Maybe<
                        {
                            __typename: 'Consultant'
                        } & CostumerConsultantFragment
                    >
                }
        >
    }

export type MetaFragment = { __typename: 'Meta' } & Pick<
    Meta,
    'title' | 'description'
> & { image: Maybe<{ __typename: 'Image' } & ImageLargeFragment> }

export type MoneyFragment = { __typename: 'Money' } & Pick<
    Money,
    'amount' | 'currency'
>

export type PaymentIconFragment = { __typename: 'PaymentIcon' } & Pick<
    PaymentIcon,
    'name'
> & { icon: { __typename: 'Image' } & ImageLargeFragment }

export type SocialNetworkFragment = { __typename: 'SocialNetwork' } & Pick<
    SocialNetwork,
    'name' | 'icon' | 'link'
>

export type TranslationFragment = { __typename: 'Translation' } & Pick<
    Translation,
    'translation' | 'token'
>

export type MagicLinkConsumeMutationVariables = Exact<{
    input: MagicLinkConsume
    isConsultant: Scalars['Boolean']['input']
}>

export type MagicLinkConsumeMutation = { __typename: 'Mutation' } & {
    magicLinkConsume:
        | ({ __typename: 'MagicLinkConsumeError' } & Pick<
              MagicLinkConsumeError,
              'message'
          >)
        | ({ __typename: 'MagicLinkConsumeSuccess' } & {
              login: {
                  __typename: 'LoginResponseSuccess'
              } & LoginResponseSuccessFragment
          })
}

export type MagicLinkRequestMutationVariables = Exact<{
    input: MagicLinkRequest
}>

export type MagicLinkRequestMutation = { __typename: 'Mutation' } & Pick<
    Mutation,
    'magicLinkRequest'
>

export type ApplyPromoCodeMutationVariables = Exact<{
    promoCode: Scalars['String']['input']
}>

export type ApplyPromoCodeMutation = { __typename: 'Mutation' } & {
    applyPromoCode: Maybe<
        {
            __typename: 'PromoCodeApplicationResult'
        } & PromoCodeApplicationResultFragment
    >
}

export type CompleteAffirmTransactionPostIframeMutationVariables = Exact<{
    input: AffirmCompleteTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CompleteAffirmTransactionPostIframeMutation = {
    __typename: 'Mutation'
} & {
    completeAffirmTransactionPostIframe: {
        __typename: 'AffirmCompleteTransactionResponse'
    } & AffirmCompleteTransactionResponseFragment
}

export type CreateAffirmTransactionMutationVariables = Exact<{
    input: AffirmTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateAffirmTransactionMutation = { __typename: 'Mutation' } & {
    createAffirmTransaction: {
        __typename: 'AffirmTransaction'
    } & AffirmTransactionFragment
}

export type PayViaAffirmMutationVariables = Exact<{
    input: AffirmPaymentInput
    locale: Scalars['Locale']['input']
}>

export type PayViaAffirmMutation = { __typename: 'Mutation' } & {
    payViaAffirm: {
        __typename: 'AffirmPaymentResponse'
    } & AffirmPaymentResponseFragment
}

export type CreateAllocationTransactionMutationVariables = Exact<{
    input: AllocationTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateAllocationTransactionMutation = { __typename: 'Mutation' } & {
    createAllocationTransaction: {
        __typename: 'AllocationTransaction'
    } & AllocationTransactionFragment
}

export type PayViaAllocationMutationVariables = Exact<{
    allocationTransactionId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaAllocationMutation = { __typename: 'Mutation' } & {
    payViaAllocation: { __typename: 'Order' } & OrderFragment
}

export type CreateBankTransactionMutationVariables = Exact<{
    orderId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type CreateBankTransactionMutation = { __typename: 'Mutation' } & {
    createBankTransaction: {
        __typename: 'BankTransaction'
    } & BankTransactionFragment
}

export type PayViaBankMutationVariables = Exact<{
    bankTransactionId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaBankMutation = { __typename: 'Mutation' } & {
    payViaBank: { __typename: 'Order' } & OrderFragment
}

export type CompleteCheckoutcomTransactionPost3dsMutationVariables = Exact<{
    input: CompleteCheckoutcomTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CompleteCheckoutcomTransactionPost3dsMutation = {
    __typename: 'Mutation'
} & {
    completeCheckoutcomTransactionPost3ds:
        | ({
              __typename: 'CompleteCheckoutcomTransactionPost3dsFailureResponse'
          } & {
              errors: Array<
                  | { __typename: 'CheckoutcomOperationDeclinedError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'PaymentAmountInvalidError' }
              >
          })
        | ({
              __typename: 'CompleteCheckoutcomTransactionPost3dsSuccessResponse'
          } & { order: { __typename: 'Order' } & OrderFragment })
}

export type CreateCheckoutcomTransactionMutationVariables = Exact<{
    input: CreateCheckoutcomTransactionInput
    locale: Scalars['Locale']['input']
}>

export type CreateCheckoutcomTransactionMutation = {
    __typename: 'Mutation'
} & {
    createCheckoutcomTransaction:
        | ({ __typename: 'CreateCheckoutcomTransactionFailureResponse' } & {
              errors: Array<
                  | { __typename: 'AvataxAddressInvalidError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAddressNotConfirmedError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'OrderEmptyError' }
                  | { __typename: 'PaymentAmountInvalidError' }
                  | { __typename: 'PaymentMethodNotAllowedError' }
              >
          })
        | ({ __typename: 'CreateCheckoutcomTransactionSuccessResponse' } & {
              transaction: {
                  __typename: 'CheckoutcomTransaction'
              } & TransactionInterface_CheckoutcomTransaction_Fragment
          })
}

export type PayViaCheckoutcomMutationVariables = Exact<{
    input: PayViaCheckoutcomInput
    locale: Scalars['Locale']['input']
}>

export type PayViaCheckoutcomMutation = { __typename: 'Mutation' } & {
    payViaCheckoutcom:
        | ({ __typename: 'PayViaCheckoutcomFailureResponse' } & {
              errors: Array<
                  | { __typename: 'CheckoutcomOperationDeclinedError' }
                  | { __typename: 'DesiredDeliveryDateInvalidError' }
                  | { __typename: 'OrderAlreadyCompletedError' }
                  | { __typename: 'PaymentAmountInvalidError' }
              >
          })
        | ({ __typename: 'PayViaCheckoutcomSuccessResponse' } & Pick<
              PayViaCheckoutcomSuccessResponse,
              'redirectUrl'
          > & { order: { __typename: 'Order' } & OrderFragment })
}

export type PayViaNoPaymentMutationVariables = Exact<{
    orderId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type PayViaNoPaymentMutation = { __typename: 'Mutation' } & {
    payViaNoPayment: { __typename: 'Order' } & OrderFragment
}

export type RemoveFromMyCartMutationVariables = Exact<{
    productId: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
}>

export type RemoveFromMyCartMutation = { __typename: 'Mutation' } & {
    removeFromMyCart: { __typename: 'Order' } & OrderFragment
}

export type CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutationVariables =
    Exact<{
        input: CustomerRegistrationInput
        type: QuestionnaireType
        isConsultant: Scalars['Boolean']['input']
        locale: Scalars['Locale']['input']
    }>

export type CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutation = {
    __typename: 'Mutation'
} & {
    createCustomerThroughQuestionnaireWithoutQuestionnaire: {
        __typename: 'CustomerRegistrationResponse'
    } & {
        login: Maybe<
            {
                __typename: 'LoginResponseSuccess'
            } & LoginResponse_LoginResponseSuccess_Fragment
        >
    }
}

export type DesignStudioUploadMutationVariables = Exact<{
    file: Scalars['Upload']['input']
}>

export type DesignStudioUploadMutation = { __typename: 'Mutation' } & {
    createDesignInspiration: { __typename: 'DesignInspiration' } & Pick<
        DesignInspiration,
        'id' | 'url'
    >
}

export type QuestionnaireCompleteExistingCustomerMutationVariables = Exact<{
    input: QuestionnaireCompleteInput
}>

export type QuestionnaireCompleteExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    questionnaireCompleteExistingCustomer: {
        __typename: 'QuestionnaireCompletedExistingCustomerResponse'
    }
}

export type QuestionnaireCompleteNewCustomerMutationVariables = Exact<{
    input: QuestionnaireCompleteInput
    customer: CustomerRegistrationInput
    isConsultant: Scalars['Boolean']['input']
}>

export type QuestionnaireCompleteNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    questionnaireCompleteNewCustomer: {
        __typename: 'QuestionnaireCompletedNewCustomerResponse'
    } & {
        customer: {
            __typename: 'CustomerRegistrationResponse'
        } & CustomerRegistrationResponseFragment
    }
}

export type RingBuilderResolveExistingCustomerMutationVariables = Exact<{
    input: RingBuilderResolveInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
}>

export type RingBuilderResolveExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    ringBuilderResolveExistingCustomer:
        | ({ __typename: 'RingBuilderResolvedExistingCustomerSuccess' } & Pick<
              RingBuilderResolvedExistingCustomerSuccess,
              'redirect'
          > & { ringBuilder: { __typename: 'RingBuilder' } & RbFragment })
        | ({ __typename: 'RingBuilderResolvedFailure' } & Pick<
              RingBuilderResolvedFailure,
              'errors'
          >)
}

export type RingBuilderResolveNewCustomerMutationVariables = Exact<{
    input: RingBuilderResolveInput
    customer: CustomerRegistrationInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    isConsultant: Scalars['Boolean']['input']
}>

export type RingBuilderResolveNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    ringBuilderResolveNewCustomer:
        | ({ __typename: 'RingBuilderResolvedFailure' } & Pick<
              RingBuilderResolvedFailure,
              'errors'
          >)
        | ({ __typename: 'RingBuilderResolvedNewCustomerSuccess' } & Pick<
              RingBuilderResolvedNewCustomerSuccess,
              'redirect'
          > & {
                  customer: {
                      __typename: 'CustomerRegistrationResponse'
                  } & CustomerRegistrationResponseFragment
                  ringBuilder: { __typename: 'RingBuilder' } & RbFragment
              })
}

export type RingBuilderSetMutationVariables = Exact<{
    input: RingBuilderInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
}>

export type RingBuilderSetMutation = { __typename: 'Mutation' } & {
    ringBuilderSet: { __typename: 'RingBuilderSetResult' } & {
        ringBuilder: { __typename: 'RingBuilder' } & RbFragment
    }
}

type CatalogueProduct_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueEngagementRing'
            } & RelatedProduct_CatalogueEngagementRing_Fragment
        >
    } & MetalVariation_CatalogueEngagementRing_Fragment

type CatalogueProduct_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryBracelet'
            } & RelatedProduct_CatalogueJewelleryBracelet_Fragment
        >
    } & MetalVariation_CatalogueJewelleryBracelet_Fragment

type CatalogueProduct_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryEarrings'
            } & RelatedProduct_CatalogueJewelleryEarrings_Fragment
        >
    } & MetalVariation_CatalogueJewelleryEarrings_Fragment

type CatalogueProduct_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryNecklace'
            } & RelatedProduct_CatalogueJewelleryNecklace_Fragment
        >
    } & MetalVariation_CatalogueJewelleryNecklace_Fragment

type CatalogueProduct_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueJewelleryRing'
            } & RelatedProduct_CatalogueJewelleryRing_Fragment
        >
    } & MetalVariation_CatalogueJewelleryRing_Fragment

type CatalogueProduct_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueReadyToGoRing'
            } & RelatedProduct_CatalogueReadyToGoRing_Fragment
        >
    } & MetalVariation_CatalogueReadyToGoRing_Fragment

type CatalogueProduct_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
    | 'customTitleTag'
    | 'supportsExpress'
> & {
        relatedProducts: Array<
            {
                __typename: 'CatalogueWeddingRing'
            } & RelatedProduct_CatalogueWeddingRing_Fragment
        >
    } & MetalVariation_CatalogueWeddingRing_Fragment

export type CatalogueProductFragment =
    | CatalogueProduct_CatalogueEngagementRing_Fragment
    | CatalogueProduct_CatalogueJewelleryBracelet_Fragment
    | CatalogueProduct_CatalogueJewelleryEarrings_Fragment
    | CatalogueProduct_CatalogueJewelleryNecklace_Fragment
    | CatalogueProduct_CatalogueJewelleryRing_Fragment
    | CatalogueProduct_CatalogueReadyToGoRing_Fragment
    | CatalogueProduct_CatalogueWeddingRing_Fragment

export type CatalogueVideoFragment = { __typename: 'CatalogueVideo' } & Pick<
    CatalogueVideo,
    'uri' | 'type'
>

export type ProductPageFacetedContentFragment = {
    __typename: 'ProductPageFacetedContent'
} & Pick<
    ProductPageFacetedContent,
    'title' | 'contentTitle' | 'description' | 'productString'
> & {
        longDescription: Maybe<
            | ({
                  __typename: 'ProductPageFacetedContentLongDescriptionBlock'
              } & ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment)
            | ({
                  __typename: 'ProductPageFacetedContentLongDescriptionText'
              } & ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment)
        >
        meta: { __typename: 'Meta' } & MetaFragment
    }

type ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment =
    { __typename: 'ProductPageFacetedContentLongDescriptionBlock' } & {
        blocks: Array<{ __typename: 'Block' } & BlockFragment>
    }

type ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment =
    { __typename: 'ProductPageFacetedContentLongDescriptionText' } & Pick<
        ProductPageFacetedContentLongDescriptionText,
        'text'
    >

export type ProductPageFacetedContentLongDescriptionFragment =
    | ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionBlock_Fragment
    | ProductPageFacetedContentLongDescription_ProductPageFacetedContentLongDescriptionText_Fragment

export type ProductPageFacetedContentLongDescriptionBlockFragment = {
    __typename: 'ProductPageFacetedContentLongDescriptionBlock'
} & { blocks: Array<{ __typename: 'Block' } & BlockFragment> }

export type CreateEnquiryCustomEngagementRingExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryCustomEngagementRing
    }>

export type CreateEnquiryCustomEngagementRingExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryCustomEngagementRingExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateEnquiryCustomEngagementRingNewCustomerMutationVariables =
    Exact<{
        input: EnquiryCustomEngagementRing
        customer: CustomerRegistrationInput
        locale: Scalars['Locale']['input']
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateEnquiryCustomEngagementRingNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryCustomEngagementRingNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type EngagementRingFiltersFragment = {
    __typename: 'CatalogueEngagementRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    ringStyles: Array<
        {
            __typename: 'CatalogueFilterEngagementRingStylesItem'
        } & FilterEngagementRingStyleFragment
    >
    designFeatures: Array<
        {
            __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
        } & FilterEngagementRingDesignFeatureFragment
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
        } & FilterEngagementRingDesignStyleFragment
    >
    centreStoneShapes: Array<
        { __typename: 'CatalogueFilterShapeItem' } & FilterShapeFragment
    >
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type FilterShapeFragment = {
    __typename: 'CatalogueFilterShapeItem'
} & Pick<CatalogueFilterShapeItem, 'totalResults'> & {
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type SignatureStoneInputFragment = {
    __typename: 'CatalogueEngagementRingSignatureStone'
} & Pick<CatalogueEngagementRingSignatureStone, 'width'> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        >
    }

export type CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryEngagementRingCollectionInput
    }>

export type CreateShapeEnquiryEngagementRingCollectionExistingCustomerMutation =
    { __typename: 'Mutation' } & {
        createEnquiryEngagementRingPreferAnotherShapeExistingCustomer: {
            __typename: 'EnquiryResponseExistingCustomer'
        }
    }

export type CreateShapeEnquiryEngagementRingCollectionNewCustomerMutationVariables =
    Exact<{
        input: EnquiryEngagementRingCollectionInput
        customer: CustomerRegistrationInput
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateShapeEnquiryEngagementRingCollectionNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryEngagementRingPreferAnotherShapeNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type FilterEngagementRingDesignFeatureFragment = {
    __typename: 'CatalogueFilterEngagementRingDesignFeatureItem'
} & Pick<CatalogueFilterEngagementRingDesignFeatureItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingDesignFeatureLabel' } & Pick<
            EngagementRingDesignFeatureLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterEngagementRingDesignStyleFragment = {
    __typename: 'CatalogueFilterEngagementRingDesingStyleItem'
} & Pick<CatalogueFilterEngagementRingDesingStyleItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingDesignStyleLabel' } & Pick<
            EngagementRingDesignStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterEngagementRingStyleFragment = {
    __typename: 'CatalogueFilterEngagementRingStylesItem'
} & Pick<CatalogueFilterEngagementRingStylesItem, 'totalResults'> & {
        label: { __typename: 'EngagementRingStyleLabel' } & Pick<
            EngagementRingStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterPriceRangeFragment = {
    __typename: 'CataloguePriceRangeFilter'
} & {
    currentRange: { __typename: 'CataloguePriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
}

export type FilterWeddingRingCategoryFragment = {
    __typename: 'CatalogueFilterWeddingRingCategoriesItem'
} & Pick<CatalogueFilterWeddingRingCategoriesItem, 'totalResults'> & {
        label: { __typename: 'WeddingRingCategoryLabel' } & Pick<
            WeddingRingCategoryLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type FilterWeddingRingStyleFragment = {
    __typename: 'CatalogueFilterWeddingRingStylesItem'
} & Pick<CatalogueFilterWeddingRingStylesItem, 'totalResults'> & {
        label: { __typename: 'WeddingRingStyleLabel' } & Pick<
            WeddingRingStyleLabel,
            'systemCode'
        > & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                > &
                    FacetedContentProductLabelTranslationFragment
                icon: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>>
            }
    }

export type MetalFilterFragment = {
    __typename: 'CatalogueFilterMetalItem'
} & Pick<CatalogueFilterMetalItem, 'totalResults'> & {
        metal: { __typename: 'Metal' } & MetalFilterMetalFragment
    }

export type MetalFilterMetalFragment = { __typename: 'Metal' } & Pick<
    Metal,
    'systemCode' | 'karat'
> & {
        translation: { __typename: 'MetalTranslation' } & Pick<
            MetalTranslation,
            'name'
        >
        color: Maybe<
            { __typename: 'MetalColor' } & Pick<MetalColor, 'systemCode'> & {
                    translation: { __typename: 'MetalColorTranslation' } & Pick<
                        MetalColorTranslation,
                        'name'
                    >
                }
        >
        element: { __typename: 'MetalElement' } & Pick<
            MetalElement,
            'systemCode'
        > & {
                translation: { __typename: 'MetalElementTranslation' } & Pick<
                    MetalElementTranslation,
                    'name'
                >
            }
    }

export type RecommendedRingSizeFragment = {
    __typename: 'RecommendedRingSize'
} & Pick<RecommendedRingSize, 'id' | 'label'> & {
        ringSize: { __typename: 'RingSize' } & RingSizeFragment
    }

export type RingSizeFragment = { __typename: 'RingSize' } & Pick<
    RingSize,
    'id'
> & { ringSizeLabel: RingSize['label'] }

type Jewellery_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<
            CatalogueJewelleryBraceletTranslation,
            'description' | 'seoText'
        >
        braceletProductStyles: Array<
            {
                __typename: 'JewelleryBraceletProductStyleLabel'
            } & JewelleryBraceletProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryBracelet'
            } & MetalVariation_CatalogueJewelleryBracelet_Fragment &
                JewelleryLink_CatalogueJewelleryBracelet_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryBracelet_Fragment &
    ProductGallery_CatalogueJewelleryBracelet_Fragment &
    ProductAnalytics_CatalogueJewelleryBracelet_Fragment &
    ProductPageMeta_CatalogueJewelleryBracelet_Fragment

type Jewellery_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<
            CatalogueJewelleryEarringsTranslation,
            'description' | 'seoText'
        >
        earringsProductStyles: Array<
            {
                __typename: 'JewelleryEarringsProductStyleLabel'
            } & JewelleryEarringsProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryEarrings'
            } & MetalVariation_CatalogueJewelleryEarrings_Fragment &
                JewelleryLink_CatalogueJewelleryEarrings_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryEarrings_Fragment &
    ProductGallery_CatalogueJewelleryEarrings_Fragment &
    ProductAnalytics_CatalogueJewelleryEarrings_Fragment &
    ProductPageMeta_CatalogueJewelleryEarrings_Fragment

type Jewellery_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'engravingDisabled'> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<
            CatalogueJewelleryNecklaceTranslation,
            'description' | 'seoText'
        >
        necklaceProductStyles: Array<
            {
                __typename: 'JewelleryNecklaceProductStyleLabel'
            } & JewelleryNecklaceProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryNecklace'
            } & MetalVariation_CatalogueJewelleryNecklace_Fragment &
                JewelleryLink_CatalogueJewelleryNecklace_Fragment
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryNecklace_Fragment &
    ProductGallery_CatalogueJewelleryNecklace_Fragment &
    ProductAnalytics_CatalogueJewelleryNecklace_Fragment &
    ProductPageMeta_CatalogueJewelleryNecklace_Fragment

type Jewellery_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'engravingDisabled'> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description' | 'seoText'
        >
        jewelleryRingProductStyles: Array<
            {
                __typename: 'JewelleryRingProductStyleLabel'
            } & JewelleryRingProductStyleLabelFragment
        >
        firstAvailableDeliveryDateHasEngraving: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        firstAvailableDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        variations: Array<
            {
                __typename: 'CatalogueJewelleryRing'
            } & MetalVariation_CatalogueJewelleryRing_Fragment &
                JewelleryLink_CatalogueJewelleryRing_Fragment
        >
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
        designStyles: Array<
            {
                __typename: 'JewelleryDesignStyleLabel'
            } & JewelleryDesignStyleLabelFragment
        >
        gemstones: Array<
            { __typename: 'JewelleryGemstoneLabel' } & Pick<
                JewelleryGemstoneLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
    } & CatalogueProduct_CatalogueJewelleryRing_Fragment &
    ProductGallery_CatalogueJewelleryRing_Fragment &
    ProductAnalytics_CatalogueJewelleryRing_Fragment &
    ProductPageMeta_CatalogueJewelleryRing_Fragment

export type JewelleryFragment =
    | Jewellery_CatalogueJewelleryBracelet_Fragment
    | Jewellery_CatalogueJewelleryEarrings_Fragment
    | Jewellery_CatalogueJewelleryNecklace_Fragment
    | Jewellery_CatalogueJewelleryRing_Fragment

export type CatalogueReadyToGoRingTranslationFragment = {
    __typename: 'CatalogueReadyToGoRingTranslation'
} & Pick<CatalogueReadyToGoRingTranslation, 'description' | 'seoText'>

export type ReadyToGoRingFiltersFragment = {
    __typename: 'CatalogueReadyToGoRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type ReadyToGoRingVariationsFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'gemType' | 'carat'> &
    ReadyToGoRingLinkFragment

export type WeddingRingFiltersFragment = {
    __typename: 'CatalogueWeddingRingFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    ringStyles: Array<
        {
            __typename: 'CatalogueFilterWeddingRingStylesItem'
        } & FilterWeddingRingStyleFragment
    >
    categories: Array<
        {
            __typename: 'CatalogueFilterWeddingRingCategoriesItem'
        } & FilterWeddingRingCategoryFragment
    >
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
}

export type CreateDiamondSearchProductEnquiryExistingCustomerMutationVariables =
    Exact<{
        input: EnquiryDiamondSearchProduct
    }>

export type CreateDiamondSearchProductEnquiryExistingCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryDiamondSearchProductExistingCustomer: {
        __typename: 'EnquiryResponseExistingCustomer'
    }
}

export type CreateDiamondSearchProductEnquiryNewCustomerMutationVariables =
    Exact<{
        input: EnquiryDiamondSearchProduct
        customer: CustomerRegistrationInput
        isConsultant: Scalars['Boolean']['input']
    }>

export type CreateDiamondSearchProductEnquiryNewCustomerMutation = {
    __typename: 'Mutation'
} & {
    createEnquiryDiamondSearchProductNewCustomer: {
        __typename: 'EnquiryResponseNewCustomer'
    } & EnquiryResponseNewCustomerFragment
}

export type QuestionnaireQueryVariables = Exact<{
    id: Scalars['ID']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type QuestionnaireQuery = { __typename: 'Query' } & {
    questionnaire: Maybe<
        { __typename: 'Questionnaire' } & QuestionnaireFragment
    >
}

export type CatalogueEngagementRingInputFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'slug' | 'suffixSlug'> & {
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type RbFragment = { __typename: 'RingBuilder' } & Pick<
    RingBuilder,
    'id' | 'productId' | 'errors'
> & {
        position1: Maybe<
            | ({
                  __typename: 'RingBuilderCentreStoneFragment'
              } & RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment)
            | ({
                  __typename: 'RingBuilderMountFragment'
              } & RingBuilderFragment_RingBuilderMountFragment_Fragment)
        >
        position2: Maybe<
            | ({
                  __typename: 'RingBuilderCentreStoneFragment'
              } & RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment)
            | ({
                  __typename: 'RingBuilderMountFragment'
              } & RingBuilderFragment_RingBuilderMountFragment_Fragment)
        >
        image: Maybe<
            { __typename: 'GenericImage' } & {
                small_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                large_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
        >
        salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
        financeOptionsAffirm: Maybe<
            { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
        >
        failure: Maybe<
            { __typename: 'DesignStudioEngagementRingFailure' } & {
                errors: Array<
                    | { __typename: 'DesignStudioEngagementRingErrorGeneric' }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorMaxCaratWeight'
                      }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorMinCaratWeight'
                      }
                    | {
                          __typename: 'DesignStudioEngagementRingErrorShapeMismatch'
                      }
                >
            }
        >
    }

type RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & RingBuilderCentreStoneFragmentFragment

type RingBuilderFragment_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
} & RingBuilderMountFragmentFragment

export type RingBuilderFragmentFragment =
    | RingBuilderFragment_RingBuilderCentreStoneFragment_Fragment
    | RingBuilderFragment_RingBuilderMountFragment_Fragment

export type RingBuilderMountFragmentFragment = {
    __typename: 'RingBuilderMountFragment'
} & Pick<RingBuilderMountFragment, 'id'> & {
        ring: { __typename: 'CatalogueEngagementRing' } & {
            variationsByCentreStoneShape: Array<
                { __typename: 'CatalogueEngagementRing' } & {
                    centreStoneConstraints: {
                        __typename: 'CatalogueEngagementRingCentreStoneConstraints'
                    } & {
                        shape: { __typename: 'StoneShape' } & Pick<
                            StoneShape,
                            'systemCode'
                        >
                    }
                } & CatalogueEngagementRingInputFragment
            >
        } & RingBuilderMountEngagementRingFragment &
            EngagementRingLinkFragment &
            ProductPageMeta_CatalogueEngagementRing_Fragment
        signatureStone: {
            __typename: 'CatalogueEngagementRingSignatureStone'
        } & Pick<
            CatalogueEngagementRingSignatureStone,
            'image' | 'segmentName'
        > & {
                crystal: { __typename: 'StoneCrystal' } & {
                    translation: {
                        __typename: 'StoneCrystalTranslation'
                    } & Pick<StoneCrystalTranslation, 'name'>
                }
                color: { __typename: 'StoneColor' } & {
                    translation: { __typename: 'StoneColorTranslation' } & Pick<
                        StoneColorTranslation,
                        'name'
                    >
                }
            } & SignatureStoneInputFragment
        totalSalePrice: { __typename: 'Money' } & MoneyFragment
    }

export type RingBuilderCentreStoneFragmentFragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & Pick<RingBuilderCentreStoneFragment, 'id'> & {
        stone: Maybe<
            | ({ __typename: 'GemsApiStone' } & {
                  stone: Maybe<
                      { __typename: 'GemsApi_Stone' } & StoneFragment &
                          GemsApiStoneAnalyticsFragment &
                          GemsApiCertificateFragment
                  >
              })
            | ({ __typename: 'NonSkuGemstone' } & NonSkuGemstoneFragment &
                  NonSkuGemstoneAnalyticsFragment)
            | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment &
                  NonSkuLabGrownAnalyticsFragment)
        >
        totalSalePrice: { __typename: 'Money' } & MoneyFragment
    }

export type RingBuilderMountEngagementRingFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'productName' | 'catalogueCode' | 'suffix'
> & {
        images: Array<
            { __typename: 'CatalogueImage' } & {
                small_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
                large_x2: {
                    __typename: 'MonolithImageSize'
                } & MonolithImageSizeFragment
            }
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                translation: { __typename: 'MetalTranslation' } & Pick<
                    MetalTranslation,
                    'name'
                >
            }
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<
                StoneShape,
                'systemCode'
            > & {
                    translation: { __typename: 'StoneShapeTranslation' } & Pick<
                        StoneShapeTranslation,
                        'name'
                    >
                }
            weight: {
                __typename: 'CatalogueEngagementRingCentreStoneWeightConstraint'
            } & Pick<
                CatalogueEngagementRingCentreStoneWeightConstraint,
                'max' | 'min'
            >
        }
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
    } & EngagementRingLinkFragment &
    CatalogueEngagementRingInputFragment

export type GemsFindStonesQueryVariables = Exact<{
    filters: InputMaybe<GemsApi_StoneFilters>
    market: Scalars['String']['input']
    categories: Array<GemsApi_StoneCategory> | GemsApi_StoneCategory
    notClarity: Array<GemsApi_StoneClarity> | GemsApi_StoneClarity
    notColour: Array<GemsApi_StoneColour> | GemsApi_StoneColour
    notSymmetry: Array<GemsApi_StoneSymmetry> | GemsApi_StoneSymmetry
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    getBound: Scalars['Boolean']['input']
    getStones: Scalars['Boolean']['input']
    isConsultant: InputMaybe<Scalars['Boolean']['input']>
    contentPath: Scalars['String']['input']
    facetedNav: ProductPageFacetedContentInputDiamondSearch
}>

export type GemsFindStonesQuery = { __typename: 'Query' } & {
    GemsApi_findStones?: Maybe<
        { __typename: 'GemsApi_StoneCollection' } & {
            collection: Array<{ __typename: 'GemsApi_Stone' } & StoneFragment>
            pagination: { __typename: 'GemsApi_Pagination' } & Pick<
                GemsApi_Pagination,
                'limit' | 'pages' | 'total'
            >
        }
    >
    GemsApi_getBounds?: Maybe<
        { __typename: 'GemsApi_Bounds' } & GemsBoundsFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
}

export type GetBoundsQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    market: Scalars['String']['input']
    categories: Array<GemsApi_StoneCategory> | GemsApi_StoneCategory
    locale: Scalars['Locale']['input']
}>

export type GetBoundsQuery = { __typename: 'Query' } & {
    GemsApi_getBounds: Maybe<
        { __typename: 'GemsApi_Bounds' } & GemsBoundsFragment
    >
}

export type GetStoneQueryVariables = Exact<{
    identifier: Scalars['GemsApi_StoneIdentifier']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type GetStoneQuery = { __typename: 'Query' } & {
    GemsApi_getStone: Maybe<
        { __typename: 'GemsApi_Stone' } & Pick<
            GemsApi_Stone,
            'containsEngagementRings'
        > &
            StoneFragment
    >
}

export type GetStoneByGiaQueryVariables = Exact<{
    giaNumber: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type GetStoneByGiaQuery = { __typename: 'Query' } & {
    GemsApi_getGiaStone: Maybe<{ __typename: 'GemsApi_Stone' } & StoneFragment>
}

export type FindStoneByExternalIdQueryVariables = Exact<{
    feedIdentifier: Scalars['String']['input']
    externalId: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type FindStoneByExternalIdQuery = { __typename: 'Query' } & {
    GemsApi_getStoneByExternalId: Maybe<
        { __typename: 'GemsApi_Stone' } & StoneFragment
    >
}

export type ClarityTranslationFragment = {
    __typename: 'StoneClarityTranslation'
} & Pick<StoneClarityTranslation, 'name'>

export type GemsApiStoneCrystalWithInfoFragment = {
    __typename: 'GemsApi_StoneCrystalInfo'
} & Pick<GemsApi_StoneCrystalInfo, 'code'> & {
        info: Maybe<
            { __typename: 'StoneCrystal' } & Pick<StoneCrystal, 'systemCode'>
        >
    }

export type GemsApiStoneShapeWithInfoFragment = {
    __typename: 'GemsApi_StoneShapeInfo'
} & Pick<GemsApi_StoneShapeInfo, 'code'> & {
        info: Maybe<{ __typename: 'StoneShape' } & StoneShapeFragment>
    }

export type StoneCategoryFragment = { __typename: 'StoneCategory' } & Pick<
    StoneCategory,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCategoryTranslation'
        } & StoneCategoryTranslationFragment
    }

export type StoneCategoryTranslationFragment = {
    __typename: 'StoneCategoryTranslation'
} & Pick<StoneCategoryTranslation, 'name'>

export type StoneColorFragment = { __typename: 'StoneColor' } & Pick<
    StoneColor,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneColorTranslation'
        } & StoneColorTranslationFragment
    }

export type StoneColorTranslationFragment = {
    __typename: 'StoneColorTranslation'
} & Pick<StoneColorTranslation, 'name'>

export type StoneCrystalFragment = { __typename: 'StoneCrystal' } & Pick<
    StoneCrystal,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCrystalTranslation'
        } & StoneCrystalTranslationFragment
    }

export type GemsBoundsFragment = { __typename: 'GemsApi_Bounds' } & Pick<
    GemsApi_Bounds,
    | 'colour'
    | 'grade'
    | 'shape'
    | 'clarity'
    | 'fluorescence'
    | 'cut'
    | 'polish'
    | 'symmetry'
    | 'shippingFromCountry'
    | 'originCountry'
    | 'category'
    | 'crystal'
> & {
        shapes: Array<
            {
                __typename: 'GemsApi_StoneShapeInfo'
            } & GemsApiStoneShapeWithInfoFragment
        >
        gemstoneType: Maybe<
            Array<
                { __typename: 'GemsApi_GemstoneTypeFilter' } & Pick<
                    GemsApi_GemstoneTypeFilter,
                    'colour' | 'crystal'
                > & {
                        colorWithInfo: {
                            __typename: 'GemsApi_StoneColorInfo'
                        } & Pick<GemsApi_StoneColorInfo, 'code'> & {
                                info: Maybe<
                                    {
                                        __typename: 'StoneColor'
                                    } & StoneColorFragment
                                >
                            }
                        crystalWithInfo: {
                            __typename: 'GemsApi_StoneCrystalInfo'
                        } & Pick<GemsApi_StoneCrystalInfo, 'code'> & {
                                info: Maybe<
                                    {
                                        __typename: 'StoneCrystal'
                                    } & StoneCrystalFragment
                                >
                            }
                    }
            >
        >
        weight: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        depthPercent: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        tablePercent: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        ratio: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        length: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        width: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        depth: { __typename: 'GemsApi_Range' } & GemsRangeFragment
        deliveryDays: { __typename: 'GemsApi_IntRange' } & GemsIntRangeFragment
        price: {
            __typename: 'GemsApi_PriceRange'
        } & GemsPriceRangeInLocalCurrencyFragment
        priceByShape: Array<
            { __typename: 'GemsApi_PriceRangeByShape' } & Pick<
                GemsApi_PriceRangeByShape,
                'shape'
            > & {
                    range: {
                        __typename: 'GemsApi_PriceRange'
                    } & GemsPriceRangeInLocalCurrencyFragment
                }
        >
    }

export type StoneImageFragment = { __typename: 'GemsApi_StoneImage' } & Pick<
    GemsApi_StoneImage,
    'url' | 'isB2B'
>

export type GemsIntRangeFragment = { __typename: 'GemsApi_IntRange' } & Pick<
    GemsApi_IntRange,
    'min' | 'max'
>

export type GemsPriceRangeInLocalCurrencyFragment = {
    __typename: 'GemsApi_PriceRange'
} & Pick<GemsApi_PriceRange, 'min' | 'max'> & {
        minInCurrency: Maybe<{ __typename: 'Money' } & MoneyFragment>
        maxInCurrency: Maybe<{ __typename: 'Money' } & MoneyFragment>
    }

export type GemsPriceRangeFragment = {
    __typename: 'GemsApi_PriceRange'
} & Pick<GemsApi_PriceRange, 'min' | 'max'>

export type GemsRangeFragment = { __typename: 'GemsApi_Range' } & Pick<
    GemsApi_Range,
    'min' | 'max'
>

export type GemsSelectedFiltersFragment = {
    __typename: 'GemsApi_SelectedStoneFilters'
} & Pick<
    GemsApi_SelectedStoneFilters,
    | 'category'
    | 'crystal'
    | 'colour'
    | 'grade'
    | 'shape'
    | 'clarity'
    | 'fluorescence'
    | 'symmetry'
    | 'cut'
    | 'polish'
    | 'shippingFrom'
    | 'originCountry'
    | 'notColour'
    | 'notClarity'
    | 'notSymmetry'
    | 'lab'
    | 'hasPhoto'
    | 'isCanadaMark'
    | 'isDtlReport'
    | 'isScsReport'
    | 'withVideo'
    | 'withOriginCountry'
    | 'isStock'
    | 'priceIndex'
> & {
        price: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        costPrice: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        weight: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        depthPercent: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        tablePercent: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        ratio: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        length: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        width: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        depth: Maybe<
            { __typename: 'GemsApi_SelectedRange' } & GemsSelectedRangeFragment
        >
        sorting: Maybe<
            { __typename: 'GemsApi_SelectedSorting' } & Pick<
                GemsApi_SelectedSorting,
                'field' | 'direction'
            >
        >
    }

export type GemsSelectedRangeFragment = {
    __typename: 'GemsApi_SelectedRange'
} & Pick<GemsApi_SelectedRange, 'min' | 'max'>

export type StoneFragment = { __typename: 'GemsApi_Stone' } & Pick<
    GemsApi_Stone,
    | 'identifier'
    | 'blackInclusion'
    | 'colourShade'
    | 'crystal'
    | 'culet'
    | 'eyeClean'
    | 'fluorescenceColour'
    | 'girdleMin'
    | 'girdleMax'
    | 'growthMethod'
    | 'shippingFromCountry'
    | 'originCountry'
    | 'length'
    | 'width'
    | 'depth'
    | 'weight'
    | 'ratio'
    | 'pavilionDepth'
    | 'pavilionAngle'
    | 'tablePercent'
    | 'depthPercent'
    | 'crownAngle'
    | 'crownHeight'
    | 'v360Url'
    | 'isMilky'
    | 'isTreated'
    | 'isCertificateVerified'
    | 'isCanadaMark'
    | 'isB2B'
    | 'isValidB2C'
    | 'isHideCertificateNumber'
    | 'isHideMeasurements'
    | 'deliveryDays'
    | 'scsReport'
    | 'price'
> & {
        categoryWithInfo: { __typename: 'GemsApi_StoneCategoryInfo' } & Pick<
            GemsApi_StoneCategoryInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneCategory' } & StoneCategoryFragment
                >
            }
        clarityWithInfo: { __typename: 'GemsApi_StoneClarityInfo' } & Pick<
            GemsApi_StoneClarityInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneClarity' } & StoneClarityFragment
                >
            }
        colorWithInfo: { __typename: 'GemsApi_StoneColorInfo' } & Pick<
            GemsApi_StoneColorInfo,
            'code'
        > & { info: Maybe<{ __typename: 'StoneColor' } & StoneColorFragment> }
        crystalWithInfo: { __typename: 'GemsApi_StoneCrystalInfo' } & Pick<
            GemsApi_StoneCrystalInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneCrystal' } & StoneCrystalFragment
                >
            }
        cutWithInfo: Maybe<
            { __typename: 'GemsApi_StoneCutInfo' } & Pick<
                GemsApi_StoneCutInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneCut' } & Pick<
                            StoneCut,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneCutTranslation'
                                } & Pick<StoneCutTranslation, 'name'>
                            }
                    >
                }
        >
        fluorescenceWithInfo: Maybe<
            { __typename: 'GemsApi_StoneFluorescenceInfo' } & Pick<
                GemsApi_StoneFluorescenceInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneFluorescence' } & Pick<
                            StoneFluorescence,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneFluorescenceTranslation'
                                } & Pick<StoneFluorescenceTranslation, 'name'>
                            }
                    >
                }
        >
        gradeWithInfo: Maybe<
            { __typename: 'GemsApi_StoneGradeInfo' } & Pick<
                GemsApi_StoneGradeInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneGrade' } & Pick<
                            StoneGrade,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneGradeTranslation'
                                } & Pick<StoneGradeTranslation, 'name'>
                            }
                    >
                }
        >
        polishWithInfo: Maybe<
            { __typename: 'GemsApi_StonePolishInfo' } & Pick<
                GemsApi_StonePolishInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StonePolish' } & Pick<
                            StonePolish,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StonePolishTranslation'
                                } & Pick<StonePolishTranslation, 'name'>
                            }
                    >
                }
        >
        shapeWithInfo: { __typename: 'GemsApi_StoneShapeInfo' } & Pick<
            GemsApi_StoneShapeInfo,
            'code'
        > & {
                info: Maybe<
                    { __typename: 'StoneShape' } & Pick<
                        StoneShape,
                        'systemCode'
                    > & {
                            samplePhoto: Maybe<
                                { __typename: 'Asset' } & Pick<Asset, 'id'> & {
                                        size: {
                                            __typename: 'MonolithImageSize'
                                        } & MonolithImageSizeFragment
                                        size_x2: {
                                            __typename: 'MonolithImageSize'
                                        } & MonolithImageSizeFragment
                                    }
                            >
                            icon: Maybe<
                                { __typename: 'Asset' } & Pick<
                                    Asset,
                                    'id' | 'url'
                                >
                            >
                            translation: {
                                __typename: 'StoneShapeTranslation'
                            } & Pick<StoneShapeTranslation, 'name'>
                        }
                >
            }
        symmetryWithInfo: Maybe<
            { __typename: 'GemsApi_StoneSymmetryInfo' } & Pick<
                GemsApi_StoneSymmetryInfo,
                'code'
            > & {
                    info: Maybe<
                        { __typename: 'StoneSymmetry' } & Pick<
                            StoneSymmetry,
                            'abbreviation' | 'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneSymmetryTranslation'
                                } & Pick<StoneSymmetryTranslation, 'name'>
                            }
                    >
                }
        >
        image: Maybe<{ __typename: 'GemsApi_StoneImage' } & StoneImageFragment>
        images: Array<{ __typename: 'GemsApi_StoneImage' } & StoneImageFragment>
        dtlReport: Maybe<
            { __typename: 'GemsApi_dtlReport' } & Pick<
                GemsApi_DtlReport,
                'url' | 'code'
            >
        >
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
    } & GemsApiCertificateFragment

export type StoneClarityFragment = { __typename: 'StoneClarity' } & Pick<
    StoneClarity,
    'abbreviation' | 'systemCode'
> & {
        translation: {
            __typename: 'StoneClarityTranslation'
        } & ClarityTranslationFragment
    }

export type StoneRecommendationsNotFoundFragment = {
    __typename: 'StoneRecommendationNotFound'
} & Pick<StoneRecommendationNotFound, 'haveWithoutPricingRange'>

export type NonSkuCaratWeightRangeFragment = {
    __typename: 'NonSkuCaratWeightRange'
} & Pick<NonSkuCaratWeightRange, 'min' | 'max'>

export type NonSkuGemstoneFragment = { __typename: 'NonSkuGemstone' } & Pick<
    NonSkuGemstone,
    'id' | 'caratWeight'
> & {
        shape: { __typename: 'StoneShape' } & StoneShapeFragment
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
        cut: { __typename: 'StoneCut' } & StoneCutFragment
        crystal: { __typename: 'StoneCrystal' } & StoneCrystalFragment
        color: { __typename: 'StoneColor' } & StoneColorFragment
        colorGrade: { __typename: 'StoneGrade' } & StoneGradeFragment
        clarity: { __typename: 'StoneClarity' } & StoneClarityFragment
    } & NonSkuGemstoneImageFragment

export type NonSkuGemstoneBoundsFragment = {
    __typename: 'NonSkuGemstonesBounds'
} & {
    caratWeight: {
        __typename: 'NonSkuCaratWeightRange'
    } & NonSkuCaratWeightRangeFragment
    price: Maybe<{ __typename: 'NonSkuPriceRange' } & NonSkuPriceRangeFragment>
    shapes: Array<{ __typename: 'StoneShape' } & StoneShapeFragment>
    types: Array<
        { __typename: 'NonSkuGemstoneType' } & Pick<
            NonSkuGemstoneType,
            'id'
        > & {
                crystal: { __typename: 'StoneCrystal' } & StoneCrystalFragment
                color: { __typename: 'StoneColor' } & StoneColorFragment
            }
    >
}

export type NonSkuLabGrownFragment = { __typename: 'NonSkuLabGrown' } & Pick<
    NonSkuLabGrown,
    'id' | 'caratWeight'
> & {
        salePrice: Maybe<{ __typename: 'Money' } & MoneyFragment>
        shape: { __typename: 'StoneShape' } & StoneShapeFragment
        color: { __typename: 'StoneColor' } & StoneColorFragment
        clarity: { __typename: 'StoneClarity' } & StoneClarityFragment
    } & NonSkuLabGrownStoneImageFragment

export type NonSkuLabGrownDiamondBoundsFragment = {
    __typename: 'NonSkuLabGrownDiamondsBounds'
} & {
    caratWeight: {
        __typename: 'NonSkuCaratWeightRange'
    } & NonSkuCaratWeightRangeFragment
    price: Maybe<{ __typename: 'NonSkuPriceRange' } & NonSkuPriceRangeFragment>
    shapes: Array<{ __typename: 'StoneShape' } & StoneShapeFragment>
    colors: Array<{ __typename: 'StoneColor' } & StoneColorFragment>
}

export type NonSkuPriceRangeFragment = { __typename: 'NonSkuPriceRange' } & {
    min: { __typename: 'Money' } & MoneyFragment
    max: { __typename: 'Money' } & MoneyFragment
}

export type StoneCrystalTranslationFragment = {
    __typename: 'StoneCrystalTranslation'
} & Pick<StoneCrystalTranslation, 'name'>

export type StoneCutFragment = { __typename: 'StoneCut' } & Pick<
    StoneCut,
    'systemCode'
> & {
        translation: {
            __typename: 'StoneCutTranslation'
        } & StoneCutTranslationFragment
    }

export type StoneCutTranslationFragment = {
    __typename: 'StoneCutTranslation'
} & Pick<StoneCutTranslation, 'name'>

export type StoneGradeFragment = { __typename: 'StoneGrade' } & Pick<
    StoneGrade,
    'systemCode'
> & {
        translation: { __typename: 'StoneGradeTranslation' } & Pick<
            StoneGradeTranslation,
            'name'
        >
    }

export type StoneShapeFragment = { __typename: 'StoneShape' } & Pick<
    StoneShape,
    'systemCode'
> & {
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
        samplePhoto: Maybe<{ __typename: 'Asset' } & AssetFragment>
        translation: {
            __typename: 'StoneShapeTranslation'
        } & StoneShapeTranslationFragment
    }

export type StoneShapeTranslationFragment = {
    __typename: 'StoneShapeTranslation'
} & Pick<StoneShapeTranslation, 'name'>

export type RingBuilderAddRingFragment = {
    __typename: 'CatalogueEngagementRing'
} & EngagementRingLinkFragment &
    CatalogueEngagementRingInputFragment

export type EngagementRingLinkFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'suffixSlug' | 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'>
        }
    }

export type GemstoneRouteFragment = { __typename: 'NonSkuGemstone' } & Pick<
    NonSkuGemstone,
    'caratWeight'
> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        >
        colorGrade: { __typename: 'StoneGrade' } & Pick<
            StoneGrade,
            'systemCode'
        >
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        >
    }

type JewelleryLink_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

type JewelleryLink_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'slug' | 'suffixSlug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type JewelleryLinkFragment =
    | JewelleryLink_CatalogueJewelleryBracelet_Fragment
    | JewelleryLink_CatalogueJewelleryEarrings_Fragment
    | JewelleryLink_CatalogueJewelleryNecklace_Fragment
    | JewelleryLink_CatalogueJewelleryRing_Fragment

export type LabGrownRouteFragment = { __typename: 'NonSkuLabGrown' } & Pick<
    NonSkuLabGrown,
    'caratWeight'
> & {
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'>
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        >
    }

type ProductLink_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & EngagementRingLinkFragment

type ProductLink_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & JewelleryLink_CatalogueJewelleryBracelet_Fragment

type ProductLink_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & JewelleryLink_CatalogueJewelleryEarrings_Fragment

type ProductLink_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & JewelleryLink_CatalogueJewelleryNecklace_Fragment

type ProductLink_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & JewelleryLink_CatalogueJewelleryRing_Fragment

type ProductLink_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & ReadyToGoRingLinkFragment

type ProductLink_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & WeddingRingLinkFragment

export type ProductLinkFragment =
    | ProductLink_CatalogueEngagementRing_Fragment
    | ProductLink_CatalogueJewelleryBracelet_Fragment
    | ProductLink_CatalogueJewelleryEarrings_Fragment
    | ProductLink_CatalogueJewelleryNecklace_Fragment
    | ProductLink_CatalogueJewelleryRing_Fragment
    | ProductLink_CatalogueReadyToGoRing_Fragment
    | ProductLink_CatalogueWeddingRing_Fragment

export type ReadyToGoRingLinkFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type WeddingRingLinkFragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'suffixSlug' | 'slug'> & {
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
    }

export type BraceletExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type BraceletExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryBracelets: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductExport_CatalogueJewelleryBracelet_Fragment
    >
}

export type EarringsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type EarringsExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryEarrings: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductExport_CatalogueJewelleryEarrings_Fragment
    >
}

export type EngagementRingsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type EngagementRingsExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductExport_CatalogueEngagementRing_Fragment
    >
}

export type EngagementRingsGemstoneExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
    type: RingBuilderProductType
}>

export type EngagementRingsGemstoneExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & EngagementRingRingBuilderExportFragment
    >
}

export type EngagementRingsLabGrownExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
    type: RingBuilderProductType
}>

export type EngagementRingsLabGrownExportQuery = { __typename: 'Query' } & {
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & EngagementRingRingBuilderExportFragment
    >
}

type ProductExport_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        ringStyles: Array<
            { __typename: 'EngagementRingStyleLabel' } & {
                translation: { __typename: 'ProductLabelTranslation' } & Pick<
                    ProductLabelTranslation,
                    'name'
                >
            }
        >
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        }
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueEngagementRing_Fragment

type ProductExport_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryBracelet_Fragment

type ProductExport_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryEarrings_Fragment

type ProductExport_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'catalogueCode' | 'productName'> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryNecklace_Fragment

type ProductExport_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueJewelleryRing_Fragment

type ProductExport_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueReadyToGoRing_Fragment

type ProductExport_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'productName'> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            >
        >
        salePrice?: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
        mainImage: Maybe<
            { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
        >
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<CatalogueImage, 'url'>
        >
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'> & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'MetalElementTranslation'
                        } & Pick<MetalElementTranslation, 'name'>
                    }
                color: Maybe<
                    { __typename: 'MetalColor' } & Pick<
                        MetalColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'MetalColorTranslation'
                            } & Pick<MetalColorTranslation, 'name'>
                        }
                >
            }
    } & ProductLink_CatalogueWeddingRing_Fragment

export type ProductExportFragment =
    | ProductExport_CatalogueEngagementRing_Fragment
    | ProductExport_CatalogueJewelleryBracelet_Fragment
    | ProductExport_CatalogueJewelleryEarrings_Fragment
    | ProductExport_CatalogueJewelleryNecklace_Fragment
    | ProductExport_CatalogueJewelleryRing_Fragment
    | ProductExport_CatalogueReadyToGoRing_Fragment
    | ProductExport_CatalogueWeddingRing_Fragment

export type EngagementRingRingBuilderExportFragment = {
    __typename: 'CatalogueEngagementRing'
} & {
    ringStyles: Array<
        { __typename: 'EngagementRingStyleLabel' } & {
            translation: { __typename: 'ProductLabelTranslation' } & Pick<
                ProductLabelTranslation,
                'name'
            >
        }
    >
    primaryMetal: { __typename: 'Metal' } & {
        translation: { __typename: 'MetalTranslation' } & Pick<
            MetalTranslation,
            'name'
        >
    }
    translation: { __typename: 'CatalogueEngagementRingTranslation' } & Pick<
        CatalogueEngagementRingTranslation,
        'seoText'
    >
    ringBuilderProducts: Array<
        { __typename: 'RingBuilder' } & Pick<
            RingBuilder,
            'id' | 'productId'
        > & {
                position1: Maybe<
                    | ({
                          __typename: 'RingBuilderCentreStoneFragment'
                      } & ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment)
                    | ({
                          __typename: 'RingBuilderMountFragment'
                      } & ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment)
                >
                position2: Maybe<
                    | ({
                          __typename: 'RingBuilderCentreStoneFragment'
                      } & ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment)
                    | ({
                          __typename: 'RingBuilderMountFragment'
                      } & ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment)
                >
                image: Maybe<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
                totalSalePrice: { __typename: 'Money' } & MoneyFragment
            }
    >
} & ProductExport_CatalogueEngagementRing_Fragment

type ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & {
    stone: Maybe<
        | { __typename: 'GemsApiStone' }
        | ({ __typename: 'NonSkuGemstone' } & Pick<
              NonSkuGemstone,
              'caratWeight'
          > & {
                  shape: { __typename: 'StoneShape' } & {
                      translation: {
                          __typename: 'StoneShapeTranslation'
                      } & Pick<StoneShapeTranslation, 'name'>
                  }
                  color: { __typename: 'StoneColor' } & {
                      translation: {
                          __typename: 'StoneColorTranslation'
                      } & Pick<StoneColorTranslation, 'name'>
                  }
                  crystal: { __typename: 'StoneCrystal' } & {
                      translation: {
                          __typename: 'StoneCrystalTranslation'
                      } & Pick<StoneCrystalTranslation, 'name'>
                  }
              } & GemstoneRouteFragment)
        | ({ __typename: 'NonSkuLabGrown' } & Pick<
              NonSkuLabGrown,
              'caratWeight'
          > & {
                  shape: { __typename: 'StoneShape' } & {
                      translation: {
                          __typename: 'StoneShapeTranslation'
                      } & Pick<StoneShapeTranslation, 'name'>
                  }
              } & LabGrownRouteFragment)
    >
}

type ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
}

export type ExportsRingBuilderPositionFragment =
    | ExportsRingBuilderPosition_RingBuilderCentreStoneFragment_Fragment
    | ExportsRingBuilderPosition_RingBuilderMountFragment_Fragment

export type NecklaceExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type NecklaceExportQuery = { __typename: 'Query' } & {
    catalogueJewelleryNecklaces: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductExport_CatalogueJewelleryNecklace_Fragment
    >
}

export type RingExportsQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type RingExportsQuery = { __typename: 'Query' } & {
    catalogueJewelleryRings: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductExport_CatalogueJewelleryRing_Fragment
    >
}

export type WeddingRingsExportQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    region: RegionCode
    rbProduct: Scalars['Boolean']['input']
}>

export type WeddingRingsExportQuery = { __typename: 'Query' } & {
    catalogueWeddingRings: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductExport_CatalogueWeddingRing_Fragment
    >
}

export type RssFeedBlogQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type RssFeedBlogQuery = { __typename: 'Query' } & {
    posts: Array<
        { __typename: 'Post' } & Pick<
            Post,
            'id' | 'title' | 'excerpt' | 'createdAt' | 'modifiedAt'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                featuredImage: { __typename: 'Image' } & Pick<
                    Image,
                    'url' | 'filesize' | 'mimeType'
                >
                author: { __typename: 'Author' } & Pick<Author, 'name'> & {
                        image: { __typename: 'Image' } & Pick<Image, 'url'>
                    } & BlogAuthorRouteFragment
            } & PostLinkFragment
    >
}

export type ReviewFeedFragment = { __typename: 'Review' } & Pick<
    Review,
    'id' | 'name' | 'date' | 'comment' | 'rating'
> & { picture: Maybe<{ __typename: 'Asset' } & Pick<Asset, 'id' | 'url'>> }

export type ReviewsFeedQueryVariables = Exact<{ [key: string]: never }>

export type ReviewsFeedQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type ReviewsFeedEngagementRingGemstoneQueryVariables = Exact<{
    [key: string]: never
}>

export type ReviewsFeedEngagementRingGemstoneQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > & {
                          ringBuilderProducts: Array<
                              { __typename: 'RingBuilder' } & Pick<
                                  RingBuilder,
                                  'productId'
                              > & {
                                      position1: Maybe<
                                          | ({
                                                __typename: 'RingBuilderCentreStoneFragment'
                                            } & {
                                                stone: Maybe<
                                                    | {
                                                          __typename: 'GemsApiStone'
                                                      }
                                                    | ({
                                                          __typename: 'NonSkuGemstone'
                                                      } & GemstoneRouteFragment)
                                                    | ({
                                                          __typename: 'NonSkuLabGrown'
                                                      } & LabGrownRouteFragment)
                                                >
                                            })
                                          | {
                                                __typename: 'RingBuilderMountFragment'
                                            }
                                      >
                                  }
                          >
                      } & ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type ReviewsFeedEngagementRingLabGrownQueryVariables = Exact<{
    [key: string]: never
}>

export type ReviewsFeedEngagementRingLabGrownQuery = { __typename: 'Query' } & {
    reviews: Array<
        { __typename: 'Review' } & {
            products: Array<
                | ({ __typename: 'CatalogueEngagementRing' } & Pick<
                      CatalogueEngagementRing,
                      'catalogueCode' | 'productName'
                  > & {
                          ringBuilderProducts: Array<
                              { __typename: 'RingBuilder' } & Pick<
                                  RingBuilder,
                                  'productId'
                              > & {
                                      position1: Maybe<
                                          | ({
                                                __typename: 'RingBuilderCentreStoneFragment'
                                            } & {
                                                stone: Maybe<
                                                    | {
                                                          __typename: 'GemsApiStone'
                                                      }
                                                    | ({
                                                          __typename: 'NonSkuGemstone'
                                                      } & GemstoneRouteFragment)
                                                    | ({
                                                          __typename: 'NonSkuLabGrown'
                                                      } & LabGrownRouteFragment)
                                                >
                                            })
                                          | {
                                                __typename: 'RingBuilderMountFragment'
                                            }
                                      >
                                  }
                          >
                      } & ProductLink_CatalogueEngagementRing_Fragment)
                | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
                      CatalogueJewelleryBracelet,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryBracelet_Fragment)
                | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
                      CatalogueJewelleryEarrings,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryEarrings_Fragment)
                | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
                      CatalogueJewelleryNecklace,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryNecklace_Fragment)
                | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
                      CatalogueJewelleryRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueJewelleryRing_Fragment)
                | ({ __typename: 'CatalogueReadyToGoRing' } & Pick<
                      CatalogueReadyToGoRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueReadyToGoRing_Fragment)
                | ({ __typename: 'CatalogueWeddingRing' } & Pick<
                      CatalogueWeddingRing,
                      'catalogueCode' | 'productName'
                  > &
                      ProductLink_CatalogueWeddingRing_Fragment)
            >
        } & ReviewFeedFragment
    >
}

export type SitemapBlockImagesFragment = { __typename: 'Block' } & {
    components: Array<
        | { __typename: 'ComponentArticleGrid' }
        | { __typename: 'ComponentArticlePreviews' }
        | { __typename: 'ComponentBannerSkinny' }
        | { __typename: 'ComponentBannerTitle' }
        | { __typename: 'ComponentCard' }
        | { __typename: 'ComponentCardCarousel' }
        | { __typename: 'ComponentCatalogueProductCarousel' }
        | { __typename: 'ComponentContent' }
        | { __typename: 'ComponentContentTwoColumns' }
        | ({ __typename: 'ComponentContentWithGallery' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentImageSitemap_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentImageSitemap_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentImageSitemap_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentImageSitemap_ComponentTitle_Fragment)
              >
              gallery: Array<
                  { __typename: 'GalleryItem' } & {
                      image: { __typename: 'Image' } & Pick<
                          Image,
                          'url' | 'title' | 'caption'
                      >
                  }
              >
          })
        | { __typename: 'ComponentCustomProductCarousel' }
        | { __typename: 'ComponentFaq' }
        | ({ __typename: 'ComponentFullWidthImage' } & {
              image: { __typename: 'Image' } & Pick<
                  Image,
                  'url' | 'title' | 'caption'
              >
          })
        | ({ __typename: 'ComponentGalleryCarousel' } & {
              items: Array<
                  { __typename: 'GalleryCarouselCard' } & {
                      image: { __typename: 'Image' } & Pick<
                          Image,
                          'url' | 'title' | 'caption'
                      >
                  }
              >
          })
        | ({ __typename: 'ComponentGalleryWithEnquiry' } & {
              items: Array<
                  { __typename: 'GalleryWithEnquiryCard' } & Pick<
                      GalleryWithEnquiryCard,
                      'caption'
                  > & {
                          image: { __typename: 'Image' } & Pick<
                              Image,
                              'url' | 'title' | 'caption'
                          >
                      }
              >
          })
        | { __typename: 'ComponentGlobalComponent' }
        | { __typename: 'ComponentGlobalSpacer' }
        | { __typename: 'ComponentIconCarousel' }
        | { __typename: 'ComponentInstagramPosts' }
        | { __typename: 'ComponentInstagramWithContent' }
        | { __typename: 'ComponentJobs' }
        | { __typename: 'ComponentLogos' }
        | { __typename: 'ComponentLogosCarousel' }
        | { __typename: 'ComponentLogosWithText' }
        | { __typename: 'ComponentMainCover' }
        | { __typename: 'ComponentOnThisPage' }
        | { __typename: 'ComponentQuote' }
        | { __typename: 'ComponentRelatedProducts' }
        | { __typename: 'ComponentReviewCarousel' }
        | ({ __typename: 'ComponentRoundedImage' } & {
              backgroundImage: Maybe<
                  { __typename: 'Image' } & Pick<
                      Image,
                      'url' | 'title' | 'caption'
                  >
              >
              roundedImage: { __typename: 'Image' } & Pick<
                  Image,
                  'url' | 'title' | 'caption'
              >
          })
        | ({ __typename: 'ComponentRoundedImageContent' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentImageSitemap_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentImageSitemap_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentImageSitemap_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentImageSitemap_ComponentTitle_Fragment)
              >
              roundedImage: { __typename: 'ComponentRoundedImage' } & {
                  roundedImage: { __typename: 'Image' } & Pick<
                      Image,
                      'url' | 'title' | 'caption'
                  >
                  backgroundImage: Maybe<
                      { __typename: 'Image' } & Pick<
                          Image,
                          'url' | 'title' | 'caption'
                      >
                  >
              }
          })
        | { __typename: 'ComponentShopWithConfidence' }
        | ({ __typename: 'ComponentSideBySideImages' } & {
              images: Array<
                  { __typename: 'ComponentSideBySideImage' } & Pick<
                      ComponentSideBySideImage,
                      'caption'
                  > & {
                          image: { __typename: 'Image' } & Pick<
                              Image,
                              'url' | 'title' | 'caption'
                          >
                      }
              >
          })
        | { __typename: 'ComponentSquareBoxes' }
        | { __typename: 'ComponentTable' }
        | { __typename: 'ComponentTextCarousel' }
        | ({ __typename: 'ComponentTextOverImage' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentImageSitemap_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentImageSitemap_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentImageSitemap_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentImageSitemap_ComponentTitle_Fragment)
              >
              image: { __typename: 'Image' } & Pick<
                  Image,
                  'url' | 'title' | 'caption'
              >
          })
        | ({ __typename: 'ComponentTextWithImage' } & {
              content: Array<
                  | ({
                        __typename: 'ComponentButton'
                    } & ContentImageSitemap_ComponentButton_Fragment)
                  | ({
                        __typename: 'ComponentImage'
                    } & ContentImageSitemap_ComponentImage_Fragment)
                  | ({
                        __typename: 'ComponentOrderedList'
                    } & ContentImageSitemap_ComponentOrderedList_Fragment)
                  | ({
                        __typename: 'ComponentSpacer'
                    } & ContentImageSitemap_ComponentSpacer_Fragment)
                  | ({
                        __typename: 'ComponentText'
                    } & ContentImageSitemap_ComponentText_Fragment)
                  | ({
                        __typename: 'ComponentTitle'
                    } & ContentImageSitemap_ComponentTitle_Fragment)
              >
              image: { __typename: 'Image' } & Pick<
                  Image,
                  'url' | 'title' | 'caption'
              >
          })
        | ({ __typename: 'ComponentTextWithImageCarousel' } & {
              slides: Array<
                  { __typename: 'ComponentTextWithImage' } & {
                      content: Array<
                          | ({
                                __typename: 'ComponentButton'
                            } & ContentImageSitemap_ComponentButton_Fragment)
                          | ({
                                __typename: 'ComponentImage'
                            } & ContentImageSitemap_ComponentImage_Fragment)
                          | ({
                                __typename: 'ComponentOrderedList'
                            } & ContentImageSitemap_ComponentOrderedList_Fragment)
                          | ({
                                __typename: 'ComponentSpacer'
                            } & ContentImageSitemap_ComponentSpacer_Fragment)
                          | ({
                                __typename: 'ComponentText'
                            } & ContentImageSitemap_ComponentText_Fragment)
                          | ({
                                __typename: 'ComponentTitle'
                            } & ContentImageSitemap_ComponentTitle_Fragment)
                      >
                      image: { __typename: 'Image' } & Pick<
                          Image,
                          'url' | 'title' | 'caption'
                      >
                  }
              >
          })
        | { __typename: 'ComponentVideo' }
        | { __typename: 'ComponentVideoWithContent' }
        | { __typename: 'ComponentWarrantyActivationForm' }
    >
}

type ContentImageSitemap_ComponentButton_Fragment = {
    __typename: 'ComponentButton'
}

type ContentImageSitemap_ComponentImage_Fragment = {
    __typename: 'ComponentImage'
}

type ContentImageSitemap_ComponentOrderedList_Fragment = {
    __typename: 'ComponentOrderedList'
}

type ContentImageSitemap_ComponentSpacer_Fragment = {
    __typename: 'ComponentSpacer'
}

type ContentImageSitemap_ComponentText_Fragment = {
    __typename: 'ComponentText'
}

type ContentImageSitemap_ComponentTitle_Fragment = {
    __typename: 'ComponentTitle'
} & {
    texts: Array<
        | { __typename: 'ComponentTitleAmpersand' }
        | ({ __typename: 'ComponentTitleText' } & Pick<
              ComponentTitleText,
              'text'
          >)
    >
}

export type ContentImageSitemapFragment =
    | ContentImageSitemap_ComponentButton_Fragment
    | ContentImageSitemap_ComponentImage_Fragment
    | ContentImageSitemap_ComponentOrderedList_Fragment
    | ContentImageSitemap_ComponentSpacer_Fragment
    | ContentImageSitemap_ComponentText_Fragment
    | ContentImageSitemap_ComponentTitle_Fragment

export type SitemapBlogQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type SitemapBlogQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    postCategories: Array<
        { __typename: 'PostCategory' } & BlogCategoryRouteFragment
    >
    postTags: Array<{ __typename: 'PostTag' } & BlogTagRouteFragment>
    authors: Array<{ __typename: 'Author' } & BlogAuthorRouteFragment>
    posts: Array<
        { __typename: 'Post' } & Pick<Post, 'modifiedAt'> & {
                blocks: Array<
                    { __typename: 'Block' } & SitemapBlockImagesFragment
                >
                meta: { __typename: 'Meta' } & Pick<Meta, 'robots'>
            } & PostLinkFragment
    >
}

export type SitemapEngagementRingQueryVariables = Exact<{
    [key: string]: never
}>

export type SitemapEngagementRingQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueEngagementRingFiltersVariations: Array<
        { __typename: 'CatalogueEngagementRingFiltersVariation' } & Pick<
            CatalogueEngagementRingFiltersVariation,
            'primaryMetal' | 'ringStyle' | 'centreStoneShape' | 'designStyle'
        >
    >
    catalogueEngagementRings: Array<
        { __typename: 'CatalogueEngagementRing' } & Pick<
            CatalogueEngagementRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
                images360: Array<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
            } & EngagementRingLinkFragment
    >
}

export type SitemapJewelleryQueryVariables = Exact<{ [key: string]: never }>

export type SitemapJewelleryQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueJewelleriesFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesFiltersVariation' } & Pick<
            CatalogueJewelleriesFiltersVariation,
            'primaryMetal' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryNecklacesFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesNecklacesFiltersVariation' } & Pick<
            CatalogueJewelleriesNecklacesFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryEarringsFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesEarringsFiltersVariation' } & Pick<
            CatalogueJewelleriesEarringsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryBraceletFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesBraceletsFiltersVariation' } & Pick<
            CatalogueJewelleriesBraceletsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleryRingsFiltersVariations: Array<
        { __typename: 'CatalogueJewelleriesRingsFiltersVariation' } & Pick<
            CatalogueJewelleriesRingsFiltersVariation,
            'primaryMetal' | 'productStyle' | 'designStyle' | 'gemstone'
        >
    >
    catalogueJewelleries: Array<
        | ({ __typename: 'CatalogueJewelleryBracelet' } & Pick<
              CatalogueJewelleryBracelet,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryBracelet_Fragment)
        | ({ __typename: 'CatalogueJewelleryEarrings' } & Pick<
              CatalogueJewelleryEarrings,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryEarrings_Fragment)
        | ({ __typename: 'CatalogueJewelleryNecklace' } & Pick<
              CatalogueJewelleryNecklace,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryNecklace_Fragment)
        | ({ __typename: 'CatalogueJewelleryRing' } & Pick<
              CatalogueJewelleryRing,
              'productName'
          > & {
                  images: Array<
                      { __typename: 'CatalogueImage' } & Pick<
                          CatalogueImage,
                          'url'
                      >
                  >
                  images360: Array<
                      { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                  >
              } & JewelleryLink_CatalogueJewelleryRing_Fragment)
    >
}

export type SitemapPagesQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type SitemapPagesQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    pages: Array<
        { __typename: 'Page' } & {
            meta: { __typename: 'Meta' } & Pick<Meta, 'robots'>
            blocks: Array<{ __typename: 'Block' } & SitemapBlockImagesFragment>
        } & PageLinkFragment
    >
}

export type SitemapReadyToGoQueryVariables = Exact<{ [key: string]: never }>

export type SitemapReadyToGoQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueReadyToGoRingsFilters: {
        __typename: 'CatalogueReadyToGoRingFilters'
    } & {
        primaryMetals: Array<
            { __typename: 'CatalogueFilterMetalItem' } & {
                metal: { __typename: 'Metal' } & Pick<Metal, 'systemCode'>
            }
        >
    }
    catalogueReadyToGoRings: Array<
        { __typename: 'CatalogueReadyToGoRing' } & Pick<
            CatalogueReadyToGoRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
            } & ReadyToGoRingLinkFragment
    >
}

export type SitemapRegionFragment = { __typename: 'Region' } & Pick<
    Region,
    'code'
>

export type SitemapWeddingRingQueryVariables = Exact<{ [key: string]: never }>

export type SitemapWeddingRingQuery = { __typename: 'Query' } & {
    regions: Array<{ __typename: 'Region' } & SitemapRegionFragment>
    catalogueWeddingRingFilterVariations: Array<
        { __typename: 'CatalogueWeddingRingFiltersVariation' } & Pick<
            CatalogueWeddingRingFiltersVariation,
            'primaryMetal' | 'ringStyle' | 'category'
        >
    >
    catalogueWeddingRings: Array<
        { __typename: 'CatalogueWeddingRing' } & Pick<
            CatalogueWeddingRing,
            'productName'
        > & {
                images: Array<
                    { __typename: 'CatalogueImage' } & Pick<
                        CatalogueImage,
                        'url'
                    >
                >
                images360: Array<
                    { __typename: 'GenericImage' } & Pick<GenericImage, 'url'>
                >
            } & WeddingRingLinkFragment
    >
}

export type BlogQueryVariables = Exact<{
    path: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type BlogQuery = { __typename: 'Query' } & {
    pageByPath: Maybe<{ __typename: 'Page' } & PageFragment>
    posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
    postsAggregation: { __typename: 'PostsAggregation' } & Pick<
        PostsAggregation,
        'count'
    >
} & PostCategoriesFragment

export type BlogAuthorQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type BlogAuthorQuery = { __typename: 'Query' } & {
    collection: Maybe<
        { __typename: 'Author' } & Pick<Author, 'id' | 'name'> & {
                posts: Maybe<
                    Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
                >
                postAggregation: { __typename: 'PostsAggregation' } & Pick<
                    PostsAggregation,
                    'count'
                >
            }
    >
}

export type PostsByCategoryQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type PostsByCategoryQuery = { __typename: 'Query' } & {
    collection: Maybe<
        { __typename: 'PostCategory' } & Pick<PostCategory, 'id' | 'name'> & {
                posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
                postAggregation: { __typename: 'PostsAggregation' } & Pick<
                    PostsAggregation,
                    'count'
                >
            }
    >
} & PostCategoriesFragment

export type BlogPostQueryVariables = Exact<{
    slug: Scalars['String']['input']
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type BlogPostQuery = { __typename: 'Query' } & {
    postBySlug: Maybe<
        { __typename: 'Post' } & Pick<
            Post,
            'id' | 'title' | 'slug' | 'excerpt' | 'date'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                tags: Array<
                    { __typename: 'PostTag' } & Pick<
                        PostTag,
                        'id' | 'name' | 'slug'
                    >
                >
                author: { __typename: 'Author' } & Pick<
                    Author,
                    'id' | 'name'
                > & {
                        image: { __typename: 'Image' } & ImageLargeFragment
                    } & BlogAuthorRouteFragment
                categories: Array<
                    { __typename: 'PostCategory' } & Pick<
                        PostCategory,
                        'id' | 'name' | 'slug'
                    >
                >
                relatedPosts: Maybe<
                    Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
                >
                meta: { __typename: 'Meta' } & MetaFragment
            } & PostLinkFragment
    >
}

export type PostsByTagQueryVariables = Exact<{
    slug: Scalars['String']['input']
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
}>

export type PostsByTagQuery = { __typename: 'Query' } & {
    collection: Maybe<
        { __typename: 'PostTag' } & Pick<PostTag, 'id' | 'name'> & {
                posts: Array<{ __typename: 'Post' } & BlogPostPreviewFragment>
                postAggregation: { __typename: 'PostsAggregation' } & Pick<
                    PostsAggregation,
                    'count'
                >
            }
    >
}

export type CtaBoxFragment = { __typename: 'ProductPageDetails' } & {
    ctaPerksLink: Maybe<{ __typename: 'Link' } & LinkFragment>
    ctaPerksList: Array<
        { __typename: 'PerkListItem' } & Pick<PerkListItem, 'title'>
    >
}

type ProductAnalytics_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    | 'bandWidth'
    | 'segmentName'
    | 'deliveryDays'
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryBracelet['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        braceletProductStyles: Array<
            { __typename: 'JewelleryBraceletProductStyleLabel' } & Pick<
                JewelleryBraceletProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryEarrings['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        earringsProductStyles: Array<
            { __typename: 'JewelleryEarringsProductStyleLabel' } & Pick<
                JewelleryEarringsProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryNecklace['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        necklaceProductStyles: Array<
            { __typename: 'JewelleryNecklaceProductStyleLabel' } & Pick<
                JewelleryNecklaceProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & { jewellerySku: CatalogueJewelleryRing['sku'] } & {
        designStyles: Array<
            { __typename: 'JewelleryDesignStyleLabel' } & Pick<
                JewelleryDesignStyleLabel,
                'systemCode'
            >
        >
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        jewelleryRingProductStyles: Array<
            { __typename: 'JewelleryRingProductStyleLabel' } & Pick<
                JewelleryRingProductStyleLabel,
                'systemCode'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'segmentName' | 'deliveryDays' | 'catalogueCode' | 'productName' | 'suffix'
> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

type ProductAnalytics_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    | 'segmentName'
    | 'deliveryDays'
    | 'bandWidth'
    | 'catalogueCode'
    | 'productName'
    | 'suffix'
> & {
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            >
        >
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        ringStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            >
        >
        signatureStone: Maybe<
            { __typename: 'Melee' } & Pick<
                Melee,
                'id' | 'width' | 'caratWeight'
            > & {
                    shape: { __typename: 'StoneShape' } & Pick<
                        StoneShape,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneShapeTranslation'
                            } & Pick<StoneShapeTranslation, 'name'>
                        }
                    crystal: { __typename: 'StoneCrystal' } & Pick<
                        StoneCrystal,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneCrystalTranslation'
                            } & Pick<StoneCrystalTranslation, 'name'>
                        }
                    grade: Maybe<
                        { __typename: 'StoneGrade' } & Pick<
                            StoneGrade,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneGradeTranslation'
                                } & Pick<StoneGradeTranslation, 'name'>
                            }
                    >
                    colors: Array<
                        { __typename: 'StoneColor' } & Pick<
                            StoneColor,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneColorTranslation'
                                } & Pick<StoneColorTranslation, 'name'>
                            }
                    >
                    clarities: Array<
                        { __typename: 'StoneClarity' } & Pick<
                            StoneClarity,
                            'systemCode'
                        > & {
                                translation: {
                                    __typename: 'StoneClarityTranslation'
                                } & Pick<StoneClarityTranslation, 'name'>
                            }
                    >
                }
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<
            Metal,
            'systemCode' | 'millesimalFineness' | 'karat' | 'segmentName'
        > & {
                element: { __typename: 'MetalElement' } & Pick<
                    MetalElement,
                    'systemCode'
                >
            }
    }

export type ProductAnalyticsFragment =
    | ProductAnalytics_CatalogueEngagementRing_Fragment
    | ProductAnalytics_CatalogueJewelleryBracelet_Fragment
    | ProductAnalytics_CatalogueJewelleryEarrings_Fragment
    | ProductAnalytics_CatalogueJewelleryNecklace_Fragment
    | ProductAnalytics_CatalogueJewelleryRing_Fragment
    | ProductAnalytics_CatalogueReadyToGoRing_Fragment
    | ProductAnalytics_CatalogueWeddingRing_Fragment

type ProductListAnalytics_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<CatalogueEngagementRing, 'catalogueCode' | 'segmentName'> & {
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueEngagementRing_Fragment

type ProductListAnalytics_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<CatalogueJewelleryBracelet, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryBracelet['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryBracelet_Fragment

type ProductListAnalytics_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<CatalogueJewelleryEarrings, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryEarrings['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryEarrings_Fragment

type ProductListAnalytics_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<CatalogueJewelleryNecklace, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryNecklace['sku']
    } & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryNecklace_Fragment

type ProductListAnalytics_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'catalogueCode' | 'segmentName'> & {
        jewellerySku: CatalogueJewelleryRing['sku']
    } & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueJewelleryRing_Fragment

type ProductListAnalytics_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<CatalogueReadyToGoRing, 'catalogueCode' | 'segmentName'> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueReadyToGoRing_Fragment

type ProductListAnalytics_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<CatalogueWeddingRing, 'catalogueCode' | 'segmentName'> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & Pick<Money, 'currency' | 'amount'>
        }
        primaryMetal: { __typename: 'Metal' } & Pick<Metal, 'segmentName'>
    } & ProductLink_CatalogueWeddingRing_Fragment

export type ProductListAnalyticsFragment =
    | ProductListAnalytics_CatalogueEngagementRing_Fragment
    | ProductListAnalytics_CatalogueJewelleryBracelet_Fragment
    | ProductListAnalytics_CatalogueJewelleryEarrings_Fragment
    | ProductListAnalytics_CatalogueJewelleryNecklace_Fragment
    | ProductListAnalytics_CatalogueJewelleryRing_Fragment
    | ProductListAnalytics_CatalogueReadyToGoRing_Fragment
    | ProductListAnalytics_CatalogueWeddingRing_Fragment

export type GemsApiStoneAnalyticsFragment = {
    __typename: 'GemsApi_Stone'
} & Pick<GemsApi_Stone, 'weight' | 'originCountry'> & {
        crystalWithInfo: { __typename: 'GemsApi_StoneCrystalInfo' } & {
            info: Maybe<
                { __typename: 'StoneCrystal' } & Pick<
                    StoneCrystal,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneCrystalTranslation'
                        } & Pick<StoneCrystalTranslation, 'name'>
                    }
            >
        }
        shapeWithInfo: { __typename: 'GemsApi_StoneShapeInfo' } & {
            info: Maybe<
                { __typename: 'StoneShape' } & Pick<
                    StoneShape,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneShapeTranslation'
                        } & Pick<StoneShapeTranslation, 'name'>
                    }
            >
        }
        colorWithInfo: { __typename: 'GemsApi_StoneColorInfo' } & {
            info: Maybe<
                { __typename: 'StoneColor' } & Pick<
                    StoneColor,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneColorTranslation'
                        } & Pick<StoneColorTranslation, 'name'>
                    }
            >
        }
        clarityWithInfo: { __typename: 'GemsApi_StoneClarityInfo' } & {
            info: Maybe<
                { __typename: 'StoneClarity' } & Pick<
                    StoneClarity,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneClarityTranslation'
                        } & Pick<StoneClarityTranslation, 'name'>
                    }
            >
        }
        cutWithInfo: Maybe<
            { __typename: 'GemsApi_StoneCutInfo' } & {
                info: Maybe<
                    { __typename: 'StoneCut' } & Pick<
                        StoneCut,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneCutTranslation'
                            } & Pick<StoneCutTranslation, 'name'>
                        }
                >
            }
        >
        gradeWithInfo: Maybe<
            { __typename: 'GemsApi_StoneGradeInfo' } & {
                info: Maybe<
                    { __typename: 'StoneGrade' } & Pick<
                        StoneGrade,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneGradeTranslation'
                            } & Pick<StoneGradeTranslation, 'name'>
                        }
                >
            }
        >
    }

export type NonSkuGemstoneAnalyticsFragment = {
    __typename: 'NonSkuGemstone'
} & Pick<NonSkuGemstone, 'caratWeight'> & {
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        > & {
                translation: { __typename: 'StoneCrystalTranslation' } & Pick<
                    StoneCrystalTranslation,
                    'name'
                >
            }
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'> & {
                translation: { __typename: 'StoneColorTranslation' } & Pick<
                    StoneColorTranslation,
                    'name'
                >
            }
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        > & {
                translation: { __typename: 'StoneClarityTranslation' } & Pick<
                    StoneClarityTranslation,
                    'name'
                >
            }
        cut: { __typename: 'StoneCut' } & Pick<StoneCut, 'systemCode'> & {
                translation: { __typename: 'StoneCutTranslation' } & Pick<
                    StoneCutTranslation,
                    'name'
                >
            }
        colorGrade: { __typename: 'StoneGrade' } & Pick<
            StoneGrade,
            'systemCode'
        > & {
                translation: { __typename: 'StoneGradeTranslation' } & Pick<
                    StoneGradeTranslation,
                    'name'
                >
            }
    }

export type NonSkuLabGrownAnalyticsFragment = {
    __typename: 'NonSkuLabGrown'
} & Pick<NonSkuLabGrown, 'caratWeight'> & {
        crystal: { __typename: 'StoneCrystal' } & Pick<
            StoneCrystal,
            'systemCode'
        > & {
                translation: { __typename: 'StoneCrystalTranslation' } & Pick<
                    StoneCrystalTranslation,
                    'name'
                >
            }
        shape: { __typename: 'StoneShape' } & Pick<StoneShape, 'systemCode'> & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'> & {
                translation: { __typename: 'StoneColorTranslation' } & Pick<
                    StoneColorTranslation,
                    'name'
                >
            }
        clarity: { __typename: 'StoneClarity' } & Pick<
            StoneClarity,
            'systemCode'
        > & {
                translation: { __typename: 'StoneClarityTranslation' } & Pick<
                    StoneClarityTranslation,
                    'name'
                >
            }
        cut: { __typename: 'StoneCut' } & Pick<StoneCut, 'systemCode'> & {
                translation: { __typename: 'StoneCutTranslation' } & Pick<
                    StoneCutTranslation,
                    'name'
                >
            }
    }

export type AccentGemFragment = { __typename: 'CatalogueAccentGem' } & Pick<
    CatalogueAccentGem,
    'id' | 'quantity'
> & {
        melee: { __typename: 'Melee' } & Pick<Melee, 'caratWeight'> & {
                crystal: { __typename: 'StoneCrystal' } & Pick<
                    StoneCrystal,
                    'systemCode'
                > & {
                        translation: {
                            __typename: 'StoneCrystalTranslation'
                        } & Pick<StoneCrystalTranslation, 'name'>
                    }
                colors: Array<
                    { __typename: 'StoneColor' } & Pick<
                        StoneColor,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneColorTranslation'
                            } & Pick<StoneColorTranslation, 'name'>
                        }
                >
                clarities: Array<
                    { __typename: 'StoneClarity' } & Pick<
                        StoneClarity,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneClarityTranslation'
                            } & Pick<StoneClarityTranslation, 'name'>
                        }
                >
            }
    }

type ProductPageMeta_CatalogueEngagementRing_Fragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        erRingStyles: Array<
            { __typename: 'EngagementRingStyleLabel' } & Pick<
                EngagementRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & Pick<
    CatalogueJewelleryBracelet,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryBraceletTranslation'
        } & Pick<CatalogueJewelleryBraceletTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & Pick<
    CatalogueJewelleryEarrings,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryEarringsTranslation'
        } & Pick<CatalogueJewelleryEarringsTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & Pick<
    CatalogueJewelleryNecklace,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: {
            __typename: 'CatalogueJewelleryNecklaceTranslation'
        } & Pick<CatalogueJewelleryNecklaceTranslation, 'description'>
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<
    CatalogueJewelleryRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueJewelleryRingTranslation' } & Pick<
            CatalogueJewelleryRingTranslation,
            'description'
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueReadyToGoRing_Fragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'sku' | 'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueReadyToGoRingTranslation' } & Pick<
            CatalogueReadyToGoRingTranslation,
            'description'
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

type ProductPageMeta_CatalogueWeddingRing_Fragment = {
    __typename: 'CatalogueWeddingRing'
} & Pick<
    CatalogueWeddingRing,
    'catalogueCode' | 'productName' | 'customTitleTag'
> & {
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'description'
        >
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        wrRingStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        reviews: Array<
            { __typename: 'Review' } & Pick<
                Review,
                'id' | 'name' | 'comment' | 'date' | 'rating'
            > & { picture: Maybe<{ __typename: 'Asset' } & AssetFragment> }
        >
        primaryMetal: { __typename: 'Metal' } & MetalFilterMetalFragment
        images: Array<
            { __typename: 'CatalogueImage' } & Pick<
                CatalogueImage,
                'id' | 'url'
            >
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        }
    }

export type ProductPageMetaFragment =
    | ProductPageMeta_CatalogueEngagementRing_Fragment
    | ProductPageMeta_CatalogueJewelleryBracelet_Fragment
    | ProductPageMeta_CatalogueJewelleryEarrings_Fragment
    | ProductPageMeta_CatalogueJewelleryNecklace_Fragment
    | ProductPageMeta_CatalogueJewelleryRing_Fragment
    | ProductPageMeta_CatalogueReadyToGoRing_Fragment
    | ProductPageMeta_CatalogueWeddingRing_Fragment

export type EngagementRingPageQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
    engagementRingFilter: CatalogueEngagementRingFilterInput
}>

export type EngagementRingPageQuery = { __typename: 'Query' } & {
    catalogueEngagementRing: Maybe<
        {
            __typename: 'CatalogueEngagementRing'
        } & CatalogueEngagementRingFragment
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
                accordionItems: Array<
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemAboutThisProduct'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemDesignInspiration'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemFinance'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemGeneric'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemShipping'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemSizing'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemWarranty'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment)
                >
            } & CtaBoxFragment
    >
}

export type CatalogueEngagementRingFragment = {
    __typename: 'CatalogueEngagementRing'
} & Pick<
    CatalogueEngagementRing,
    | 'supportsExpress'
    | 'isResizeable'
    | 'catalogueCode'
    | 'productName'
    | 'bandWidth'
> & {
        accentGemItems: Array<
            { __typename: 'CatalogueAccentGem' } & AccentGemFragment
        >
        noEngravingDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        hasEngravingDeliveryDate: {
            __typename: 'DeliveryDate'
        } & DeliveryTimeframeFragment
        reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
        reviewsAggregate: {
            __typename: 'ReviewsAggregate'
        } & ReviewsAggregateFragment
        salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
        variationsByCentreStoneShape: Array<
            { __typename: 'CatalogueEngagementRing' } & {
                centreStoneConstraints: {
                    __typename: 'CatalogueEngagementRingCentreStoneConstraints'
                } & {
                    shape: { __typename: 'StoneShape' } & Pick<
                        StoneShape,
                        'systemCode'
                    > & {
                            translation: {
                                __typename: 'StoneShapeTranslation'
                            } & Pick<StoneShapeTranslation, 'name'>
                            icon: Maybe<
                                { __typename: 'Asset' } & Pick<
                                    Asset,
                                    'id' | 'url'
                                >
                            >
                        }
                }
            } & EngagementRingLinkFragment
        >
        variationsByPrimaryMetal: Array<
            {
                __typename: 'CatalogueEngagementRing'
            } & MetalVariation_CatalogueEngagementRing_Fragment &
                EngagementRingLinkFragment
        >
        relatedProducts: Array<
            {
                __typename: 'CatalogueEngagementRing'
            } & RelatedProduct_CatalogueEngagementRing_Fragment
        >
        primaryMetal: { __typename: 'Metal' } & {
            translation: { __typename: 'MetalTranslation' } & Pick<
                MetalTranslation,
                'name'
            >
        }
        translation: {
            __typename: 'CatalogueEngagementRingTranslation'
        } & Pick<CatalogueEngagementRingTranslation, 'seoText'>
        centreStoneConstraints: {
            __typename: 'CatalogueEngagementRingCentreStoneConstraints'
        } & {
            shape: { __typename: 'StoneShape' } & {
                translation: { __typename: 'StoneShapeTranslation' } & Pick<
                    StoneShapeTranslation,
                    'name'
                >
            }
        }
        signatureStone: Maybe<
            { __typename: 'Melee' } & Pick<Melee, 'width'> & {
                    colors: Array<
                        { __typename: 'StoneColor' } & Pick<
                            StoneColor,
                            'systemCode'
                        >
                    >
                    crystal: { __typename: 'StoneCrystal' } & Pick<
                        StoneCrystal,
                        'systemCode'
                    >
                }
        >
        signatureStones: Array<
            {
                __typename: 'CatalogueEngagementRingAndSignatureStone'
            } & EngagementRingAndSignatureStoneFragment
        >
    } & EngagementRingLinkFragment &
    ProductPageMeta_CatalogueEngagementRing_Fragment &
    ProductGallery_CatalogueEngagementRing_Fragment &
    ProductAnalytics_CatalogueEngagementRing_Fragment &
    ShopWithConfidenceProduct_CatalogueEngagementRing_Fragment

export type EngagementRingAndSignatureStoneFragment = {
    __typename: 'CatalogueEngagementRingAndSignatureStone'
} & {
    salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
    signatureStone: {
        __typename: 'CatalogueEngagementRingSignatureStone'
    } & Pick<CatalogueEngagementRingSignatureStone, 'isDefault' | 'image'> & {
            crystal: { __typename: 'StoneCrystal' } & Pick<
                StoneCrystal,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'StoneCrystalTranslation'
                    } & Pick<StoneCrystalTranslation, 'name'>
                }
            color: { __typename: 'StoneColor' } & Pick<
                StoneColor,
                'systemCode'
            > & {
                    translation: { __typename: 'StoneColorTranslation' } & Pick<
                        StoneColorTranslation,
                        'name'
                    >
                }
            price: { __typename: 'Money' } & MoneyFragment
        } & SignatureStoneInputFragment
}

export type EngagementRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueEngagementRingsFilterInput
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit: Scalars['Int']['input']
    path: Scalars['String']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type EngagementRingBrowseQuery = { __typename: 'Query' } & {
    catalogueEngagementRingFilters: {
        __typename: 'CatalogueEngagementRingFilters'
    } & EngagementRingFiltersFragment
    catalogueEngagementRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueEngagementRings: Array<
        {
            __typename: 'CatalogueEngagementRing'
        } & ProductGrid_CatalogueEngagementRing_Fragment
    >
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type StoneRecommendationsQueryVariables = Exact<{
    minPrice: InputMaybe<MoneyInput>
    maxPrice: InputMaybe<MoneyInput>
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    hasPrice: Scalars['Boolean']['input']
}>

export type StoneRecommendationsQuery = { __typename: 'Query' } & {
    ringBuilder: { __typename: 'RingBuilder' } & Pick<RingBuilder, 'id'> & {
            position1: Maybe<
                | ({
                      __typename: 'RingBuilderCentreStoneFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment)
                | ({
                      __typename: 'RingBuilderMountFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment)
            >
            position2: Maybe<
                | ({
                      __typename: 'RingBuilderCentreStoneFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment)
                | ({
                      __typename: 'RingBuilderMountFragment'
                  } & RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment)
            >
        }
    cms: Maybe<
        { __typename: 'EngagementRingStoneRecommendations' } & Pick<
            EngagementRingStoneRecommendations,
            'fullSearchButtonText'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                naturalDiamonds: {
                    __typename: 'EngagementRingStoneRecommendationNaturalDiamonds'
                } & {
                    forSizeCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    forBalanceCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    labGrownAlternative: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                }
                nonSkuLabGrown: {
                    __typename: 'EngagementRingStoneRecommendationNonSkuLabGrown'
                } & {
                    forSizeCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    forPriceCard: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                    naturalDiamondAlternative: {
                        __typename: 'EngagementRingStoneRecommendationCard'
                    } & EngagementRingStoneRecommendationCardFragment
                }
                nonSkuGemStones: Array<
                    {
                        __typename: 'EngagementRingStoneRecommendationNonSkuGemStoneCard'
                    } & Pick<
                        EngagementRingStoneRecommendationNonSkuGemStoneCard,
                        'color'
                    > & {
                            content: {
                                __typename: 'EngagementRingStoneRecommendationCard'
                            } & EngagementRingStoneRecommendationCardFragment
                        }
                >
            }
    >
}

type RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment = {
    __typename: 'RingBuilderCentreStoneFragment'
} & Pick<RingBuilderCentreStoneFragment, 'id'>

type RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment = {
    __typename: 'RingBuilderMountFragment'
} & Pick<RingBuilderMountFragment, 'id'> & {
        stoneRecommendations:
            | ({
                  __typename: 'StoneRecommendationsResponseFailure'
              } & StoneRecommendations_StoneRecommendationsResponseFailure_Fragment)
            | ({
                  __typename: 'StoneRecommendationsResponseSuccess'
              } & StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment)
    }

export type RingBuilderStoneRecommendationsFragment =
    | RingBuilderStoneRecommendations_RingBuilderCentreStoneFragment_Fragment
    | RingBuilderStoneRecommendations_RingBuilderMountFragment_Fragment

type StoneRecommendations_StoneRecommendationsResponseFailure_Fragment = {
    __typename: 'StoneRecommendationsResponseFailure'
} & Pick<StoneRecommendationsResponseFailure, 'error'>

type StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment = {
    __typename: 'StoneRecommendationsResponseSuccess'
} & {
    priceBounds: { __typename: 'StoneRecommendationsPriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
    priceInitialValues?: { __typename: 'StoneRecommendationsPriceRange' } & {
        min: { __typename: 'Money' } & MoneyFragment
        max: { __typename: 'Money' } & MoneyFragment
    }
    naturalDiamondBestForBalance:
        | ({ __typename: 'GemsApi_Stone' } & StoneFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    naturalDiamondBestForSize:
        | ({ __typename: 'GemsApi_Stone' } & StoneFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    skuGemStones: Array<
        {
            __typename: 'StoneRecommendationGemsApiGemstone'
        } & StoneRecommendationGemsApiGemstoneFragment
    >
    nonSkuLabGrownBestForPrice:
        | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
    nonSkuLabGrownBestForSize:
        | ({ __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
}

export type StoneRecommendationsFragment =
    | StoneRecommendations_StoneRecommendationsResponseFailure_Fragment
    | StoneRecommendations_StoneRecommendationsResponseSuccess_Fragment

export type StoneRecommendationGemsApiGemstoneFragment = {
    __typename: 'StoneRecommendationGemsApiGemstone'
} & {
    color: { __typename: 'StoneColor' } & Pick<StoneColor, 'systemCode'> & {
            translation: { __typename: 'StoneColorTranslation' } & Pick<
                StoneColorTranslation,
                'name'
            >
        }
    stone:
        | ({ __typename: 'GemsApi_Stone' } & StoneFragment)
        | ({
              __typename: 'StoneRecommendationNotFound'
          } & StoneRecommendationsNotFoundFragment)
}

export type EngagementRingStoneRecommendationCardFragment = {
    __typename: 'EngagementRingStoneRecommendationCard'
} & Pick<EngagementRingStoneRecommendationCard, 'title' | 'description'> & {
        notSupportedContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
        notFoundContent: Array<
            | ({
                  __typename: 'ComponentButton'
              } & ContentComponentItem_ComponentButton_Fragment)
            | ({
                  __typename: 'ComponentImage'
              } & ContentComponentItem_ComponentImage_Fragment)
            | ({
                  __typename: 'ComponentOrderedList'
              } & ContentComponentItem_ComponentOrderedList_Fragment)
            | ({
                  __typename: 'ComponentSpacer'
              } & ContentComponentItem_ComponentSpacer_Fragment)
            | ({
                  __typename: 'ComponentText'
              } & ContentComponentItem_ComponentText_Fragment)
            | ({
                  __typename: 'ComponentTitle'
              } & ContentComponentItem_ComponentTitle_Fragment)
        >
    }

export type JewelleryBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueJewelleriesFilterInput
    braceletFilter: CatalogueJewelleriesBraceletsFilterInput
    necklaceFilter: CatalogueJewelleriesNecklacesFilterInput
    earringsFilter: CatalogueJewelleriesEarringsFilterInput
    ringsFilter: CatalogueJewelleriesRingsFilterInput
    isJewellery: Scalars['Boolean']['input']
    isBracelet: Scalars['Boolean']['input']
    isNecklace: Scalars['Boolean']['input']
    isEarrings: Scalars['Boolean']['input']
    isRing: Scalars['Boolean']['input']
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit?: InputMaybe<Scalars['Int']['input']>
    path: Scalars['String']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type JewelleryBrowseQuery = { __typename: 'Query' } & {
    catalogueJewelleriesFilters?: {
        __typename: 'CatalogueJewelleriesFilters'
    } & JewelleryFiltersFragment
    catalogueJewelleries?: Array<
        | ({
              __typename: 'CatalogueJewelleryBracelet'
          } & ProductGrid_CatalogueJewelleryBracelet_Fragment)
        | ({
              __typename: 'CatalogueJewelleryEarrings'
          } & ProductGrid_CatalogueJewelleryEarrings_Fragment)
        | ({
              __typename: 'CatalogueJewelleryNecklace'
          } & ProductGrid_CatalogueJewelleryNecklace_Fragment)
        | ({
              __typename: 'CatalogueJewelleryRing'
          } & ProductGrid_CatalogueJewelleryRing_Fragment)
    >
    catalogueJewelleryNecklacesFilters?: {
        __typename: 'CatalogueJewelleryNecklacesFilters'
    } & JewelleryNecklaceFiltersFragment
    catalogueJewelleryNecklaces?: Array<
        {
            __typename: 'CatalogueJewelleryNecklace'
        } & ProductGrid_CatalogueJewelleryNecklace_Fragment
    >
    catalogueJewelleryBraceletsFilters?: {
        __typename: 'CatalogueJewelleryBraceletsFilters'
    } & JewelleryBraceletFiltersFragment
    catalogueJewelleryBracelets?: Array<
        {
            __typename: 'CatalogueJewelleryBracelet'
        } & ProductGrid_CatalogueJewelleryBracelet_Fragment
    >
    catalogueJewelleryEarringsFilters?: {
        __typename: 'CatalogueJewelleryEarringsFilters'
    } & JewelleryEarringsFiltersFragment
    catalogueJewelleryEarrings?: Array<
        {
            __typename: 'CatalogueJewelleryEarrings'
        } & ProductGrid_CatalogueJewelleryEarrings_Fragment
    >
    catalogueJewelleryRingsFilters?: {
        __typename: 'CatalogueJewelleryRingsFilters'
    } & JewelleryRingsFiltersFragment
    catalogueJewelleryRings?: Array<
        {
            __typename: 'CatalogueJewelleryRing'
        } & ProductGrid_CatalogueJewelleryRing_Fragment
    >
    catalogueJewelleriesAggregate: { __typename: 'CatalogueAggregate' } & Pick<
        CatalogueAggregate,
        'count'
    >
    catalogueJewelleryBraceletsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryEarringsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryNecklacesAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueJewelleryRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type JewelleryFiltersFragment = {
    __typename: 'CatalogueJewelleriesFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryNecklaceFiltersFragment = {
    __typename: 'CatalogueJewelleryNecklacesFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryNecklaceProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryNecklaceProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryNecklaceProductStyleLabel'
                } & JewelleryNecklaceProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryBraceletFiltersFragment = {
    __typename: 'CatalogueJewelleryBraceletsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryBraceletProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryBraceletProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryBraceletProductStyleLabel'
                } & JewelleryBraceletProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryEarringsFiltersFragment = {
    __typename: 'CatalogueJewelleryEarringsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryEarringsProductStyleLabel'
        } & Pick<
            CatalogueFilterJewelleryEarringsProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryEarringsProductStyleLabel'
                } & JewelleryEarringsProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryRingsFiltersFragment = {
    __typename: 'CatalogueJewelleryRingsFilters'
} & {
    price: {
        __typename: 'CataloguePriceRangeFilter'
    } & FilterPriceRangeFragment
    primaryMetals: Array<
        { __typename: 'CatalogueFilterMetalItem' } & MetalFilterFragment
    >
    productStyles: Array<
        { __typename: 'CatalogueFilterJewelleryRingProductStyleLabel' } & Pick<
            CatalogueFilterJewelleryRingProductStyleLabel,
            'totalResults'
        > & {
                label: {
                    __typename: 'JewelleryRingProductStyleLabel'
                } & JewelleryRingProductStyleLabelFragment
            }
    >
    designStyles: Array<
        {
            __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
        } & JewelleryDesignStyleFilterFragment
    >
    gemstones: Array<
        {
            __typename: 'CatalogueFilterJewelleryGemstoneLabel'
        } & CatalogueFilterJewelleryGemstoneLabelFragment
    >
}

export type JewelleryDesignStyleFilterFragment = {
    __typename: 'CatalogueFilterJewelleryDesignStyleLabel'
} & Pick<CatalogueFilterJewelleryDesignStyleLabel, 'totalResults'> & {
        label: {
            __typename: 'JewelleryDesignStyleLabel'
        } & JewelleryDesignStyleLabelFragment
    }

export type JewelleryDesignStyleLabelFragment = {
    __typename: 'JewelleryDesignStyleLabel'
} & Pick<JewelleryDesignStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryNecklaceProductStyleLabelFragment = {
    __typename: 'JewelleryNecklaceProductStyleLabel'
} & Pick<JewelleryNecklaceProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryBraceletProductStyleLabelFragment = {
    __typename: 'JewelleryBraceletProductStyleLabel'
} & Pick<JewelleryBraceletProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryEarringsProductStyleLabelFragment = {
    __typename: 'JewelleryEarringsProductStyleLabel'
} & Pick<JewelleryEarringsProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryRingProductStyleLabelFragment = {
    __typename: 'JewelleryRingProductStyleLabel'
} & Pick<JewelleryRingProductStyleLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type CatalogueFilterJewelleryGemstoneLabelFragment = {
    __typename: 'CatalogueFilterJewelleryGemstoneLabel'
} & Pick<CatalogueFilterJewelleryGemstoneLabel, 'totalResults'> & {
        label: {
            __typename: 'JewelleryGemstoneLabel'
        } & JewelleryGemstoneLabelFragment
    }

export type JewelleryGemstoneLabelFragment = {
    __typename: 'JewelleryGemstoneLabel'
} & Pick<JewelleryGemstoneLabel, 'systemCode'> & {
        translation: { __typename: 'ProductLabelTranslation' } & Pick<
            ProductLabelTranslation,
            'name'
        > &
            FacetedContentProductLabelTranslationFragment
        icon: Maybe<{ __typename: 'Asset' } & AssetFragment>
    }

export type JewelleryDetailsQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    suffixSlug: InputMaybe<Scalars['String']['input']>
    locale: Scalars['Locale']['input']
    region: RegionCode
    currency: CurrencyInput
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
    type: CatalogueJewelleryType
}>

export type JewelleryDetailsQuery = { __typename: 'Query' } & {
    catalogueJewellery: Maybe<
        | ({
              __typename: 'CatalogueJewelleryBracelet'
          } & JewelleryDetails_CatalogueJewelleryBracelet_Fragment)
        | ({
              __typename: 'CatalogueJewelleryEarrings'
          } & JewelleryDetails_CatalogueJewelleryEarrings_Fragment)
        | ({
              __typename: 'CatalogueJewelleryNecklace'
          } & JewelleryDetails_CatalogueJewelleryNecklace_Fragment)
        | ({
              __typename: 'CatalogueJewelleryRing'
          } & JewelleryDetails_CatalogueJewelleryRing_Fragment)
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
                accordionItems: Array<
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemAboutThisProduct'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemDesignInspiration'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemFinance'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemGeneric'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemShipping'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemSizing'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemWarranty'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment)
                >
            } & CtaBoxFragment
    >
}

type JewelleryDetails_CatalogueJewelleryBracelet_Fragment = {
    __typename: 'CatalogueJewelleryBracelet'
} & {
    financeOptionsAffirm: Maybe<
        { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
    >
    reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
    reviewsAggregate: {
        __typename: 'ReviewsAggregate'
    } & ReviewsAggregateFragment
} & Jewellery_CatalogueJewelleryBracelet_Fragment &
    JewelleryLink_CatalogueJewelleryBracelet_Fragment &
    ShopWithConfidenceProduct_CatalogueJewelleryBracelet_Fragment

type JewelleryDetails_CatalogueJewelleryEarrings_Fragment = {
    __typename: 'CatalogueJewelleryEarrings'
} & {
    financeOptionsAffirm: Maybe<
        { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
    >
    reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
    reviewsAggregate: {
        __typename: 'ReviewsAggregate'
    } & ReviewsAggregateFragment
} & Jewellery_CatalogueJewelleryEarrings_Fragment &
    JewelleryLink_CatalogueJewelleryEarrings_Fragment &
    ShopWithConfidenceProduct_CatalogueJewelleryEarrings_Fragment

type JewelleryDetails_CatalogueJewelleryNecklace_Fragment = {
    __typename: 'CatalogueJewelleryNecklace'
} & {
    financeOptionsAffirm: Maybe<
        { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
    >
    reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
    reviewsAggregate: {
        __typename: 'ReviewsAggregate'
    } & ReviewsAggregateFragment
} & Jewellery_CatalogueJewelleryNecklace_Fragment &
    JewelleryLink_CatalogueJewelleryNecklace_Fragment &
    ShopWithConfidenceProduct_CatalogueJewelleryNecklace_Fragment

type JewelleryDetails_CatalogueJewelleryRing_Fragment = {
    __typename: 'CatalogueJewelleryRing'
} & Pick<CatalogueJewelleryRing, 'isResizeable'> & {
        financeOptionsAffirm: Maybe<
            { __typename: 'AffirmFinanceOption' } & AffirmFinanceOptionsFragment
        >
        reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
        reviewsAggregate: {
            __typename: 'ReviewsAggregate'
        } & ReviewsAggregateFragment
    } & Jewellery_CatalogueJewelleryRing_Fragment &
    JewelleryLink_CatalogueJewelleryRing_Fragment &
    ShopWithConfidenceProduct_CatalogueJewelleryRing_Fragment

export type JewelleryDetailsFragment =
    | JewelleryDetails_CatalogueJewelleryBracelet_Fragment
    | JewelleryDetails_CatalogueJewelleryEarrings_Fragment
    | JewelleryDetails_CatalogueJewelleryNecklace_Fragment
    | JewelleryDetails_CatalogueJewelleryRing_Fragment

export type ReadyToGoRingFragment = {
    __typename: 'CatalogueReadyToGoRing'
} & Pick<
    CatalogueReadyToGoRing,
    'carat' | 'gemType' | 'sku' | 'isReadyToShip'
> & {
        salePrice: { __typename: 'SalePrice' } & TaxSnippetFragment
        sizes: Array<
            { __typename: 'RecommendedRingSize' } & RecommendedRingSizeFragment
        >
        variations: Array<
            {
                __typename: 'CatalogueReadyToGoRing'
            } & ReadyToGoRingVariationsFragment
        >
        translation: {
            __typename: 'CatalogueReadyToGoRingTranslation'
        } & CatalogueReadyToGoRingTranslationFragment
        reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
    } & CatalogueProduct_CatalogueReadyToGoRing_Fragment &
    ProductGallery_CatalogueReadyToGoRing_Fragment &
    ReadyToGoRingLinkFragment &
    ProductPageMeta_CatalogueReadyToGoRing_Fragment

export type GetReadyToGoRingQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
}>

export type GetReadyToGoRingQuery = { __typename: 'Query' } & {
    catalogueReadyToGoRing: Maybe<
        { __typename: 'CatalogueReadyToGoRing' } & {
            firstAvailableDeliveryDate: {
                __typename: 'DeliveryDate'
            } & DeliveryTimeframeFragment
            financeOptionsAffirm: Maybe<
                {
                    __typename: 'AffirmFinanceOption'
                } & AffirmFinanceOptionsFragment
            >
            reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
        } & ReadyToGoRingFragment &
            ShopWithConfidenceProduct_CatalogueReadyToGoRing_Fragment &
            ProductAnalytics_CatalogueReadyToGoRing_Fragment
    >
}

export type GetReadyToGoRingContentQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
}>

export type GetReadyToGoRingContentQuery = { __typename: 'Query' } & {
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                accordionItems: Array<
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemAboutThisProduct'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemDesignInspiration'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemFinance'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemGeneric'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemShipping'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemSizing'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemWarranty'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment)
                >
            } & CtaBoxFragment
    >
}

export type ReadyToGoRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueReadyToGoRingsFilterInput
    page: Scalars['Int']['input']
    limit: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    sortBy: CatalogueSortOrder
}>

export type ReadyToGoRingBrowseQuery = { __typename: 'Query' } & {
    catalogueReadyToGoRingsFilters: {
        __typename: 'CatalogueReadyToGoRingFilters'
    } & ReadyToGoRingFiltersFragment
    catalogueReadyToGoRingsAggregate: {
        __typename: 'CatalogueAggregate'
    } & Pick<CatalogueAggregate, 'count'>
    catalogueReadyToGoRings: Array<
        {
            __typename: 'CatalogueReadyToGoRing'
        } & ProductGrid_CatalogueReadyToGoRing_Fragment
    >
}

export type ReadyToGoRingsContentQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
    currency: CurrencyInput
    region: RegionCode
}>

export type ReadyToGoRingsContentQuery = { __typename: 'Query' } & {
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type WeddingRingFragment = { __typename: 'CatalogueWeddingRing' } & Pick<
    CatalogueWeddingRing,
    'bandWidth' | 'bandThickness'
> & {
        video: Maybe<{ __typename: 'CatalogueVideo' } & CatalogueVideoFragment>
        accentGemItems: Array<
            { __typename: 'CatalogueAccentGem' } & AccentGemFragment
        >
        categories: Array<
            { __typename: 'WeddingRingCategoryLabel' } & Pick<
                WeddingRingCategoryLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        ringStyles: Array<
            { __typename: 'WeddingRingStyleLabel' } & Pick<
                WeddingRingStyleLabel,
                'systemCode'
            > & {
                    translation: {
                        __typename: 'ProductLabelTranslation'
                    } & Pick<ProductLabelTranslation, 'name'>
                }
        >
        variations: Array<
            { __typename: 'CatalogueWeddingRing' } & Pick<
                CatalogueWeddingRing,
                'catalogueCode' | 'suffix' | 'productName'
            > & {
                    primaryMetal: {
                        __typename: 'Metal'
                    } & MetalFilterMetalFragment
                } & WeddingRingLinkFragment
        >
        translation: { __typename: 'CatalogueWeddingRingTranslation' } & Pick<
            CatalogueWeddingRingTranslation,
            'seoText' | 'description'
        >
        salePrice: { __typename: 'SalePrice' } & {
            total: { __typename: 'Money' } & MoneyFragment
        } & TaxSnippetFragment
        sizes: Array<
            | ({
                  __typename: 'RecommendedRingSize'
              } & RecommendedRingSizeFragment)
            | ({ __typename: 'RingSize' } & RingSizeFragment)
        >
    } & CatalogueProduct_CatalogueWeddingRing_Fragment &
    ProductGallery_CatalogueWeddingRing_Fragment &
    ProductPageMeta_CatalogueWeddingRing_Fragment &
    WeddingRingLinkFragment

export type GetWeddingRingQueryVariables = Exact<{
    slug: Scalars['String']['input']
    metal: MetalCode
    suffixSlug: InputMaybe<Scalars['String']['input']>
    locale: Scalars['Locale']['input']
    currency: CurrencyInput
    region: RegionCode
    page: Scalars['String']['input']
    pageFallback: Scalars['String']['input']
}>

export type GetWeddingRingQuery = { __typename: 'Query' } & {
    catalogueWeddingRing: Maybe<
        { __typename: 'CatalogueWeddingRing' } & Pick<
            CatalogueWeddingRing,
            'isResizeable'
        > & {
                firstAvailableDeliveryDateWithoutEngraving: {
                    __typename: 'DeliveryDate'
                } & DeliveryTimeframeFragment
                firstAvailableDeliveryDateWithEngraving: {
                    __typename: 'DeliveryDate'
                } & DeliveryTimeframeFragment
                financeOptionsAffirm: Maybe<
                    {
                        __typename: 'AffirmFinanceOption'
                    } & AffirmFinanceOptionsFragment
                >
                reviews: Array<{ __typename: 'Review' } & ReviewsFragment>
                reviewsAggregate: {
                    __typename: 'ReviewsAggregate'
                } & ReviewsAggregateFragment
            } & WeddingRingFragment &
            ShopWithConfidenceProduct_CatalogueWeddingRing_Fragment &
            ProductAnalytics_CatalogueWeddingRing_Fragment
    >
    pageProductDetails: Maybe<
        { __typename: 'ProductPageDetails' } & Pick<
            ProductPageDetails,
            'id'
        > & {
                blocks: Array<{ __typename: 'Block' } & BlockFragment>
                meta: { __typename: 'Meta' } & MetaFragment
                priceExplainedTooltip: Maybe<
                    { __typename: 'PageTooltip' } & PageTooltipFragment
                >
                accordionItems: Array<
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemAboutThisProduct'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemAboutThisProduct_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemDesignInspiration'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemDesignInspiration_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemFinance'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemFinance_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemGeneric'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemGeneric_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemShipping'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemShipping_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemSizing'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemSizing_Fragment)
                    | ({
                          __typename: 'ProductPageDetailsAccordionItemWarranty'
                      } & PdpAccordionItem_ProductPageDetailsAccordionItemWarranty_Fragment)
                >
            } & CtaBoxFragment
    >
}

export type WeddingRingBrowseQueryVariables = Exact<{
    currency: CurrencyInput
    region: RegionCode
    filter: CatalogueWeddingRingFilterInput
    page: Scalars['Int']['input']
    locale: Scalars['Locale']['input']
    limit: Scalars['Int']['input']
    facetedContentInput: ProductPageFacetedContentInput
    sortBy: CatalogueSortOrder
}>

export type WeddingRingBrowseQuery = { __typename: 'Query' } & {
    catalogueWeddingRingFilters: {
        __typename: 'CatalogueWeddingRingFilters'
    } & WeddingRingFiltersFragment
    catalogueWeddingRingsAggregate: { __typename: 'CatalogueAggregate' } & Pick<
        CatalogueAggregate,
        'count'
    >
    catalogueWeddingRings: Array<
        {
            __typename: 'CatalogueWeddingRing'
        } & ProductGrid_CatalogueWeddingRing_Fragment
    >
    pageProductListingFacetedContent: Maybe<
        {
            __typename: 'ProductPageFacetedContent'
        } & ProductPageFacetedContentFragment
    >
}

export type WeddingRingBrowseContentQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
    path: Scalars['String']['input']
    region: RegionCode
    currency: CurrencyInput
}>

export type WeddingRingBrowseContentQuery = { __typename: 'Query' } & {
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type MyOrdersQueryVariables = Exact<{
    locale: Scalars['Locale']['input']
}>

export type MyOrdersQuery = { __typename: 'Query' } & {
    me: Maybe<
        { __typename: 'User' } & Pick<User, 'id'> & {
                customer: Maybe<
                    { __typename: 'Customer' } & Pick<Customer, 'id'> & {
                            orders: Array<
                                {
                                    __typename: 'Order'
                                } & OrderListViewFragment &
                                    OrderDetailedViewFragment &
                                    LinkOrderFragment
                            >
                        }
                >
            }
    >
}

export type OrderListViewFragment = { __typename: 'Order' } & Pick<
    Order,
    'id' | 'placementDate'
> & {
        totalAmount: { __typename: 'Money' } & MoneyFragment
        status: { __typename: 'OrderStatus' } & Pick<OrderStatus, 'name'>
    }

export type OrderDetailedViewFragment = { __typename: 'Order' } & Pick<
    Order,
    'isPayable'
> & {
        products: Array<
            { __typename: 'OrderProduct' } & Pick<
                OrderProduct,
                'id' | 'name'
            > & {
                    designStudioProduct: Maybe<
                        | ({
                              __typename: 'DesignStudioProductAdditionalResize'
                          } & Pick<
                              DesignStudioProductAdditionalResize,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductAdditionalResize_Fragment)
                        | ({ __typename: 'DesignStudioProductCustom' } & Pick<
                              DesignStudioProductCustom,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductCustom_Fragment)
                        | ({
                              __typename: 'DesignStudioProductEngagementRing'
                          } & Pick<DesignStudioProductEngagementRing, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductEngagementRing_Fragment)
                        | ({ __typename: 'DesignStudioProductGeneric' } & Pick<
                              DesignStudioProductGeneric,
                              'name'
                          > &
                              LinkDesignStudioProduct_DesignStudioProductGeneric_Fragment)
                        | ({
                              __typename: 'DesignStudioProductLooseStone'
                          } & Pick<DesignStudioProductLooseStone, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductLooseStone_Fragment)
                        | ({
                              __typename: 'DesignStudioProductWeddingRing'
                          } & Pick<DesignStudioProductWeddingRing, 'name'> &
                              LinkDesignStudioProduct_DesignStudioProductWeddingRing_Fragment)
                    >
                }
        >
        paidAmount: { __typename: 'Money' } & MoneyFragment
        remainingAmount: { __typename: 'Money' } & MoneyFragment
        paymentPlan: { __typename: 'PaymentPlan' } & {
            paid: Array<
                { __typename: 'PaymentPlanPaidRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
            upcoming: Array<
                { __typename: 'PaymentPlanUpcomingRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
            current: Maybe<
                { __typename: 'PaymentPlanUpcomingRecord' } & {
                    amount: { __typename: 'Money' } & MoneyFragment
                }
            >
        }
        prediscountTotalAmount: { __typename: 'Money' } & MoneyFragment
        totalAmount: { __typename: 'Money' } & MoneyFragment
        basePromoCode: Maybe<
            | ({ __typename: 'MultiUsePromoCode' } & Pick<
                  MultiUsePromoCode,
                  'id'
              >)
            | ({ __typename: 'SingleUsePromoCode' } & Pick<
                  SingleUsePromoCode,
                  'id'
              >)
        >
        shippingAddress: { __typename: 'OrderAddress' } & Pick<
            OrderAddress,
            | 'id'
            | 'firstName'
            | 'lastName'
            | 'addressLine1'
            | 'addressLine2'
            | 'city'
            | 'postalCode'
            | 'country'
        > & {
                phoneNumber: Maybe<
                    { __typename: 'PhoneNumberType' } & Pick<
                        PhoneNumberType,
                        'formatted'
                    >
                >
            }
        shipmentTrackingInformation: Maybe<
            { __typename: 'ShipmentTrackingInformation' } & Pick<
                ShipmentTrackingInformation,
                'dispatchedAt' | 'shippingCompany' | 'trackingNumber'
            >
        >
        transactions: Array<
            | ({ __typename: 'AffirmTransaction' } & Pick<
                  AffirmTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'AllocationTransaction' } & Pick<
                  AllocationTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'BankTransaction' } & Pick<
                  BankTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'CheckoutcomTransaction' } & Pick<
                  CheckoutcomTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'KlarnaTransaction' } & Pick<
                  KlarnaTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'LegacyTransaction' } & Pick<
                  LegacyTransaction,
                  'paymentMethodName' | 'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
            | ({ __typename: 'StripeTransaction' } & Pick<
                  StripeTransaction,
                  'id' | 'createdAt'
              > & {
                      status: { __typename: 'TransactionStatus' } & Pick<
                          TransactionStatus,
                          'systemCode' | 'name'
                      >
                      amount: { __typename: 'Money' } & MoneyFragment
                  })
        >
    } & OrderListViewFragment

export type RedirectDiamondSearchStoneByLabAndNumberQueryVariables = Exact<{
    number: Scalars['String']['input']
}>

export type RedirectDiamondSearchStoneByLabAndNumberQuery = {
    __typename: 'Query'
} & {
    GemsApi_getGiaStone: Maybe<
        { __typename: 'GemsApi_Stone' } & Pick<GemsApi_Stone, 'identifier'>
    >
}

export type GemstoneSearchQueryVariables = Exact<{
    filters: NonSkuGemstoneFilters
    sort: NonSkuGemstoneSortInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    contentPath: Scalars['String']['input']
}>

export type GemstoneSearchQuery = { __typename: 'Query' } & {
    nonSkuGemStones: Array<
        { __typename: 'NonSkuGemstone' } & NonSkuGemstoneFragment
    >
    nonSkuGemStonesBounds: {
        __typename: 'NonSkuGemstonesBounds'
    } & NonSkuGemstoneBoundsFragment
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type LabGrownSearchQueryVariables = Exact<{
    filters: NonSkuLabGrownDiamondsFilters
    sort: NonSkuLabGrownDiamondSortInput
    currency: CurrencyInput
    region: RegionCode
    locale: Scalars['Locale']['input']
    contentPath: Scalars['String']['input']
}>

export type LabGrownSearchQuery = { __typename: 'Query' } & {
    nonSkuLabGrownDiamonds: Array<
        { __typename: 'NonSkuLabGrown' } & NonSkuLabGrownFragment
    >
    nonSkuLabGrownDiamondsBounds: {
        __typename: 'NonSkuLabGrownDiamondsBounds'
    } & NonSkuLabGrownDiamondBoundsFragment
    pageProductListing: Maybe<
        { __typename: 'ProductPageListing' } & ProductPageListingFragment
    >
}

export type WpRedirectQueryVariables = Exact<{
    currentUrl: Scalars['String']['input']
}>

export type WpRedirectQuery = { __typename: 'Query' } & {
    redirection: Maybe<
        { __typename: 'RedirectionRedirect' } & Pick<
            RedirectionRedirect,
            'code' | 'target'
        >
    >
}
